//@ts-nocheck
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.8
//   protoc               v3.19.1
// source: messages.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FieldMask } from "./google/protobuf/field_mask";
import { Value } from "./google/protobuf/struct";
import { BoolValue, Int32Value, StringValue, UInt32Value } from "./google/protobuf/wrappers";

export const protobufPackage = "";

export enum AvailabilityStatus {
  UNCHANGED = 0,
  ONLINE = 1,
  SILENT = 2,
  AWAY = 3,
  JITSI = 4,
  BBB = 5,
  DENY_PROXIMITY_MEETING = 6,
  SPEAKER = 7,
  BUSY = 8,
  DO_NOT_DISTURB = 9,
  BACK_IN_A_MOMENT = 10,
  LIVEKIT = 11,
  LISTENER = 12,
  /**
   * SOUND_BLOCKED - Set automatically when the browser refuses to play audio for lack of a user
   * gesture. Unlike BACK_IN_A_MOMENT, which the user picks, this one is imposed and
   * clears on the next click.
   */
  SOUND_BLOCKED = 13,
  UNRECOGNIZED = -1,
}

export function availabilityStatusFromJSON(object: any): AvailabilityStatus {
  switch (object) {
    case 0:
    case "UNCHANGED":
      return AvailabilityStatus.UNCHANGED;
    case 1:
    case "ONLINE":
      return AvailabilityStatus.ONLINE;
    case 2:
    case "SILENT":
      return AvailabilityStatus.SILENT;
    case 3:
    case "AWAY":
      return AvailabilityStatus.AWAY;
    case 4:
    case "JITSI":
      return AvailabilityStatus.JITSI;
    case 5:
    case "BBB":
      return AvailabilityStatus.BBB;
    case 6:
    case "DENY_PROXIMITY_MEETING":
      return AvailabilityStatus.DENY_PROXIMITY_MEETING;
    case 7:
    case "SPEAKER":
      return AvailabilityStatus.SPEAKER;
    case 8:
    case "BUSY":
      return AvailabilityStatus.BUSY;
    case 9:
    case "DO_NOT_DISTURB":
      return AvailabilityStatus.DO_NOT_DISTURB;
    case 10:
    case "BACK_IN_A_MOMENT":
      return AvailabilityStatus.BACK_IN_A_MOMENT;
    case 11:
    case "LIVEKIT":
      return AvailabilityStatus.LIVEKIT;
    case 12:
    case "LISTENER":
      return AvailabilityStatus.LISTENER;
    case 13:
    case "SOUND_BLOCKED":
      return AvailabilityStatus.SOUND_BLOCKED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AvailabilityStatus.UNRECOGNIZED;
  }
}

export function availabilityStatusToJSON(object: AvailabilityStatus): string {
  switch (object) {
    case AvailabilityStatus.UNCHANGED:
      return "UNCHANGED";
    case AvailabilityStatus.ONLINE:
      return "ONLINE";
    case AvailabilityStatus.SILENT:
      return "SILENT";
    case AvailabilityStatus.AWAY:
      return "AWAY";
    case AvailabilityStatus.JITSI:
      return "JITSI";
    case AvailabilityStatus.BBB:
      return "BBB";
    case AvailabilityStatus.DENY_PROXIMITY_MEETING:
      return "DENY_PROXIMITY_MEETING";
    case AvailabilityStatus.SPEAKER:
      return "SPEAKER";
    case AvailabilityStatus.BUSY:
      return "BUSY";
    case AvailabilityStatus.DO_NOT_DISTURB:
      return "DO_NOT_DISTURB";
    case AvailabilityStatus.BACK_IN_A_MOMENT:
      return "BACK_IN_A_MOMENT";
    case AvailabilityStatus.LIVEKIT:
      return "LIVEKIT";
    case AvailabilityStatus.LISTENER:
      return "LISTENER";
    case AvailabilityStatus.SOUND_BLOCKED:
      return "SOUND_BLOCKED";
    case AvailabilityStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SayMessageType {
  SpeechBubble = 0,
  ThinkingCloud = 1,
  UNRECOGNIZED = -1,
}

export function sayMessageTypeFromJSON(object: any): SayMessageType {
  switch (object) {
    case 0:
    case "SpeechBubble":
      return SayMessageType.SpeechBubble;
    case 1:
    case "ThinkingCloud":
      return SayMessageType.ThinkingCloud;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SayMessageType.UNRECOGNIZED;
  }
}

export function sayMessageTypeToJSON(object: SayMessageType): string {
  switch (object) {
    case SayMessageType.SpeechBubble:
      return "SpeechBubble";
    case SayMessageType.ThinkingCloud:
      return "ThinkingCloud";
    case SayMessageType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum VideoQualityStreamCategory {
  VIDEO_QUALITY_STREAM_CATEGORY_VIDEO = 0,
  VIDEO_QUALITY_STREAM_CATEGORY_SCREEN_SHARING = 1,
  UNRECOGNIZED = -1,
}

export function videoQualityStreamCategoryFromJSON(object: any): VideoQualityStreamCategory {
  switch (object) {
    case 0:
    case "VIDEO_QUALITY_STREAM_CATEGORY_VIDEO":
      return VideoQualityStreamCategory.VIDEO_QUALITY_STREAM_CATEGORY_VIDEO;
    case 1:
    case "VIDEO_QUALITY_STREAM_CATEGORY_SCREEN_SHARING":
      return VideoQualityStreamCategory.VIDEO_QUALITY_STREAM_CATEGORY_SCREEN_SHARING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VideoQualityStreamCategory.UNRECOGNIZED;
  }
}

export function videoQualityStreamCategoryToJSON(object: VideoQualityStreamCategory): string {
  switch (object) {
    case VideoQualityStreamCategory.VIDEO_QUALITY_STREAM_CATEGORY_VIDEO:
      return "VIDEO_QUALITY_STREAM_CATEGORY_VIDEO";
    case VideoQualityStreamCategory.VIDEO_QUALITY_STREAM_CATEGORY_SCREEN_SHARING:
      return "VIDEO_QUALITY_STREAM_CATEGORY_SCREEN_SHARING";
    case VideoQualityStreamCategory.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum VideoQualityTransportType {
  VIDEO_QUALITY_TRANSPORT_TYPE_P2P = 0,
  VIDEO_QUALITY_TRANSPORT_TYPE_LIVEKIT = 1,
  UNRECOGNIZED = -1,
}

export function videoQualityTransportTypeFromJSON(object: any): VideoQualityTransportType {
  switch (object) {
    case 0:
    case "VIDEO_QUALITY_TRANSPORT_TYPE_P2P":
      return VideoQualityTransportType.VIDEO_QUALITY_TRANSPORT_TYPE_P2P;
    case 1:
    case "VIDEO_QUALITY_TRANSPORT_TYPE_LIVEKIT":
      return VideoQualityTransportType.VIDEO_QUALITY_TRANSPORT_TYPE_LIVEKIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VideoQualityTransportType.UNRECOGNIZED;
  }
}

export function videoQualityTransportTypeToJSON(object: VideoQualityTransportType): string {
  switch (object) {
    case VideoQualityTransportType.VIDEO_QUALITY_TRANSPORT_TYPE_P2P:
      return "VIDEO_QUALITY_TRANSPORT_TYPE_P2P";
    case VideoQualityTransportType.VIDEO_QUALITY_TRANSPORT_TYPE_LIVEKIT:
      return "VIDEO_QUALITY_TRANSPORT_TYPE_LIVEKIT";
    case VideoQualityTransportType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum VideoQualityRelayProtocol {
  VIDEO_QUALITY_RELAY_PROTOCOL_UDP = 0,
  VIDEO_QUALITY_RELAY_PROTOCOL_TCP = 1,
  VIDEO_QUALITY_RELAY_PROTOCOL_TLS = 2,
  UNRECOGNIZED = -1,
}

export function videoQualityRelayProtocolFromJSON(object: any): VideoQualityRelayProtocol {
  switch (object) {
    case 0:
    case "VIDEO_QUALITY_RELAY_PROTOCOL_UDP":
      return VideoQualityRelayProtocol.VIDEO_QUALITY_RELAY_PROTOCOL_UDP;
    case 1:
    case "VIDEO_QUALITY_RELAY_PROTOCOL_TCP":
      return VideoQualityRelayProtocol.VIDEO_QUALITY_RELAY_PROTOCOL_TCP;
    case 2:
    case "VIDEO_QUALITY_RELAY_PROTOCOL_TLS":
      return VideoQualityRelayProtocol.VIDEO_QUALITY_RELAY_PROTOCOL_TLS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VideoQualityRelayProtocol.UNRECOGNIZED;
  }
}

export function videoQualityRelayProtocolToJSON(object: VideoQualityRelayProtocol): string {
  switch (object) {
    case VideoQualityRelayProtocol.VIDEO_QUALITY_RELAY_PROTOCOL_UDP:
      return "VIDEO_QUALITY_RELAY_PROTOCOL_UDP";
    case VideoQualityRelayProtocol.VIDEO_QUALITY_RELAY_PROTOCOL_TCP:
      return "VIDEO_QUALITY_RELAY_PROTOCOL_TCP";
    case VideoQualityRelayProtocol.VIDEO_QUALITY_RELAY_PROTOCOL_TLS:
      return "VIDEO_QUALITY_RELAY_PROTOCOL_TLS";
    case VideoQualityRelayProtocol.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Direction of a video stream from the reporter's point of view. */
export enum VideoQualityStreamDirection {
  VIDEO_QUALITY_STREAM_DIRECTION_INBOUND = 0,
  VIDEO_QUALITY_STREAM_DIRECTION_OUTBOUND = 1,
  UNRECOGNIZED = -1,
}

export function videoQualityStreamDirectionFromJSON(object: any): VideoQualityStreamDirection {
  switch (object) {
    case 0:
    case "VIDEO_QUALITY_STREAM_DIRECTION_INBOUND":
      return VideoQualityStreamDirection.VIDEO_QUALITY_STREAM_DIRECTION_INBOUND;
    case 1:
    case "VIDEO_QUALITY_STREAM_DIRECTION_OUTBOUND":
      return VideoQualityStreamDirection.VIDEO_QUALITY_STREAM_DIRECTION_OUTBOUND;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VideoQualityStreamDirection.UNRECOGNIZED;
  }
}

export function videoQualityStreamDirectionToJSON(object: VideoQualityStreamDirection): string {
  switch (object) {
    case VideoQualityStreamDirection.VIDEO_QUALITY_STREAM_DIRECTION_INBOUND:
      return "VIDEO_QUALITY_STREAM_DIRECTION_INBOUND";
    case VideoQualityStreamDirection.VIDEO_QUALITY_STREAM_DIRECTION_OUTBOUND:
      return "VIDEO_QUALITY_STREAM_DIRECTION_OUTBOUND";
    case VideoQualityStreamDirection.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Why the browser's encoder is not sending at full quality (RTCOutboundRtpStreamStats.qualityLimitationReason). */
export enum VideoQualityLimitationReason {
  VIDEO_QUALITY_LIMITATION_REASON_NONE = 0,
  VIDEO_QUALITY_LIMITATION_REASON_CPU = 1,
  VIDEO_QUALITY_LIMITATION_REASON_BANDWIDTH = 2,
  VIDEO_QUALITY_LIMITATION_REASON_OTHER = 3,
  UNRECOGNIZED = -1,
}

export function videoQualityLimitationReasonFromJSON(object: any): VideoQualityLimitationReason {
  switch (object) {
    case 0:
    case "VIDEO_QUALITY_LIMITATION_REASON_NONE":
      return VideoQualityLimitationReason.VIDEO_QUALITY_LIMITATION_REASON_NONE;
    case 1:
    case "VIDEO_QUALITY_LIMITATION_REASON_CPU":
      return VideoQualityLimitationReason.VIDEO_QUALITY_LIMITATION_REASON_CPU;
    case 2:
    case "VIDEO_QUALITY_LIMITATION_REASON_BANDWIDTH":
      return VideoQualityLimitationReason.VIDEO_QUALITY_LIMITATION_REASON_BANDWIDTH;
    case 3:
    case "VIDEO_QUALITY_LIMITATION_REASON_OTHER":
      return VideoQualityLimitationReason.VIDEO_QUALITY_LIMITATION_REASON_OTHER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VideoQualityLimitationReason.UNRECOGNIZED;
  }
}

export function videoQualityLimitationReasonToJSON(object: VideoQualityLimitationReason): string {
  switch (object) {
    case VideoQualityLimitationReason.VIDEO_QUALITY_LIMITATION_REASON_NONE:
      return "VIDEO_QUALITY_LIMITATION_REASON_NONE";
    case VideoQualityLimitationReason.VIDEO_QUALITY_LIMITATION_REASON_CPU:
      return "VIDEO_QUALITY_LIMITATION_REASON_CPU";
    case VideoQualityLimitationReason.VIDEO_QUALITY_LIMITATION_REASON_BANDWIDTH:
      return "VIDEO_QUALITY_LIMITATION_REASON_BANDWIDTH";
    case VideoQualityLimitationReason.VIDEO_QUALITY_LIMITATION_REASON_OTHER:
      return "VIDEO_QUALITY_LIMITATION_REASON_OTHER";
    case VideoQualityLimitationReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum CustomEntityDirection {
  Up = 0,
  Right = 1,
  Down = 2,
  Left = 3,
  UNRECOGNIZED = -1,
}

export function customEntityDirectionFromJSON(object: any): CustomEntityDirection {
  switch (object) {
    case 0:
    case "Up":
      return CustomEntityDirection.Up;
    case 1:
    case "Right":
      return CustomEntityDirection.Right;
    case 2:
    case "Down":
      return CustomEntityDirection.Down;
    case 3:
    case "Left":
      return CustomEntityDirection.Left;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CustomEntityDirection.UNRECOGNIZED;
  }
}

export function customEntityDirectionToJSON(object: CustomEntityDirection): string {
  switch (object) {
    case CustomEntityDirection.Up:
      return "Up";
    case CustomEntityDirection.Right:
      return "Right";
    case CustomEntityDirection.Down:
      return "Down";
    case CustomEntityDirection.Left:
      return "Left";
    case CustomEntityDirection.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RecordingWebhookPhase {
  RECORDING_WEBHOOK_PHASE_UNSPECIFIED = 0,
  RECORDING_WEBHOOK_PHASE_STARTED = 1,
  RECORDING_WEBHOOK_PHASE_ENDED = 2,
  UNRECOGNIZED = -1,
}

export function recordingWebhookPhaseFromJSON(object: any): RecordingWebhookPhase {
  switch (object) {
    case 0:
    case "RECORDING_WEBHOOK_PHASE_UNSPECIFIED":
      return RecordingWebhookPhase.RECORDING_WEBHOOK_PHASE_UNSPECIFIED;
    case 1:
    case "RECORDING_WEBHOOK_PHASE_STARTED":
      return RecordingWebhookPhase.RECORDING_WEBHOOK_PHASE_STARTED;
    case 2:
    case "RECORDING_WEBHOOK_PHASE_ENDED":
      return RecordingWebhookPhase.RECORDING_WEBHOOK_PHASE_ENDED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RecordingWebhookPhase.UNRECOGNIZED;
  }
}

export function recordingWebhookPhaseToJSON(object: RecordingWebhookPhase): string {
  switch (object) {
    case RecordingWebhookPhase.RECORDING_WEBHOOK_PHASE_UNSPECIFIED:
      return "RECORDING_WEBHOOK_PHASE_UNSPECIFIED";
    case RecordingWebhookPhase.RECORDING_WEBHOOK_PHASE_STARTED:
      return "RECORDING_WEBHOOK_PHASE_STARTED";
    case RecordingWebhookPhase.RECORDING_WEBHOOK_PHASE_ENDED:
      return "RECORDING_WEBHOOK_PHASE_ENDED";
    case RecordingWebhookPhase.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FilterType {
  ALL_USERS = 0,
  LIVE_STREAMING_USERS = 1,
  LIVE_STREAMING_USERS_WITH_FEEDBACK = 2,
  UNRECOGNIZED = -1,
}

export function filterTypeFromJSON(object: any): FilterType {
  switch (object) {
    case 0:
    case "ALL_USERS":
      return FilterType.ALL_USERS;
    case 1:
    case "LIVE_STREAMING_USERS":
      return FilterType.LIVE_STREAMING_USERS;
    case 2:
    case "LIVE_STREAMING_USERS_WITH_FEEDBACK":
      return FilterType.LIVE_STREAMING_USERS_WITH_FEEDBACK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FilterType.UNRECOGNIZED;
  }
}

export function filterTypeToJSON(object: FilterType): string {
  switch (object) {
    case FilterType.ALL_USERS:
      return "ALL_USERS";
    case FilterType.LIVE_STREAMING_USERS:
      return "LIVE_STREAMING_USERS";
    case FilterType.LIVE_STREAMING_USERS_WITH_FEEDBACK:
      return "LIVE_STREAMING_USERS_WITH_FEEDBACK";
    case FilterType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PositionMessage {
  x: number;
  y: number;
  direction: PositionMessage_Direction;
  moving: boolean;
}

export enum PositionMessage_Direction {
  UP = 0,
  RIGHT = 1,
  DOWN = 2,
  LEFT = 3,
  UNRECOGNIZED = -1,
}

export function positionMessage_DirectionFromJSON(object: any): PositionMessage_Direction {
  switch (object) {
    case 0:
    case "UP":
      return PositionMessage_Direction.UP;
    case 1:
    case "RIGHT":
      return PositionMessage_Direction.RIGHT;
    case 2:
    case "DOWN":
      return PositionMessage_Direction.DOWN;
    case 3:
    case "LEFT":
      return PositionMessage_Direction.LEFT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PositionMessage_Direction.UNRECOGNIZED;
  }
}

export function positionMessage_DirectionToJSON(object: PositionMessage_Direction): string {
  switch (object) {
    case PositionMessage_Direction.UP:
      return "UP";
    case PositionMessage_Direction.RIGHT:
      return "RIGHT";
    case PositionMessage_Direction.DOWN:
      return "DOWN";
    case PositionMessage_Direction.LEFT:
      return "LEFT";
    case PositionMessage_Direction.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PointMessage {
  x: number;
  y: number;
}

export interface ViewportMessage {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

export interface CharacterTextureMessage {
  url: string;
  id: string;
}

export interface ApplicationMessage {
  name: string;
  script?: string | undefined;
  doc?: string | undefined;
  description?: string | undefined;
  image?: string | undefined;
  enabled?: boolean | undefined;
  regexUrl?: string | undefined;
  targetUrl?: string | undefined;
  default?: boolean | undefined;
  forceNewTab?: boolean | undefined;
  allowAPI?: boolean | undefined;
  policy?: string | undefined;
  imageLogo?: string | undefined;
}

export interface CompanionTextureMessage {
  url: string;
  id: string;
}

/** Wrapper for all messages destined to a specific zone */
export interface ZoneMessage {
  x: number;
  y: number;
  message:
    | { $case: "userJoinedZoneMessage"; userJoinedZoneMessage: UserJoinedZoneMessage }
    | { $case: "groupUpdateZoneMessage"; groupUpdateZoneMessage: GroupUpdateZoneMessage }
    | { $case: "userMovedMessage"; userMovedMessage: UserMovedMessage }
    | { $case: "groupLeftZoneMessage"; groupLeftZoneMessage: GroupLeftZoneMessage }
    | { $case: "userLeftZoneMessage"; userLeftZoneMessage: UserLeftZoneMessage }
    | { $case: "emoteEventMessage"; emoteEventMessage: EmoteEventMessage }
    | { $case: "playerDetailsUpdatedMessage"; playerDetailsUpdatedMessage: PlayerDetailsUpdatedMessage }
    | { $case: "groupUsersUpdateMessage"; groupUsersUpdateMessage: GroupUsersUpdateMessage }
    | undefined;
}

export interface PingMessage {
}

export interface UpdateMapToNewestMessage {
  commandId?: string | undefined;
}

export interface UpdateMapToNewestWithKeyMessage {
  mapKey: string;
  updateMapToNewestMessage: UpdateMapToNewestMessage | undefined;
}

export interface SetPlayerDetailsMessage {
  outlineColor: number | undefined;
  removeOutlineColor: boolean | undefined;
  showVoiceIndicator: boolean | undefined;
  availabilityStatus: AvailabilityStatus;
  setVariable: SetPlayerVariableMessage | undefined;
  chatID: string | undefined;
  sayMessage: SayMessage | undefined;
}

export interface SayMessage {
  message: string;
  type: SayMessageType;
}

export interface UserMovesMessage {
  position: PositionMessage | undefined;
  viewport: ViewportMessage | undefined;
}

export interface WebRtcSignal {
  signal: string;
  connectionId: string;
}

export interface VideoQualitySampleMessage {
  clientEventTimeMs: number;
  sampleSeq?: number | undefined;
  streamId: string;
  connectionId?: string | undefined;
  sessionId?: string | undefined;
  remoteUserUuid?: string | undefined;
  remoteSpaceUserId: string;
  spaceName: string;
  streamCategory: VideoQualityStreamCategory;
  transportType: VideoQualityTransportType;
  relay?: boolean | undefined;
  relayProtocol?: VideoQualityRelayProtocol | undefined;
  livekitServerUrl?: string | undefined;
  fps: number;
  fpsStdDev?: number | undefined;
  jitter: number;
  bandwidthBytesPerSecond: number;
  frameWidth: number;
  frameHeight: number;
  mimeType?: string | undefined;
  direction: VideoQualityStreamDirection;
  /** Outbound streams only. */
  qualityLimitationReason?:
    | VideoQualityLimitationReason
    | undefined;
  /** Outbound streams only: encoder implementation reported by the browser (e.g. "libaom", "libvpx", "ExternalEncoder"). */
  encoderImplementation?:
    | string
    | undefined;
  /**
   * Inbound streams only: what the browser counted since the previous sample of this stream (the difference of the
   * cumulative RTCInboundRtpStreamStats counters), over windowSeconds. Absent when the window is not measurable (first
   * sample, counters restarted, right after a deliberate pause); each counter is also absent when the browser does
   * not expose it.
   */
  windowSeconds?: number | undefined;
  framesDecoded?: number | undefined;
  framesDropped?:
    | number
    | undefined;
  /** Gaps between two rendered frames longer than max(3 x the average frame duration, average + 150 ms), up to 5 s */
  freezeCount?: number | undefined;
  freezeSeconds?:
    | number
    | undefined;
  /** Gaps longer than 5 s, never counted as freezes */
  pauseCount?: number | undefined;
  pauseSeconds?: number | undefined;
  interFrameDelaySumSeconds?: number | undefined;
  interFrameDelaySquaredSumSeconds?: number | undefined;
  decodeSeconds?:
    | number
    | undefined;
  /**
   * Outbound streams only, over the last second like fps: frames per second the capture delivered
   * (RTCVideoSourceStats.frames), and the rate it is configured at (MediaTrackSettings.frameRate).
   */
  captureFps?: number | undefined;
  captureTargetFps?:
    | number
    | undefined;
  /**
   * Outbound streams only, over the last second: encoding time per encoded frame (all layers), and the share of the
   * time (0 to 1) the encoder degraded the stream for lack of CPU / of bandwidth (qualityLimitationDurations).
   */
  encodeMsPerFrame?: number | undefined;
  cpuLimitedRatio?: number | undefined;
  bandwidthLimitedRatio?:
    | number
    | undefined;
  /**
   * Inbound streams only, over windowSeconds like the playback counters: packets received and lost (a packet counted
   * as lost then received late is taken back, never below 0).
   */
  packetsReceived?: number | undefined;
  packetsLost?:
    | number
    | undefined;
  /**
   * Inbound streams only: round-trip time of the connection the stream arrives on (selected ICE candidate pair), when
   * the sample was taken.
   */
  roundTripTimeMs?:
    | number
    | undefined;
  /**
   * Outbound streams only, from the latest receiver report of the other end about the largest layer: round-trip time,
   * and the share of the packets lost on the way (0 to 1).
   */
  uploadRoundTripTimeMs?: number | undefined;
  uploadLossRatio?:
    | number
    | undefined;
  /** Outbound streams only: the browser's estimate of the bandwidth it can send, in bits per second. */
  availableOutgoingBitrate?:
    | number
    | undefined;
  /**
   * LiveKit streams only: region of the LiveKit server the client is connected to (serverInfo.region). Set by
   * LiveKit Cloud, usually empty on a self-hosted server.
   */
  livekitRegion?: string | undefined;
}

export interface VideoQualityReportMessage {
  samples: VideoQualitySampleMessage[];
}

export interface AnalyticsEventMessage {
  eventName: string;
  source: string;
  clientEventTimeMs: number;
  eventId: string;
  /**
   * A flat bag of key/value pairs describing this one event. Its shape is declared per event in
   * AnalyticsEventCatalog (@workadventure/messages), which the pusher enforces: an event name it
   * does not carry is dropped, and so is a payload missing a field the entry requires. The payload
   * stays passthrough, so a newer front may add fields to a known event without a lockstep deploy —
   * only the event NAME is closed.
   *
   * Note this is deliberately NOT how high-frequency samples travel: VideoQualityReportMessage keeps
   * its own strongly-typed shape rather than paying Value's per-sample field names and untyped
   * numbers, and being pusher-synthesized is what lets the admin trust its source.
   */
  properties: any | undefined;
}

export interface AnalyticsEventReportMessage {
  events: AnalyticsEventMessage[];
}

export interface ReportPlayerMessage {
  reportedUserUuid: string;
  reportComment: string;
}

export interface BanPlayerMessage {
  banUserUuid: string;
  banUserName: string;
  /** true: kick the user out of the room only, without persisting anything in the admin */
  kick: boolean;
  /** reason given by the moderator, displayed to the kicked/banned user and stored with the ban */
  reason: string;
  /** ban: also ban the IP the user connected from, which locks out everyone behind it (see BanIpPreviewQuery) */
  byIp: boolean;
}

export interface UpdateChatIdMessage {
  email: string;
  chatId: string;
}

export interface LeaveChatRoomAreaMessage {
  roomID: string;
}

export interface EmotePromptMessage {
  emote: string;
}

export interface EmoteEventMessage {
  actorUserId: number;
  emote: string;
}

export interface FollowRequestMessage {
  leader: number;
  forceFollow: boolean;
}

export interface FollowConfirmationMessage {
  leader: number;
  follower: number;
}

export interface FollowAbortMessage {
  leader: number;
  follower: number;
}

export interface LockGroupPromptMessage {
  lock: boolean;
}

export interface EditMapMessage {
  message:
    | { $case: "modifyAreaMessage"; modifyAreaMessage: ModifyAreaMessage }
    | { $case: "createAreaMessage"; createAreaMessage: CreateAreaMessage }
    | { $case: "deleteAreaMessage"; deleteAreaMessage: DeleteAreaMessage }
    | { $case: "modifyEntityMessage"; modifyEntityMessage: ModifyEntityMessage }
    | { $case: "createEntityMessage"; createEntityMessage: CreateEntityMessage }
    | { $case: "deleteEntityMessage"; deleteEntityMessage: DeleteEntityMessage }
    | { $case: "updateWAMSettingsMessage"; updateWAMSettingsMessage: UpdateWAMSettingsMessage }
    | { $case: "errorCommandMessage"; errorCommandMessage: ErrorCommandMessage }
    | { $case: "uploadEntityMessage"; uploadEntityMessage: UploadEntityMessage }
    | { $case: "modifyCustomEntityMessage"; modifyCustomEntityMessage: ModifyCustomEntityMessage }
    | { $case: "deleteCustomEntityMessage"; deleteCustomEntityMessage: DeleteCustomEntityMessage }
    | { $case: "modifiyWAMMetadataMessage"; modifiyWAMMetadataMessage: ModifiyWAMMetadataMessage }
    | { $case: "uploadFileMessage"; uploadFileMessage: UploadFileMessage }
    | undefined;
}

export interface ErrorCommandMessage {
  reason: string;
}

export interface UpdateWAMSettingsMessage {
  message: { $case: "updateMegaphoneSettingMessage"; updateMegaphoneSettingMessage: UpdateMegaphoneSettingMessage } | {
    $case: "updateRecordingSettingMessage";
    updateRecordingSettingMessage: UpdateRecordingSettingMessage;
  } | undefined;
}

export interface UpdateMegaphoneSettingMessage {
  /**
   * The megaphone block to store in the WAM file, or nothing to clear it. Schemaless here, but
   * UpdateWAMSettingCommand parses it against MegaphoneSettings (libs/map-editor) before it is written,
   * so anything that does not match that schema is rejected rather than stored.
   */
  settings: any | undefined;
}

export interface UpdateRecordingSettingMessage {
  /**
   * The recording block to store in the WAM file, or nothing to clear it. Parsed against
   * RecordingSettings (libs/map-editor) by UpdateWAMSettingCommand before it is written.
   */
  settings: any | undefined;
}

export interface EditMapCommandMessage {
  id: string;
  editMapMessage: EditMapMessage | undefined;
}

export interface EditMapCommandsArrayMessage {
  editMapCommands: EditMapCommandMessage[];
}

export interface EditMapCommandWithKeyMessage {
  mapKey: string;
  editMapCommandMessage: EditMapCommandMessage | undefined;
  connectedUserTags: string[];
  userCanEdit: boolean;
  userUUID: string;
}

export interface ModifyAreaMessage {
  id: string;
  name?: string | undefined;
  x?: number | undefined;
  y?: number | undefined;
  width?: number | undefined;
  height?:
    | number
    | undefined;
  /**
   * AreaDataProperty values (libs/map-editor): a discriminated union on `type`, not free-form JSON.
   * Only applied when modifyProperties is set. Nothing checks them at this boundary, but the
   * map-storage re-parses the whole WAM file after the command runs and rejects the change if the
   * result no longer matches WAMFileFormat (MapsManager, "Security check").
   */
  properties: any[];
  /**
   * Whether `properties` above means anything. It exists because protobuf cannot tell an unset
   * repeated field from an empty one: without this flag, "do not touch the properties" and "erase
   * every property" would arrive identically. Leave it unset to keep the area's current properties.
   */
  modifyProperties?: boolean | undefined;
  modifyServerData?: boolean | undefined;
}

export interface DeleteAreaMessage {
  id: string;
}

export interface CreateAreaMessage {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  name: string;
  /**
   * AreaDataProperty values (libs/map-editor): a discriminated union on `type`, not free-form JSON.
   * See ModifyAreaMessage.properties for where they are checked.
   */
  properties: any[];
}

export interface CreateEntityMessage {
  id: string;
  x: number;
  y: number;
  collectionName: string;
  prefabId: string;
  /**
   * EntityDataProperty values (libs/map-editor): a discriminated union on `type`, not free-form JSON.
   * See ModifyAreaMessage.properties for where they are checked.
   */
  properties: any[];
  name?: string | undefined;
  width: number;
  height: number;
}

export interface DeleteEntityMessage {
  id: string;
}

export interface CollisionGridRow {
  row: number[];
}

export interface UploadEntityMessage {
  file: Uint8Array;
  id: string;
  name: string;
  tags: string[];
  imagePath: string;
  direction: CustomEntityDirection;
  color: string;
  /**
   * A grid of numbers, one row per tile row, saying which tiles of the entity block movement
   * (CollisionGrid in libs/map-editor, i.e. number[][]). Nested arrays are why this is a Value and not
   * a repeated field: protobuf has no repeated-of-repeated. The map-storage parses it against that
   * schema before storing (CustomEntityCollectionService).
   */
  collisionGrid?: any | undefined;
  depthOffset?:
    | number
    | undefined;
  /**
   * UUID of the user who uploaded the entity. Always overwritten by map-storage with the
   * authenticated user UUID: any value sent by the client is discarded. It is sent back in the
   * broadcast copy of the command so every client knows who owns the asset.
   */
  ownerId?: string | undefined;
}

export interface UploadFileMessage {
  file: Uint8Array;
  id: string;
  name: string;
  propertyId: string;
  areaId?: string | undefined;
  entityId?: string | undefined;
}

export interface ModifyCustomEntityMessage {
  id: string;
  name: string;
  tags: string[];
  /** See UploadEntityMessage.collisionGrid. Leave unset to keep the entity's current grid. */
  collisionGrid?: any | undefined;
  depthOffset?: number | undefined;
}

export interface DeleteCustomEntityMessage {
  id: string;
}

export interface ModifyEntityMessage {
  id: string;
  x: number;
  y: number;
  /**
   * EntityDataProperty values (libs/map-editor): a discriminated union on `type`, not free-form JSON.
   * See ModifyAreaMessage.properties for where they are checked.
   */
  properties: any[];
  /** Same role as ModifyAreaMessage.modifyProperties: leave unset to keep the entity's current properties. */
  modifyProperties?: boolean | undefined;
  name?: string | undefined;
  width: number;
  height: number;
}

/** Transport envelope for websocket frames sent from front to pusher. */
export interface FrontToPusherWebSocketMessage {
  nonce: number;
  message: ClientToServerMessage | undefined;
}

/** Transport envelope for websocket frames sent from pusher to front. */
export interface PusherToFrontWebSocketMessage {
  nonce: number;
  message: ServerToClientMessage | undefined;
}

export interface ClientToServerMessage {
  message:
    | { $case: "joinRoomFrontMessage"; joinRoomFrontMessage: JoinRoomFrontMessage }
    | { $case: "userMovesMessage"; userMovesMessage: UserMovesMessage }
    | { $case: "viewportMessage"; viewportMessage: ViewportMessage }
    | { $case: "itemEventMessage"; itemEventMessage: ItemEventMessage }
    | { $case: "setPlayerDetailsMessage"; setPlayerDetailsMessage: SetPlayerDetailsMessage }
    | { $case: "playGlobalMessage"; playGlobalMessage: PlayGlobalMessage }
    | { $case: "reportPlayerMessage"; reportPlayerMessage: ReportPlayerMessage }
    | { $case: "emotePromptMessage"; emotePromptMessage: EmotePromptMessage }
    | { $case: "variableMessage"; variableMessage: VariableMessage }
    | { $case: "followRequestMessage"; followRequestMessage: FollowRequestMessage }
    | { $case: "followConfirmationMessage"; followConfirmationMessage: FollowConfirmationMessage }
    | { $case: "followAbortMessage"; followAbortMessage: FollowAbortMessage }
    | { $case: "lockGroupPromptMessage"; lockGroupPromptMessage: LockGroupPromptMessage }
    | { $case: "queryMessage"; queryMessage: QueryMessage }
    | { $case: "abortQueryMessage"; abortQueryMessage: AbortQueryMessage }
    | { $case: "pingMessage"; pingMessage: PingMessage }
    | //
    /** XmppMessage xmppMessage = 22; */
    { $case: "askPositionMessage"; askPositionMessage: AskPositionMessage }
    | { $case: "editMapCommandMessage"; editMapCommandMessage: EditMapCommandMessage }
    | { $case: "addSpaceFilterMessage"; addSpaceFilterMessage: AddSpaceFilterMessage }
    | { $case: "removeSpaceFilterMessage"; removeSpaceFilterMessage: RemoveSpaceFilterMessage }
    | { $case: "updateSpaceUserMessage"; updateSpaceUserMessage: UpdateSpaceUserMessage }
    | { $case: "updateSpaceMetadataMessage"; updateSpaceMetadataMessage: UpdateSpaceMetadataMessage }
    | { $case: "banPlayerMessage"; banPlayerMessage: BanPlayerMessage }
    | { $case: "updateChatIdMessage"; updateChatIdMessage: UpdateChatIdMessage }
    | { $case: "publicEvent"; publicEvent: PublicEventFrontToPusher }
    | { $case: "privateEvent"; privateEvent: PrivateEventFrontToPusher }
    | { $case: "backEvent"; backEvent: BackEventFrontToPusherMessage }
    | { $case: "leaveChatRoomAreaMessage"; leaveChatRoomAreaMessage: LeaveChatRoomAreaMessage }
    | { $case: "meetingInvitationRequestMessage"; meetingInvitationRequestMessage: MeetingInvitationRequestMessage }
    | { $case: "meetingInvitationResponseMessage"; meetingInvitationResponseMessage: MeetingInvitationResponseMessage }
    | { $case: "setAreaPropertyVariableMessage"; setAreaPropertyVariableMessage: SetAreaPropertyVariableMessage }
    | { $case: "videoQualityReportMessage"; videoQualityReportMessage: VideoQualityReportMessage }
    | { $case: "analyticsEventReportMessage"; analyticsEventReportMessage: AnalyticsEventReportMessage }
    | { $case: "entityMessage"; entityMessage: EntityMessage }
    | undefined;
}

/**
 * An event delivered to a client, either broadcast by another player's script (WA.event) or by the
 * Room API. The name and payload are defined by whoever wrote the map's script, so they are opaque
 * here on purpose: this is an extension point, and constraining it would break the scripting API.
 */
export interface ReceivedEventMessage {
  name: string;
  /** Whatever the sender attached, verbatim. The server does not read it. */
  data:
    | any
    | undefined;
  /**
   * The id, within the room, of the player whose script sent the event. Absent when it came from the
   * Room API rather than from a player.
   */
  senderId?: number | undefined;
}

export interface ModifiyWAMMetadataMessage {
  name: string;
  description?: string | undefined;
  copyright?: string | undefined;
  thumbnail?: string | undefined;
  tags?: string | undefined;
}

export interface ItemEventMessage {
  itemId: number;
  event: string;
  stateJson: string;
  parametersJson: string;
}

export interface VariableMessage {
  name: string;
  value: string;
}

/** Message to set/update a property variable attached to an area property */
export interface SetAreaPropertyVariableMessage {
  areaId: string;
  propertyId: string;
  key: string;
  value: string;
}

/** Message for broadcasting property variable changes and initial state */
export interface AreaPropertyVariableMessage {
  areaId: string;
  propertyId: string;
  key: string;
  value: string;
}

/** A sound attached to an entity was activated and must be played by every player of the map. */
export interface EntitySoundPlayed {
  soundUrl: string;
}

/** Events that happen on a given entity. New entity events are added to this oneof. */
export interface EntityEvent {
  event: { $case: "entitySoundPlayed"; entitySoundPlayed: EntitySoundPlayed } | undefined;
}

/** An entity event, sent by a player and broadcast to the whole room */
export interface EntityMessage {
  entityId: string;
  entityEvent: EntityEvent | undefined;
}

export interface SetPlayerVariableMessage {
  name: string;
  value: string;
  public: boolean;
  persist: boolean;
  ttl: number | undefined;
  scope: SetPlayerVariableMessage_Scope;
}

export enum SetPlayerVariableMessage_Scope {
  ROOM = 0,
  WORLD = 1,
  UNRECOGNIZED = -1,
}

export function setPlayerVariableMessage_ScopeFromJSON(object: any): SetPlayerVariableMessage_Scope {
  switch (object) {
    case 0:
    case "ROOM":
      return SetPlayerVariableMessage_Scope.ROOM;
    case 1:
    case "WORLD":
      return SetPlayerVariableMessage_Scope.WORLD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SetPlayerVariableMessage_Scope.UNRECOGNIZED;
  }
}

export function setPlayerVariableMessage_ScopeToJSON(object: SetPlayerVariableMessage_Scope): string {
  switch (object) {
    case SetPlayerVariableMessage_Scope.ROOM:
      return "ROOM";
    case SetPlayerVariableMessage_Scope.WORLD:
      return "WORLD";
    case SetPlayerVariableMessage_Scope.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** A variable, along the tag describing who it is targeted at */
export interface VariableWithTagMessage {
  name: string;
  value: string;
  readableBy: string;
}

export interface PlayGlobalMessage {
  type: string;
  content: string;
  broadcastToWorld: boolean;
}

export interface QueryMessage {
  id: number;
  query:
    | { $case: "jitsiJwtQuery"; jitsiJwtQuery: JitsiJwtQuery }
    | { $case: "joinBBBMeetingQuery"; joinBBBMeetingQuery: JoinBBBMeetingQuery }
    | { $case: "roomTagsQuery"; roomTagsQuery: RoomTagsQuery }
    | { $case: "embeddableWebsiteQuery"; embeddableWebsiteQuery: EmbeddableWebsiteQuery }
    | { $case: "roomsFromSameWorldQuery"; roomsFromSameWorldQuery: RoomsFromSameWorldQuery }
    | { $case: "sendEventQuery"; sendEventQuery: SendEventQuery }
    | { $case: "searchMemberQuery"; searchMemberQuery: SearchMemberQuery }
    | { $case: "getMemberQuery"; getMemberQuery: GetMemberQuery }
    | { $case: "iceServersQuery"; iceServersQuery: IceServersQuery }
    | { $case: "chatMembersQuery"; chatMembersQuery: ChatMembersQuery }
    | { $case: "searchTagsQuery"; searchTagsQuery: SearchTagsQuery }
    | { $case: "oauthRefreshTokenQuery"; oauthRefreshTokenQuery: OauthRefreshTokenQuery }
    | { $case: "enterChatRoomAreaQuery"; enterChatRoomAreaQuery: EnterChatRoomAreaQuery }
    | { $case: "joinSpaceQuery"; joinSpaceQuery: JoinSpaceQuery }
    | { $case: "leaveSpaceQuery"; leaveSpaceQuery: LeaveSpaceQuery }
    | { $case: "mapStorageJwtQuery"; mapStorageJwtQuery: MapStorageJwtQuery }
    | { $case: "getRecordingsQuery"; getRecordingsQuery: GetRecordingsQuery }
    | { $case: "deleteRecordingQuery"; deleteRecordingQuery: DeleteRecordingQuery }
    | { $case: "getSignedUrlQuery"; getSignedUrlQuery: GetSignedUrlQuery }
    | { $case: "getRecordingThumbnailsQuery"; getRecordingThumbnailsQuery: GetRecordingThumbnailsQuery }
    | { $case: "banIpPreviewQuery"; banIpPreviewQuery: BanIpPreviewQuery }
    | { $case: "spaceStateQuery"; spaceStateQuery: SpaceStateQueryFrontToPusher }
    | undefined;
}

export interface GetSignedUrlQuery {
  key: string;
}

export interface AbortQueryMessage {
  id: number;
}

export interface MapStorageJwtQuery {
}

export interface JitsiJwtQuery {
  jitsiRoom: string;
}

export interface JoinBBBMeetingQuery {
  /** a hash of domain, instance and localMeetingId */
  meetingId: string;
  /** bbbMeeting field from the map */
  localMeetingId: string;
  /**
   * Fix me Pusher linter fails because eslint-plugin version < 3.0
   * map<string, string> userdata = 3;
   */
  meetingName: string;
}

export interface RoomTagsQuery {
}

export interface EmbeddableWebsiteQuery {
  url: string;
}

export interface RoomsFromSameWorldQuery {
}

/**
 * A player's script broadcasting an event to the room (WA.event). The back stamps the sender's id on
 * it and fans it out; see ReceivedEventMessage for the delivered form.
 */
export interface SendEventQuery {
  name: string;
  /** Defined by the map's script, so opaque here on purpose. The server does not read it. */
  data:
    | any
    | undefined;
  /** Leave empty to reach every player in the room, or list the ids to reach only those. */
  targetUserIds: number[];
}

export interface SearchMemberQuery {
  searchText: string;
}

export interface GetMemberQuery {
  uuid: string;
}

export interface ChatMembersQuery {
  searchText: string;
}

export interface OauthRefreshTokenQuery {
  tokenToRefresh: string;
  provider?: string | undefined;
  userIdentifier?: string | undefined;
}

export interface SearchTagsQuery {
  searchText: string;
}

export interface EnterChatRoomAreaQuery {
  roomID: string;
}

export interface JoinSpaceQuery {
  spaceName: string;
  filterType: FilterType;
  propertiesToSync: string[];
}

export interface LeaveSpaceQuery {
  spaceName: string;
}

export interface GetRecordingsQuery {
  uuid?: string | undefined;
}

/** Thumbnails of a single recording, fetched on demand: the list only carries one poster per recording. */
export interface GetRecordingThumbnailsQuery {
  baseFilename: string;
}

export interface DeleteRecordingQuery {
  recordingId: string;
}

export interface AnswerMessage {
  id: number;
  answer:
    | { $case: "error"; error: ErrorMessage }
    | { $case: "jitsiJwtAnswer"; jitsiJwtAnswer: JitsiJwtAnswer }
    | { $case: "joinBBBMeetingAnswer"; joinBBBMeetingAnswer: JoinBBBMeetingAnswer }
    | { $case: "roomTagsAnswer"; roomTagsAnswer: RoomTagsAnswer }
    | { $case: "embeddableWebsiteAnswer"; embeddableWebsiteAnswer: EmbeddableWebsiteAnswer }
    | { $case: "roomsFromSameWorldAnswer"; roomsFromSameWorldAnswer: RoomsFromSameWorldAnswer }
    | { $case: "sendEventAnswer"; sendEventAnswer: SendEventAnswer }
    | { $case: "searchMemberAnswer"; searchMemberAnswer: SearchMemberAnswer }
    | { $case: "getMemberAnswer"; getMemberAnswer: GetMemberAnswer }
    | { $case: "iceServersAnswer"; iceServersAnswer: IceServersAnswer }
    | { $case: "chatMembersAnswer"; chatMembersAnswer: ChatMembersAnswer }
    | { $case: "searchTagsAnswer"; searchTagsAnswer: SearchTagsAnswer }
    | { $case: "oauthRefreshTokenAnswer"; oauthRefreshTokenAnswer: OauthRefreshTokenAnswer }
    | { $case: "enterChatRoomAreaAnswer"; enterChatRoomAreaAnswer: EnterChatRoomAreaAnswer }
    | { $case: "joinSpaceAnswer"; joinSpaceAnswer: JoinSpaceAnswer }
    | { $case: "leaveSpaceAnswer"; leaveSpaceAnswer: LeaveSpaceAnswer }
    | { $case: "mapStorageJwtAnswer"; mapStorageJwtAnswer: MapStorageJwtAnswer }
    | { $case: "getRecordingsAnswer"; getRecordingsAnswer: GetRecordingsAnswer }
    | { $case: "deleteRecordingAnswer"; deleteRecordingAnswer: DeleteRecordingAnswer }
    | { $case: "getSignedUrlAnswer"; getSignedUrlAnswer: GetSignedUrlAnswer }
    | { $case: "getRecordingThumbnailsAnswer"; getRecordingThumbnailsAnswer: GetRecordingThumbnailsAnswer }
    | { $case: "banIpPreviewAnswer"; banIpPreviewAnswer: BanIpPreviewAnswer }
    | { $case: "spaceStateAnswer"; spaceStateAnswer: SpaceStateAnswer }
    | undefined;
}

export interface JitsiJwtAnswer {
  jwt: string;
  url: string;
}

export interface MapStorageJwtAnswer {
  jwt: string;
}

export interface JoinBBBMeetingAnswer {
  meetingId: string;
  clientURL: string;
}

export interface RoomTagsAnswer {
  tags: string[];
}

export interface EmbeddableWebsiteAnswer {
  url: string;
  state: boolean;
  embeddable: boolean;
  message?: string | undefined;
}

export interface RoomShortDescription {
  name: string;
  roomUrl: string;
  wamUrl?: string | undefined;
  description?: string | undefined;
  copyright?: string | undefined;
  thumbnail?: string | undefined;
  areasSearchable?: number | undefined;
  entitiesSearchable?: number | undefined;
}

export interface RoomsFromSameWorldAnswer {
  roomDescriptions: RoomShortDescription[];
}

export interface SendEventAnswer {
}

export interface SearchMemberAnswer {
  members: Member[];
}

export interface GetMemberAnswer {
  member: Member | undefined;
}

export interface ChatMembersAnswer {
  total: number;
  members: ChatMember[];
}

export interface OauthRefreshTokenAnswer {
  message: string;
  token: string;
}

export interface EnterChatRoomAreaAnswer {
}

export interface JoinSpaceAnswer {
  spaceUserId: string;
}

export interface LeaveSpaceAnswer {
}

export interface SearchTagsAnswer {
  tags: string[];
}

export interface GetRecordingsAnswer {
  recordings: Recording[];
}

export interface GetRecordingThumbnailsAnswer {
  /** Signed URLs, evenly spaced over the recording, oldest first. */
  urls: string[];
}

export interface DeleteRecordingAnswer {
  success: boolean;
  errorMessage?: string | undefined;
}

export interface GetSignedUrlAnswer {
  signedUrl: string;
}

/** Who else a ban by IP of banUserUuid would lock out. Reserved to the admins of the world (enforced by the pusher). */
export interface BanIpPreviewQuery {
  banUserUuid: string;
}

/** Someone connected to the world from the same IP address as the user to ban. No IP address, no email. */
export interface BanIpPreviewUser {
  name: string;
}

export interface BanIpPreviewAnswer {
  /** false when the user to ban is not connected any more: their IP is unknown, they cannot be banned by IP */
  ipKnown: boolean;
  /** the moderator shares that IP: they cannot ban it without locking themselves out */
  includesModerator: boolean;
  /** everyone else connected to the world from that IP right now */
  users: BanIpPreviewUser[];
}

export interface Member {
  id: string;
  name?: string | undefined;
  email?: string | undefined;
  visitCardUrl?: string | undefined;
  chatID?: string | undefined;
}

export interface IceServer {
  urls: string[];
  username?: string | undefined;
  credential?: string | undefined;
  credentialType?: string | undefined;
}

export interface IceServersAnswer {
  iceServers: IceServer[];
}

export interface IceServersQuery {
}

export interface ChatMember {
  uuid: string;
  wokaName?: string | undefined;
  email?: string | undefined;
  chatId?: string | undefined;
  tags: string[];
}

export interface Recording {
  timestamp: string;
  baseFilename: string;
  videoFile:
    | VideoFile
    | undefined;
  /**
   * Signed URL of the thumbnail shown in the list, empty if the recording has none.
   * The other thumbnails are fetched on demand, see GetRecordingThumbnailsQuery.
   */
  posterUrl: string;
}

export interface VideoFile {
  key: string;
  filename: string;
  size?: number | undefined;
}

export interface SpaceQueryMessage {
  id: number;
  spaceName: string;
  query:
    | { $case: "addSpaceUserQuery"; addSpaceUserQuery: AddSpaceUserQuery }
    | { $case: "removeSpaceUserQuery"; removeSpaceUserQuery: RemoveSpaceUserQuery }
    | { $case: "spaceStateQuery"; spaceStateQuery: SpaceStateQueryPusherToBack }
    | undefined;
}

export interface AddSpaceUserQuery {
  spaceName: string;
  user: SpaceUser | undefined;
  filterType: FilterType;
}

export interface RemoveSpaceUserQuery {
  spaceName: string;
  spaceUserId: string;
}

/**
 * The typed, server-owned state of a space (raised hands, floor holders, recording, proximity polls and Q&A).
 * Clients never write it: they send a SpaceStateQuery, the back applies it to its SpaceState and broadcasts the
 * change as a JSON Patch (SpaceStatePatchMessage). The shape of the state lives in @workadventure/shared-utils.
 */
export interface SpaceStateQuery {
  query:
    | { $case: "raiseHand"; raiseHand: RaiseHandQuery }
    | { $case: "lowerHand"; lowerHand: LowerHandQuery }
    | { $case: "giveFloor"; giveFloor: GiveFloorQuery }
    | { $case: "revokeFloor"; revokeFloor: RevokeFloorQuery }
    | { $case: "startRecording"; startRecording: StartRecordingQuery }
    | { $case: "stopRecording"; stopRecording: StopRecordingQuery }
    | { $case: "createPoll"; createPoll: CreatePollQuery }
    | { $case: "votePoll"; votePoll: VotePollQuery }
    | { $case: "closePoll"; closePoll: ClosePollQuery }
    | { $case: "deletePoll"; deletePoll: DeletePollQuery }
    | { $case: "askQuestion"; askQuestion: AskQuestionQuery }
    | { $case: "upvoteQuestion"; upvoteQuestion: UpvoteQuestionQuery }
    | { $case: "answerQuestion"; answerQuestion: AnswerQuestionQuery }
    | { $case: "deleteQuestion"; deleteQuestion: DeleteQuestionQuery }
    | { $case: "setKind"; setKind: SetSpaceKindQuery }
    | undefined;
}

/** Declares what the space is (see spaceKindSchema). Sent by every client joining a space it knows the kind of. */
export interface SetSpaceKindQuery {
  kind: string;
}

/** Raises or lowers the sender's own hand. */
export interface RaiseHandQuery {
  raised: boolean;
}

/** Moderator only: lowers someone else's hand. */
export interface LowerHandQuery {
  targetSpaceUserId: string;
}

/** Moderator only: gives the floor to a user (lowers their hand at the same time). */
export interface GiveFloorQuery {
  targetSpaceUserId: string;
}

/** Moderator only: takes the floor back. A floor holder may also revoke their own floor. */
export interface RevokeFloorQuery {
  targetSpaceUserId: string;
}

export interface StartRecordingQuery {
}

export interface StopRecordingQuery {
}

export interface CreatePollQuery {
  question: string;
  /** "open" or "closed" */
  kind: string;
  answers: string[];
  maxSelections: number;
}

export interface VotePollQuery {
  pollId: string;
  answerIds: string[];
}

export interface ClosePollQuery {
  pollId: string;
  closingMessage?: string | undefined;
}

export interface DeletePollQuery {
  pollId: string;
}

export interface AskQuestionQuery {
  body: string;
}

export interface UpvoteQuestionQuery {
  questionId: string;
  upvoted: boolean;
}

export interface AnswerQuestionQuery {
  questionId: string;
}

export interface DeleteQuestionQuery {
  questionId: string;
}

export interface SpaceStateQueryFrontToPusher {
  spaceName: string;
  query: SpaceStateQuery | undefined;
}

export interface SpaceStateQueryPusherToBack {
  spaceUserId: string;
  query: SpaceStateQuery | undefined;
}

export interface SpaceStateAnswer {
}

/** A JSON Patch (RFC 6902, serialized as JSON) to apply to the SpaceState of the space. */
export interface SpaceStatePatchMessage {
  spaceName: string;
  patch: string;
}

export interface SpaceAnswerMessage {
  id: number;
  spaceName: string;
  answer:
    | { $case: "error"; error: ErrorMessage }
    | { $case: "addSpaceUserAnswer"; addSpaceUserAnswer: AddSpaceUserAnswer }
    | { $case: "removeSpaceUserAnswer"; removeSpaceUserAnswer: RemoveSpaceUserAnswer }
    | { $case: "joinSpaceAnswer"; joinSpaceAnswer: JoinSpaceAnswer }
    | { $case: "leaveSpaceAnswer"; leaveSpaceAnswer: LeaveSpaceAnswer }
    | { $case: "spaceStateAnswer"; spaceStateAnswer: SpaceStateAnswer }
    | undefined;
}

export interface AddSpaceUserAnswer {
  spaceName: string;
  spaceUserId: string;
}

export interface RemoveSpaceUserAnswer {
  spaceName: string;
  spaceUserId: string;
}

export interface HandleRecordingWebhookRequest {
  spaceName: string;
  eventId: string;
  recordingSessionId: string;
  egressId: string;
  roomName: string;
  phase: RecordingWebhookPhase;
  status: string;
  error: string;
  createdAt: number;
  /** Milliseconds since the epoch, 0 when LiveKit did not report them. */
  startedAtMs: number;
  endedAtMs: number;
  /** The files LiveKit wrote for this egress (empty until the egress ended). */
  fileResults: RecordingFileResult[];
}

export interface RecordingFileResult {
  /** Object key in the recording bucket, as LiveKit reports it. */
  filename: string;
  sizeBytes: number;
  durationMs: number;
}

export interface HandleLivekitWebhookRequest {
  spaceName: string;
  recordingSessionId: string;
  rawBody: Uint8Array;
  authorizationHeader: string;
}

export interface UserMovedMessage {
  userId: number;
  position: PositionMessage | undefined;
}

export interface MoveToPositionMessage {
  position: PositionMessage | undefined;
}

export interface LocatePositionMessage {
  position: PositionMessage | undefined;
  userId: number;
  userUuid: string;
}

export interface SubMessage {
  message:
    | { $case: "userMovedMessage"; userMovedMessage: UserMovedMessage }
    | { $case: "groupUpdateMessage"; groupUpdateMessage: GroupUpdateMessage }
    | { $case: "groupDeleteMessage"; groupDeleteMessage: GroupDeleteMessage }
    | { $case: "userJoinedMessage"; userJoinedMessage: UserJoinedMessage }
    | { $case: "userLeftMessage"; userLeftMessage: UserLeftMessage }
    | { $case: "itemEventMessage"; itemEventMessage: ItemEventMessage }
    | { $case: "emoteEventMessage"; emoteEventMessage: EmoteEventMessage }
    | { $case: "variableMessage"; variableMessage: VariableMessage }
    | { $case: "errorMessage"; errorMessage: ErrorMessage }
    | { $case: "playerDetailsUpdatedMessage"; playerDetailsUpdatedMessage: PlayerDetailsUpdatedMessage }
    | { $case: "pingMessage"; pingMessage: PingMessage }
    | { $case: "editMapCommandMessage"; editMapCommandMessage: EditMapCommandMessage }
    | { $case: "addSpaceUserMessage"; addSpaceUserMessage: AddSpaceUserMessage }
    | { $case: "updateSpaceUserMessage"; updateSpaceUserMessage: UpdateSpaceUserPusherToFrontMessage }
    | { $case: "removeSpaceUserMessage"; removeSpaceUserMessage: RemoveSpaceUserPusherToFrontMessage }
    | { $case: "receivedEventMessage"; receivedEventMessage: ReceivedEventMessage }
    | { $case: "updateSpaceMetadataMessage"; updateSpaceMetadataMessage: UpdateSpaceMetadataMessage }
    | { $case: "groupUsersUpdateMessage"; groupUsersUpdateMessage: GroupUsersUpdateMessage }
    | //
    /** FIXME: remove all this */
    { $case: "kickOffMessage"; kickOffMessage: KickOffMessage }
    | { $case: "publicEvent"; publicEvent: PublicEvent }
    | { $case: "privateEvent"; privateEvent: PrivateEventPusherToFront }
    | { $case: "spaceDestroyedMessage"; spaceDestroyedMessage: SpaceDestroyedMessage }
    | { $case: "initSpaceUsersMessage"; initSpaceUsersMessage: InitSpaceUsersMessage }
    | { $case: "areaPropertyVariableMessage"; areaPropertyVariableMessage: AreaPropertyVariableMessage }
    | { $case: "duplicateUserConnectedMessage"; duplicateUserConnectedMessage: DuplicateUserConnectedMessage }
    | { $case: "entityMessage"; entityMessage: EntityMessage }
    | { $case: "spaceStatePatchMessage"; spaceStatePatchMessage: SpaceStatePatchMessage }
    | undefined;
}

export interface BatchMessage {
  /** FIXME: event seems to be useless */
  event: string;
  payload: SubMessage[];
}

export interface GroupUpdateMessage {
  groupId: number;
  position: PointMessage | undefined;
  groupSize: number | undefined;
  locked: boolean | undefined;
  userIds: number[];
}

export interface GroupDeleteMessage {
  groupId: number;
}

export interface UserJoinedMessage {
  userId: number;
  name: string;
  characterTextures: CharacterTextureMessage[];
  position: PositionMessage | undefined;
  companionTexture: CompanionTextureMessage | undefined;
  visitCardUrl: string;
  userUuid: string;
  outlineColor: number;
  hasOutline: boolean;
  availabilityStatus: AvailabilityStatus;
  variables: { [key: string]: string };
  chatID?: string | undefined;
  sayMessage: SayMessage | undefined;
}

export interface UserJoinedMessage_VariablesEntry {
  key: string;
  value: string;
}

export interface UserLeftMessage {
  userId: number;
}

/** ErrorMessage is only used to console.error the message in the front */
export interface ErrorMessage {
  message: string;
}

/** ErrorScreenMessage is used to show the ErrorScreen in the front */
export interface ErrorScreenMessage {
  type: string;
  code: string | undefined;
  title: string | undefined;
  subtitle: string | undefined;
  details: string | undefined;
  timeToRetry: number | undefined;
  canRetryManual: boolean | undefined;
  urlToRedirect: string | undefined;
  buttonTitle: string | undefined;
  image: string | undefined;
  imageLogo: string | undefined;
}

export interface ItemStateMessage {
  itemId: number;
  stateJson: string;
}

export interface GroupUsersUpdateMessage {
  groupId: number;
  userIds: number[];
}

export interface RoomConnectedMessage {
  editMapCommandsArrayMessage: EditMapCommandsArrayMessage | undefined;
  tag: string[];
}

export interface RoomJoinedMessage {
  /**
   * repeated UserJoinedMessage user = 1;
   * repeated GroupUpdateMessage group = 2;
   */
  item: ItemStateMessage[];
  currentUserId: number;
  variable: VariableMessage[];
  userRoomToken: string;
  /** We send the current skin of the current player. */
  characterTextures: CharacterTextureMessage[];
  activatedInviteUser: boolean;
  playerVariable: VariableMessage[];
  applications: ApplicationMessage[];
  canEdit: boolean;
  companionTexture: CompanionTextureMessage | undefined;
  areaPropertyVariable: AreaPropertyVariableMessage[];
}

export interface WebRtcStartMessage {
  userId: string;
  initiator: boolean;
  connectionId: string;
}

export interface MeetingConnectionRestartMessage {
  /**
   * Optional. Present for WebRTC reconnections to specify which peer to reconnect with.
   * Absent for LiveKit reconnections, where no specific peer is targeted.
   */
  userId?:
    | string
    | undefined;
  /**
   * Optional for backward compatibility during rolling deployments.
   * Once all clients send it, this can become required in the next protocol version.
   */
  connectionId?: string | undefined;
}

export interface WebRtcDisconnectMessage {
  userId: string;
}

export interface TeleportMessageMessage {
  map: string;
}

export interface SendUserMessage {
  type: string;
  message: string;
}

export interface WorldFullWarningMessage {
}

export interface WorldFullWarningToRoomMessage {
  roomId: string;
}

export interface RefreshRoomPromptMessage {
  roomId: string;
}

export interface RefreshRoomMessage {
  roomId: string;
  versionNumber: number;
  timeToRefresh?: number | undefined;
}

export interface DeleteMapMessage {
}

export interface TokenExpiredMessage {
}

export interface InvalidCharacterTextureMessage {
  message: string;
}

export interface InvalidCompanionTextureMessage {
  message: string;
}

export interface WorldConnectionMessage {
  message: string;
}

export interface BanUserMessage {
  type: string;
  message: string;
}

export interface AskPositionMessage {
  userIdentifier: string;
  playUri: string;
  askType: AskPositionMessage_AskType;
  userId?: number | undefined;
}

export enum AskPositionMessage_AskType {
  MOVE = 0,
  LOCATE = 1,
  UNRECOGNIZED = -1,
}

export function askPositionMessage_AskTypeFromJSON(object: any): AskPositionMessage_AskType {
  switch (object) {
    case 0:
    case "MOVE":
      return AskPositionMessage_AskType.MOVE;
    case 1:
    case "LOCATE":
      return AskPositionMessage_AskType.LOCATE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AskPositionMessage_AskType.UNRECOGNIZED;
  }
}

export function askPositionMessage_AskTypeToJSON(object: AskPositionMessage_AskType): string {
  switch (object) {
    case AskPositionMessage_AskType.MOVE:
      return "MOVE";
    case AskPositionMessage_AskType.LOCATE:
      return "LOCATE";
    case AskPositionMessage_AskType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Sent by a user in a meeting to invite another user (by uuid) to join. */
export interface MeetingInvitationRequestMessage {
  receiverUserUuid: string;
  receiverUserId?: number | undefined;
}

/** Sent by the server to the invitee with sender info (accept/decline popup, and to walk to sender on accept). */
export interface MeetingInvitationRequestReceivedMessage {
  senderUserUuid: string;
  senderPlayUri: string;
  senderName: string;
  senderUserId?: number | undefined;
}

/** Sent by the invitee to accept or decline the invitation. */
export interface MeetingInvitationResponseMessage {
  accept: boolean;
  requestSenderUserUuid: string;
}

/** Sent by the server to the requester when the invitee has accepted or declined. */
export interface MeetingInvitationResponseReceivedMessage {
  accepted: boolean;
  responderName: string;
}

/** Send by the server to show invitation request limitation. */
export interface MeetingInvitationRequestTooHighMessage {
}

/** Send a close request message when the user accepts or declines the invitation to clear the invitation if there are multiple users with the same account connected */
export interface MeetingInvitationRequestClosedMessage {
}

/** A request sent within a space to mute the audio of a specific user */
export interface MuteAudioPrivateMessage {
  /** The "force" field is filled by the pusher server if the user is an admin */
  force: boolean;
}

/** A request sent within a space to mute the video of a specific user */
export interface MuteVideoPrivateMessage {
  /** The "force" field is filled by the pusher server if the user is an admin */
  force: boolean;
}

export interface MuteAudioForEverybodyPublicMessage {
}

export interface MuteVideoForEverybodyPublicMessage {
}

export interface KickOffUserPrivateMessage {
}

export interface RecordingUnexpectedlyStoppedPrivateMessage {
}

export interface PublicEventFrontToPusher {
  spaceName: string;
  spaceEvent: SpaceEvent | undefined;
}

export interface BackEventFrontToPusherMessage {
  spaceName: string;
  backEvent: BackEvent | undefined;
}

export interface PublicEvent {
  spaceName: string;
  spaceEvent: SpaceEvent | undefined;
  senderUserId: string;
}

export interface SpaceEvent {
  event:
    | { $case: "spaceMessage"; spaceMessage: SpaceMessage }
    | { $case: "spaceIsTyping"; spaceIsTyping: SpaceIsTyping }
    | { $case: "muteAudioForEverybody"; muteAudioForEverybody: MuteAudioForEverybodyPublicMessage }
    | { $case: "muteVideoForEverybody"; muteVideoForEverybody: MuteVideoForEverybodyPublicMessage }
    | undefined;
}

export interface PrivateSpaceEvent {
  event:
    | { $case: "muteVideo"; muteVideo: MuteVideoPrivateMessage }
    | { $case: "muteAudio"; muteAudio: MuteAudioPrivateMessage }
    | { $case: "kickOffUser"; kickOffUser: KickOffUserPrivateMessage }
    | { $case: "webRtcStartMessage"; webRtcStartMessage: WebRtcStartMessage }
    | { $case: "webRtcSignal"; webRtcSignal: WebRtcSignal }
    | { $case: "webRtcScreenSharingSignal"; webRtcScreenSharingSignal: WebRtcSignal }
    | { $case: "webRtcDisconnectMessage"; webRtcDisconnectMessage: WebRtcDisconnectMessage }
    | { $case: "communicationStrategyMessage"; communicationStrategyMessage: CommunicationStrategyMessage }
    | { $case: "switchMessage"; switchMessage: SwitchMessage }
    | { $case: "finalizeSwitchMessage"; finalizeSwitchMessage: FinalizeSwitchMessage }
    | { $case: "livekitInvitationMessage"; livekitInvitationMessage: LivekitInvitationMessage }
    | { $case: "livekitDisconnectMessage"; livekitDisconnectMessage: LivekitDisconnectMessage }
    | { $case: "addSpaceUserMessage"; addSpaceUserMessage: AddSpaceUserMessage }
    | { $case: "updateSpaceUserMessage"; updateSpaceUserMessage: UpdateSpaceUserMessage }
    | { $case: "removeSpaceUserMessage"; removeSpaceUserMessage: RemoveSpaceUserMessage }
    | { $case: "blockUserMessage"; blockUserMessage: BlockUserMessage }
    | { $case: "unblockUserMessage"; unblockUserMessage: UnblockUserMessage }
    | { $case: "meetingConnectionRestartMessage"; meetingConnectionRestartMessage: MeetingConnectionRestartMessage }
    | {
      $case: "recordingUnexpectedlyStoppedMessage";
      recordingUnexpectedlyStoppedMessage: RecordingUnexpectedlyStoppedPrivateMessage;
    }
    | undefined;
}

export interface CommunicationStrategyMessage {
  strategy: string;
}

export interface SwitchMessage {
  strategy: string;
}

export interface FinalizeSwitchMessage {
  strategy: string;
}

export interface BlockUserMessage {
}

export interface UnblockUserMessage {
}

export interface LivekitInvitationMessage {
  token: string;
  serverUrl: string;
}

export interface LivekitDisconnectMessage {
}

export interface SpaceMessage {
  message: string;
  characterTextures: CharacterTextureMessage[];
  name?: string | undefined;
}

export interface SpaceIsTyping {
  isTyping: boolean;
  characterTextures: CharacterTextureMessage[];
  name?: string | undefined;
}

export interface BackEventMessage {
  spaceName: string;
  senderUserId: string;
  backEvent: BackEvent | undefined;
}

export interface BackEvent {
  event:
    | { $case: "meetingConnectionRestartMessage"; meetingConnectionRestartMessage: MeetingConnectionRestartMessage }
    | undefined;
}

export interface PrivateEvent {
  spaceName: string;
  receiverUserId: string;
  senderUserId: string;
  spaceEvent: PrivateSpaceEvent | undefined;
}

export interface PrivateEventBackToPusher {
  spaceName: string;
  receiverUserId: string;
  sender: SpaceUser | undefined;
  spaceEvent: PrivateSpaceEvent | undefined;
}

export interface PrivateEventPusherToFront {
  spaceName: string;
  receiverUserId: string;
  sender: SpaceUser | undefined;
  spaceEvent: PrivateSpaceEvent | undefined;
}

export interface PrivateEventFrontToPusher {
  spaceName: string;
  receiverUserId: string;
  spaceEvent: PrivateSpaceEvent | undefined;
}

/** Messages going from server to the client to ask the client to join a space */
export interface JoinSpaceRequestMessage {
  spaceName: string;
  propertiesToSync: string[];
}

/** Messages going from server to the client to ask the client to leave a space */
export interface LeaveSpaceRequestMessage {
  spaceName: string;
}

/**
 * Sent to the client when the same user is already connected in this room (duplicate connection).
 * The client should show a popup and offer to close the page.
 */
export interface DuplicateUserConnectedMessage {
}

/**
 * Internal message sent by the back to the pusher just before closing the
 * joinRoom stream. The pusher must consume it and never forward it to the
 * front.
 */
export interface BackConnectionCloseReasonMessage {
  reason: string;
}

/** Messages going from back and pusher to the front */
export interface ServerToClientMessage {
  message:
    | { $case: "batchMessage"; batchMessage: BatchMessage }
    | { $case: "errorMessage"; errorMessage: ErrorMessage }
    | { $case: "roomConnectedMessage"; roomConnectedMessage: RoomConnectedMessage }
    | { $case: "roomJoinedMessage"; roomJoinedMessage: RoomJoinedMessage }
    | { $case: "teleportMessageMessage"; teleportMessageMessage: TeleportMessageMessage }
    | { $case: "sendUserMessage"; sendUserMessage: SendUserMessage }
    | { $case: "banUserMessage"; banUserMessage: BanUserMessage }
    | //
    /** AdminRoomMessage adminRoomMessage = 14; */
    { $case: "worldFullWarningMessage"; worldFullWarningMessage: WorldFullWarningMessage }
    | { $case: "refreshRoomMessage"; refreshRoomMessage: RefreshRoomMessage }
    | { $case: "worldConnectionMessage"; worldConnectionMessage: WorldConnectionMessage }
    | //
    /** EmoteEventMessage emoteEventMessage = 19; */
    { $case: "tokenExpiredMessage"; tokenExpiredMessage: TokenExpiredMessage }
    | { $case: "followRequestMessage"; followRequestMessage: FollowRequestMessage }
    | { $case: "followConfirmationMessage"; followConfirmationMessage: FollowConfirmationMessage }
    | { $case: "followAbortMessage"; followAbortMessage: FollowAbortMessage }
    | { $case: "invalidCharacterTextureMessage"; invalidCharacterTextureMessage: InvalidCharacterTextureMessage }
    | { $case: "deleteMapMessage"; deleteMapMessage: DeleteMapMessage }
    | { $case: "errorScreenMessage"; errorScreenMessage: ErrorScreenMessage }
    | { $case: "answerMessage"; answerMessage: AnswerMessage }
    | { $case: "moveToPositionMessage"; moveToPositionMessage: MoveToPositionMessage }
    | { $case: "invalidCompanionTextureMessage"; invalidCompanionTextureMessage: InvalidCompanionTextureMessage }
    | { $case: "joinSpaceRequestMessage"; joinSpaceRequestMessage: JoinSpaceRequestMessage }
    | { $case: "leaveSpaceRequestMessage"; leaveSpaceRequestMessage: LeaveSpaceRequestMessage }
    | { $case: "externalModuleMessage"; externalModuleMessage: ExternalModuleMessage }
    | { $case: "locatePositionMessage"; locatePositionMessage: LocatePositionMessage }
    | {
      $case: "meetingInvitationRequestReceivedMessage";
      meetingInvitationRequestReceivedMessage: MeetingInvitationRequestReceivedMessage;
    }
    | {
      $case: "meetingInvitationResponseReceivedMessage";
      meetingInvitationResponseReceivedMessage: MeetingInvitationResponseReceivedMessage;
    }
    | {
      $case: "meetingInvitationRequestTooHighMessage";
      meetingInvitationRequestTooHighMessage: MeetingInvitationRequestTooHighMessage;
    }
    | {
      $case: "meetingInvitationRequestClosedMessage";
      meetingInvitationRequestClosedMessage: MeetingInvitationRequestClosedMessage;
    }
    | { $case: "duplicateUserConnectedMessage"; duplicateUserConnectedMessage: DuplicateUserConnectedMessage }
    | { $case: "backConnectionCloseReasonMessage"; backConnectionCloseReasonMessage: BackConnectionCloseReasonMessage }
    | undefined;
}

/** Message sent from the pusher to the back when a user connects to a room, before joining it */
export interface ConnectToRoomMessage {
  roomId: string;
  lastCommandId: string | undefined;
  tag: string[];
}

/** Message sent by the client to the pusher when joining a room */
export interface JoinRoomFrontMessage {
  positionMessage: PositionMessage | undefined;
  viewportMessage: ViewportMessage | undefined;
  name: string;
  availabilityStatus: AvailabilityStatus;
}

/** Message sent by the pusher to the back when a user joins a room */
export interface JoinRoomMessage {
  positionMessage: PositionMessage | undefined;
  name: string;
  characterTextures: CharacterTextureMessage[];
  userUuid: string;
  tag: string[];
  IPAddress: string;
  companionTexture: CompanionTextureMessage | undefined;
  visitCardUrl: string | undefined;
  userRoomToken: string;
  availabilityStatus: AvailabilityStatus;
  activatedInviteUser: boolean;
  isLogged: boolean;
  applications: ApplicationMessage[];
  canEdit: boolean;
  chatID:
    | string
    | undefined;
  /**
   * Unique identifier for the browser tab, used to detect reconnections from the same tab
   * and kill stale connections immediately instead of waiting for ping timeout
   * TODO : remove the optional when the tabId is always present in the query string (next version of the app )
   */
  tabId?: string | undefined;
}

export interface UserJoinedZoneMessage {
  userId: number;
  name: string;
  characterTextures: CharacterTextureMessage[];
  position: PositionMessage | undefined;
  fromZone: Zone | undefined;
  companionTexture: CompanionTextureMessage | undefined;
  visitCardUrl: string;
  userUuid: string;
  outlineColor: number;
  hasOutline: boolean;
  availabilityStatus: AvailabilityStatus;
  variables: { [key: string]: string };
  chatID?: string | undefined;
  sayMessage: SayMessage | undefined;
}

export interface UserJoinedZoneMessage_VariablesEntry {
  key: string;
  value: string;
}

export interface UserLeftZoneMessage {
  userId: number;
  toZone: Zone | undefined;
}

export interface GroupUpdateZoneMessage {
  groupId: number;
  position: PointMessage | undefined;
  groupSize: number;
  fromZone: Zone | undefined;
  locked: boolean;
  userIds: number[];
}

export interface GroupLeftZoneMessage {
  groupId: number;
  toZone: Zone | undefined;
}

export interface PlayerDetailsUpdatedMessage {
  userId: number;
  details: SetPlayerDetailsMessage | undefined;
}

export interface Zone {
  x: number;
  y: number;
}

export interface SubscribeZoneMessage {
  x: number;
  y: number;
}

export interface UnsubscribeZoneMessage {
  x: number;
  y: number;
}

export interface RoomMessage {
  roomId: string;
}

export interface PusherToBackRoomMessage {
  message:
    | { $case: "initRoomMessage"; initRoomMessage: InitRoomMessage }
    | { $case: "subscribeZoneMessage"; subscribeZoneMessage: SubscribeZoneMessage }
    | { $case: "unsubscribeZoneMessage"; unsubscribeZoneMessage: UnsubscribeZoneMessage }
    | undefined;
}

export interface InitRoomMessage {
  roomId: string;
}

export interface PusherToBackMessage {
  message:
    | { $case: "connectToRoomMessage"; connectToRoomMessage: ConnectToRoomMessage }
    | { $case: "joinRoomMessage"; joinRoomMessage: JoinRoomMessage }
    | { $case: "userMovesMessage"; userMovesMessage: UserMovesMessage }
    | { $case: "itemEventMessage"; itemEventMessage: ItemEventMessage }
    | { $case: "setPlayerDetailsMessage"; setPlayerDetailsMessage: SetPlayerDetailsMessage }
    | { $case: "emotePromptMessage"; emotePromptMessage: EmotePromptMessage }
    | { $case: "variableMessage"; variableMessage: VariableMessage }
    | { $case: "followRequestMessage"; followRequestMessage: FollowRequestMessage }
    | { $case: "followConfirmationMessage"; followConfirmationMessage: FollowConfirmationMessage }
    | { $case: "followAbortMessage"; followAbortMessage: FollowAbortMessage }
    | { $case: "lockGroupPromptMessage"; lockGroupPromptMessage: LockGroupPromptMessage }
    | { $case: "queryMessage"; queryMessage: QueryMessage }
    | { $case: "abortQueryMessage"; abortQueryMessage: AbortQueryMessage }
    | { $case: "askPositionMessage"; askPositionMessage: AskPositionMessage }
    | { $case: "editMapCommandMessage"; editMapCommandMessage: EditMapCommandMessage }
    | { $case: "pingMessage"; pingMessage: PingMessage }
    | { $case: "publicEvent"; publicEvent: PublicEvent }
    | { $case: "privateEvent"; privateEvent: PrivateEvent }
    | { $case: "meetingInvitationRequestMessage"; meetingInvitationRequestMessage: MeetingInvitationRequestMessage }
    | { $case: "meetingInvitationResponseMessage"; meetingInvitationResponseMessage: MeetingInvitationResponseMessage }
    | { $case: "setAreaPropertyVariableMessage"; setAreaPropertyVariableMessage: SetAreaPropertyVariableMessage }
    | { $case: "entityMessage"; entityMessage: EntityMessage }
    | undefined;
}

export interface BatchToPusherRoomMessage {
  payload: SubToPusherRoomMessage[];
}

export interface SubToPusherRoomMessage {
  message:
    | //
    /** Room-wide messages */
    { $case: "variableMessage"; variableMessage: VariableWithTagMessage }
    | { $case: "errorMessage"; errorMessage: ErrorMessage }
    | { $case: "editMapCommandMessage"; editMapCommandMessage: EditMapCommandMessage }
    | { $case: "receivedEventMessage"; receivedEventMessage: ReceivedEventMessage }
    | { $case: "entityMessage"; entityMessage: EntityMessage }
    | //
    /** Zone-specific messages (all grouped in ZoneMessage) */
    { $case: "zoneMessage"; zoneMessage: ZoneMessage }
    | { $case: "areaPropertyVariableMessage"; areaPropertyVariableMessage: AreaPropertyVariableMessage }
    | undefined;
}

export interface UserJoinedRoomMessage {
  uuid: string;
  ipAddress: string;
  name: string;
}

export interface UserLeftRoomMessage {
  uuid: string;
}

export interface ServerToAdminClientMessage {
  message:
    | { $case: "userJoinedRoom"; userJoinedRoom: UserJoinedRoomMessage }
    | { $case: "userLeftRoom"; userLeftRoom: UserLeftRoomMessage }
    | { $case: "errorMessage"; errorMessage: ErrorMessage }
    | undefined;
}

export interface AdminPusherToBackMessage {
  message:
    | //
    /** TODO ban, unban */
    { $case: "subscribeToRoom"; subscribeToRoom: string }
    | undefined;
}

export interface MapStorageRefreshMessage {
  comment: string;
}

export interface MapStorageToBackMessage {
  message: { $case: "mapStorageRefreshMessage"; mapStorageRefreshMessage: MapStorageRefreshMessage } | undefined;
}

export interface MapStorageUrlMessage {
  mapUrl: string;
  roomId: string;
}

export interface MapStorageClearAfterUploadMessage {
  wamUrl: string;
}

export interface MapStorageDeleteMessage {
  wamUrl: string;
}

/** A message sent by an administrator to everyone in a specific room */
export interface AdminRoomMessage {
  message: string;
  roomId: string;
  type: string;
}

/** A message sent by an administrator to absolutely everybody */
export interface AdminGlobalMessage {
  message: string;
}

export interface BanMessage {
  recipientUuid: string;
  roomId: string;
  type: string;
  message: string;
}

export interface RoomDescription {
  roomId: string;
  nbUsers: number;
}

export interface RoomsList {
  roomDescription: RoomDescription[];
}

export interface WorldUsersQuery {
  /** The world URL the admin returns for the user. A room belongs to the world when its URL starts with it. */
  world: string;
}

/** A user connected to a room of the world. Carries their IP address: never forward it to a game client. */
export interface WorldUser {
  uuid: string;
  name: string;
  ipAddress: string;
  roomUrl: string;
}

export interface WorldUsersAnswer {
  users: WorldUser[];
}

export interface DispatchGlobalEventRequest {
  name: string;
  /** Defined by whoever posts the global event; delivered to the map scripts untouched. */
  value: any | undefined;
}

export interface ExternalModuleMessage {
  moduleId: string;
  /**
   * Optional on the wire, required in practice: the back drops the message and logs
   * "isn't implemented yet" if either recipientUuid or roomId is missing. Sending to a whole room, or
   * to a user across rooms, is not built yet.
   */
  recipientUuid?: string | undefined;
  roomId?:
    | string
    | undefined;
  /** Defined by the external module; the back only routes it. */
  message: any | undefined;
}

/**
 * ******************************************************************************
 * Start Spaces messages
 * ******************************************************************************
 */
export interface PusherToBackSpaceMessage {
  message:
    | { $case: "joinSpaceMessage"; joinSpaceMessage: JoinSpaceMessage }
    | { $case: "leaveSpaceMessage"; leaveSpaceMessage: LeaveSpaceMessage }
    | { $case: "updateSpaceUserMessage"; updateSpaceUserMessage: UpdateSpaceUserMessage }
    | { $case: "pongMessage"; pongMessage: PingMessage }
    | {
      $case: "updateSpaceMetadataPusherToBackMessage";
      updateSpaceMetadataPusherToBackMessage: UpdateSpaceMetadataPusherToBackMessage;
    }
    | //
    /** FIXME: the kick of message should be global to the room (unless we apply it on the world space???) */
    { $case: "kickOffMessage"; kickOffMessage: KickOffMessage }
    | { $case: "publicEvent"; publicEvent: PublicEvent }
    | { $case: "privateEvent"; privateEvent: PrivateEvent }
    | { $case: "syncSpaceUsersMessage"; syncSpaceUsersMessage: SyncSpaceUsersMessage }
    | { $case: "spaceQueryMessage"; spaceQueryMessage: SpaceQueryMessage }
    | { $case: "addSpaceUserToNotifyMessage"; addSpaceUserToNotifyMessage: AddSpaceUserToNotifyMessage }
    | { $case: "deleteSpaceUserToNotifyMessage"; deleteSpaceUserToNotifyMessage: DeleteSpaceUserToNotifyMessage }
    | { $case: "backEvent"; backEvent: BackEventMessage }
    | undefined;
}

export interface BackToPusherSpaceMessage {
  message:
    | { $case: "addSpaceUserMessage"; addSpaceUserMessage: AddSpaceUserMessage }
    | { $case: "updateSpaceUserMessage"; updateSpaceUserMessage: UpdateSpaceUserMessage }
    | { $case: "removeSpaceUserMessage"; removeSpaceUserMessage: RemoveSpaceUserMessage }
    | { $case: "pingMessage"; pingMessage: PingMessage }
    | { $case: "updateSpaceMetadataMessage"; updateSpaceMetadataMessage: UpdateSpaceMetadataMessage }
    | //
    /** FIXME: the kick of message should be global to the room (unless we apply it on the world space???) */
    { $case: "kickOffMessage"; kickOffMessage: KickOffMessage }
    | { $case: "publicEvent"; publicEvent: PublicEvent }
    | { $case: "privateEvent"; privateEvent: PrivateEventBackToPusher }
    | { $case: "spaceAnswerMessage"; spaceAnswerMessage: SpaceAnswerMessage }
    | { $case: "initSpaceUsersMessage"; initSpaceUsersMessage: InitSpaceUsersMessage }
    | { $case: "spaceStatePatchMessage"; spaceStatePatchMessage: SpaceStatePatchMessage }
    | undefined;
}

/** Message sent by the user to join a space as a participant. */
export interface JoinSpaceMessage {
  spaceName: string;
  propertiesToSync: string[];
  filterType: FilterType;
  world: string;
}

export interface LeaveSpaceMessage {
  spaceName: string;
}

export interface SpaceUser {
  /** used */
  spaceUserId: string;
  /** used */
  name: string;
  playUri: string;
  /** TO DELETE */
  color: string;
  characterTextures: CharacterTextureMessage[];
  isLogged: boolean;
  availabilityStatus: number;
  roomName: string | undefined;
  visitCardUrl: string | undefined;
  tags: string[];
  /** used */
  cameraState: boolean;
  /** used */
  microphoneState: boolean;
  /** used */
  screenSharingState: boolean;
  /** used */
  megaphoneState: boolean;
  /** used */
  jitsiParticipantId:
    | string
    | undefined;
  /** used */
  uuid: string;
  /** used */
  chatID: string | undefined;
  showVoiceIndicator: boolean;
  attendeesState: boolean;
  /**
   * Raised by a client whose video encoders could not keep up while it encoded for several P2P peers: the back moves
   * the space to LiveKit and keeps it there while such a user is present. Never lowered within a session.
   */
  cpuLimited: boolean;
}

/** Message adding a user to a space (front to pusher, pusher to back-space, back-space to pusher) */
export interface AddSpaceUserMessage {
  spaceName: string;
  user: SpaceUser | undefined;
}

export interface InitSpaceUsersMessage {
  spaceName: string;
  users: SpaceUser[];
  metadata: string;
  /**
   * Back to pusher only: the whole SpaceState, as JSON. Later changes arrive as SpaceStatePatchMessage. The pusher
   * hands the state to a user who joins the space as a patch replacing the root.
   */
  state: string;
}

/** Message updating a user in a space (front to pusher, pusher to back-space, back-space to pusher) */
export interface UpdateSpaceUserMessage {
  spaceName: string;
  user: SpaceUser | undefined;
  updateMask: string[] | undefined;
}

export interface UpdateSpaceUserPusherToFrontMessage {
  spaceName: string;
  user: SpaceUser | undefined;
  updateMask: string[] | undefined;
}

/** Message removing a user from a space (front to pusher, pusher to back-space, back-space to pusher) */
export interface RemoveSpaceUserMessage {
  spaceName: string;
  spaceUserId: string;
}

export interface RemoveSpaceUserPusherToFrontMessage {
  spaceName: string;
  spaceUserId: string;
}

export interface UpdateSpaceMetadataMessage {
  spaceName: string;
  metadata: string;
}

export interface UpdateSpaceMetadataPusherToBackMessage {
  spaceName: string;
  metadata: string;
  senderId: string;
}

/** Message sent by the pusher to the back to sync the space users with the server after a reconnection */
export interface SyncSpaceUsersMessage {
  spaceName: string;
  users: SpaceUser[];
}

/** Message sent by the pusher to the back to add a user to the notify list */
export interface AddSpaceUserToNotifyMessage {
  spaceName: string;
  user: SpaceUser | undefined;
}

/** Message sent by the pusher to the back to delete a user from the notify list */
export interface DeleteSpaceUserToNotifyMessage {
  spaceName: string;
  user: SpaceUser | undefined;
}

/** The space we were listening to has been destroyed for some awful reason (connection to back was lost) */
export interface SpaceDestroyedMessage {
  spaceName: string;
}

export interface KickOffMessage {
  spaceName: string;
  userId: string;
}

/** Filter * */
export interface AddSpaceFilterMessage {
  spaceFilterMessage: SpaceFilterMessage | undefined;
}

export interface RemoveSpaceFilterMessage {
  spaceFilterMessage: SpaceFilterMessage | undefined;
}

export interface SpaceFilterMessage {
  spaceName: string;
}

export interface SpaceFilterContainName {
  value: string;
}

export interface SpaceFilterLiveStreaming {
}

export interface SpaceFilterEverybody {
}

export interface VariableRequest {
  /** Full URL of the room, e.g. "https://play.workadventu.re/@/my-organization/my-world/my-room". */
  room: string;
  /** Name of the variable, as declared by a variable object in the map. */
  name: string;
}

export interface SaveVariableRequest {
  room: string;
  /**
   * Name of the variable. The back fails the call if the map does not declare it: the map is the only
   * place variables can be created.
   */
  name: string;
  /** Any JSON value. Stored serialized; writing the value the variable already holds notifies nobody. */
  value: any | undefined;
}

export interface EventRequest {
  room: string;
  /** Name of the event to listen to. Only events dispatched under this exact name are streamed. */
  name: string;
}

export interface EventResponse {
  data:
    | any
    | undefined;
  /**
   * The id, within the room, of the player who dispatched the event. Absent when it came from the
   * Room API itself.
   */
  senderId?: number | undefined;
}

export interface DispatchEventRequest {
  room: string;
  name: string;
  data:
    | any
    | undefined;
  /**
   * If targetUserIds is empty, the event is broadcast to all users in the room. Otherwise, it targets the users with the given ids.
   * Careful: a targeted event reaches those users' clients only — listenEvent subscribers do not see it.
   */
  targetUserIds: number[];
}

function createBasePositionMessage(): PositionMessage {
  return { x: 0, y: 0, direction: 0, moving: false };
}

export const PositionMessage: MessageFns<PositionMessage> = {
  encode(message: PositionMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(8).int32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(16).int32(message.y);
    }
    if (message.direction !== 0) {
      writer.uint32(24).int32(message.direction);
    }
    if (message.moving !== false) {
      writer.uint32(32).bool(message.moving);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PositionMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePositionMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.x = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.y = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.direction = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.moving = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PositionMessage {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      direction: isSet(object.direction) ? positionMessage_DirectionFromJSON(object.direction) : 0,
      moving: isSet(object.moving) ? globalThis.Boolean(object.moving) : false,
    };
  },

  toJSON(message: PositionMessage): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y);
    }
    if (message.direction !== 0) {
      obj.direction = positionMessage_DirectionToJSON(message.direction);
    }
    if (message.moving !== false) {
      obj.moving = message.moving;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PositionMessage>, I>>(base?: I): PositionMessage {
    return PositionMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PositionMessage>, I>>(object: I): PositionMessage {
    const message = createBasePositionMessage();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.direction = object.direction ?? 0;
    message.moving = object.moving ?? false;
    return message;
  },
};

function createBasePointMessage(): PointMessage {
  return { x: 0, y: 0 };
}

export const PointMessage: MessageFns<PointMessage> = {
  encode(message: PointMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(8).int32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(16).int32(message.y);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PointMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePointMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.x = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.y = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PointMessage {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
    };
  },

  toJSON(message: PointMessage): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PointMessage>, I>>(base?: I): PointMessage {
    return PointMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PointMessage>, I>>(object: I): PointMessage {
    const message = createBasePointMessage();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    return message;
  },
};

function createBaseViewportMessage(): ViewportMessage {
  return { left: 0, top: 0, right: 0, bottom: 0 };
}

export const ViewportMessage: MessageFns<ViewportMessage> = {
  encode(message: ViewportMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.left !== 0) {
      writer.uint32(8).int32(message.left);
    }
    if (message.top !== 0) {
      writer.uint32(16).int32(message.top);
    }
    if (message.right !== 0) {
      writer.uint32(24).int32(message.right);
    }
    if (message.bottom !== 0) {
      writer.uint32(32).int32(message.bottom);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ViewportMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseViewportMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.left = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.top = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.right = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.bottom = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ViewportMessage {
    return {
      left: isSet(object.left) ? globalThis.Number(object.left) : 0,
      top: isSet(object.top) ? globalThis.Number(object.top) : 0,
      right: isSet(object.right) ? globalThis.Number(object.right) : 0,
      bottom: isSet(object.bottom) ? globalThis.Number(object.bottom) : 0,
    };
  },

  toJSON(message: ViewportMessage): unknown {
    const obj: any = {};
    if (message.left !== 0) {
      obj.left = Math.round(message.left);
    }
    if (message.top !== 0) {
      obj.top = Math.round(message.top);
    }
    if (message.right !== 0) {
      obj.right = Math.round(message.right);
    }
    if (message.bottom !== 0) {
      obj.bottom = Math.round(message.bottom);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ViewportMessage>, I>>(base?: I): ViewportMessage {
    return ViewportMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ViewportMessage>, I>>(object: I): ViewportMessage {
    const message = createBaseViewportMessage();
    message.left = object.left ?? 0;
    message.top = object.top ?? 0;
    message.right = object.right ?? 0;
    message.bottom = object.bottom ?? 0;
    return message;
  },
};

function createBaseCharacterTextureMessage(): CharacterTextureMessage {
  return { url: "", id: "" };
}

export const CharacterTextureMessage: MessageFns<CharacterTextureMessage> = {
  encode(message: CharacterTextureMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CharacterTextureMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCharacterTextureMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CharacterTextureMessage {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: CharacterTextureMessage): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CharacterTextureMessage>, I>>(base?: I): CharacterTextureMessage {
    return CharacterTextureMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CharacterTextureMessage>, I>>(object: I): CharacterTextureMessage {
    const message = createBaseCharacterTextureMessage();
    message.url = object.url ?? "";
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseApplicationMessage(): ApplicationMessage {
  return {
    name: "",
    script: undefined,
    doc: undefined,
    description: undefined,
    image: undefined,
    enabled: undefined,
    regexUrl: undefined,
    targetUrl: undefined,
    default: undefined,
    forceNewTab: undefined,
    allowAPI: undefined,
    policy: undefined,
    imageLogo: undefined,
  };
}

export const ApplicationMessage: MessageFns<ApplicationMessage> = {
  encode(message: ApplicationMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.script !== undefined) {
      writer.uint32(18).string(message.script);
    }
    if (message.doc !== undefined) {
      writer.uint32(26).string(message.doc);
    }
    if (message.description !== undefined) {
      writer.uint32(34).string(message.description);
    }
    if (message.image !== undefined) {
      writer.uint32(42).string(message.image);
    }
    if (message.enabled !== undefined) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.regexUrl !== undefined) {
      writer.uint32(58).string(message.regexUrl);
    }
    if (message.targetUrl !== undefined) {
      writer.uint32(66).string(message.targetUrl);
    }
    if (message.default !== undefined) {
      writer.uint32(72).bool(message.default);
    }
    if (message.forceNewTab !== undefined) {
      writer.uint32(80).bool(message.forceNewTab);
    }
    if (message.allowAPI !== undefined) {
      writer.uint32(88).bool(message.allowAPI);
    }
    if (message.policy !== undefined) {
      writer.uint32(98).string(message.policy);
    }
    if (message.imageLogo !== undefined) {
      writer.uint32(106).string(message.imageLogo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApplicationMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApplicationMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.script = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.doc = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.image = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.regexUrl = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.targetUrl = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.default = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.forceNewTab = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.allowAPI = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.policy = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.imageLogo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApplicationMessage {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      script: isSet(object.script) ? globalThis.String(object.script) : undefined,
      doc: isSet(object.doc) ? globalThis.String(object.doc) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      image: isSet(object.image) ? globalThis.String(object.image) : undefined,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : undefined,
      regexUrl: isSet(object.regexUrl) ? globalThis.String(object.regexUrl) : undefined,
      targetUrl: isSet(object.targetUrl) ? globalThis.String(object.targetUrl) : undefined,
      default: isSet(object.default) ? globalThis.Boolean(object.default) : undefined,
      forceNewTab: isSet(object.forceNewTab) ? globalThis.Boolean(object.forceNewTab) : undefined,
      allowAPI: isSet(object.allowAPI) ? globalThis.Boolean(object.allowAPI) : undefined,
      policy: isSet(object.policy) ? globalThis.String(object.policy) : undefined,
      imageLogo: isSet(object.imageLogo) ? globalThis.String(object.imageLogo) : undefined,
    };
  },

  toJSON(message: ApplicationMessage): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.script !== undefined) {
      obj.script = message.script;
    }
    if (message.doc !== undefined) {
      obj.doc = message.doc;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.image !== undefined) {
      obj.image = message.image;
    }
    if (message.enabled !== undefined) {
      obj.enabled = message.enabled;
    }
    if (message.regexUrl !== undefined) {
      obj.regexUrl = message.regexUrl;
    }
    if (message.targetUrl !== undefined) {
      obj.targetUrl = message.targetUrl;
    }
    if (message.default !== undefined) {
      obj.default = message.default;
    }
    if (message.forceNewTab !== undefined) {
      obj.forceNewTab = message.forceNewTab;
    }
    if (message.allowAPI !== undefined) {
      obj.allowAPI = message.allowAPI;
    }
    if (message.policy !== undefined) {
      obj.policy = message.policy;
    }
    if (message.imageLogo !== undefined) {
      obj.imageLogo = message.imageLogo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApplicationMessage>, I>>(base?: I): ApplicationMessage {
    return ApplicationMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApplicationMessage>, I>>(object: I): ApplicationMessage {
    const message = createBaseApplicationMessage();
    message.name = object.name ?? "";
    message.script = object.script ?? undefined;
    message.doc = object.doc ?? undefined;
    message.description = object.description ?? undefined;
    message.image = object.image ?? undefined;
    message.enabled = object.enabled ?? undefined;
    message.regexUrl = object.regexUrl ?? undefined;
    message.targetUrl = object.targetUrl ?? undefined;
    message.default = object.default ?? undefined;
    message.forceNewTab = object.forceNewTab ?? undefined;
    message.allowAPI = object.allowAPI ?? undefined;
    message.policy = object.policy ?? undefined;
    message.imageLogo = object.imageLogo ?? undefined;
    return message;
  },
};

function createBaseCompanionTextureMessage(): CompanionTextureMessage {
  return { url: "", id: "" };
}

export const CompanionTextureMessage: MessageFns<CompanionTextureMessage> = {
  encode(message: CompanionTextureMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompanionTextureMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanionTextureMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanionTextureMessage {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: CompanionTextureMessage): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompanionTextureMessage>, I>>(base?: I): CompanionTextureMessage {
    return CompanionTextureMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompanionTextureMessage>, I>>(object: I): CompanionTextureMessage {
    const message = createBaseCompanionTextureMessage();
    message.url = object.url ?? "";
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseZoneMessage(): ZoneMessage {
  return { x: 0, y: 0, message: undefined };
}

export const ZoneMessage: MessageFns<ZoneMessage> = {
  encode(message: ZoneMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(8).int32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(16).int32(message.y);
    }
    switch (message.message?.$case) {
      case "userJoinedZoneMessage":
        UserJoinedZoneMessage.encode(message.message.userJoinedZoneMessage, writer.uint32(26).fork()).join();
        break;
      case "groupUpdateZoneMessage":
        GroupUpdateZoneMessage.encode(message.message.groupUpdateZoneMessage, writer.uint32(34).fork()).join();
        break;
      case "userMovedMessage":
        UserMovedMessage.encode(message.message.userMovedMessage, writer.uint32(42).fork()).join();
        break;
      case "groupLeftZoneMessage":
        GroupLeftZoneMessage.encode(message.message.groupLeftZoneMessage, writer.uint32(50).fork()).join();
        break;
      case "userLeftZoneMessage":
        UserLeftZoneMessage.encode(message.message.userLeftZoneMessage, writer.uint32(58).fork()).join();
        break;
      case "emoteEventMessage":
        EmoteEventMessage.encode(message.message.emoteEventMessage, writer.uint32(90).fork()).join();
        break;
      case "playerDetailsUpdatedMessage":
        PlayerDetailsUpdatedMessage.encode(message.message.playerDetailsUpdatedMessage, writer.uint32(98).fork())
          .join();
        break;
      case "groupUsersUpdateMessage":
        GroupUsersUpdateMessage.encode(message.message.groupUsersUpdateMessage, writer.uint32(106).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ZoneMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseZoneMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.x = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.y = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = {
            $case: "userJoinedZoneMessage",
            userJoinedZoneMessage: UserJoinedZoneMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = {
            $case: "groupUpdateZoneMessage",
            groupUpdateZoneMessage: GroupUpdateZoneMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.message = {
            $case: "userMovedMessage",
            userMovedMessage: UserMovedMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.message = {
            $case: "groupLeftZoneMessage",
            groupLeftZoneMessage: GroupLeftZoneMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.message = {
            $case: "userLeftZoneMessage",
            userLeftZoneMessage: UserLeftZoneMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.message = {
            $case: "emoteEventMessage",
            emoteEventMessage: EmoteEventMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.message = {
            $case: "playerDetailsUpdatedMessage",
            playerDetailsUpdatedMessage: PlayerDetailsUpdatedMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.message = {
            $case: "groupUsersUpdateMessage",
            groupUsersUpdateMessage: GroupUsersUpdateMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ZoneMessage {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      message: isSet(object.userJoinedZoneMessage)
        ? {
          $case: "userJoinedZoneMessage",
          userJoinedZoneMessage: UserJoinedZoneMessage.fromJSON(object.userJoinedZoneMessage),
        }
        : isSet(object.groupUpdateZoneMessage)
        ? {
          $case: "groupUpdateZoneMessage",
          groupUpdateZoneMessage: GroupUpdateZoneMessage.fromJSON(object.groupUpdateZoneMessage),
        }
        : isSet(object.userMovedMessage)
        ? { $case: "userMovedMessage", userMovedMessage: UserMovedMessage.fromJSON(object.userMovedMessage) }
        : isSet(object.groupLeftZoneMessage)
        ? {
          $case: "groupLeftZoneMessage",
          groupLeftZoneMessage: GroupLeftZoneMessage.fromJSON(object.groupLeftZoneMessage),
        }
        : isSet(object.userLeftZoneMessage)
        ? {
          $case: "userLeftZoneMessage",
          userLeftZoneMessage: UserLeftZoneMessage.fromJSON(object.userLeftZoneMessage),
        }
        : isSet(object.emoteEventMessage)
        ? { $case: "emoteEventMessage", emoteEventMessage: EmoteEventMessage.fromJSON(object.emoteEventMessage) }
        : isSet(object.playerDetailsUpdatedMessage)
        ? {
          $case: "playerDetailsUpdatedMessage",
          playerDetailsUpdatedMessage: PlayerDetailsUpdatedMessage.fromJSON(object.playerDetailsUpdatedMessage),
        }
        : isSet(object.groupUsersUpdateMessage)
        ? {
          $case: "groupUsersUpdateMessage",
          groupUsersUpdateMessage: GroupUsersUpdateMessage.fromJSON(object.groupUsersUpdateMessage),
        }
        : undefined,
    };
  },

  toJSON(message: ZoneMessage): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y);
    }
    if (message.message?.$case === "userJoinedZoneMessage") {
      obj.userJoinedZoneMessage = UserJoinedZoneMessage.toJSON(message.message.userJoinedZoneMessage);
    } else if (message.message?.$case === "groupUpdateZoneMessage") {
      obj.groupUpdateZoneMessage = GroupUpdateZoneMessage.toJSON(message.message.groupUpdateZoneMessage);
    } else if (message.message?.$case === "userMovedMessage") {
      obj.userMovedMessage = UserMovedMessage.toJSON(message.message.userMovedMessage);
    } else if (message.message?.$case === "groupLeftZoneMessage") {
      obj.groupLeftZoneMessage = GroupLeftZoneMessage.toJSON(message.message.groupLeftZoneMessage);
    } else if (message.message?.$case === "userLeftZoneMessage") {
      obj.userLeftZoneMessage = UserLeftZoneMessage.toJSON(message.message.userLeftZoneMessage);
    } else if (message.message?.$case === "emoteEventMessage") {
      obj.emoteEventMessage = EmoteEventMessage.toJSON(message.message.emoteEventMessage);
    } else if (message.message?.$case === "playerDetailsUpdatedMessage") {
      obj.playerDetailsUpdatedMessage = PlayerDetailsUpdatedMessage.toJSON(message.message.playerDetailsUpdatedMessage);
    } else if (message.message?.$case === "groupUsersUpdateMessage") {
      obj.groupUsersUpdateMessage = GroupUsersUpdateMessage.toJSON(message.message.groupUsersUpdateMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ZoneMessage>, I>>(base?: I): ZoneMessage {
    return ZoneMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ZoneMessage>, I>>(object: I): ZoneMessage {
    const message = createBaseZoneMessage();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    switch (object.message?.$case) {
      case "userJoinedZoneMessage": {
        if (object.message?.userJoinedZoneMessage !== undefined && object.message?.userJoinedZoneMessage !== null) {
          message.message = {
            $case: "userJoinedZoneMessage",
            userJoinedZoneMessage: UserJoinedZoneMessage.fromPartial(object.message.userJoinedZoneMessage),
          };
        }
        break;
      }
      case "groupUpdateZoneMessage": {
        if (object.message?.groupUpdateZoneMessage !== undefined && object.message?.groupUpdateZoneMessage !== null) {
          message.message = {
            $case: "groupUpdateZoneMessage",
            groupUpdateZoneMessage: GroupUpdateZoneMessage.fromPartial(object.message.groupUpdateZoneMessage),
          };
        }
        break;
      }
      case "userMovedMessage": {
        if (object.message?.userMovedMessage !== undefined && object.message?.userMovedMessage !== null) {
          message.message = {
            $case: "userMovedMessage",
            userMovedMessage: UserMovedMessage.fromPartial(object.message.userMovedMessage),
          };
        }
        break;
      }
      case "groupLeftZoneMessage": {
        if (object.message?.groupLeftZoneMessage !== undefined && object.message?.groupLeftZoneMessage !== null) {
          message.message = {
            $case: "groupLeftZoneMessage",
            groupLeftZoneMessage: GroupLeftZoneMessage.fromPartial(object.message.groupLeftZoneMessage),
          };
        }
        break;
      }
      case "userLeftZoneMessage": {
        if (object.message?.userLeftZoneMessage !== undefined && object.message?.userLeftZoneMessage !== null) {
          message.message = {
            $case: "userLeftZoneMessage",
            userLeftZoneMessage: UserLeftZoneMessage.fromPartial(object.message.userLeftZoneMessage),
          };
        }
        break;
      }
      case "emoteEventMessage": {
        if (object.message?.emoteEventMessage !== undefined && object.message?.emoteEventMessage !== null) {
          message.message = {
            $case: "emoteEventMessage",
            emoteEventMessage: EmoteEventMessage.fromPartial(object.message.emoteEventMessage),
          };
        }
        break;
      }
      case "playerDetailsUpdatedMessage": {
        if (
          object.message?.playerDetailsUpdatedMessage !== undefined &&
          object.message?.playerDetailsUpdatedMessage !== null
        ) {
          message.message = {
            $case: "playerDetailsUpdatedMessage",
            playerDetailsUpdatedMessage: PlayerDetailsUpdatedMessage.fromPartial(
              object.message.playerDetailsUpdatedMessage,
            ),
          };
        }
        break;
      }
      case "groupUsersUpdateMessage": {
        if (object.message?.groupUsersUpdateMessage !== undefined && object.message?.groupUsersUpdateMessage !== null) {
          message.message = {
            $case: "groupUsersUpdateMessage",
            groupUsersUpdateMessage: GroupUsersUpdateMessage.fromPartial(object.message.groupUsersUpdateMessage),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBasePingMessage(): PingMessage {
  return {};
}

export const PingMessage: MessageFns<PingMessage> = {
  encode(_: PingMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PingMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePingMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PingMessage {
    return {};
  },

  toJSON(_: PingMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PingMessage>, I>>(base?: I): PingMessage {
    return PingMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PingMessage>, I>>(_: I): PingMessage {
    const message = createBasePingMessage();
    return message;
  },
};

function createBaseUpdateMapToNewestMessage(): UpdateMapToNewestMessage {
  return { commandId: undefined };
}

export const UpdateMapToNewestMessage: MessageFns<UpdateMapToNewestMessage> = {
  encode(message: UpdateMapToNewestMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.commandId !== undefined) {
      writer.uint32(10).string(message.commandId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateMapToNewestMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateMapToNewestMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.commandId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateMapToNewestMessage {
    return { commandId: isSet(object.commandId) ? globalThis.String(object.commandId) : undefined };
  },

  toJSON(message: UpdateMapToNewestMessage): unknown {
    const obj: any = {};
    if (message.commandId !== undefined) {
      obj.commandId = message.commandId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateMapToNewestMessage>, I>>(base?: I): UpdateMapToNewestMessage {
    return UpdateMapToNewestMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateMapToNewestMessage>, I>>(object: I): UpdateMapToNewestMessage {
    const message = createBaseUpdateMapToNewestMessage();
    message.commandId = object.commandId ?? undefined;
    return message;
  },
};

function createBaseUpdateMapToNewestWithKeyMessage(): UpdateMapToNewestWithKeyMessage {
  return { mapKey: "", updateMapToNewestMessage: undefined };
}

export const UpdateMapToNewestWithKeyMessage: MessageFns<UpdateMapToNewestWithKeyMessage> = {
  encode(message: UpdateMapToNewestWithKeyMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mapKey !== "") {
      writer.uint32(10).string(message.mapKey);
    }
    if (message.updateMapToNewestMessage !== undefined) {
      UpdateMapToNewestMessage.encode(message.updateMapToNewestMessage, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateMapToNewestWithKeyMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateMapToNewestWithKeyMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mapKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updateMapToNewestMessage = UpdateMapToNewestMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateMapToNewestWithKeyMessage {
    return {
      mapKey: isSet(object.mapKey) ? globalThis.String(object.mapKey) : "",
      updateMapToNewestMessage: isSet(object.updateMapToNewestMessage)
        ? UpdateMapToNewestMessage.fromJSON(object.updateMapToNewestMessage)
        : undefined,
    };
  },

  toJSON(message: UpdateMapToNewestWithKeyMessage): unknown {
    const obj: any = {};
    if (message.mapKey !== "") {
      obj.mapKey = message.mapKey;
    }
    if (message.updateMapToNewestMessage !== undefined) {
      obj.updateMapToNewestMessage = UpdateMapToNewestMessage.toJSON(message.updateMapToNewestMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateMapToNewestWithKeyMessage>, I>>(base?: I): UpdateMapToNewestWithKeyMessage {
    return UpdateMapToNewestWithKeyMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateMapToNewestWithKeyMessage>, I>>(
    object: I,
  ): UpdateMapToNewestWithKeyMessage {
    const message = createBaseUpdateMapToNewestWithKeyMessage();
    message.mapKey = object.mapKey ?? "";
    message.updateMapToNewestMessage =
      (object.updateMapToNewestMessage !== undefined && object.updateMapToNewestMessage !== null)
        ? UpdateMapToNewestMessage.fromPartial(object.updateMapToNewestMessage)
        : undefined;
    return message;
  },
};

function createBaseSetPlayerDetailsMessage(): SetPlayerDetailsMessage {
  return {
    outlineColor: undefined,
    removeOutlineColor: undefined,
    showVoiceIndicator: undefined,
    availabilityStatus: 0,
    setVariable: undefined,
    chatID: undefined,
    sayMessage: undefined,
  };
}

export const SetPlayerDetailsMessage: MessageFns<SetPlayerDetailsMessage> = {
  encode(message: SetPlayerDetailsMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outlineColor !== undefined) {
      UInt32Value.encode({ value: message.outlineColor! }, writer.uint32(26).fork()).join();
    }
    if (message.removeOutlineColor !== undefined) {
      BoolValue.encode({ value: message.removeOutlineColor! }, writer.uint32(34).fork()).join();
    }
    if (message.showVoiceIndicator !== undefined) {
      BoolValue.encode({ value: message.showVoiceIndicator! }, writer.uint32(42).fork()).join();
    }
    if (message.availabilityStatus !== 0) {
      writer.uint32(48).int32(message.availabilityStatus);
    }
    if (message.setVariable !== undefined) {
      SetPlayerVariableMessage.encode(message.setVariable, writer.uint32(58).fork()).join();
    }
    if (message.chatID !== undefined) {
      StringValue.encode({ value: message.chatID! }, writer.uint32(66).fork()).join();
    }
    if (message.sayMessage !== undefined) {
      SayMessage.encode(message.sayMessage, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetPlayerDetailsMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetPlayerDetailsMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.outlineColor = UInt32Value.decode(reader, reader.uint32()).value;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.removeOutlineColor = BoolValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.showVoiceIndicator = BoolValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.availabilityStatus = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.setVariable = SetPlayerVariableMessage.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.chatID = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.sayMessage = SayMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetPlayerDetailsMessage {
    return {
      outlineColor: isSet(object.outlineColor) ? Number(object.outlineColor) : undefined,
      removeOutlineColor: isSet(object.removeOutlineColor) ? Boolean(object.removeOutlineColor) : undefined,
      showVoiceIndicator: isSet(object.showVoiceIndicator) ? Boolean(object.showVoiceIndicator) : undefined,
      availabilityStatus: isSet(object.availabilityStatus) ? availabilityStatusFromJSON(object.availabilityStatus) : 0,
      setVariable: isSet(object.setVariable) ? SetPlayerVariableMessage.fromJSON(object.setVariable) : undefined,
      chatID: isSet(object.chatID) ? String(object.chatID) : undefined,
      sayMessage: isSet(object.sayMessage) ? SayMessage.fromJSON(object.sayMessage) : undefined,
    };
  },

  toJSON(message: SetPlayerDetailsMessage): unknown {
    const obj: any = {};
    if (message.outlineColor !== undefined) {
      obj.outlineColor = message.outlineColor;
    }
    if (message.removeOutlineColor !== undefined) {
      obj.removeOutlineColor = message.removeOutlineColor;
    }
    if (message.showVoiceIndicator !== undefined) {
      obj.showVoiceIndicator = message.showVoiceIndicator;
    }
    if (message.availabilityStatus !== 0) {
      obj.availabilityStatus = availabilityStatusToJSON(message.availabilityStatus);
    }
    if (message.setVariable !== undefined) {
      obj.setVariable = SetPlayerVariableMessage.toJSON(message.setVariable);
    }
    if (message.chatID !== undefined) {
      obj.chatID = message.chatID;
    }
    if (message.sayMessage !== undefined) {
      obj.sayMessage = SayMessage.toJSON(message.sayMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetPlayerDetailsMessage>, I>>(base?: I): SetPlayerDetailsMessage {
    return SetPlayerDetailsMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetPlayerDetailsMessage>, I>>(object: I): SetPlayerDetailsMessage {
    const message = createBaseSetPlayerDetailsMessage();
    message.outlineColor = object.outlineColor ?? undefined;
    message.removeOutlineColor = object.removeOutlineColor ?? undefined;
    message.showVoiceIndicator = object.showVoiceIndicator ?? undefined;
    message.availabilityStatus = object.availabilityStatus ?? 0;
    message.setVariable = (object.setVariable !== undefined && object.setVariable !== null)
      ? SetPlayerVariableMessage.fromPartial(object.setVariable)
      : undefined;
    message.chatID = object.chatID ?? undefined;
    message.sayMessage = (object.sayMessage !== undefined && object.sayMessage !== null)
      ? SayMessage.fromPartial(object.sayMessage)
      : undefined;
    return message;
  },
};

function createBaseSayMessage(): SayMessage {
  return { message: "", type: 0 };
}

export const SayMessage: MessageFns<SayMessage> = {
  encode(message: SayMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SayMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSayMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SayMessage {
    return {
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      type: isSet(object.type) ? sayMessageTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: SayMessage): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.type !== 0) {
      obj.type = sayMessageTypeToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SayMessage>, I>>(base?: I): SayMessage {
    return SayMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SayMessage>, I>>(object: I): SayMessage {
    const message = createBaseSayMessage();
    message.message = object.message ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseUserMovesMessage(): UserMovesMessage {
  return { position: undefined, viewport: undefined };
}

export const UserMovesMessage: MessageFns<UserMovesMessage> = {
  encode(message: UserMovesMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.position !== undefined) {
      PositionMessage.encode(message.position, writer.uint32(10).fork()).join();
    }
    if (message.viewport !== undefined) {
      ViewportMessage.encode(message.viewport, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserMovesMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserMovesMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.position = PositionMessage.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.viewport = ViewportMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserMovesMessage {
    return {
      position: isSet(object.position) ? PositionMessage.fromJSON(object.position) : undefined,
      viewport: isSet(object.viewport) ? ViewportMessage.fromJSON(object.viewport) : undefined,
    };
  },

  toJSON(message: UserMovesMessage): unknown {
    const obj: any = {};
    if (message.position !== undefined) {
      obj.position = PositionMessage.toJSON(message.position);
    }
    if (message.viewport !== undefined) {
      obj.viewport = ViewportMessage.toJSON(message.viewport);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserMovesMessage>, I>>(base?: I): UserMovesMessage {
    return UserMovesMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserMovesMessage>, I>>(object: I): UserMovesMessage {
    const message = createBaseUserMovesMessage();
    message.position = (object.position !== undefined && object.position !== null)
      ? PositionMessage.fromPartial(object.position)
      : undefined;
    message.viewport = (object.viewport !== undefined && object.viewport !== null)
      ? ViewportMessage.fromPartial(object.viewport)
      : undefined;
    return message;
  },
};

function createBaseWebRtcSignal(): WebRtcSignal {
  return { signal: "", connectionId: "" };
}

export const WebRtcSignal: MessageFns<WebRtcSignal> = {
  encode(message: WebRtcSignal, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.signal !== "") {
      writer.uint32(18).string(message.signal);
    }
    if (message.connectionId !== "") {
      writer.uint32(26).string(message.connectionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WebRtcSignal {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebRtcSignal();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.signal = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.connectionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebRtcSignal {
    return {
      signal: isSet(object.signal) ? globalThis.String(object.signal) : "",
      connectionId: isSet(object.connectionId) ? globalThis.String(object.connectionId) : "",
    };
  },

  toJSON(message: WebRtcSignal): unknown {
    const obj: any = {};
    if (message.signal !== "") {
      obj.signal = message.signal;
    }
    if (message.connectionId !== "") {
      obj.connectionId = message.connectionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebRtcSignal>, I>>(base?: I): WebRtcSignal {
    return WebRtcSignal.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebRtcSignal>, I>>(object: I): WebRtcSignal {
    const message = createBaseWebRtcSignal();
    message.signal = object.signal ?? "";
    message.connectionId = object.connectionId ?? "";
    return message;
  },
};

function createBaseVideoQualitySampleMessage(): VideoQualitySampleMessage {
  return {
    clientEventTimeMs: 0,
    sampleSeq: undefined,
    streamId: "",
    connectionId: undefined,
    sessionId: undefined,
    remoteUserUuid: undefined,
    remoteSpaceUserId: "",
    spaceName: "",
    streamCategory: 0,
    transportType: 0,
    relay: undefined,
    relayProtocol: undefined,
    livekitServerUrl: undefined,
    fps: 0,
    fpsStdDev: undefined,
    jitter: 0,
    bandwidthBytesPerSecond: 0,
    frameWidth: 0,
    frameHeight: 0,
    mimeType: undefined,
    direction: 0,
    qualityLimitationReason: undefined,
    encoderImplementation: undefined,
    windowSeconds: undefined,
    framesDecoded: undefined,
    framesDropped: undefined,
    freezeCount: undefined,
    freezeSeconds: undefined,
    pauseCount: undefined,
    pauseSeconds: undefined,
    interFrameDelaySumSeconds: undefined,
    interFrameDelaySquaredSumSeconds: undefined,
    decodeSeconds: undefined,
    captureFps: undefined,
    captureTargetFps: undefined,
    encodeMsPerFrame: undefined,
    cpuLimitedRatio: undefined,
    bandwidthLimitedRatio: undefined,
    packetsReceived: undefined,
    packetsLost: undefined,
    roundTripTimeMs: undefined,
    uploadRoundTripTimeMs: undefined,
    uploadLossRatio: undefined,
    availableOutgoingBitrate: undefined,
    livekitRegion: undefined,
  };
}

export const VideoQualitySampleMessage: MessageFns<VideoQualitySampleMessage> = {
  encode(message: VideoQualitySampleMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.clientEventTimeMs !== 0) {
      writer.uint32(8).uint64(message.clientEventTimeMs);
    }
    if (message.sampleSeq !== undefined) {
      writer.uint32(16).uint64(message.sampleSeq);
    }
    if (message.streamId !== "") {
      writer.uint32(26).string(message.streamId);
    }
    if (message.connectionId !== undefined) {
      writer.uint32(34).string(message.connectionId);
    }
    if (message.sessionId !== undefined) {
      writer.uint32(42).string(message.sessionId);
    }
    if (message.remoteUserUuid !== undefined) {
      writer.uint32(50).string(message.remoteUserUuid);
    }
    if (message.remoteSpaceUserId !== "") {
      writer.uint32(58).string(message.remoteSpaceUserId);
    }
    if (message.spaceName !== "") {
      writer.uint32(66).string(message.spaceName);
    }
    if (message.streamCategory !== 0) {
      writer.uint32(72).int32(message.streamCategory);
    }
    if (message.transportType !== 0) {
      writer.uint32(80).int32(message.transportType);
    }
    if (message.relay !== undefined) {
      writer.uint32(88).bool(message.relay);
    }
    if (message.relayProtocol !== undefined) {
      writer.uint32(96).int32(message.relayProtocol);
    }
    if (message.livekitServerUrl !== undefined) {
      writer.uint32(106).string(message.livekitServerUrl);
    }
    if (message.fps !== 0) {
      writer.uint32(113).double(message.fps);
    }
    if (message.fpsStdDev !== undefined) {
      writer.uint32(121).double(message.fpsStdDev);
    }
    if (message.jitter !== 0) {
      writer.uint32(129).double(message.jitter);
    }
    if (message.bandwidthBytesPerSecond !== 0) {
      writer.uint32(137).double(message.bandwidthBytesPerSecond);
    }
    if (message.frameWidth !== 0) {
      writer.uint32(144).uint32(message.frameWidth);
    }
    if (message.frameHeight !== 0) {
      writer.uint32(152).uint32(message.frameHeight);
    }
    if (message.mimeType !== undefined) {
      writer.uint32(162).string(message.mimeType);
    }
    if (message.direction !== 0) {
      writer.uint32(168).int32(message.direction);
    }
    if (message.qualityLimitationReason !== undefined) {
      writer.uint32(176).int32(message.qualityLimitationReason);
    }
    if (message.encoderImplementation !== undefined) {
      writer.uint32(186).string(message.encoderImplementation);
    }
    if (message.windowSeconds !== undefined) {
      writer.uint32(193).double(message.windowSeconds);
    }
    if (message.framesDecoded !== undefined) {
      writer.uint32(200).uint32(message.framesDecoded);
    }
    if (message.framesDropped !== undefined) {
      writer.uint32(208).uint32(message.framesDropped);
    }
    if (message.freezeCount !== undefined) {
      writer.uint32(216).uint32(message.freezeCount);
    }
    if (message.freezeSeconds !== undefined) {
      writer.uint32(225).double(message.freezeSeconds);
    }
    if (message.pauseCount !== undefined) {
      writer.uint32(232).uint32(message.pauseCount);
    }
    if (message.pauseSeconds !== undefined) {
      writer.uint32(241).double(message.pauseSeconds);
    }
    if (message.interFrameDelaySumSeconds !== undefined) {
      writer.uint32(249).double(message.interFrameDelaySumSeconds);
    }
    if (message.interFrameDelaySquaredSumSeconds !== undefined) {
      writer.uint32(257).double(message.interFrameDelaySquaredSumSeconds);
    }
    if (message.decodeSeconds !== undefined) {
      writer.uint32(265).double(message.decodeSeconds);
    }
    if (message.captureFps !== undefined) {
      writer.uint32(273).double(message.captureFps);
    }
    if (message.captureTargetFps !== undefined) {
      writer.uint32(281).double(message.captureTargetFps);
    }
    if (message.encodeMsPerFrame !== undefined) {
      writer.uint32(289).double(message.encodeMsPerFrame);
    }
    if (message.cpuLimitedRatio !== undefined) {
      writer.uint32(297).double(message.cpuLimitedRatio);
    }
    if (message.bandwidthLimitedRatio !== undefined) {
      writer.uint32(305).double(message.bandwidthLimitedRatio);
    }
    if (message.packetsReceived !== undefined) {
      writer.uint32(312).uint32(message.packetsReceived);
    }
    if (message.packetsLost !== undefined) {
      writer.uint32(320).uint32(message.packetsLost);
    }
    if (message.roundTripTimeMs !== undefined) {
      writer.uint32(329).double(message.roundTripTimeMs);
    }
    if (message.uploadRoundTripTimeMs !== undefined) {
      writer.uint32(337).double(message.uploadRoundTripTimeMs);
    }
    if (message.uploadLossRatio !== undefined) {
      writer.uint32(345).double(message.uploadLossRatio);
    }
    if (message.availableOutgoingBitrate !== undefined) {
      writer.uint32(353).double(message.availableOutgoingBitrate);
    }
    if (message.livekitRegion !== undefined) {
      writer.uint32(362).string(message.livekitRegion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VideoQualitySampleMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVideoQualitySampleMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.clientEventTimeMs = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sampleSeq = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.streamId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.connectionId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.remoteUserUuid = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.remoteSpaceUserId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.streamCategory = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.transportType = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.relay = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.relayProtocol = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.livekitServerUrl = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 113) {
            break;
          }

          message.fps = reader.double();
          continue;
        }
        case 15: {
          if (tag !== 121) {
            break;
          }

          message.fpsStdDev = reader.double();
          continue;
        }
        case 16: {
          if (tag !== 129) {
            break;
          }

          message.jitter = reader.double();
          continue;
        }
        case 17: {
          if (tag !== 137) {
            break;
          }

          message.bandwidthBytesPerSecond = reader.double();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.frameWidth = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.frameHeight = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.direction = reader.int32() as any;
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.qualityLimitationReason = reader.int32() as any;
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.encoderImplementation = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 193) {
            break;
          }

          message.windowSeconds = reader.double();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.framesDecoded = reader.uint32();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.framesDropped = reader.uint32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.freezeCount = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 225) {
            break;
          }

          message.freezeSeconds = reader.double();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.pauseCount = reader.uint32();
          continue;
        }
        case 30: {
          if (tag !== 241) {
            break;
          }

          message.pauseSeconds = reader.double();
          continue;
        }
        case 31: {
          if (tag !== 249) {
            break;
          }

          message.interFrameDelaySumSeconds = reader.double();
          continue;
        }
        case 32: {
          if (tag !== 257) {
            break;
          }

          message.interFrameDelaySquaredSumSeconds = reader.double();
          continue;
        }
        case 33: {
          if (tag !== 265) {
            break;
          }

          message.decodeSeconds = reader.double();
          continue;
        }
        case 34: {
          if (tag !== 273) {
            break;
          }

          message.captureFps = reader.double();
          continue;
        }
        case 35: {
          if (tag !== 281) {
            break;
          }

          message.captureTargetFps = reader.double();
          continue;
        }
        case 36: {
          if (tag !== 289) {
            break;
          }

          message.encodeMsPerFrame = reader.double();
          continue;
        }
        case 37: {
          if (tag !== 297) {
            break;
          }

          message.cpuLimitedRatio = reader.double();
          continue;
        }
        case 38: {
          if (tag !== 305) {
            break;
          }

          message.bandwidthLimitedRatio = reader.double();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.packetsReceived = reader.uint32();
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.packetsLost = reader.uint32();
          continue;
        }
        case 41: {
          if (tag !== 329) {
            break;
          }

          message.roundTripTimeMs = reader.double();
          continue;
        }
        case 42: {
          if (tag !== 337) {
            break;
          }

          message.uploadRoundTripTimeMs = reader.double();
          continue;
        }
        case 43: {
          if (tag !== 345) {
            break;
          }

          message.uploadLossRatio = reader.double();
          continue;
        }
        case 44: {
          if (tag !== 353) {
            break;
          }

          message.availableOutgoingBitrate = reader.double();
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.livekitRegion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VideoQualitySampleMessage {
    return {
      clientEventTimeMs: isSet(object.clientEventTimeMs) ? globalThis.Number(object.clientEventTimeMs) : 0,
      sampleSeq: isSet(object.sampleSeq) ? globalThis.Number(object.sampleSeq) : undefined,
      streamId: isSet(object.streamId) ? globalThis.String(object.streamId) : "",
      connectionId: isSet(object.connectionId) ? globalThis.String(object.connectionId) : undefined,
      sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : undefined,
      remoteUserUuid: isSet(object.remoteUserUuid) ? globalThis.String(object.remoteUserUuid) : undefined,
      remoteSpaceUserId: isSet(object.remoteSpaceUserId) ? globalThis.String(object.remoteSpaceUserId) : "",
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      streamCategory: isSet(object.streamCategory) ? videoQualityStreamCategoryFromJSON(object.streamCategory) : 0,
      transportType: isSet(object.transportType) ? videoQualityTransportTypeFromJSON(object.transportType) : 0,
      relay: isSet(object.relay) ? globalThis.Boolean(object.relay) : undefined,
      relayProtocol: isSet(object.relayProtocol) ? videoQualityRelayProtocolFromJSON(object.relayProtocol) : undefined,
      livekitServerUrl: isSet(object.livekitServerUrl) ? globalThis.String(object.livekitServerUrl) : undefined,
      fps: isSet(object.fps) ? globalThis.Number(object.fps) : 0,
      fpsStdDev: isSet(object.fpsStdDev) ? globalThis.Number(object.fpsStdDev) : undefined,
      jitter: isSet(object.jitter) ? globalThis.Number(object.jitter) : 0,
      bandwidthBytesPerSecond: isSet(object.bandwidthBytesPerSecond)
        ? globalThis.Number(object.bandwidthBytesPerSecond)
        : 0,
      frameWidth: isSet(object.frameWidth) ? globalThis.Number(object.frameWidth) : 0,
      frameHeight: isSet(object.frameHeight) ? globalThis.Number(object.frameHeight) : 0,
      mimeType: isSet(object.mimeType) ? globalThis.String(object.mimeType) : undefined,
      direction: isSet(object.direction) ? videoQualityStreamDirectionFromJSON(object.direction) : 0,
      qualityLimitationReason: isSet(object.qualityLimitationReason)
        ? videoQualityLimitationReasonFromJSON(object.qualityLimitationReason)
        : undefined,
      encoderImplementation: isSet(object.encoderImplementation)
        ? globalThis.String(object.encoderImplementation)
        : undefined,
      windowSeconds: isSet(object.windowSeconds) ? globalThis.Number(object.windowSeconds) : undefined,
      framesDecoded: isSet(object.framesDecoded) ? globalThis.Number(object.framesDecoded) : undefined,
      framesDropped: isSet(object.framesDropped) ? globalThis.Number(object.framesDropped) : undefined,
      freezeCount: isSet(object.freezeCount) ? globalThis.Number(object.freezeCount) : undefined,
      freezeSeconds: isSet(object.freezeSeconds) ? globalThis.Number(object.freezeSeconds) : undefined,
      pauseCount: isSet(object.pauseCount) ? globalThis.Number(object.pauseCount) : undefined,
      pauseSeconds: isSet(object.pauseSeconds) ? globalThis.Number(object.pauseSeconds) : undefined,
      interFrameDelaySumSeconds: isSet(object.interFrameDelaySumSeconds)
        ? globalThis.Number(object.interFrameDelaySumSeconds)
        : undefined,
      interFrameDelaySquaredSumSeconds: isSet(object.interFrameDelaySquaredSumSeconds)
        ? globalThis.Number(object.interFrameDelaySquaredSumSeconds)
        : undefined,
      decodeSeconds: isSet(object.decodeSeconds) ? globalThis.Number(object.decodeSeconds) : undefined,
      captureFps: isSet(object.captureFps) ? globalThis.Number(object.captureFps) : undefined,
      captureTargetFps: isSet(object.captureTargetFps) ? globalThis.Number(object.captureTargetFps) : undefined,
      encodeMsPerFrame: isSet(object.encodeMsPerFrame) ? globalThis.Number(object.encodeMsPerFrame) : undefined,
      cpuLimitedRatio: isSet(object.cpuLimitedRatio) ? globalThis.Number(object.cpuLimitedRatio) : undefined,
      bandwidthLimitedRatio: isSet(object.bandwidthLimitedRatio)
        ? globalThis.Number(object.bandwidthLimitedRatio)
        : undefined,
      packetsReceived: isSet(object.packetsReceived) ? globalThis.Number(object.packetsReceived) : undefined,
      packetsLost: isSet(object.packetsLost) ? globalThis.Number(object.packetsLost) : undefined,
      roundTripTimeMs: isSet(object.roundTripTimeMs) ? globalThis.Number(object.roundTripTimeMs) : undefined,
      uploadRoundTripTimeMs: isSet(object.uploadRoundTripTimeMs)
        ? globalThis.Number(object.uploadRoundTripTimeMs)
        : undefined,
      uploadLossRatio: isSet(object.uploadLossRatio) ? globalThis.Number(object.uploadLossRatio) : undefined,
      availableOutgoingBitrate: isSet(object.availableOutgoingBitrate)
        ? globalThis.Number(object.availableOutgoingBitrate)
        : undefined,
      livekitRegion: isSet(object.livekitRegion) ? globalThis.String(object.livekitRegion) : undefined,
    };
  },

  toJSON(message: VideoQualitySampleMessage): unknown {
    const obj: any = {};
    if (message.clientEventTimeMs !== 0) {
      obj.clientEventTimeMs = Math.round(message.clientEventTimeMs);
    }
    if (message.sampleSeq !== undefined) {
      obj.sampleSeq = Math.round(message.sampleSeq);
    }
    if (message.streamId !== "") {
      obj.streamId = message.streamId;
    }
    if (message.connectionId !== undefined) {
      obj.connectionId = message.connectionId;
    }
    if (message.sessionId !== undefined) {
      obj.sessionId = message.sessionId;
    }
    if (message.remoteUserUuid !== undefined) {
      obj.remoteUserUuid = message.remoteUserUuid;
    }
    if (message.remoteSpaceUserId !== "") {
      obj.remoteSpaceUserId = message.remoteSpaceUserId;
    }
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.streamCategory !== 0) {
      obj.streamCategory = videoQualityStreamCategoryToJSON(message.streamCategory);
    }
    if (message.transportType !== 0) {
      obj.transportType = videoQualityTransportTypeToJSON(message.transportType);
    }
    if (message.relay !== undefined) {
      obj.relay = message.relay;
    }
    if (message.relayProtocol !== undefined) {
      obj.relayProtocol = videoQualityRelayProtocolToJSON(message.relayProtocol);
    }
    if (message.livekitServerUrl !== undefined) {
      obj.livekitServerUrl = message.livekitServerUrl;
    }
    if (message.fps !== 0) {
      obj.fps = message.fps;
    }
    if (message.fpsStdDev !== undefined) {
      obj.fpsStdDev = message.fpsStdDev;
    }
    if (message.jitter !== 0) {
      obj.jitter = message.jitter;
    }
    if (message.bandwidthBytesPerSecond !== 0) {
      obj.bandwidthBytesPerSecond = message.bandwidthBytesPerSecond;
    }
    if (message.frameWidth !== 0) {
      obj.frameWidth = Math.round(message.frameWidth);
    }
    if (message.frameHeight !== 0) {
      obj.frameHeight = Math.round(message.frameHeight);
    }
    if (message.mimeType !== undefined) {
      obj.mimeType = message.mimeType;
    }
    if (message.direction !== 0) {
      obj.direction = videoQualityStreamDirectionToJSON(message.direction);
    }
    if (message.qualityLimitationReason !== undefined) {
      obj.qualityLimitationReason = videoQualityLimitationReasonToJSON(message.qualityLimitationReason);
    }
    if (message.encoderImplementation !== undefined) {
      obj.encoderImplementation = message.encoderImplementation;
    }
    if (message.windowSeconds !== undefined) {
      obj.windowSeconds = message.windowSeconds;
    }
    if (message.framesDecoded !== undefined) {
      obj.framesDecoded = Math.round(message.framesDecoded);
    }
    if (message.framesDropped !== undefined) {
      obj.framesDropped = Math.round(message.framesDropped);
    }
    if (message.freezeCount !== undefined) {
      obj.freezeCount = Math.round(message.freezeCount);
    }
    if (message.freezeSeconds !== undefined) {
      obj.freezeSeconds = message.freezeSeconds;
    }
    if (message.pauseCount !== undefined) {
      obj.pauseCount = Math.round(message.pauseCount);
    }
    if (message.pauseSeconds !== undefined) {
      obj.pauseSeconds = message.pauseSeconds;
    }
    if (message.interFrameDelaySumSeconds !== undefined) {
      obj.interFrameDelaySumSeconds = message.interFrameDelaySumSeconds;
    }
    if (message.interFrameDelaySquaredSumSeconds !== undefined) {
      obj.interFrameDelaySquaredSumSeconds = message.interFrameDelaySquaredSumSeconds;
    }
    if (message.decodeSeconds !== undefined) {
      obj.decodeSeconds = message.decodeSeconds;
    }
    if (message.captureFps !== undefined) {
      obj.captureFps = message.captureFps;
    }
    if (message.captureTargetFps !== undefined) {
      obj.captureTargetFps = message.captureTargetFps;
    }
    if (message.encodeMsPerFrame !== undefined) {
      obj.encodeMsPerFrame = message.encodeMsPerFrame;
    }
    if (message.cpuLimitedRatio !== undefined) {
      obj.cpuLimitedRatio = message.cpuLimitedRatio;
    }
    if (message.bandwidthLimitedRatio !== undefined) {
      obj.bandwidthLimitedRatio = message.bandwidthLimitedRatio;
    }
    if (message.packetsReceived !== undefined) {
      obj.packetsReceived = Math.round(message.packetsReceived);
    }
    if (message.packetsLost !== undefined) {
      obj.packetsLost = Math.round(message.packetsLost);
    }
    if (message.roundTripTimeMs !== undefined) {
      obj.roundTripTimeMs = message.roundTripTimeMs;
    }
    if (message.uploadRoundTripTimeMs !== undefined) {
      obj.uploadRoundTripTimeMs = message.uploadRoundTripTimeMs;
    }
    if (message.uploadLossRatio !== undefined) {
      obj.uploadLossRatio = message.uploadLossRatio;
    }
    if (message.availableOutgoingBitrate !== undefined) {
      obj.availableOutgoingBitrate = message.availableOutgoingBitrate;
    }
    if (message.livekitRegion !== undefined) {
      obj.livekitRegion = message.livekitRegion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VideoQualitySampleMessage>, I>>(base?: I): VideoQualitySampleMessage {
    return VideoQualitySampleMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VideoQualitySampleMessage>, I>>(object: I): VideoQualitySampleMessage {
    const message = createBaseVideoQualitySampleMessage();
    message.clientEventTimeMs = object.clientEventTimeMs ?? 0;
    message.sampleSeq = object.sampleSeq ?? undefined;
    message.streamId = object.streamId ?? "";
    message.connectionId = object.connectionId ?? undefined;
    message.sessionId = object.sessionId ?? undefined;
    message.remoteUserUuid = object.remoteUserUuid ?? undefined;
    message.remoteSpaceUserId = object.remoteSpaceUserId ?? "";
    message.spaceName = object.spaceName ?? "";
    message.streamCategory = object.streamCategory ?? 0;
    message.transportType = object.transportType ?? 0;
    message.relay = object.relay ?? undefined;
    message.relayProtocol = object.relayProtocol ?? undefined;
    message.livekitServerUrl = object.livekitServerUrl ?? undefined;
    message.fps = object.fps ?? 0;
    message.fpsStdDev = object.fpsStdDev ?? undefined;
    message.jitter = object.jitter ?? 0;
    message.bandwidthBytesPerSecond = object.bandwidthBytesPerSecond ?? 0;
    message.frameWidth = object.frameWidth ?? 0;
    message.frameHeight = object.frameHeight ?? 0;
    message.mimeType = object.mimeType ?? undefined;
    message.direction = object.direction ?? 0;
    message.qualityLimitationReason = object.qualityLimitationReason ?? undefined;
    message.encoderImplementation = object.encoderImplementation ?? undefined;
    message.windowSeconds = object.windowSeconds ?? undefined;
    message.framesDecoded = object.framesDecoded ?? undefined;
    message.framesDropped = object.framesDropped ?? undefined;
    message.freezeCount = object.freezeCount ?? undefined;
    message.freezeSeconds = object.freezeSeconds ?? undefined;
    message.pauseCount = object.pauseCount ?? undefined;
    message.pauseSeconds = object.pauseSeconds ?? undefined;
    message.interFrameDelaySumSeconds = object.interFrameDelaySumSeconds ?? undefined;
    message.interFrameDelaySquaredSumSeconds = object.interFrameDelaySquaredSumSeconds ?? undefined;
    message.decodeSeconds = object.decodeSeconds ?? undefined;
    message.captureFps = object.captureFps ?? undefined;
    message.captureTargetFps = object.captureTargetFps ?? undefined;
    message.encodeMsPerFrame = object.encodeMsPerFrame ?? undefined;
    message.cpuLimitedRatio = object.cpuLimitedRatio ?? undefined;
    message.bandwidthLimitedRatio = object.bandwidthLimitedRatio ?? undefined;
    message.packetsReceived = object.packetsReceived ?? undefined;
    message.packetsLost = object.packetsLost ?? undefined;
    message.roundTripTimeMs = object.roundTripTimeMs ?? undefined;
    message.uploadRoundTripTimeMs = object.uploadRoundTripTimeMs ?? undefined;
    message.uploadLossRatio = object.uploadLossRatio ?? undefined;
    message.availableOutgoingBitrate = object.availableOutgoingBitrate ?? undefined;
    message.livekitRegion = object.livekitRegion ?? undefined;
    return message;
  },
};

function createBaseVideoQualityReportMessage(): VideoQualityReportMessage {
  return { samples: [] };
}

export const VideoQualityReportMessage: MessageFns<VideoQualityReportMessage> = {
  encode(message: VideoQualityReportMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.samples) {
      VideoQualitySampleMessage.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VideoQualityReportMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVideoQualityReportMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.samples.push(VideoQualitySampleMessage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VideoQualityReportMessage {
    return {
      samples: globalThis.Array.isArray(object?.samples)
        ? object.samples.map((e: any) => VideoQualitySampleMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: VideoQualityReportMessage): unknown {
    const obj: any = {};
    if (message.samples?.length) {
      obj.samples = message.samples.map((e) => VideoQualitySampleMessage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VideoQualityReportMessage>, I>>(base?: I): VideoQualityReportMessage {
    return VideoQualityReportMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VideoQualityReportMessage>, I>>(object: I): VideoQualityReportMessage {
    const message = createBaseVideoQualityReportMessage();
    message.samples = object.samples?.map((e) => VideoQualitySampleMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAnalyticsEventMessage(): AnalyticsEventMessage {
  return { eventName: "", source: "", clientEventTimeMs: 0, eventId: "", properties: undefined };
}

export const AnalyticsEventMessage: MessageFns<AnalyticsEventMessage> = {
  encode(message: AnalyticsEventMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.eventName !== "") {
      writer.uint32(10).string(message.eventName);
    }
    if (message.source !== "") {
      writer.uint32(18).string(message.source);
    }
    if (message.clientEventTimeMs !== 0) {
      writer.uint32(24).uint64(message.clientEventTimeMs);
    }
    if (message.eventId !== "") {
      writer.uint32(34).string(message.eventId);
    }
    if (message.properties !== undefined) {
      Value.encode(Value.wrap(message.properties), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalyticsEventMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalyticsEventMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.eventName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.source = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.clientEventTimeMs = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.eventId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.properties = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalyticsEventMessage {
    return {
      eventName: isSet(object.eventName) ? globalThis.String(object.eventName) : "",
      source: isSet(object.source) ? globalThis.String(object.source) : "",
      clientEventTimeMs: isSet(object.clientEventTimeMs) ? globalThis.Number(object.clientEventTimeMs) : 0,
      eventId: isSet(object.eventId) ? globalThis.String(object.eventId) : "",
      properties: isSet(object?.properties) ? object.properties : undefined,
    };
  },

  toJSON(message: AnalyticsEventMessage): unknown {
    const obj: any = {};
    if (message.eventName !== "") {
      obj.eventName = message.eventName;
    }
    if (message.source !== "") {
      obj.source = message.source;
    }
    if (message.clientEventTimeMs !== 0) {
      obj.clientEventTimeMs = Math.round(message.clientEventTimeMs);
    }
    if (message.eventId !== "") {
      obj.eventId = message.eventId;
    }
    if (message.properties !== undefined) {
      obj.properties = message.properties;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalyticsEventMessage>, I>>(base?: I): AnalyticsEventMessage {
    return AnalyticsEventMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalyticsEventMessage>, I>>(object: I): AnalyticsEventMessage {
    const message = createBaseAnalyticsEventMessage();
    message.eventName = object.eventName ?? "";
    message.source = object.source ?? "";
    message.clientEventTimeMs = object.clientEventTimeMs ?? 0;
    message.eventId = object.eventId ?? "";
    message.properties = object.properties ?? undefined;
    return message;
  },
};

function createBaseAnalyticsEventReportMessage(): AnalyticsEventReportMessage {
  return { events: [] };
}

export const AnalyticsEventReportMessage: MessageFns<AnalyticsEventReportMessage> = {
  encode(message: AnalyticsEventReportMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.events) {
      AnalyticsEventMessage.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalyticsEventReportMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalyticsEventReportMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.events.push(AnalyticsEventMessage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalyticsEventReportMessage {
    return {
      events: globalThis.Array.isArray(object?.events)
        ? object.events.map((e: any) => AnalyticsEventMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AnalyticsEventReportMessage): unknown {
    const obj: any = {};
    if (message.events?.length) {
      obj.events = message.events.map((e) => AnalyticsEventMessage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalyticsEventReportMessage>, I>>(base?: I): AnalyticsEventReportMessage {
    return AnalyticsEventReportMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalyticsEventReportMessage>, I>>(object: I): AnalyticsEventReportMessage {
    const message = createBaseAnalyticsEventReportMessage();
    message.events = object.events?.map((e) => AnalyticsEventMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseReportPlayerMessage(): ReportPlayerMessage {
  return { reportedUserUuid: "", reportComment: "" };
}

export const ReportPlayerMessage: MessageFns<ReportPlayerMessage> = {
  encode(message: ReportPlayerMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reportedUserUuid !== "") {
      writer.uint32(10).string(message.reportedUserUuid);
    }
    if (message.reportComment !== "") {
      writer.uint32(18).string(message.reportComment);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReportPlayerMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReportPlayerMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reportedUserUuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reportComment = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReportPlayerMessage {
    return {
      reportedUserUuid: isSet(object.reportedUserUuid) ? globalThis.String(object.reportedUserUuid) : "",
      reportComment: isSet(object.reportComment) ? globalThis.String(object.reportComment) : "",
    };
  },

  toJSON(message: ReportPlayerMessage): unknown {
    const obj: any = {};
    if (message.reportedUserUuid !== "") {
      obj.reportedUserUuid = message.reportedUserUuid;
    }
    if (message.reportComment !== "") {
      obj.reportComment = message.reportComment;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReportPlayerMessage>, I>>(base?: I): ReportPlayerMessage {
    return ReportPlayerMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReportPlayerMessage>, I>>(object: I): ReportPlayerMessage {
    const message = createBaseReportPlayerMessage();
    message.reportedUserUuid = object.reportedUserUuid ?? "";
    message.reportComment = object.reportComment ?? "";
    return message;
  },
};

function createBaseBanPlayerMessage(): BanPlayerMessage {
  return { banUserUuid: "", banUserName: "", kick: false, reason: "", byIp: false };
}

export const BanPlayerMessage: MessageFns<BanPlayerMessage> = {
  encode(message: BanPlayerMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.banUserUuid !== "") {
      writer.uint32(10).string(message.banUserUuid);
    }
    if (message.banUserName !== "") {
      writer.uint32(18).string(message.banUserName);
    }
    if (message.kick !== false) {
      writer.uint32(24).bool(message.kick);
    }
    if (message.reason !== "") {
      writer.uint32(34).string(message.reason);
    }
    if (message.byIp !== false) {
      writer.uint32(40).bool(message.byIp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BanPlayerMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBanPlayerMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.banUserUuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.banUserName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.kick = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.byIp = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BanPlayerMessage {
    return {
      banUserUuid: isSet(object.banUserUuid) ? globalThis.String(object.banUserUuid) : "",
      banUserName: isSet(object.banUserName) ? globalThis.String(object.banUserName) : "",
      kick: isSet(object.kick) ? globalThis.Boolean(object.kick) : false,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
      byIp: isSet(object.byIp) ? globalThis.Boolean(object.byIp) : false,
    };
  },

  toJSON(message: BanPlayerMessage): unknown {
    const obj: any = {};
    if (message.banUserUuid !== "") {
      obj.banUserUuid = message.banUserUuid;
    }
    if (message.banUserName !== "") {
      obj.banUserName = message.banUserName;
    }
    if (message.kick !== false) {
      obj.kick = message.kick;
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    if (message.byIp !== false) {
      obj.byIp = message.byIp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BanPlayerMessage>, I>>(base?: I): BanPlayerMessage {
    return BanPlayerMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BanPlayerMessage>, I>>(object: I): BanPlayerMessage {
    const message = createBaseBanPlayerMessage();
    message.banUserUuid = object.banUserUuid ?? "";
    message.banUserName = object.banUserName ?? "";
    message.kick = object.kick ?? false;
    message.reason = object.reason ?? "";
    message.byIp = object.byIp ?? false;
    return message;
  },
};

function createBaseUpdateChatIdMessage(): UpdateChatIdMessage {
  return { email: "", chatId: "" };
}

export const UpdateChatIdMessage: MessageFns<UpdateChatIdMessage> = {
  encode(message: UpdateChatIdMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.chatId !== "") {
      writer.uint32(18).string(message.chatId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateChatIdMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateChatIdMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chatId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateChatIdMessage {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      chatId: isSet(object.chatId) ? globalThis.String(object.chatId) : "",
    };
  },

  toJSON(message: UpdateChatIdMessage): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.chatId !== "") {
      obj.chatId = message.chatId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateChatIdMessage>, I>>(base?: I): UpdateChatIdMessage {
    return UpdateChatIdMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateChatIdMessage>, I>>(object: I): UpdateChatIdMessage {
    const message = createBaseUpdateChatIdMessage();
    message.email = object.email ?? "";
    message.chatId = object.chatId ?? "";
    return message;
  },
};

function createBaseLeaveChatRoomAreaMessage(): LeaveChatRoomAreaMessage {
  return { roomID: "" };
}

export const LeaveChatRoomAreaMessage: MessageFns<LeaveChatRoomAreaMessage> = {
  encode(message: LeaveChatRoomAreaMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.roomID !== "") {
      writer.uint32(10).string(message.roomID);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LeaveChatRoomAreaMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeaveChatRoomAreaMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roomID = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LeaveChatRoomAreaMessage {
    return { roomID: isSet(object.roomID) ? globalThis.String(object.roomID) : "" };
  },

  toJSON(message: LeaveChatRoomAreaMessage): unknown {
    const obj: any = {};
    if (message.roomID !== "") {
      obj.roomID = message.roomID;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LeaveChatRoomAreaMessage>, I>>(base?: I): LeaveChatRoomAreaMessage {
    return LeaveChatRoomAreaMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LeaveChatRoomAreaMessage>, I>>(object: I): LeaveChatRoomAreaMessage {
    const message = createBaseLeaveChatRoomAreaMessage();
    message.roomID = object.roomID ?? "";
    return message;
  },
};

function createBaseEmotePromptMessage(): EmotePromptMessage {
  return { emote: "" };
}

export const EmotePromptMessage: MessageFns<EmotePromptMessage> = {
  encode(message: EmotePromptMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.emote !== "") {
      writer.uint32(18).string(message.emote);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmotePromptMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmotePromptMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.emote = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EmotePromptMessage {
    return { emote: isSet(object.emote) ? globalThis.String(object.emote) : "" };
  },

  toJSON(message: EmotePromptMessage): unknown {
    const obj: any = {};
    if (message.emote !== "") {
      obj.emote = message.emote;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EmotePromptMessage>, I>>(base?: I): EmotePromptMessage {
    return EmotePromptMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmotePromptMessage>, I>>(object: I): EmotePromptMessage {
    const message = createBaseEmotePromptMessage();
    message.emote = object.emote ?? "";
    return message;
  },
};

function createBaseEmoteEventMessage(): EmoteEventMessage {
  return { actorUserId: 0, emote: "" };
}

export const EmoteEventMessage: MessageFns<EmoteEventMessage> = {
  encode(message: EmoteEventMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.actorUserId !== 0) {
      writer.uint32(8).int32(message.actorUserId);
    }
    if (message.emote !== "") {
      writer.uint32(18).string(message.emote);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmoteEventMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmoteEventMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.actorUserId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.emote = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EmoteEventMessage {
    return {
      actorUserId: isSet(object.actorUserId) ? globalThis.Number(object.actorUserId) : 0,
      emote: isSet(object.emote) ? globalThis.String(object.emote) : "",
    };
  },

  toJSON(message: EmoteEventMessage): unknown {
    const obj: any = {};
    if (message.actorUserId !== 0) {
      obj.actorUserId = Math.round(message.actorUserId);
    }
    if (message.emote !== "") {
      obj.emote = message.emote;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EmoteEventMessage>, I>>(base?: I): EmoteEventMessage {
    return EmoteEventMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmoteEventMessage>, I>>(object: I): EmoteEventMessage {
    const message = createBaseEmoteEventMessage();
    message.actorUserId = object.actorUserId ?? 0;
    message.emote = object.emote ?? "";
    return message;
  },
};

function createBaseFollowRequestMessage(): FollowRequestMessage {
  return { leader: 0, forceFollow: false };
}

export const FollowRequestMessage: MessageFns<FollowRequestMessage> = {
  encode(message: FollowRequestMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.leader !== 0) {
      writer.uint32(8).int32(message.leader);
    }
    if (message.forceFollow !== false) {
      writer.uint32(16).bool(message.forceFollow);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FollowRequestMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFollowRequestMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.leader = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.forceFollow = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FollowRequestMessage {
    return {
      leader: isSet(object.leader) ? globalThis.Number(object.leader) : 0,
      forceFollow: isSet(object.forceFollow) ? globalThis.Boolean(object.forceFollow) : false,
    };
  },

  toJSON(message: FollowRequestMessage): unknown {
    const obj: any = {};
    if (message.leader !== 0) {
      obj.leader = Math.round(message.leader);
    }
    if (message.forceFollow !== false) {
      obj.forceFollow = message.forceFollow;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FollowRequestMessage>, I>>(base?: I): FollowRequestMessage {
    return FollowRequestMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FollowRequestMessage>, I>>(object: I): FollowRequestMessage {
    const message = createBaseFollowRequestMessage();
    message.leader = object.leader ?? 0;
    message.forceFollow = object.forceFollow ?? false;
    return message;
  },
};

function createBaseFollowConfirmationMessage(): FollowConfirmationMessage {
  return { leader: 0, follower: 0 };
}

export const FollowConfirmationMessage: MessageFns<FollowConfirmationMessage> = {
  encode(message: FollowConfirmationMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.leader !== 0) {
      writer.uint32(8).int32(message.leader);
    }
    if (message.follower !== 0) {
      writer.uint32(16).int32(message.follower);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FollowConfirmationMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFollowConfirmationMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.leader = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.follower = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FollowConfirmationMessage {
    return {
      leader: isSet(object.leader) ? globalThis.Number(object.leader) : 0,
      follower: isSet(object.follower) ? globalThis.Number(object.follower) : 0,
    };
  },

  toJSON(message: FollowConfirmationMessage): unknown {
    const obj: any = {};
    if (message.leader !== 0) {
      obj.leader = Math.round(message.leader);
    }
    if (message.follower !== 0) {
      obj.follower = Math.round(message.follower);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FollowConfirmationMessage>, I>>(base?: I): FollowConfirmationMessage {
    return FollowConfirmationMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FollowConfirmationMessage>, I>>(object: I): FollowConfirmationMessage {
    const message = createBaseFollowConfirmationMessage();
    message.leader = object.leader ?? 0;
    message.follower = object.follower ?? 0;
    return message;
  },
};

function createBaseFollowAbortMessage(): FollowAbortMessage {
  return { leader: 0, follower: 0 };
}

export const FollowAbortMessage: MessageFns<FollowAbortMessage> = {
  encode(message: FollowAbortMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.leader !== 0) {
      writer.uint32(8).int32(message.leader);
    }
    if (message.follower !== 0) {
      writer.uint32(16).int32(message.follower);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FollowAbortMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFollowAbortMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.leader = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.follower = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FollowAbortMessage {
    return {
      leader: isSet(object.leader) ? globalThis.Number(object.leader) : 0,
      follower: isSet(object.follower) ? globalThis.Number(object.follower) : 0,
    };
  },

  toJSON(message: FollowAbortMessage): unknown {
    const obj: any = {};
    if (message.leader !== 0) {
      obj.leader = Math.round(message.leader);
    }
    if (message.follower !== 0) {
      obj.follower = Math.round(message.follower);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FollowAbortMessage>, I>>(base?: I): FollowAbortMessage {
    return FollowAbortMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FollowAbortMessage>, I>>(object: I): FollowAbortMessage {
    const message = createBaseFollowAbortMessage();
    message.leader = object.leader ?? 0;
    message.follower = object.follower ?? 0;
    return message;
  },
};

function createBaseLockGroupPromptMessage(): LockGroupPromptMessage {
  return { lock: false };
}

export const LockGroupPromptMessage: MessageFns<LockGroupPromptMessage> = {
  encode(message: LockGroupPromptMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lock !== false) {
      writer.uint32(8).bool(message.lock);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LockGroupPromptMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLockGroupPromptMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.lock = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LockGroupPromptMessage {
    return { lock: isSet(object.lock) ? globalThis.Boolean(object.lock) : false };
  },

  toJSON(message: LockGroupPromptMessage): unknown {
    const obj: any = {};
    if (message.lock !== false) {
      obj.lock = message.lock;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LockGroupPromptMessage>, I>>(base?: I): LockGroupPromptMessage {
    return LockGroupPromptMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LockGroupPromptMessage>, I>>(object: I): LockGroupPromptMessage {
    const message = createBaseLockGroupPromptMessage();
    message.lock = object.lock ?? false;
    return message;
  },
};

function createBaseEditMapMessage(): EditMapMessage {
  return { message: undefined };
}

export const EditMapMessage: MessageFns<EditMapMessage> = {
  encode(message: EditMapMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "modifyAreaMessage":
        ModifyAreaMessage.encode(message.message.modifyAreaMessage, writer.uint32(10).fork()).join();
        break;
      case "createAreaMessage":
        CreateAreaMessage.encode(message.message.createAreaMessage, writer.uint32(18).fork()).join();
        break;
      case "deleteAreaMessage":
        DeleteAreaMessage.encode(message.message.deleteAreaMessage, writer.uint32(26).fork()).join();
        break;
      case "modifyEntityMessage":
        ModifyEntityMessage.encode(message.message.modifyEntityMessage, writer.uint32(34).fork()).join();
        break;
      case "createEntityMessage":
        CreateEntityMessage.encode(message.message.createEntityMessage, writer.uint32(42).fork()).join();
        break;
      case "deleteEntityMessage":
        DeleteEntityMessage.encode(message.message.deleteEntityMessage, writer.uint32(50).fork()).join();
        break;
      case "updateWAMSettingsMessage":
        UpdateWAMSettingsMessage.encode(message.message.updateWAMSettingsMessage, writer.uint32(58).fork()).join();
        break;
      case "errorCommandMessage":
        ErrorCommandMessage.encode(message.message.errorCommandMessage, writer.uint32(66).fork()).join();
        break;
      case "uploadEntityMessage":
        UploadEntityMessage.encode(message.message.uploadEntityMessage, writer.uint32(74).fork()).join();
        break;
      case "modifyCustomEntityMessage":
        ModifyCustomEntityMessage.encode(message.message.modifyCustomEntityMessage, writer.uint32(82).fork()).join();
        break;
      case "deleteCustomEntityMessage":
        DeleteCustomEntityMessage.encode(message.message.deleteCustomEntityMessage, writer.uint32(90).fork()).join();
        break;
      case "modifiyWAMMetadataMessage":
        ModifiyWAMMetadataMessage.encode(message.message.modifiyWAMMetadataMessage, writer.uint32(98).fork()).join();
        break;
      case "uploadFileMessage":
        UploadFileMessage.encode(message.message.uploadFileMessage, writer.uint32(106).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EditMapMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditMapMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = {
            $case: "modifyAreaMessage",
            modifyAreaMessage: ModifyAreaMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = {
            $case: "createAreaMessage",
            createAreaMessage: CreateAreaMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = {
            $case: "deleteAreaMessage",
            deleteAreaMessage: DeleteAreaMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = {
            $case: "modifyEntityMessage",
            modifyEntityMessage: ModifyEntityMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.message = {
            $case: "createEntityMessage",
            createEntityMessage: CreateEntityMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.message = {
            $case: "deleteEntityMessage",
            deleteEntityMessage: DeleteEntityMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.message = {
            $case: "updateWAMSettingsMessage",
            updateWAMSettingsMessage: UpdateWAMSettingsMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.message = {
            $case: "errorCommandMessage",
            errorCommandMessage: ErrorCommandMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.message = {
            $case: "uploadEntityMessage",
            uploadEntityMessage: UploadEntityMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.message = {
            $case: "modifyCustomEntityMessage",
            modifyCustomEntityMessage: ModifyCustomEntityMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.message = {
            $case: "deleteCustomEntityMessage",
            deleteCustomEntityMessage: DeleteCustomEntityMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.message = {
            $case: "modifiyWAMMetadataMessage",
            modifiyWAMMetadataMessage: ModifiyWAMMetadataMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.message = {
            $case: "uploadFileMessage",
            uploadFileMessage: UploadFileMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditMapMessage {
    return {
      message: isSet(object.modifyAreaMessage)
        ? { $case: "modifyAreaMessage", modifyAreaMessage: ModifyAreaMessage.fromJSON(object.modifyAreaMessage) }
        : isSet(object.createAreaMessage)
        ? { $case: "createAreaMessage", createAreaMessage: CreateAreaMessage.fromJSON(object.createAreaMessage) }
        : isSet(object.deleteAreaMessage)
        ? { $case: "deleteAreaMessage", deleteAreaMessage: DeleteAreaMessage.fromJSON(object.deleteAreaMessage) }
        : isSet(object.modifyEntityMessage)
        ? {
          $case: "modifyEntityMessage",
          modifyEntityMessage: ModifyEntityMessage.fromJSON(object.modifyEntityMessage),
        }
        : isSet(object.createEntityMessage)
        ? {
          $case: "createEntityMessage",
          createEntityMessage: CreateEntityMessage.fromJSON(object.createEntityMessage),
        }
        : isSet(object.deleteEntityMessage)
        ? {
          $case: "deleteEntityMessage",
          deleteEntityMessage: DeleteEntityMessage.fromJSON(object.deleteEntityMessage),
        }
        : isSet(object.updateWAMSettingsMessage)
        ? {
          $case: "updateWAMSettingsMessage",
          updateWAMSettingsMessage: UpdateWAMSettingsMessage.fromJSON(object.updateWAMSettingsMessage),
        }
        : isSet(object.errorCommandMessage)
        ? {
          $case: "errorCommandMessage",
          errorCommandMessage: ErrorCommandMessage.fromJSON(object.errorCommandMessage),
        }
        : isSet(object.uploadEntityMessage)
        ? {
          $case: "uploadEntityMessage",
          uploadEntityMessage: UploadEntityMessage.fromJSON(object.uploadEntityMessage),
        }
        : isSet(object.modifyCustomEntityMessage)
        ? {
          $case: "modifyCustomEntityMessage",
          modifyCustomEntityMessage: ModifyCustomEntityMessage.fromJSON(object.modifyCustomEntityMessage),
        }
        : isSet(object.deleteCustomEntityMessage)
        ? {
          $case: "deleteCustomEntityMessage",
          deleteCustomEntityMessage: DeleteCustomEntityMessage.fromJSON(object.deleteCustomEntityMessage),
        }
        : isSet(object.modifiyWAMMetadataMessage)
        ? {
          $case: "modifiyWAMMetadataMessage",
          modifiyWAMMetadataMessage: ModifiyWAMMetadataMessage.fromJSON(object.modifiyWAMMetadataMessage),
        }
        : isSet(object.uploadFileMessage)
        ? { $case: "uploadFileMessage", uploadFileMessage: UploadFileMessage.fromJSON(object.uploadFileMessage) }
        : undefined,
    };
  },

  toJSON(message: EditMapMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "modifyAreaMessage") {
      obj.modifyAreaMessage = ModifyAreaMessage.toJSON(message.message.modifyAreaMessage);
    } else if (message.message?.$case === "createAreaMessage") {
      obj.createAreaMessage = CreateAreaMessage.toJSON(message.message.createAreaMessage);
    } else if (message.message?.$case === "deleteAreaMessage") {
      obj.deleteAreaMessage = DeleteAreaMessage.toJSON(message.message.deleteAreaMessage);
    } else if (message.message?.$case === "modifyEntityMessage") {
      obj.modifyEntityMessage = ModifyEntityMessage.toJSON(message.message.modifyEntityMessage);
    } else if (message.message?.$case === "createEntityMessage") {
      obj.createEntityMessage = CreateEntityMessage.toJSON(message.message.createEntityMessage);
    } else if (message.message?.$case === "deleteEntityMessage") {
      obj.deleteEntityMessage = DeleteEntityMessage.toJSON(message.message.deleteEntityMessage);
    } else if (message.message?.$case === "updateWAMSettingsMessage") {
      obj.updateWAMSettingsMessage = UpdateWAMSettingsMessage.toJSON(message.message.updateWAMSettingsMessage);
    } else if (message.message?.$case === "errorCommandMessage") {
      obj.errorCommandMessage = ErrorCommandMessage.toJSON(message.message.errorCommandMessage);
    } else if (message.message?.$case === "uploadEntityMessage") {
      obj.uploadEntityMessage = UploadEntityMessage.toJSON(message.message.uploadEntityMessage);
    } else if (message.message?.$case === "modifyCustomEntityMessage") {
      obj.modifyCustomEntityMessage = ModifyCustomEntityMessage.toJSON(message.message.modifyCustomEntityMessage);
    } else if (message.message?.$case === "deleteCustomEntityMessage") {
      obj.deleteCustomEntityMessage = DeleteCustomEntityMessage.toJSON(message.message.deleteCustomEntityMessage);
    } else if (message.message?.$case === "modifiyWAMMetadataMessage") {
      obj.modifiyWAMMetadataMessage = ModifiyWAMMetadataMessage.toJSON(message.message.modifiyWAMMetadataMessage);
    } else if (message.message?.$case === "uploadFileMessage") {
      obj.uploadFileMessage = UploadFileMessage.toJSON(message.message.uploadFileMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditMapMessage>, I>>(base?: I): EditMapMessage {
    return EditMapMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditMapMessage>, I>>(object: I): EditMapMessage {
    const message = createBaseEditMapMessage();
    switch (object.message?.$case) {
      case "modifyAreaMessage": {
        if (object.message?.modifyAreaMessage !== undefined && object.message?.modifyAreaMessage !== null) {
          message.message = {
            $case: "modifyAreaMessage",
            modifyAreaMessage: ModifyAreaMessage.fromPartial(object.message.modifyAreaMessage),
          };
        }
        break;
      }
      case "createAreaMessage": {
        if (object.message?.createAreaMessage !== undefined && object.message?.createAreaMessage !== null) {
          message.message = {
            $case: "createAreaMessage",
            createAreaMessage: CreateAreaMessage.fromPartial(object.message.createAreaMessage),
          };
        }
        break;
      }
      case "deleteAreaMessage": {
        if (object.message?.deleteAreaMessage !== undefined && object.message?.deleteAreaMessage !== null) {
          message.message = {
            $case: "deleteAreaMessage",
            deleteAreaMessage: DeleteAreaMessage.fromPartial(object.message.deleteAreaMessage),
          };
        }
        break;
      }
      case "modifyEntityMessage": {
        if (object.message?.modifyEntityMessage !== undefined && object.message?.modifyEntityMessage !== null) {
          message.message = {
            $case: "modifyEntityMessage",
            modifyEntityMessage: ModifyEntityMessage.fromPartial(object.message.modifyEntityMessage),
          };
        }
        break;
      }
      case "createEntityMessage": {
        if (object.message?.createEntityMessage !== undefined && object.message?.createEntityMessage !== null) {
          message.message = {
            $case: "createEntityMessage",
            createEntityMessage: CreateEntityMessage.fromPartial(object.message.createEntityMessage),
          };
        }
        break;
      }
      case "deleteEntityMessage": {
        if (object.message?.deleteEntityMessage !== undefined && object.message?.deleteEntityMessage !== null) {
          message.message = {
            $case: "deleteEntityMessage",
            deleteEntityMessage: DeleteEntityMessage.fromPartial(object.message.deleteEntityMessage),
          };
        }
        break;
      }
      case "updateWAMSettingsMessage": {
        if (
          object.message?.updateWAMSettingsMessage !== undefined && object.message?.updateWAMSettingsMessage !== null
        ) {
          message.message = {
            $case: "updateWAMSettingsMessage",
            updateWAMSettingsMessage: UpdateWAMSettingsMessage.fromPartial(object.message.updateWAMSettingsMessage),
          };
        }
        break;
      }
      case "errorCommandMessage": {
        if (object.message?.errorCommandMessage !== undefined && object.message?.errorCommandMessage !== null) {
          message.message = {
            $case: "errorCommandMessage",
            errorCommandMessage: ErrorCommandMessage.fromPartial(object.message.errorCommandMessage),
          };
        }
        break;
      }
      case "uploadEntityMessage": {
        if (object.message?.uploadEntityMessage !== undefined && object.message?.uploadEntityMessage !== null) {
          message.message = {
            $case: "uploadEntityMessage",
            uploadEntityMessage: UploadEntityMessage.fromPartial(object.message.uploadEntityMessage),
          };
        }
        break;
      }
      case "modifyCustomEntityMessage": {
        if (
          object.message?.modifyCustomEntityMessage !== undefined && object.message?.modifyCustomEntityMessage !== null
        ) {
          message.message = {
            $case: "modifyCustomEntityMessage",
            modifyCustomEntityMessage: ModifyCustomEntityMessage.fromPartial(object.message.modifyCustomEntityMessage),
          };
        }
        break;
      }
      case "deleteCustomEntityMessage": {
        if (
          object.message?.deleteCustomEntityMessage !== undefined && object.message?.deleteCustomEntityMessage !== null
        ) {
          message.message = {
            $case: "deleteCustomEntityMessage",
            deleteCustomEntityMessage: DeleteCustomEntityMessage.fromPartial(object.message.deleteCustomEntityMessage),
          };
        }
        break;
      }
      case "modifiyWAMMetadataMessage": {
        if (
          object.message?.modifiyWAMMetadataMessage !== undefined && object.message?.modifiyWAMMetadataMessage !== null
        ) {
          message.message = {
            $case: "modifiyWAMMetadataMessage",
            modifiyWAMMetadataMessage: ModifiyWAMMetadataMessage.fromPartial(object.message.modifiyWAMMetadataMessage),
          };
        }
        break;
      }
      case "uploadFileMessage": {
        if (object.message?.uploadFileMessage !== undefined && object.message?.uploadFileMessage !== null) {
          message.message = {
            $case: "uploadFileMessage",
            uploadFileMessage: UploadFileMessage.fromPartial(object.message.uploadFileMessage),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseErrorCommandMessage(): ErrorCommandMessage {
  return { reason: "" };
}

export const ErrorCommandMessage: MessageFns<ErrorCommandMessage> = {
  encode(message: ErrorCommandMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reason !== "") {
      writer.uint32(10).string(message.reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ErrorCommandMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseErrorCommandMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ErrorCommandMessage {
    return { reason: isSet(object.reason) ? globalThis.String(object.reason) : "" };
  },

  toJSON(message: ErrorCommandMessage): unknown {
    const obj: any = {};
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ErrorCommandMessage>, I>>(base?: I): ErrorCommandMessage {
    return ErrorCommandMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ErrorCommandMessage>, I>>(object: I): ErrorCommandMessage {
    const message = createBaseErrorCommandMessage();
    message.reason = object.reason ?? "";
    return message;
  },
};

function createBaseUpdateWAMSettingsMessage(): UpdateWAMSettingsMessage {
  return { message: undefined };
}

export const UpdateWAMSettingsMessage: MessageFns<UpdateWAMSettingsMessage> = {
  encode(message: UpdateWAMSettingsMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "updateMegaphoneSettingMessage":
        UpdateMegaphoneSettingMessage.encode(message.message.updateMegaphoneSettingMessage, writer.uint32(10).fork())
          .join();
        break;
      case "updateRecordingSettingMessage":
        UpdateRecordingSettingMessage.encode(message.message.updateRecordingSettingMessage, writer.uint32(18).fork())
          .join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateWAMSettingsMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateWAMSettingsMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = {
            $case: "updateMegaphoneSettingMessage",
            updateMegaphoneSettingMessage: UpdateMegaphoneSettingMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = {
            $case: "updateRecordingSettingMessage",
            updateRecordingSettingMessage: UpdateRecordingSettingMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateWAMSettingsMessage {
    return {
      message: isSet(object.updateMegaphoneSettingMessage)
        ? {
          $case: "updateMegaphoneSettingMessage",
          updateMegaphoneSettingMessage: UpdateMegaphoneSettingMessage.fromJSON(object.updateMegaphoneSettingMessage),
        }
        : isSet(object.updateRecordingSettingMessage)
        ? {
          $case: "updateRecordingSettingMessage",
          updateRecordingSettingMessage: UpdateRecordingSettingMessage.fromJSON(object.updateRecordingSettingMessage),
        }
        : undefined,
    };
  },

  toJSON(message: UpdateWAMSettingsMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "updateMegaphoneSettingMessage") {
      obj.updateMegaphoneSettingMessage = UpdateMegaphoneSettingMessage.toJSON(
        message.message.updateMegaphoneSettingMessage,
      );
    } else if (message.message?.$case === "updateRecordingSettingMessage") {
      obj.updateRecordingSettingMessage = UpdateRecordingSettingMessage.toJSON(
        message.message.updateRecordingSettingMessage,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateWAMSettingsMessage>, I>>(base?: I): UpdateWAMSettingsMessage {
    return UpdateWAMSettingsMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateWAMSettingsMessage>, I>>(object: I): UpdateWAMSettingsMessage {
    const message = createBaseUpdateWAMSettingsMessage();
    switch (object.message?.$case) {
      case "updateMegaphoneSettingMessage": {
        if (
          object.message?.updateMegaphoneSettingMessage !== undefined &&
          object.message?.updateMegaphoneSettingMessage !== null
        ) {
          message.message = {
            $case: "updateMegaphoneSettingMessage",
            updateMegaphoneSettingMessage: UpdateMegaphoneSettingMessage.fromPartial(
              object.message.updateMegaphoneSettingMessage,
            ),
          };
        }
        break;
      }
      case "updateRecordingSettingMessage": {
        if (
          object.message?.updateRecordingSettingMessage !== undefined &&
          object.message?.updateRecordingSettingMessage !== null
        ) {
          message.message = {
            $case: "updateRecordingSettingMessage",
            updateRecordingSettingMessage: UpdateRecordingSettingMessage.fromPartial(
              object.message.updateRecordingSettingMessage,
            ),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseUpdateMegaphoneSettingMessage(): UpdateMegaphoneSettingMessage {
  return { settings: undefined };
}

export const UpdateMegaphoneSettingMessage: MessageFns<UpdateMegaphoneSettingMessage> = {
  encode(message: UpdateMegaphoneSettingMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      Value.encode(Value.wrap(message.settings), writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateMegaphoneSettingMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateMegaphoneSettingMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateMegaphoneSettingMessage {
    return { settings: isSet(object?.settings) ? object.settings : undefined };
  },

  toJSON(message: UpdateMegaphoneSettingMessage): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = message.settings;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateMegaphoneSettingMessage>, I>>(base?: I): UpdateMegaphoneSettingMessage {
    return UpdateMegaphoneSettingMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateMegaphoneSettingMessage>, I>>(
    object: I,
  ): UpdateMegaphoneSettingMessage {
    const message = createBaseUpdateMegaphoneSettingMessage();
    message.settings = object.settings ?? undefined;
    return message;
  },
};

function createBaseUpdateRecordingSettingMessage(): UpdateRecordingSettingMessage {
  return { settings: undefined };
}

export const UpdateRecordingSettingMessage: MessageFns<UpdateRecordingSettingMessage> = {
  encode(message: UpdateRecordingSettingMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      Value.encode(Value.wrap(message.settings), writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateRecordingSettingMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateRecordingSettingMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateRecordingSettingMessage {
    return { settings: isSet(object?.settings) ? object.settings : undefined };
  },

  toJSON(message: UpdateRecordingSettingMessage): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = message.settings;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateRecordingSettingMessage>, I>>(base?: I): UpdateRecordingSettingMessage {
    return UpdateRecordingSettingMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateRecordingSettingMessage>, I>>(
    object: I,
  ): UpdateRecordingSettingMessage {
    const message = createBaseUpdateRecordingSettingMessage();
    message.settings = object.settings ?? undefined;
    return message;
  },
};

function createBaseEditMapCommandMessage(): EditMapCommandMessage {
  return { id: "", editMapMessage: undefined };
}

export const EditMapCommandMessage: MessageFns<EditMapCommandMessage> = {
  encode(message: EditMapCommandMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.editMapMessage !== undefined) {
      EditMapMessage.encode(message.editMapMessage, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EditMapCommandMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditMapCommandMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.editMapMessage = EditMapMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditMapCommandMessage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      editMapMessage: isSet(object.editMapMessage) ? EditMapMessage.fromJSON(object.editMapMessage) : undefined,
    };
  },

  toJSON(message: EditMapCommandMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.editMapMessage !== undefined) {
      obj.editMapMessage = EditMapMessage.toJSON(message.editMapMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditMapCommandMessage>, I>>(base?: I): EditMapCommandMessage {
    return EditMapCommandMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditMapCommandMessage>, I>>(object: I): EditMapCommandMessage {
    const message = createBaseEditMapCommandMessage();
    message.id = object.id ?? "";
    message.editMapMessage = (object.editMapMessage !== undefined && object.editMapMessage !== null)
      ? EditMapMessage.fromPartial(object.editMapMessage)
      : undefined;
    return message;
  },
};

function createBaseEditMapCommandsArrayMessage(): EditMapCommandsArrayMessage {
  return { editMapCommands: [] };
}

export const EditMapCommandsArrayMessage: MessageFns<EditMapCommandsArrayMessage> = {
  encode(message: EditMapCommandsArrayMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.editMapCommands) {
      EditMapCommandMessage.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EditMapCommandsArrayMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditMapCommandsArrayMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.editMapCommands.push(EditMapCommandMessage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditMapCommandsArrayMessage {
    return {
      editMapCommands: globalThis.Array.isArray(object?.editMapCommands)
        ? object.editMapCommands.map((e: any) => EditMapCommandMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: EditMapCommandsArrayMessage): unknown {
    const obj: any = {};
    if (message.editMapCommands?.length) {
      obj.editMapCommands = message.editMapCommands.map((e) => EditMapCommandMessage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditMapCommandsArrayMessage>, I>>(base?: I): EditMapCommandsArrayMessage {
    return EditMapCommandsArrayMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditMapCommandsArrayMessage>, I>>(object: I): EditMapCommandsArrayMessage {
    const message = createBaseEditMapCommandsArrayMessage();
    message.editMapCommands = object.editMapCommands?.map((e) => EditMapCommandMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEditMapCommandWithKeyMessage(): EditMapCommandWithKeyMessage {
  return { mapKey: "", editMapCommandMessage: undefined, connectedUserTags: [], userCanEdit: false, userUUID: "" };
}

export const EditMapCommandWithKeyMessage: MessageFns<EditMapCommandWithKeyMessage> = {
  encode(message: EditMapCommandWithKeyMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mapKey !== "") {
      writer.uint32(10).string(message.mapKey);
    }
    if (message.editMapCommandMessage !== undefined) {
      EditMapCommandMessage.encode(message.editMapCommandMessage, writer.uint32(18).fork()).join();
    }
    for (const v of message.connectedUserTags) {
      writer.uint32(26).string(v!);
    }
    if (message.userCanEdit !== false) {
      writer.uint32(32).bool(message.userCanEdit);
    }
    if (message.userUUID !== "") {
      writer.uint32(42).string(message.userUUID);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EditMapCommandWithKeyMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditMapCommandWithKeyMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mapKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.editMapCommandMessage = EditMapCommandMessage.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.connectedUserTags.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.userCanEdit = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.userUUID = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditMapCommandWithKeyMessage {
    return {
      mapKey: isSet(object.mapKey) ? globalThis.String(object.mapKey) : "",
      editMapCommandMessage: isSet(object.editMapCommandMessage)
        ? EditMapCommandMessage.fromJSON(object.editMapCommandMessage)
        : undefined,
      connectedUserTags: globalThis.Array.isArray(object?.connectedUserTags)
        ? object.connectedUserTags.map((e: any) => globalThis.String(e))
        : [],
      userCanEdit: isSet(object.userCanEdit) ? globalThis.Boolean(object.userCanEdit) : false,
      userUUID: isSet(object.userUUID) ? globalThis.String(object.userUUID) : "",
    };
  },

  toJSON(message: EditMapCommandWithKeyMessage): unknown {
    const obj: any = {};
    if (message.mapKey !== "") {
      obj.mapKey = message.mapKey;
    }
    if (message.editMapCommandMessage !== undefined) {
      obj.editMapCommandMessage = EditMapCommandMessage.toJSON(message.editMapCommandMessage);
    }
    if (message.connectedUserTags?.length) {
      obj.connectedUserTags = message.connectedUserTags;
    }
    if (message.userCanEdit !== false) {
      obj.userCanEdit = message.userCanEdit;
    }
    if (message.userUUID !== "") {
      obj.userUUID = message.userUUID;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditMapCommandWithKeyMessage>, I>>(base?: I): EditMapCommandWithKeyMessage {
    return EditMapCommandWithKeyMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditMapCommandWithKeyMessage>, I>>(object: I): EditMapCommandWithKeyMessage {
    const message = createBaseEditMapCommandWithKeyMessage();
    message.mapKey = object.mapKey ?? "";
    message.editMapCommandMessage =
      (object.editMapCommandMessage !== undefined && object.editMapCommandMessage !== null)
        ? EditMapCommandMessage.fromPartial(object.editMapCommandMessage)
        : undefined;
    message.connectedUserTags = object.connectedUserTags?.map((e) => e) || [];
    message.userCanEdit = object.userCanEdit ?? false;
    message.userUUID = object.userUUID ?? "";
    return message;
  },
};

function createBaseModifyAreaMessage(): ModifyAreaMessage {
  return {
    id: "",
    name: undefined,
    x: undefined,
    y: undefined,
    width: undefined,
    height: undefined,
    properties: [],
    modifyProperties: undefined,
    modifyServerData: undefined,
  };
}

export const ModifyAreaMessage: MessageFns<ModifyAreaMessage> = {
  encode(message: ModifyAreaMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.x !== undefined) {
      writer.uint32(24).int32(message.x);
    }
    if (message.y !== undefined) {
      writer.uint32(32).int32(message.y);
    }
    if (message.width !== undefined) {
      writer.uint32(40).uint32(message.width);
    }
    if (message.height !== undefined) {
      writer.uint32(48).uint32(message.height);
    }
    for (const v of message.properties) {
      Value.encode(Value.wrap(v!), writer.uint32(58).fork()).join();
    }
    if (message.modifyProperties !== undefined) {
      writer.uint32(64).bool(message.modifyProperties);
    }
    if (message.modifyServerData !== undefined) {
      writer.uint32(72).bool(message.modifyServerData);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModifyAreaMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModifyAreaMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.x = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.y = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.width = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.height = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.properties.push(Value.unwrap(Value.decode(reader, reader.uint32())));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.modifyProperties = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.modifyServerData = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModifyAreaMessage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      x: isSet(object.x) ? globalThis.Number(object.x) : undefined,
      y: isSet(object.y) ? globalThis.Number(object.y) : undefined,
      width: isSet(object.width) ? globalThis.Number(object.width) : undefined,
      height: isSet(object.height) ? globalThis.Number(object.height) : undefined,
      properties: globalThis.Array.isArray(object?.properties) ? [...object.properties] : [],
      modifyProperties: isSet(object.modifyProperties) ? globalThis.Boolean(object.modifyProperties) : undefined,
      modifyServerData: isSet(object.modifyServerData) ? globalThis.Boolean(object.modifyServerData) : undefined,
    };
  },

  toJSON(message: ModifyAreaMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.x !== undefined) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== undefined) {
      obj.y = Math.round(message.y);
    }
    if (message.width !== undefined) {
      obj.width = Math.round(message.width);
    }
    if (message.height !== undefined) {
      obj.height = Math.round(message.height);
    }
    if (message.properties?.length) {
      obj.properties = message.properties;
    }
    if (message.modifyProperties !== undefined) {
      obj.modifyProperties = message.modifyProperties;
    }
    if (message.modifyServerData !== undefined) {
      obj.modifyServerData = message.modifyServerData;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModifyAreaMessage>, I>>(base?: I): ModifyAreaMessage {
    return ModifyAreaMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModifyAreaMessage>, I>>(object: I): ModifyAreaMessage {
    const message = createBaseModifyAreaMessage();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.x = object.x ?? undefined;
    message.y = object.y ?? undefined;
    message.width = object.width ?? undefined;
    message.height = object.height ?? undefined;
    message.properties = object.properties?.map((e) => e) || [];
    message.modifyProperties = object.modifyProperties ?? undefined;
    message.modifyServerData = object.modifyServerData ?? undefined;
    return message;
  },
};

function createBaseDeleteAreaMessage(): DeleteAreaMessage {
  return { id: "" };
}

export const DeleteAreaMessage: MessageFns<DeleteAreaMessage> = {
  encode(message: DeleteAreaMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteAreaMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteAreaMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteAreaMessage {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: DeleteAreaMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteAreaMessage>, I>>(base?: I): DeleteAreaMessage {
    return DeleteAreaMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteAreaMessage>, I>>(object: I): DeleteAreaMessage {
    const message = createBaseDeleteAreaMessage();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseCreateAreaMessage(): CreateAreaMessage {
  return { id: "", x: 0, y: 0, width: 0, height: 0, name: "", properties: [] };
}

export const CreateAreaMessage: MessageFns<CreateAreaMessage> = {
  encode(message: CreateAreaMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.x !== 0) {
      writer.uint32(16).int32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(24).int32(message.y);
    }
    if (message.width !== 0) {
      writer.uint32(32).uint32(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(40).uint32(message.height);
    }
    if (message.name !== "") {
      writer.uint32(50).string(message.name);
    }
    for (const v of message.properties) {
      Value.encode(Value.wrap(v!), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateAreaMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateAreaMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.x = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.y = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.width = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.height = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.properties.push(Value.unwrap(Value.decode(reader, reader.uint32())));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateAreaMessage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      properties: globalThis.Array.isArray(object?.properties) ? [...object.properties] : [],
    };
  },

  toJSON(message: CreateAreaMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.x !== 0) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y);
    }
    if (message.width !== 0) {
      obj.width = Math.round(message.width);
    }
    if (message.height !== 0) {
      obj.height = Math.round(message.height);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.properties?.length) {
      obj.properties = message.properties;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateAreaMessage>, I>>(base?: I): CreateAreaMessage {
    return CreateAreaMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateAreaMessage>, I>>(object: I): CreateAreaMessage {
    const message = createBaseCreateAreaMessage();
    message.id = object.id ?? "";
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    message.name = object.name ?? "";
    message.properties = object.properties?.map((e) => e) || [];
    return message;
  },
};

function createBaseCreateEntityMessage(): CreateEntityMessage {
  return { id: "", x: 0, y: 0, collectionName: "", prefabId: "", properties: [], name: undefined, width: 0, height: 0 };
}

export const CreateEntityMessage: MessageFns<CreateEntityMessage> = {
  encode(message: CreateEntityMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.x !== 0) {
      writer.uint32(16).int32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(24).int32(message.y);
    }
    if (message.collectionName !== "") {
      writer.uint32(34).string(message.collectionName);
    }
    if (message.prefabId !== "") {
      writer.uint32(42).string(message.prefabId);
    }
    for (const v of message.properties) {
      Value.encode(Value.wrap(v!), writer.uint32(50).fork()).join();
    }
    if (message.name !== undefined) {
      writer.uint32(58).string(message.name);
    }
    if (message.width !== 0) {
      writer.uint32(64).uint32(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(72).uint32(message.height);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateEntityMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateEntityMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.x = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.y = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.collectionName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.prefabId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.properties.push(Value.unwrap(Value.decode(reader, reader.uint32())));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.width = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.height = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateEntityMessage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      collectionName: isSet(object.collectionName) ? globalThis.String(object.collectionName) : "",
      prefabId: isSet(object.prefabId) ? globalThis.String(object.prefabId) : "",
      properties: globalThis.Array.isArray(object?.properties) ? [...object.properties] : [],
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
    };
  },

  toJSON(message: CreateEntityMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.x !== 0) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y);
    }
    if (message.collectionName !== "") {
      obj.collectionName = message.collectionName;
    }
    if (message.prefabId !== "") {
      obj.prefabId = message.prefabId;
    }
    if (message.properties?.length) {
      obj.properties = message.properties;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.width !== 0) {
      obj.width = Math.round(message.width);
    }
    if (message.height !== 0) {
      obj.height = Math.round(message.height);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateEntityMessage>, I>>(base?: I): CreateEntityMessage {
    return CreateEntityMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateEntityMessage>, I>>(object: I): CreateEntityMessage {
    const message = createBaseCreateEntityMessage();
    message.id = object.id ?? "";
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.collectionName = object.collectionName ?? "";
    message.prefabId = object.prefabId ?? "";
    message.properties = object.properties?.map((e) => e) || [];
    message.name = object.name ?? undefined;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    return message;
  },
};

function createBaseDeleteEntityMessage(): DeleteEntityMessage {
  return { id: "" };
}

export const DeleteEntityMessage: MessageFns<DeleteEntityMessage> = {
  encode(message: DeleteEntityMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteEntityMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteEntityMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteEntityMessage {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: DeleteEntityMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteEntityMessage>, I>>(base?: I): DeleteEntityMessage {
    return DeleteEntityMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteEntityMessage>, I>>(object: I): DeleteEntityMessage {
    const message = createBaseDeleteEntityMessage();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseCollisionGridRow(): CollisionGridRow {
  return { row: [] };
}

export const CollisionGridRow: MessageFns<CollisionGridRow> = {
  encode(message: CollisionGridRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.row) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CollisionGridRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCollisionGridRow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.row.push(reader.uint32());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.row.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CollisionGridRow {
    return { row: globalThis.Array.isArray(object?.row) ? object.row.map((e: any) => globalThis.Number(e)) : [] };
  },

  toJSON(message: CollisionGridRow): unknown {
    const obj: any = {};
    if (message.row?.length) {
      obj.row = message.row.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CollisionGridRow>, I>>(base?: I): CollisionGridRow {
    return CollisionGridRow.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CollisionGridRow>, I>>(object: I): CollisionGridRow {
    const message = createBaseCollisionGridRow();
    message.row = object.row?.map((e) => e) || [];
    return message;
  },
};

function createBaseUploadEntityMessage(): UploadEntityMessage {
  return {
    file: new Uint8Array(0),
    id: "",
    name: "",
    tags: [],
    imagePath: "",
    direction: 0,
    color: "",
    collisionGrid: undefined,
    depthOffset: undefined,
    ownerId: undefined,
  };
}

export const UploadEntityMessage: MessageFns<UploadEntityMessage> = {
  encode(message: UploadEntityMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.file.length !== 0) {
      writer.uint32(10).bytes(message.file);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    for (const v of message.tags) {
      writer.uint32(34).string(v!);
    }
    if (message.imagePath !== "") {
      writer.uint32(42).string(message.imagePath);
    }
    if (message.direction !== 0) {
      writer.uint32(48).int32(message.direction);
    }
    if (message.color !== "") {
      writer.uint32(58).string(message.color);
    }
    if (message.collisionGrid !== undefined) {
      Value.encode(Value.wrap(message.collisionGrid), writer.uint32(66).fork()).join();
    }
    if (message.depthOffset !== undefined) {
      writer.uint32(72).int32(message.depthOffset);
    }
    if (message.ownerId !== undefined) {
      writer.uint32(82).string(message.ownerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadEntityMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadEntityMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.file = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.imagePath = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.direction = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.color = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.collisionGrid = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.depthOffset = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.ownerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadEntityMessage {
    return {
      file: isSet(object.file) ? bytesFromBase64(object.file) : new Uint8Array(0),
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
      imagePath: isSet(object.imagePath) ? globalThis.String(object.imagePath) : "",
      direction: isSet(object.direction) ? customEntityDirectionFromJSON(object.direction) : 0,
      color: isSet(object.color) ? globalThis.String(object.color) : "",
      collisionGrid: isSet(object?.collisionGrid) ? object.collisionGrid : undefined,
      depthOffset: isSet(object.depthOffset) ? globalThis.Number(object.depthOffset) : undefined,
      ownerId: isSet(object.ownerId) ? globalThis.String(object.ownerId) : undefined,
    };
  },

  toJSON(message: UploadEntityMessage): unknown {
    const obj: any = {};
    if (message.file.length !== 0) {
      obj.file = base64FromBytes(message.file);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.imagePath !== "") {
      obj.imagePath = message.imagePath;
    }
    if (message.direction !== 0) {
      obj.direction = customEntityDirectionToJSON(message.direction);
    }
    if (message.color !== "") {
      obj.color = message.color;
    }
    if (message.collisionGrid !== undefined) {
      obj.collisionGrid = message.collisionGrid;
    }
    if (message.depthOffset !== undefined) {
      obj.depthOffset = Math.round(message.depthOffset);
    }
    if (message.ownerId !== undefined) {
      obj.ownerId = message.ownerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadEntityMessage>, I>>(base?: I): UploadEntityMessage {
    return UploadEntityMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadEntityMessage>, I>>(object: I): UploadEntityMessage {
    const message = createBaseUploadEntityMessage();
    message.file = object.file ?? new Uint8Array(0);
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.tags = object.tags?.map((e) => e) || [];
    message.imagePath = object.imagePath ?? "";
    message.direction = object.direction ?? 0;
    message.color = object.color ?? "";
    message.collisionGrid = object.collisionGrid ?? undefined;
    message.depthOffset = object.depthOffset ?? undefined;
    message.ownerId = object.ownerId ?? undefined;
    return message;
  },
};

function createBaseUploadFileMessage(): UploadFileMessage {
  return { file: new Uint8Array(0), id: "", name: "", propertyId: "", areaId: undefined, entityId: undefined };
}

export const UploadFileMessage: MessageFns<UploadFileMessage> = {
  encode(message: UploadFileMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.file.length !== 0) {
      writer.uint32(10).bytes(message.file);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.propertyId !== "") {
      writer.uint32(34).string(message.propertyId);
    }
    if (message.areaId !== undefined) {
      writer.uint32(42).string(message.areaId);
    }
    if (message.entityId !== undefined) {
      writer.uint32(50).string(message.entityId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadFileMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadFileMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.file = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.propertyId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.areaId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.entityId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadFileMessage {
    return {
      file: isSet(object.file) ? bytesFromBase64(object.file) : new Uint8Array(0),
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      propertyId: isSet(object.propertyId) ? globalThis.String(object.propertyId) : "",
      areaId: isSet(object.areaId) ? globalThis.String(object.areaId) : undefined,
      entityId: isSet(object.entityId) ? globalThis.String(object.entityId) : undefined,
    };
  },

  toJSON(message: UploadFileMessage): unknown {
    const obj: any = {};
    if (message.file.length !== 0) {
      obj.file = base64FromBytes(message.file);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.propertyId !== "") {
      obj.propertyId = message.propertyId;
    }
    if (message.areaId !== undefined) {
      obj.areaId = message.areaId;
    }
    if (message.entityId !== undefined) {
      obj.entityId = message.entityId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadFileMessage>, I>>(base?: I): UploadFileMessage {
    return UploadFileMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadFileMessage>, I>>(object: I): UploadFileMessage {
    const message = createBaseUploadFileMessage();
    message.file = object.file ?? new Uint8Array(0);
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.propertyId = object.propertyId ?? "";
    message.areaId = object.areaId ?? undefined;
    message.entityId = object.entityId ?? undefined;
    return message;
  },
};

function createBaseModifyCustomEntityMessage(): ModifyCustomEntityMessage {
  return { id: "", name: "", tags: [], collisionGrid: undefined, depthOffset: undefined };
}

export const ModifyCustomEntityMessage: MessageFns<ModifyCustomEntityMessage> = {
  encode(message: ModifyCustomEntityMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    for (const v of message.tags) {
      writer.uint32(26).string(v!);
    }
    if (message.collisionGrid !== undefined) {
      Value.encode(Value.wrap(message.collisionGrid), writer.uint32(34).fork()).join();
    }
    if (message.depthOffset !== undefined) {
      writer.uint32(40).int32(message.depthOffset);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModifyCustomEntityMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModifyCustomEntityMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.collisionGrid = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.depthOffset = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModifyCustomEntityMessage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
      collisionGrid: isSet(object?.collisionGrid) ? object.collisionGrid : undefined,
      depthOffset: isSet(object.depthOffset) ? globalThis.Number(object.depthOffset) : undefined,
    };
  },

  toJSON(message: ModifyCustomEntityMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.collisionGrid !== undefined) {
      obj.collisionGrid = message.collisionGrid;
    }
    if (message.depthOffset !== undefined) {
      obj.depthOffset = Math.round(message.depthOffset);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModifyCustomEntityMessage>, I>>(base?: I): ModifyCustomEntityMessage {
    return ModifyCustomEntityMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModifyCustomEntityMessage>, I>>(object: I): ModifyCustomEntityMessage {
    const message = createBaseModifyCustomEntityMessage();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.tags = object.tags?.map((e) => e) || [];
    message.collisionGrid = object.collisionGrid ?? undefined;
    message.depthOffset = object.depthOffset ?? undefined;
    return message;
  },
};

function createBaseDeleteCustomEntityMessage(): DeleteCustomEntityMessage {
  return { id: "" };
}

export const DeleteCustomEntityMessage: MessageFns<DeleteCustomEntityMessage> = {
  encode(message: DeleteCustomEntityMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCustomEntityMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCustomEntityMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteCustomEntityMessage {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: DeleteCustomEntityMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteCustomEntityMessage>, I>>(base?: I): DeleteCustomEntityMessage {
    return DeleteCustomEntityMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteCustomEntityMessage>, I>>(object: I): DeleteCustomEntityMessage {
    const message = createBaseDeleteCustomEntityMessage();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseModifyEntityMessage(): ModifyEntityMessage {
  return { id: "", x: 0, y: 0, properties: [], modifyProperties: undefined, name: undefined, width: 0, height: 0 };
}

export const ModifyEntityMessage: MessageFns<ModifyEntityMessage> = {
  encode(message: ModifyEntityMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.x !== 0) {
      writer.uint32(16).int32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(24).int32(message.y);
    }
    for (const v of message.properties) {
      Value.encode(Value.wrap(v!), writer.uint32(34).fork()).join();
    }
    if (message.modifyProperties !== undefined) {
      writer.uint32(40).bool(message.modifyProperties);
    }
    if (message.name !== undefined) {
      writer.uint32(50).string(message.name);
    }
    if (message.width !== 0) {
      writer.uint32(56).uint32(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(64).uint32(message.height);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModifyEntityMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModifyEntityMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.x = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.y = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.properties.push(Value.unwrap(Value.decode(reader, reader.uint32())));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.modifyProperties = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.width = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.height = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModifyEntityMessage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      properties: globalThis.Array.isArray(object?.properties) ? [...object.properties] : [],
      modifyProperties: isSet(object.modifyProperties) ? globalThis.Boolean(object.modifyProperties) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
    };
  },

  toJSON(message: ModifyEntityMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.x !== 0) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y);
    }
    if (message.properties?.length) {
      obj.properties = message.properties;
    }
    if (message.modifyProperties !== undefined) {
      obj.modifyProperties = message.modifyProperties;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.width !== 0) {
      obj.width = Math.round(message.width);
    }
    if (message.height !== 0) {
      obj.height = Math.round(message.height);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModifyEntityMessage>, I>>(base?: I): ModifyEntityMessage {
    return ModifyEntityMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModifyEntityMessage>, I>>(object: I): ModifyEntityMessage {
    const message = createBaseModifyEntityMessage();
    message.id = object.id ?? "";
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.properties = object.properties?.map((e) => e) || [];
    message.modifyProperties = object.modifyProperties ?? undefined;
    message.name = object.name ?? undefined;
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    return message;
  },
};

function createBaseFrontToPusherWebSocketMessage(): FrontToPusherWebSocketMessage {
  return { nonce: 0, message: undefined };
}

export const FrontToPusherWebSocketMessage: MessageFns<FrontToPusherWebSocketMessage> = {
  encode(message: FrontToPusherWebSocketMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nonce !== 0) {
      writer.uint32(8).uint32(message.nonce);
    }
    if (message.message !== undefined) {
      ClientToServerMessage.encode(message.message, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FrontToPusherWebSocketMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFrontToPusherWebSocketMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.nonce = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = ClientToServerMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FrontToPusherWebSocketMessage {
    return {
      nonce: isSet(object.nonce) ? globalThis.Number(object.nonce) : 0,
      message: isSet(object.message) ? ClientToServerMessage.fromJSON(object.message) : undefined,
    };
  },

  toJSON(message: FrontToPusherWebSocketMessage): unknown {
    const obj: any = {};
    if (message.nonce !== 0) {
      obj.nonce = Math.round(message.nonce);
    }
    if (message.message !== undefined) {
      obj.message = ClientToServerMessage.toJSON(message.message);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FrontToPusherWebSocketMessage>, I>>(base?: I): FrontToPusherWebSocketMessage {
    return FrontToPusherWebSocketMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FrontToPusherWebSocketMessage>, I>>(
    object: I,
  ): FrontToPusherWebSocketMessage {
    const message = createBaseFrontToPusherWebSocketMessage();
    message.nonce = object.nonce ?? 0;
    message.message = (object.message !== undefined && object.message !== null)
      ? ClientToServerMessage.fromPartial(object.message)
      : undefined;
    return message;
  },
};

function createBasePusherToFrontWebSocketMessage(): PusherToFrontWebSocketMessage {
  return { nonce: 0, message: undefined };
}

export const PusherToFrontWebSocketMessage: MessageFns<PusherToFrontWebSocketMessage> = {
  encode(message: PusherToFrontWebSocketMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nonce !== 0) {
      writer.uint32(8).uint32(message.nonce);
    }
    if (message.message !== undefined) {
      ServerToClientMessage.encode(message.message, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PusherToFrontWebSocketMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePusherToFrontWebSocketMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.nonce = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = ServerToClientMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PusherToFrontWebSocketMessage {
    return {
      nonce: isSet(object.nonce) ? globalThis.Number(object.nonce) : 0,
      message: isSet(object.message) ? ServerToClientMessage.fromJSON(object.message) : undefined,
    };
  },

  toJSON(message: PusherToFrontWebSocketMessage): unknown {
    const obj: any = {};
    if (message.nonce !== 0) {
      obj.nonce = Math.round(message.nonce);
    }
    if (message.message !== undefined) {
      obj.message = ServerToClientMessage.toJSON(message.message);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PusherToFrontWebSocketMessage>, I>>(base?: I): PusherToFrontWebSocketMessage {
    return PusherToFrontWebSocketMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PusherToFrontWebSocketMessage>, I>>(
    object: I,
  ): PusherToFrontWebSocketMessage {
    const message = createBasePusherToFrontWebSocketMessage();
    message.nonce = object.nonce ?? 0;
    message.message = (object.message !== undefined && object.message !== null)
      ? ServerToClientMessage.fromPartial(object.message)
      : undefined;
    return message;
  },
};

function createBaseClientToServerMessage(): ClientToServerMessage {
  return { message: undefined };
}

export const ClientToServerMessage: MessageFns<ClientToServerMessage> = {
  encode(message: ClientToServerMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "joinRoomFrontMessage":
        JoinRoomFrontMessage.encode(message.message.joinRoomFrontMessage, writer.uint32(10).fork()).join();
        break;
      case "userMovesMessage":
        UserMovesMessage.encode(message.message.userMovesMessage, writer.uint32(18).fork()).join();
        break;
      case "viewportMessage":
        ViewportMessage.encode(message.message.viewportMessage, writer.uint32(34).fork()).join();
        break;
      case "itemEventMessage":
        ItemEventMessage.encode(message.message.itemEventMessage, writer.uint32(42).fork()).join();
        break;
      case "setPlayerDetailsMessage":
        SetPlayerDetailsMessage.encode(message.message.setPlayerDetailsMessage, writer.uint32(50).fork()).join();
        break;
      case "playGlobalMessage":
        PlayGlobalMessage.encode(message.message.playGlobalMessage, writer.uint32(74).fork()).join();
        break;
      case "reportPlayerMessage":
        ReportPlayerMessage.encode(message.message.reportPlayerMessage, writer.uint32(90).fork()).join();
        break;
      case "emotePromptMessage":
        EmotePromptMessage.encode(message.message.emotePromptMessage, writer.uint32(106).fork()).join();
        break;
      case "variableMessage":
        VariableMessage.encode(message.message.variableMessage, writer.uint32(114).fork()).join();
        break;
      case "followRequestMessage":
        FollowRequestMessage.encode(message.message.followRequestMessage, writer.uint32(122).fork()).join();
        break;
      case "followConfirmationMessage":
        FollowConfirmationMessage.encode(message.message.followConfirmationMessage, writer.uint32(130).fork()).join();
        break;
      case "followAbortMessage":
        FollowAbortMessage.encode(message.message.followAbortMessage, writer.uint32(138).fork()).join();
        break;
      case "lockGroupPromptMessage":
        LockGroupPromptMessage.encode(message.message.lockGroupPromptMessage, writer.uint32(146).fork()).join();
        break;
      case "queryMessage":
        QueryMessage.encode(message.message.queryMessage, writer.uint32(162).fork()).join();
        break;
      case "abortQueryMessage":
        AbortQueryMessage.encode(message.message.abortQueryMessage, writer.uint32(218).fork()).join();
        break;
      case "pingMessage":
        PingMessage.encode(message.message.pingMessage, writer.uint32(170).fork()).join();
        break;
      case "askPositionMessage":
        AskPositionMessage.encode(message.message.askPositionMessage, writer.uint32(186).fork()).join();
        break;
      case "editMapCommandMessage":
        EditMapCommandMessage.encode(message.message.editMapCommandMessage, writer.uint32(194).fork()).join();
        break;
      case "addSpaceFilterMessage":
        AddSpaceFilterMessage.encode(message.message.addSpaceFilterMessage, writer.uint32(202).fork()).join();
        break;
      case "removeSpaceFilterMessage":
        RemoveSpaceFilterMessage.encode(message.message.removeSpaceFilterMessage, writer.uint32(210).fork()).join();
        break;
      case "updateSpaceUserMessage":
        UpdateSpaceUserMessage.encode(message.message.updateSpaceUserMessage, writer.uint32(242).fork()).join();
        break;
      case "updateSpaceMetadataMessage":
        UpdateSpaceMetadataMessage.encode(message.message.updateSpaceMetadataMessage, writer.uint32(282).fork()).join();
        break;
      case "banPlayerMessage":
        BanPlayerMessage.encode(message.message.banPlayerMessage, writer.uint32(330).fork()).join();
        break;
      case "updateChatIdMessage":
        UpdateChatIdMessage.encode(message.message.updateChatIdMessage, writer.uint32(338).fork()).join();
        break;
      case "publicEvent":
        PublicEventFrontToPusher.encode(message.message.publicEvent, writer.uint32(346).fork()).join();
        break;
      case "privateEvent":
        PrivateEventFrontToPusher.encode(message.message.privateEvent, writer.uint32(354).fork()).join();
        break;
      case "backEvent":
        BackEventFrontToPusherMessage.encode(message.message.backEvent, writer.uint32(378).fork()).join();
        break;
      case "leaveChatRoomAreaMessage":
        LeaveChatRoomAreaMessage.encode(message.message.leaveChatRoomAreaMessage, writer.uint32(362).fork()).join();
        break;
      case "meetingInvitationRequestMessage":
        MeetingInvitationRequestMessage.encode(
          message.message.meetingInvitationRequestMessage,
          writer.uint32(386).fork(),
        ).join();
        break;
      case "meetingInvitationResponseMessage":
        MeetingInvitationResponseMessage.encode(
          message.message.meetingInvitationResponseMessage,
          writer.uint32(394).fork(),
        ).join();
        break;
      case "setAreaPropertyVariableMessage":
        SetAreaPropertyVariableMessage.encode(message.message.setAreaPropertyVariableMessage, writer.uint32(370).fork())
          .join();
        break;
      case "videoQualityReportMessage":
        VideoQualityReportMessage.encode(message.message.videoQualityReportMessage, writer.uint32(402).fork()).join();
        break;
      case "analyticsEventReportMessage":
        AnalyticsEventReportMessage.encode(message.message.analyticsEventReportMessage, writer.uint32(418).fork())
          .join();
        break;
      case "entityMessage":
        EntityMessage.encode(message.message.entityMessage, writer.uint32(426).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClientToServerMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientToServerMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = {
            $case: "joinRoomFrontMessage",
            joinRoomFrontMessage: JoinRoomFrontMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = {
            $case: "userMovesMessage",
            userMovesMessage: UserMovesMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = {
            $case: "viewportMessage",
            viewportMessage: ViewportMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.message = {
            $case: "itemEventMessage",
            itemEventMessage: ItemEventMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.message = {
            $case: "setPlayerDetailsMessage",
            setPlayerDetailsMessage: SetPlayerDetailsMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.message = {
            $case: "playGlobalMessage",
            playGlobalMessage: PlayGlobalMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.message = {
            $case: "reportPlayerMessage",
            reportPlayerMessage: ReportPlayerMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.message = {
            $case: "emotePromptMessage",
            emotePromptMessage: EmotePromptMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.message = {
            $case: "variableMessage",
            variableMessage: VariableMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.message = {
            $case: "followRequestMessage",
            followRequestMessage: FollowRequestMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.message = {
            $case: "followConfirmationMessage",
            followConfirmationMessage: FollowConfirmationMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.message = {
            $case: "followAbortMessage",
            followAbortMessage: FollowAbortMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.message = {
            $case: "lockGroupPromptMessage",
            lockGroupPromptMessage: LockGroupPromptMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.message = { $case: "queryMessage", queryMessage: QueryMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.message = {
            $case: "abortQueryMessage",
            abortQueryMessage: AbortQueryMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.message = { $case: "pingMessage", pingMessage: PingMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.message = {
            $case: "askPositionMessage",
            askPositionMessage: AskPositionMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.message = {
            $case: "editMapCommandMessage",
            editMapCommandMessage: EditMapCommandMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.message = {
            $case: "addSpaceFilterMessage",
            addSpaceFilterMessage: AddSpaceFilterMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.message = {
            $case: "removeSpaceFilterMessage",
            removeSpaceFilterMessage: RemoveSpaceFilterMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.message = {
            $case: "updateSpaceUserMessage",
            updateSpaceUserMessage: UpdateSpaceUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.message = {
            $case: "updateSpaceMetadataMessage",
            updateSpaceMetadataMessage: UpdateSpaceMetadataMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.message = {
            $case: "banPlayerMessage",
            banPlayerMessage: BanPlayerMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.message = {
            $case: "updateChatIdMessage",
            updateChatIdMessage: UpdateChatIdMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.message = {
            $case: "publicEvent",
            publicEvent: PublicEventFrontToPusher.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.message = {
            $case: "privateEvent",
            privateEvent: PrivateEventFrontToPusher.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 47: {
          if (tag !== 378) {
            break;
          }

          message.message = {
            $case: "backEvent",
            backEvent: BackEventFrontToPusherMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.message = {
            $case: "leaveChatRoomAreaMessage",
            leaveChatRoomAreaMessage: LeaveChatRoomAreaMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 48: {
          if (tag !== 386) {
            break;
          }

          message.message = {
            $case: "meetingInvitationRequestMessage",
            meetingInvitationRequestMessage: MeetingInvitationRequestMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 49: {
          if (tag !== 394) {
            break;
          }

          message.message = {
            $case: "meetingInvitationResponseMessage",
            meetingInvitationResponseMessage: MeetingInvitationResponseMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 46: {
          if (tag !== 370) {
            break;
          }

          message.message = {
            $case: "setAreaPropertyVariableMessage",
            setAreaPropertyVariableMessage: SetAreaPropertyVariableMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.message = {
            $case: "videoQualityReportMessage",
            videoQualityReportMessage: VideoQualityReportMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 52: {
          if (tag !== 418) {
            break;
          }

          message.message = {
            $case: "analyticsEventReportMessage",
            analyticsEventReportMessage: AnalyticsEventReportMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.message = { $case: "entityMessage", entityMessage: EntityMessage.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClientToServerMessage {
    return {
      message: isSet(object.joinRoomFrontMessage)
        ? {
          $case: "joinRoomFrontMessage",
          joinRoomFrontMessage: JoinRoomFrontMessage.fromJSON(object.joinRoomFrontMessage),
        }
        : isSet(object.userMovesMessage)
        ? { $case: "userMovesMessage", userMovesMessage: UserMovesMessage.fromJSON(object.userMovesMessage) }
        : isSet(object.viewportMessage)
        ? { $case: "viewportMessage", viewportMessage: ViewportMessage.fromJSON(object.viewportMessage) }
        : isSet(object.itemEventMessage)
        ? { $case: "itemEventMessage", itemEventMessage: ItemEventMessage.fromJSON(object.itemEventMessage) }
        : isSet(object.setPlayerDetailsMessage)
        ? {
          $case: "setPlayerDetailsMessage",
          setPlayerDetailsMessage: SetPlayerDetailsMessage.fromJSON(object.setPlayerDetailsMessage),
        }
        : isSet(object.playGlobalMessage)
        ? { $case: "playGlobalMessage", playGlobalMessage: PlayGlobalMessage.fromJSON(object.playGlobalMessage) }
        : isSet(object.reportPlayerMessage)
        ? {
          $case: "reportPlayerMessage",
          reportPlayerMessage: ReportPlayerMessage.fromJSON(object.reportPlayerMessage),
        }
        : isSet(object.emotePromptMessage)
        ? { $case: "emotePromptMessage", emotePromptMessage: EmotePromptMessage.fromJSON(object.emotePromptMessage) }
        : isSet(object.variableMessage)
        ? { $case: "variableMessage", variableMessage: VariableMessage.fromJSON(object.variableMessage) }
        : isSet(object.followRequestMessage)
        ? {
          $case: "followRequestMessage",
          followRequestMessage: FollowRequestMessage.fromJSON(object.followRequestMessage),
        }
        : isSet(object.followConfirmationMessage)
        ? {
          $case: "followConfirmationMessage",
          followConfirmationMessage: FollowConfirmationMessage.fromJSON(object.followConfirmationMessage),
        }
        : isSet(object.followAbortMessage)
        ? { $case: "followAbortMessage", followAbortMessage: FollowAbortMessage.fromJSON(object.followAbortMessage) }
        : isSet(object.lockGroupPromptMessage)
        ? {
          $case: "lockGroupPromptMessage",
          lockGroupPromptMessage: LockGroupPromptMessage.fromJSON(object.lockGroupPromptMessage),
        }
        : isSet(object.queryMessage)
        ? { $case: "queryMessage", queryMessage: QueryMessage.fromJSON(object.queryMessage) }
        : isSet(object.abortQueryMessage)
        ? { $case: "abortQueryMessage", abortQueryMessage: AbortQueryMessage.fromJSON(object.abortQueryMessage) }
        : isSet(object.pingMessage)
        ? { $case: "pingMessage", pingMessage: PingMessage.fromJSON(object.pingMessage) }
        : isSet(object.askPositionMessage)
        ? { $case: "askPositionMessage", askPositionMessage: AskPositionMessage.fromJSON(object.askPositionMessage) }
        : isSet(object.editMapCommandMessage)
        ? {
          $case: "editMapCommandMessage",
          editMapCommandMessage: EditMapCommandMessage.fromJSON(object.editMapCommandMessage),
        }
        : isSet(object.addSpaceFilterMessage)
        ? {
          $case: "addSpaceFilterMessage",
          addSpaceFilterMessage: AddSpaceFilterMessage.fromJSON(object.addSpaceFilterMessage),
        }
        : isSet(object.removeSpaceFilterMessage)
        ? {
          $case: "removeSpaceFilterMessage",
          removeSpaceFilterMessage: RemoveSpaceFilterMessage.fromJSON(object.removeSpaceFilterMessage),
        }
        : isSet(object.updateSpaceUserMessage)
        ? {
          $case: "updateSpaceUserMessage",
          updateSpaceUserMessage: UpdateSpaceUserMessage.fromJSON(object.updateSpaceUserMessage),
        }
        : isSet(object.updateSpaceMetadataMessage)
        ? {
          $case: "updateSpaceMetadataMessage",
          updateSpaceMetadataMessage: UpdateSpaceMetadataMessage.fromJSON(object.updateSpaceMetadataMessage),
        }
        : isSet(object.banPlayerMessage)
        ? { $case: "banPlayerMessage", banPlayerMessage: BanPlayerMessage.fromJSON(object.banPlayerMessage) }
        : isSet(object.updateChatIdMessage)
        ? {
          $case: "updateChatIdMessage",
          updateChatIdMessage: UpdateChatIdMessage.fromJSON(object.updateChatIdMessage),
        }
        : isSet(object.publicEvent)
        ? { $case: "publicEvent", publicEvent: PublicEventFrontToPusher.fromJSON(object.publicEvent) }
        : isSet(object.privateEvent)
        ? { $case: "privateEvent", privateEvent: PrivateEventFrontToPusher.fromJSON(object.privateEvent) }
        : isSet(object.backEvent)
        ? { $case: "backEvent", backEvent: BackEventFrontToPusherMessage.fromJSON(object.backEvent) }
        : isSet(object.leaveChatRoomAreaMessage)
        ? {
          $case: "leaveChatRoomAreaMessage",
          leaveChatRoomAreaMessage: LeaveChatRoomAreaMessage.fromJSON(object.leaveChatRoomAreaMessage),
        }
        : isSet(object.meetingInvitationRequestMessage)
        ? {
          $case: "meetingInvitationRequestMessage",
          meetingInvitationRequestMessage: MeetingInvitationRequestMessage.fromJSON(
            object.meetingInvitationRequestMessage,
          ),
        }
        : isSet(object.meetingInvitationResponseMessage)
        ? {
          $case: "meetingInvitationResponseMessage",
          meetingInvitationResponseMessage: MeetingInvitationResponseMessage.fromJSON(
            object.meetingInvitationResponseMessage,
          ),
        }
        : isSet(object.setAreaPropertyVariableMessage)
        ? {
          $case: "setAreaPropertyVariableMessage",
          setAreaPropertyVariableMessage: SetAreaPropertyVariableMessage.fromJSON(
            object.setAreaPropertyVariableMessage,
          ),
        }
        : isSet(object.videoQualityReportMessage)
        ? {
          $case: "videoQualityReportMessage",
          videoQualityReportMessage: VideoQualityReportMessage.fromJSON(object.videoQualityReportMessage),
        }
        : isSet(object.analyticsEventReportMessage)
        ? {
          $case: "analyticsEventReportMessage",
          analyticsEventReportMessage: AnalyticsEventReportMessage.fromJSON(object.analyticsEventReportMessage),
        }
        : isSet(object.entityMessage)
        ? { $case: "entityMessage", entityMessage: EntityMessage.fromJSON(object.entityMessage) }
        : undefined,
    };
  },

  toJSON(message: ClientToServerMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "joinRoomFrontMessage") {
      obj.joinRoomFrontMessage = JoinRoomFrontMessage.toJSON(message.message.joinRoomFrontMessage);
    } else if (message.message?.$case === "userMovesMessage") {
      obj.userMovesMessage = UserMovesMessage.toJSON(message.message.userMovesMessage);
    } else if (message.message?.$case === "viewportMessage") {
      obj.viewportMessage = ViewportMessage.toJSON(message.message.viewportMessage);
    } else if (message.message?.$case === "itemEventMessage") {
      obj.itemEventMessage = ItemEventMessage.toJSON(message.message.itemEventMessage);
    } else if (message.message?.$case === "setPlayerDetailsMessage") {
      obj.setPlayerDetailsMessage = SetPlayerDetailsMessage.toJSON(message.message.setPlayerDetailsMessage);
    } else if (message.message?.$case === "playGlobalMessage") {
      obj.playGlobalMessage = PlayGlobalMessage.toJSON(message.message.playGlobalMessage);
    } else if (message.message?.$case === "reportPlayerMessage") {
      obj.reportPlayerMessage = ReportPlayerMessage.toJSON(message.message.reportPlayerMessage);
    } else if (message.message?.$case === "emotePromptMessage") {
      obj.emotePromptMessage = EmotePromptMessage.toJSON(message.message.emotePromptMessage);
    } else if (message.message?.$case === "variableMessage") {
      obj.variableMessage = VariableMessage.toJSON(message.message.variableMessage);
    } else if (message.message?.$case === "followRequestMessage") {
      obj.followRequestMessage = FollowRequestMessage.toJSON(message.message.followRequestMessage);
    } else if (message.message?.$case === "followConfirmationMessage") {
      obj.followConfirmationMessage = FollowConfirmationMessage.toJSON(message.message.followConfirmationMessage);
    } else if (message.message?.$case === "followAbortMessage") {
      obj.followAbortMessage = FollowAbortMessage.toJSON(message.message.followAbortMessage);
    } else if (message.message?.$case === "lockGroupPromptMessage") {
      obj.lockGroupPromptMessage = LockGroupPromptMessage.toJSON(message.message.lockGroupPromptMessage);
    } else if (message.message?.$case === "queryMessage") {
      obj.queryMessage = QueryMessage.toJSON(message.message.queryMessage);
    } else if (message.message?.$case === "abortQueryMessage") {
      obj.abortQueryMessage = AbortQueryMessage.toJSON(message.message.abortQueryMessage);
    } else if (message.message?.$case === "pingMessage") {
      obj.pingMessage = PingMessage.toJSON(message.message.pingMessage);
    } else if (message.message?.$case === "askPositionMessage") {
      obj.askPositionMessage = AskPositionMessage.toJSON(message.message.askPositionMessage);
    } else if (message.message?.$case === "editMapCommandMessage") {
      obj.editMapCommandMessage = EditMapCommandMessage.toJSON(message.message.editMapCommandMessage);
    } else if (message.message?.$case === "addSpaceFilterMessage") {
      obj.addSpaceFilterMessage = AddSpaceFilterMessage.toJSON(message.message.addSpaceFilterMessage);
    } else if (message.message?.$case === "removeSpaceFilterMessage") {
      obj.removeSpaceFilterMessage = RemoveSpaceFilterMessage.toJSON(message.message.removeSpaceFilterMessage);
    } else if (message.message?.$case === "updateSpaceUserMessage") {
      obj.updateSpaceUserMessage = UpdateSpaceUserMessage.toJSON(message.message.updateSpaceUserMessage);
    } else if (message.message?.$case === "updateSpaceMetadataMessage") {
      obj.updateSpaceMetadataMessage = UpdateSpaceMetadataMessage.toJSON(message.message.updateSpaceMetadataMessage);
    } else if (message.message?.$case === "banPlayerMessage") {
      obj.banPlayerMessage = BanPlayerMessage.toJSON(message.message.banPlayerMessage);
    } else if (message.message?.$case === "updateChatIdMessage") {
      obj.updateChatIdMessage = UpdateChatIdMessage.toJSON(message.message.updateChatIdMessage);
    } else if (message.message?.$case === "publicEvent") {
      obj.publicEvent = PublicEventFrontToPusher.toJSON(message.message.publicEvent);
    } else if (message.message?.$case === "privateEvent") {
      obj.privateEvent = PrivateEventFrontToPusher.toJSON(message.message.privateEvent);
    } else if (message.message?.$case === "backEvent") {
      obj.backEvent = BackEventFrontToPusherMessage.toJSON(message.message.backEvent);
    } else if (message.message?.$case === "leaveChatRoomAreaMessage") {
      obj.leaveChatRoomAreaMessage = LeaveChatRoomAreaMessage.toJSON(message.message.leaveChatRoomAreaMessage);
    } else if (message.message?.$case === "meetingInvitationRequestMessage") {
      obj.meetingInvitationRequestMessage = MeetingInvitationRequestMessage.toJSON(
        message.message.meetingInvitationRequestMessage,
      );
    } else if (message.message?.$case === "meetingInvitationResponseMessage") {
      obj.meetingInvitationResponseMessage = MeetingInvitationResponseMessage.toJSON(
        message.message.meetingInvitationResponseMessage,
      );
    } else if (message.message?.$case === "setAreaPropertyVariableMessage") {
      obj.setAreaPropertyVariableMessage = SetAreaPropertyVariableMessage.toJSON(
        message.message.setAreaPropertyVariableMessage,
      );
    } else if (message.message?.$case === "videoQualityReportMessage") {
      obj.videoQualityReportMessage = VideoQualityReportMessage.toJSON(message.message.videoQualityReportMessage);
    } else if (message.message?.$case === "analyticsEventReportMessage") {
      obj.analyticsEventReportMessage = AnalyticsEventReportMessage.toJSON(message.message.analyticsEventReportMessage);
    } else if (message.message?.$case === "entityMessage") {
      obj.entityMessage = EntityMessage.toJSON(message.message.entityMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClientToServerMessage>, I>>(base?: I): ClientToServerMessage {
    return ClientToServerMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClientToServerMessage>, I>>(object: I): ClientToServerMessage {
    const message = createBaseClientToServerMessage();
    switch (object.message?.$case) {
      case "joinRoomFrontMessage": {
        if (object.message?.joinRoomFrontMessage !== undefined && object.message?.joinRoomFrontMessage !== null) {
          message.message = {
            $case: "joinRoomFrontMessage",
            joinRoomFrontMessage: JoinRoomFrontMessage.fromPartial(object.message.joinRoomFrontMessage),
          };
        }
        break;
      }
      case "userMovesMessage": {
        if (object.message?.userMovesMessage !== undefined && object.message?.userMovesMessage !== null) {
          message.message = {
            $case: "userMovesMessage",
            userMovesMessage: UserMovesMessage.fromPartial(object.message.userMovesMessage),
          };
        }
        break;
      }
      case "viewportMessage": {
        if (object.message?.viewportMessage !== undefined && object.message?.viewportMessage !== null) {
          message.message = {
            $case: "viewportMessage",
            viewportMessage: ViewportMessage.fromPartial(object.message.viewportMessage),
          };
        }
        break;
      }
      case "itemEventMessage": {
        if (object.message?.itemEventMessage !== undefined && object.message?.itemEventMessage !== null) {
          message.message = {
            $case: "itemEventMessage",
            itemEventMessage: ItemEventMessage.fromPartial(object.message.itemEventMessage),
          };
        }
        break;
      }
      case "setPlayerDetailsMessage": {
        if (object.message?.setPlayerDetailsMessage !== undefined && object.message?.setPlayerDetailsMessage !== null) {
          message.message = {
            $case: "setPlayerDetailsMessage",
            setPlayerDetailsMessage: SetPlayerDetailsMessage.fromPartial(object.message.setPlayerDetailsMessage),
          };
        }
        break;
      }
      case "playGlobalMessage": {
        if (object.message?.playGlobalMessage !== undefined && object.message?.playGlobalMessage !== null) {
          message.message = {
            $case: "playGlobalMessage",
            playGlobalMessage: PlayGlobalMessage.fromPartial(object.message.playGlobalMessage),
          };
        }
        break;
      }
      case "reportPlayerMessage": {
        if (object.message?.reportPlayerMessage !== undefined && object.message?.reportPlayerMessage !== null) {
          message.message = {
            $case: "reportPlayerMessage",
            reportPlayerMessage: ReportPlayerMessage.fromPartial(object.message.reportPlayerMessage),
          };
        }
        break;
      }
      case "emotePromptMessage": {
        if (object.message?.emotePromptMessage !== undefined && object.message?.emotePromptMessage !== null) {
          message.message = {
            $case: "emotePromptMessage",
            emotePromptMessage: EmotePromptMessage.fromPartial(object.message.emotePromptMessage),
          };
        }
        break;
      }
      case "variableMessage": {
        if (object.message?.variableMessage !== undefined && object.message?.variableMessage !== null) {
          message.message = {
            $case: "variableMessage",
            variableMessage: VariableMessage.fromPartial(object.message.variableMessage),
          };
        }
        break;
      }
      case "followRequestMessage": {
        if (object.message?.followRequestMessage !== undefined && object.message?.followRequestMessage !== null) {
          message.message = {
            $case: "followRequestMessage",
            followRequestMessage: FollowRequestMessage.fromPartial(object.message.followRequestMessage),
          };
        }
        break;
      }
      case "followConfirmationMessage": {
        if (
          object.message?.followConfirmationMessage !== undefined && object.message?.followConfirmationMessage !== null
        ) {
          message.message = {
            $case: "followConfirmationMessage",
            followConfirmationMessage: FollowConfirmationMessage.fromPartial(object.message.followConfirmationMessage),
          };
        }
        break;
      }
      case "followAbortMessage": {
        if (object.message?.followAbortMessage !== undefined && object.message?.followAbortMessage !== null) {
          message.message = {
            $case: "followAbortMessage",
            followAbortMessage: FollowAbortMessage.fromPartial(object.message.followAbortMessage),
          };
        }
        break;
      }
      case "lockGroupPromptMessage": {
        if (object.message?.lockGroupPromptMessage !== undefined && object.message?.lockGroupPromptMessage !== null) {
          message.message = {
            $case: "lockGroupPromptMessage",
            lockGroupPromptMessage: LockGroupPromptMessage.fromPartial(object.message.lockGroupPromptMessage),
          };
        }
        break;
      }
      case "queryMessage": {
        if (object.message?.queryMessage !== undefined && object.message?.queryMessage !== null) {
          message.message = {
            $case: "queryMessage",
            queryMessage: QueryMessage.fromPartial(object.message.queryMessage),
          };
        }
        break;
      }
      case "abortQueryMessage": {
        if (object.message?.abortQueryMessage !== undefined && object.message?.abortQueryMessage !== null) {
          message.message = {
            $case: "abortQueryMessage",
            abortQueryMessage: AbortQueryMessage.fromPartial(object.message.abortQueryMessage),
          };
        }
        break;
      }
      case "pingMessage": {
        if (object.message?.pingMessage !== undefined && object.message?.pingMessage !== null) {
          message.message = { $case: "pingMessage", pingMessage: PingMessage.fromPartial(object.message.pingMessage) };
        }
        break;
      }
      case "askPositionMessage": {
        if (object.message?.askPositionMessage !== undefined && object.message?.askPositionMessage !== null) {
          message.message = {
            $case: "askPositionMessage",
            askPositionMessage: AskPositionMessage.fromPartial(object.message.askPositionMessage),
          };
        }
        break;
      }
      case "editMapCommandMessage": {
        if (object.message?.editMapCommandMessage !== undefined && object.message?.editMapCommandMessage !== null) {
          message.message = {
            $case: "editMapCommandMessage",
            editMapCommandMessage: EditMapCommandMessage.fromPartial(object.message.editMapCommandMessage),
          };
        }
        break;
      }
      case "addSpaceFilterMessage": {
        if (object.message?.addSpaceFilterMessage !== undefined && object.message?.addSpaceFilterMessage !== null) {
          message.message = {
            $case: "addSpaceFilterMessage",
            addSpaceFilterMessage: AddSpaceFilterMessage.fromPartial(object.message.addSpaceFilterMessage),
          };
        }
        break;
      }
      case "removeSpaceFilterMessage": {
        if (
          object.message?.removeSpaceFilterMessage !== undefined && object.message?.removeSpaceFilterMessage !== null
        ) {
          message.message = {
            $case: "removeSpaceFilterMessage",
            removeSpaceFilterMessage: RemoveSpaceFilterMessage.fromPartial(object.message.removeSpaceFilterMessage),
          };
        }
        break;
      }
      case "updateSpaceUserMessage": {
        if (object.message?.updateSpaceUserMessage !== undefined && object.message?.updateSpaceUserMessage !== null) {
          message.message = {
            $case: "updateSpaceUserMessage",
            updateSpaceUserMessage: UpdateSpaceUserMessage.fromPartial(object.message.updateSpaceUserMessage),
          };
        }
        break;
      }
      case "updateSpaceMetadataMessage": {
        if (
          object.message?.updateSpaceMetadataMessage !== undefined &&
          object.message?.updateSpaceMetadataMessage !== null
        ) {
          message.message = {
            $case: "updateSpaceMetadataMessage",
            updateSpaceMetadataMessage: UpdateSpaceMetadataMessage.fromPartial(
              object.message.updateSpaceMetadataMessage,
            ),
          };
        }
        break;
      }
      case "banPlayerMessage": {
        if (object.message?.banPlayerMessage !== undefined && object.message?.banPlayerMessage !== null) {
          message.message = {
            $case: "banPlayerMessage",
            banPlayerMessage: BanPlayerMessage.fromPartial(object.message.banPlayerMessage),
          };
        }
        break;
      }
      case "updateChatIdMessage": {
        if (object.message?.updateChatIdMessage !== undefined && object.message?.updateChatIdMessage !== null) {
          message.message = {
            $case: "updateChatIdMessage",
            updateChatIdMessage: UpdateChatIdMessage.fromPartial(object.message.updateChatIdMessage),
          };
        }
        break;
      }
      case "publicEvent": {
        if (object.message?.publicEvent !== undefined && object.message?.publicEvent !== null) {
          message.message = {
            $case: "publicEvent",
            publicEvent: PublicEventFrontToPusher.fromPartial(object.message.publicEvent),
          };
        }
        break;
      }
      case "privateEvent": {
        if (object.message?.privateEvent !== undefined && object.message?.privateEvent !== null) {
          message.message = {
            $case: "privateEvent",
            privateEvent: PrivateEventFrontToPusher.fromPartial(object.message.privateEvent),
          };
        }
        break;
      }
      case "backEvent": {
        if (object.message?.backEvent !== undefined && object.message?.backEvent !== null) {
          message.message = {
            $case: "backEvent",
            backEvent: BackEventFrontToPusherMessage.fromPartial(object.message.backEvent),
          };
        }
        break;
      }
      case "leaveChatRoomAreaMessage": {
        if (
          object.message?.leaveChatRoomAreaMessage !== undefined && object.message?.leaveChatRoomAreaMessage !== null
        ) {
          message.message = {
            $case: "leaveChatRoomAreaMessage",
            leaveChatRoomAreaMessage: LeaveChatRoomAreaMessage.fromPartial(object.message.leaveChatRoomAreaMessage),
          };
        }
        break;
      }
      case "meetingInvitationRequestMessage": {
        if (
          object.message?.meetingInvitationRequestMessage !== undefined &&
          object.message?.meetingInvitationRequestMessage !== null
        ) {
          message.message = {
            $case: "meetingInvitationRequestMessage",
            meetingInvitationRequestMessage: MeetingInvitationRequestMessage.fromPartial(
              object.message.meetingInvitationRequestMessage,
            ),
          };
        }
        break;
      }
      case "meetingInvitationResponseMessage": {
        if (
          object.message?.meetingInvitationResponseMessage !== undefined &&
          object.message?.meetingInvitationResponseMessage !== null
        ) {
          message.message = {
            $case: "meetingInvitationResponseMessage",
            meetingInvitationResponseMessage: MeetingInvitationResponseMessage.fromPartial(
              object.message.meetingInvitationResponseMessage,
            ),
          };
        }
        break;
      }
      case "setAreaPropertyVariableMessage": {
        if (
          object.message?.setAreaPropertyVariableMessage !== undefined &&
          object.message?.setAreaPropertyVariableMessage !== null
        ) {
          message.message = {
            $case: "setAreaPropertyVariableMessage",
            setAreaPropertyVariableMessage: SetAreaPropertyVariableMessage.fromPartial(
              object.message.setAreaPropertyVariableMessage,
            ),
          };
        }
        break;
      }
      case "videoQualityReportMessage": {
        if (
          object.message?.videoQualityReportMessage !== undefined && object.message?.videoQualityReportMessage !== null
        ) {
          message.message = {
            $case: "videoQualityReportMessage",
            videoQualityReportMessage: VideoQualityReportMessage.fromPartial(object.message.videoQualityReportMessage),
          };
        }
        break;
      }
      case "analyticsEventReportMessage": {
        if (
          object.message?.analyticsEventReportMessage !== undefined &&
          object.message?.analyticsEventReportMessage !== null
        ) {
          message.message = {
            $case: "analyticsEventReportMessage",
            analyticsEventReportMessage: AnalyticsEventReportMessage.fromPartial(
              object.message.analyticsEventReportMessage,
            ),
          };
        }
        break;
      }
      case "entityMessage": {
        if (object.message?.entityMessage !== undefined && object.message?.entityMessage !== null) {
          message.message = {
            $case: "entityMessage",
            entityMessage: EntityMessage.fromPartial(object.message.entityMessage),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseReceivedEventMessage(): ReceivedEventMessage {
  return { name: "", data: undefined, senderId: undefined };
}

export const ReceivedEventMessage: MessageFns<ReceivedEventMessage> = {
  encode(message: ReceivedEventMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.data !== undefined) {
      Value.encode(Value.wrap(message.data), writer.uint32(18).fork()).join();
    }
    if (message.senderId !== undefined) {
      writer.uint32(24).int32(message.senderId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReceivedEventMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReceivedEventMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.senderId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReceivedEventMessage {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      data: isSet(object?.data) ? object.data : undefined,
      senderId: isSet(object.senderId) ? globalThis.Number(object.senderId) : undefined,
    };
  },

  toJSON(message: ReceivedEventMessage): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.data !== undefined) {
      obj.data = message.data;
    }
    if (message.senderId !== undefined) {
      obj.senderId = Math.round(message.senderId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReceivedEventMessage>, I>>(base?: I): ReceivedEventMessage {
    return ReceivedEventMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReceivedEventMessage>, I>>(object: I): ReceivedEventMessage {
    const message = createBaseReceivedEventMessage();
    message.name = object.name ?? "";
    message.data = object.data ?? undefined;
    message.senderId = object.senderId ?? undefined;
    return message;
  },
};

function createBaseModifiyWAMMetadataMessage(): ModifiyWAMMetadataMessage {
  return { name: "", description: undefined, copyright: undefined, thumbnail: undefined, tags: undefined };
}

export const ModifiyWAMMetadataMessage: MessageFns<ModifiyWAMMetadataMessage> = {
  encode(message: ModifiyWAMMetadataMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    if (message.copyright !== undefined) {
      writer.uint32(26).string(message.copyright);
    }
    if (message.thumbnail !== undefined) {
      writer.uint32(34).string(message.thumbnail);
    }
    if (message.tags !== undefined) {
      writer.uint32(42).string(message.tags);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModifiyWAMMetadataMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModifiyWAMMetadataMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.copyright = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.thumbnail = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tags = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModifiyWAMMetadataMessage {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      copyright: isSet(object.copyright) ? globalThis.String(object.copyright) : undefined,
      thumbnail: isSet(object.thumbnail) ? globalThis.String(object.thumbnail) : undefined,
      tags: isSet(object.tags) ? globalThis.String(object.tags) : undefined,
    };
  },

  toJSON(message: ModifiyWAMMetadataMessage): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.copyright !== undefined) {
      obj.copyright = message.copyright;
    }
    if (message.thumbnail !== undefined) {
      obj.thumbnail = message.thumbnail;
    }
    if (message.tags !== undefined) {
      obj.tags = message.tags;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModifiyWAMMetadataMessage>, I>>(base?: I): ModifiyWAMMetadataMessage {
    return ModifiyWAMMetadataMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModifiyWAMMetadataMessage>, I>>(object: I): ModifiyWAMMetadataMessage {
    const message = createBaseModifiyWAMMetadataMessage();
    message.name = object.name ?? "";
    message.description = object.description ?? undefined;
    message.copyright = object.copyright ?? undefined;
    message.thumbnail = object.thumbnail ?? undefined;
    message.tags = object.tags ?? undefined;
    return message;
  },
};

function createBaseItemEventMessage(): ItemEventMessage {
  return { itemId: 0, event: "", stateJson: "", parametersJson: "" };
}

export const ItemEventMessage: MessageFns<ItemEventMessage> = {
  encode(message: ItemEventMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.itemId !== 0) {
      writer.uint32(8).int32(message.itemId);
    }
    if (message.event !== "") {
      writer.uint32(18).string(message.event);
    }
    if (message.stateJson !== "") {
      writer.uint32(26).string(message.stateJson);
    }
    if (message.parametersJson !== "") {
      writer.uint32(34).string(message.parametersJson);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ItemEventMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseItemEventMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.itemId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.event = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.stateJson = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parametersJson = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ItemEventMessage {
    return {
      itemId: isSet(object.itemId) ? globalThis.Number(object.itemId) : 0,
      event: isSet(object.event) ? globalThis.String(object.event) : "",
      stateJson: isSet(object.stateJson) ? globalThis.String(object.stateJson) : "",
      parametersJson: isSet(object.parametersJson) ? globalThis.String(object.parametersJson) : "",
    };
  },

  toJSON(message: ItemEventMessage): unknown {
    const obj: any = {};
    if (message.itemId !== 0) {
      obj.itemId = Math.round(message.itemId);
    }
    if (message.event !== "") {
      obj.event = message.event;
    }
    if (message.stateJson !== "") {
      obj.stateJson = message.stateJson;
    }
    if (message.parametersJson !== "") {
      obj.parametersJson = message.parametersJson;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ItemEventMessage>, I>>(base?: I): ItemEventMessage {
    return ItemEventMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ItemEventMessage>, I>>(object: I): ItemEventMessage {
    const message = createBaseItemEventMessage();
    message.itemId = object.itemId ?? 0;
    message.event = object.event ?? "";
    message.stateJson = object.stateJson ?? "";
    message.parametersJson = object.parametersJson ?? "";
    return message;
  },
};

function createBaseVariableMessage(): VariableMessage {
  return { name: "", value: "" };
}

export const VariableMessage: MessageFns<VariableMessage> = {
  encode(message: VariableMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableMessage {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: VariableMessage): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VariableMessage>, I>>(base?: I): VariableMessage {
    return VariableMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VariableMessage>, I>>(object: I): VariableMessage {
    const message = createBaseVariableMessage();
    message.name = object.name ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseSetAreaPropertyVariableMessage(): SetAreaPropertyVariableMessage {
  return { areaId: "", propertyId: "", key: "", value: "" };
}

export const SetAreaPropertyVariableMessage: MessageFns<SetAreaPropertyVariableMessage> = {
  encode(message: SetAreaPropertyVariableMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.areaId !== "") {
      writer.uint32(10).string(message.areaId);
    }
    if (message.propertyId !== "") {
      writer.uint32(18).string(message.propertyId);
    }
    if (message.key !== "") {
      writer.uint32(26).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(34).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetAreaPropertyVariableMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetAreaPropertyVariableMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.areaId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.propertyId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetAreaPropertyVariableMessage {
    return {
      areaId: isSet(object.areaId) ? globalThis.String(object.areaId) : "",
      propertyId: isSet(object.propertyId) ? globalThis.String(object.propertyId) : "",
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: SetAreaPropertyVariableMessage): unknown {
    const obj: any = {};
    if (message.areaId !== "") {
      obj.areaId = message.areaId;
    }
    if (message.propertyId !== "") {
      obj.propertyId = message.propertyId;
    }
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetAreaPropertyVariableMessage>, I>>(base?: I): SetAreaPropertyVariableMessage {
    return SetAreaPropertyVariableMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetAreaPropertyVariableMessage>, I>>(
    object: I,
  ): SetAreaPropertyVariableMessage {
    const message = createBaseSetAreaPropertyVariableMessage();
    message.areaId = object.areaId ?? "";
    message.propertyId = object.propertyId ?? "";
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseAreaPropertyVariableMessage(): AreaPropertyVariableMessage {
  return { areaId: "", propertyId: "", key: "", value: "" };
}

export const AreaPropertyVariableMessage: MessageFns<AreaPropertyVariableMessage> = {
  encode(message: AreaPropertyVariableMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.areaId !== "") {
      writer.uint32(10).string(message.areaId);
    }
    if (message.propertyId !== "") {
      writer.uint32(18).string(message.propertyId);
    }
    if (message.key !== "") {
      writer.uint32(26).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(34).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AreaPropertyVariableMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAreaPropertyVariableMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.areaId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.propertyId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AreaPropertyVariableMessage {
    return {
      areaId: isSet(object.areaId) ? globalThis.String(object.areaId) : "",
      propertyId: isSet(object.propertyId) ? globalThis.String(object.propertyId) : "",
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: AreaPropertyVariableMessage): unknown {
    const obj: any = {};
    if (message.areaId !== "") {
      obj.areaId = message.areaId;
    }
    if (message.propertyId !== "") {
      obj.propertyId = message.propertyId;
    }
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AreaPropertyVariableMessage>, I>>(base?: I): AreaPropertyVariableMessage {
    return AreaPropertyVariableMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AreaPropertyVariableMessage>, I>>(object: I): AreaPropertyVariableMessage {
    const message = createBaseAreaPropertyVariableMessage();
    message.areaId = object.areaId ?? "";
    message.propertyId = object.propertyId ?? "";
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseEntitySoundPlayed(): EntitySoundPlayed {
  return { soundUrl: "" };
}

export const EntitySoundPlayed: MessageFns<EntitySoundPlayed> = {
  encode(message: EntitySoundPlayed, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.soundUrl !== "") {
      writer.uint32(10).string(message.soundUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntitySoundPlayed {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntitySoundPlayed();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.soundUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntitySoundPlayed {
    return { soundUrl: isSet(object.soundUrl) ? globalThis.String(object.soundUrl) : "" };
  },

  toJSON(message: EntitySoundPlayed): unknown {
    const obj: any = {};
    if (message.soundUrl !== "") {
      obj.soundUrl = message.soundUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntitySoundPlayed>, I>>(base?: I): EntitySoundPlayed {
    return EntitySoundPlayed.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntitySoundPlayed>, I>>(object: I): EntitySoundPlayed {
    const message = createBaseEntitySoundPlayed();
    message.soundUrl = object.soundUrl ?? "";
    return message;
  },
};

function createBaseEntityEvent(): EntityEvent {
  return { event: undefined };
}

export const EntityEvent: MessageFns<EntityEvent> = {
  encode(message: EntityEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.event?.$case) {
      case "entitySoundPlayed":
        EntitySoundPlayed.encode(message.event.entitySoundPlayed, writer.uint32(10).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntityEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntityEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.event = {
            $case: "entitySoundPlayed",
            entitySoundPlayed: EntitySoundPlayed.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntityEvent {
    return {
      event: isSet(object.entitySoundPlayed)
        ? { $case: "entitySoundPlayed", entitySoundPlayed: EntitySoundPlayed.fromJSON(object.entitySoundPlayed) }
        : undefined,
    };
  },

  toJSON(message: EntityEvent): unknown {
    const obj: any = {};
    if (message.event?.$case === "entitySoundPlayed") {
      obj.entitySoundPlayed = EntitySoundPlayed.toJSON(message.event.entitySoundPlayed);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntityEvent>, I>>(base?: I): EntityEvent {
    return EntityEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntityEvent>, I>>(object: I): EntityEvent {
    const message = createBaseEntityEvent();
    switch (object.event?.$case) {
      case "entitySoundPlayed": {
        if (object.event?.entitySoundPlayed !== undefined && object.event?.entitySoundPlayed !== null) {
          message.event = {
            $case: "entitySoundPlayed",
            entitySoundPlayed: EntitySoundPlayed.fromPartial(object.event.entitySoundPlayed),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseEntityMessage(): EntityMessage {
  return { entityId: "", entityEvent: undefined };
}

export const EntityMessage: MessageFns<EntityMessage> = {
  encode(message: EntityMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.entityId !== "") {
      writer.uint32(10).string(message.entityId);
    }
    if (message.entityEvent !== undefined) {
      EntityEvent.encode(message.entityEvent, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntityMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntityMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entityId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.entityEvent = EntityEvent.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntityMessage {
    return {
      entityId: isSet(object.entityId) ? globalThis.String(object.entityId) : "",
      entityEvent: isSet(object.entityEvent) ? EntityEvent.fromJSON(object.entityEvent) : undefined,
    };
  },

  toJSON(message: EntityMessage): unknown {
    const obj: any = {};
    if (message.entityId !== "") {
      obj.entityId = message.entityId;
    }
    if (message.entityEvent !== undefined) {
      obj.entityEvent = EntityEvent.toJSON(message.entityEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntityMessage>, I>>(base?: I): EntityMessage {
    return EntityMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntityMessage>, I>>(object: I): EntityMessage {
    const message = createBaseEntityMessage();
    message.entityId = object.entityId ?? "";
    message.entityEvent = (object.entityEvent !== undefined && object.entityEvent !== null)
      ? EntityEvent.fromPartial(object.entityEvent)
      : undefined;
    return message;
  },
};

function createBaseSetPlayerVariableMessage(): SetPlayerVariableMessage {
  return { name: "", value: "", public: false, persist: false, ttl: undefined, scope: 0 };
}

export const SetPlayerVariableMessage: MessageFns<SetPlayerVariableMessage> = {
  encode(message: SetPlayerVariableMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    if (message.public !== false) {
      writer.uint32(24).bool(message.public);
    }
    if (message.persist !== false) {
      writer.uint32(32).bool(message.persist);
    }
    if (message.ttl !== undefined) {
      Int32Value.encode({ value: message.ttl! }, writer.uint32(42).fork()).join();
    }
    if (message.scope !== 0) {
      writer.uint32(48).int32(message.scope);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetPlayerVariableMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetPlayerVariableMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.public = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.persist = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ttl = Int32Value.decode(reader, reader.uint32()).value;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.scope = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetPlayerVariableMessage {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      public: isSet(object.public) ? globalThis.Boolean(object.public) : false,
      persist: isSet(object.persist) ? globalThis.Boolean(object.persist) : false,
      ttl: isSet(object.ttl) ? Number(object.ttl) : undefined,
      scope: isSet(object.scope) ? setPlayerVariableMessage_ScopeFromJSON(object.scope) : 0,
    };
  },

  toJSON(message: SetPlayerVariableMessage): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.public !== false) {
      obj.public = message.public;
    }
    if (message.persist !== false) {
      obj.persist = message.persist;
    }
    if (message.ttl !== undefined) {
      obj.ttl = message.ttl;
    }
    if (message.scope !== 0) {
      obj.scope = setPlayerVariableMessage_ScopeToJSON(message.scope);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetPlayerVariableMessage>, I>>(base?: I): SetPlayerVariableMessage {
    return SetPlayerVariableMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetPlayerVariableMessage>, I>>(object: I): SetPlayerVariableMessage {
    const message = createBaseSetPlayerVariableMessage();
    message.name = object.name ?? "";
    message.value = object.value ?? "";
    message.public = object.public ?? false;
    message.persist = object.persist ?? false;
    message.ttl = object.ttl ?? undefined;
    message.scope = object.scope ?? 0;
    return message;
  },
};

function createBaseVariableWithTagMessage(): VariableWithTagMessage {
  return { name: "", value: "", readableBy: "" };
}

export const VariableWithTagMessage: MessageFns<VariableWithTagMessage> = {
  encode(message: VariableWithTagMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    if (message.readableBy !== "") {
      writer.uint32(26).string(message.readableBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableWithTagMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableWithTagMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.readableBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableWithTagMessage {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      readableBy: isSet(object.readableBy) ? globalThis.String(object.readableBy) : "",
    };
  },

  toJSON(message: VariableWithTagMessage): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.readableBy !== "") {
      obj.readableBy = message.readableBy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VariableWithTagMessage>, I>>(base?: I): VariableWithTagMessage {
    return VariableWithTagMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VariableWithTagMessage>, I>>(object: I): VariableWithTagMessage {
    const message = createBaseVariableWithTagMessage();
    message.name = object.name ?? "";
    message.value = object.value ?? "";
    message.readableBy = object.readableBy ?? "";
    return message;
  },
};

function createBasePlayGlobalMessage(): PlayGlobalMessage {
  return { type: "", content: "", broadcastToWorld: false };
}

export const PlayGlobalMessage: MessageFns<PlayGlobalMessage> = {
  encode(message: PlayGlobalMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.content !== "") {
      writer.uint32(18).string(message.content);
    }
    if (message.broadcastToWorld !== false) {
      writer.uint32(24).bool(message.broadcastToWorld);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlayGlobalMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlayGlobalMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.broadcastToWorld = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlayGlobalMessage {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      content: isSet(object.content) ? globalThis.String(object.content) : "",
      broadcastToWorld: isSet(object.broadcastToWorld) ? globalThis.Boolean(object.broadcastToWorld) : false,
    };
  },

  toJSON(message: PlayGlobalMessage): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.content !== "") {
      obj.content = message.content;
    }
    if (message.broadcastToWorld !== false) {
      obj.broadcastToWorld = message.broadcastToWorld;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlayGlobalMessage>, I>>(base?: I): PlayGlobalMessage {
    return PlayGlobalMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlayGlobalMessage>, I>>(object: I): PlayGlobalMessage {
    const message = createBasePlayGlobalMessage();
    message.type = object.type ?? "";
    message.content = object.content ?? "";
    message.broadcastToWorld = object.broadcastToWorld ?? false;
    return message;
  },
};

function createBaseQueryMessage(): QueryMessage {
  return { id: 0, query: undefined };
}

export const QueryMessage: MessageFns<QueryMessage> = {
  encode(message: QueryMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    switch (message.query?.$case) {
      case "jitsiJwtQuery":
        JitsiJwtQuery.encode(message.query.jitsiJwtQuery, writer.uint32(18).fork()).join();
        break;
      case "joinBBBMeetingQuery":
        JoinBBBMeetingQuery.encode(message.query.joinBBBMeetingQuery, writer.uint32(162).fork()).join();
        break;
      case "roomTagsQuery":
        RoomTagsQuery.encode(message.query.roomTagsQuery, writer.uint32(26).fork()).join();
        break;
      case "embeddableWebsiteQuery":
        EmbeddableWebsiteQuery.encode(message.query.embeddableWebsiteQuery, writer.uint32(34).fork()).join();
        break;
      case "roomsFromSameWorldQuery":
        RoomsFromSameWorldQuery.encode(message.query.roomsFromSameWorldQuery, writer.uint32(42).fork()).join();
        break;
      case "sendEventQuery":
        SendEventQuery.encode(message.query.sendEventQuery, writer.uint32(50).fork()).join();
        break;
      case "searchMemberQuery":
        SearchMemberQuery.encode(message.query.searchMemberQuery, writer.uint32(58).fork()).join();
        break;
      case "getMemberQuery":
        GetMemberQuery.encode(message.query.getMemberQuery, writer.uint32(66).fork()).join();
        break;
      case "iceServersQuery":
        IceServersQuery.encode(message.query.iceServersQuery, writer.uint32(74).fork()).join();
        break;
      case "chatMembersQuery":
        ChatMembersQuery.encode(message.query.chatMembersQuery, writer.uint32(82).fork()).join();
        break;
      case "searchTagsQuery":
        SearchTagsQuery.encode(message.query.searchTagsQuery, writer.uint32(90).fork()).join();
        break;
      case "oauthRefreshTokenQuery":
        OauthRefreshTokenQuery.encode(message.query.oauthRefreshTokenQuery, writer.uint32(98).fork()).join();
        break;
      case "enterChatRoomAreaQuery":
        EnterChatRoomAreaQuery.encode(message.query.enterChatRoomAreaQuery, writer.uint32(106).fork()).join();
        break;
      case "joinSpaceQuery":
        JoinSpaceQuery.encode(message.query.joinSpaceQuery, writer.uint32(114).fork()).join();
        break;
      case "leaveSpaceQuery":
        LeaveSpaceQuery.encode(message.query.leaveSpaceQuery, writer.uint32(122).fork()).join();
        break;
      case "mapStorageJwtQuery":
        MapStorageJwtQuery.encode(message.query.mapStorageJwtQuery, writer.uint32(130).fork()).join();
        break;
      case "getRecordingsQuery":
        GetRecordingsQuery.encode(message.query.getRecordingsQuery, writer.uint32(138).fork()).join();
        break;
      case "deleteRecordingQuery":
        DeleteRecordingQuery.encode(message.query.deleteRecordingQuery, writer.uint32(146).fork()).join();
        break;
      case "getSignedUrlQuery":
        GetSignedUrlQuery.encode(message.query.getSignedUrlQuery, writer.uint32(154).fork()).join();
        break;
      case "getRecordingThumbnailsQuery":
        GetRecordingThumbnailsQuery.encode(message.query.getRecordingThumbnailsQuery, writer.uint32(186).fork()).join();
        break;
      case "banIpPreviewQuery":
        BanIpPreviewQuery.encode(message.query.banIpPreviewQuery, writer.uint32(194).fork()).join();
        break;
      case "spaceStateQuery":
        SpaceStateQueryFrontToPusher.encode(message.query.spaceStateQuery, writer.uint32(202).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QueryMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.query = { $case: "jitsiJwtQuery", jitsiJwtQuery: JitsiJwtQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.query = {
            $case: "joinBBBMeetingQuery",
            joinBBBMeetingQuery: JoinBBBMeetingQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.query = { $case: "roomTagsQuery", roomTagsQuery: RoomTagsQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.query = {
            $case: "embeddableWebsiteQuery",
            embeddableWebsiteQuery: EmbeddableWebsiteQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.query = {
            $case: "roomsFromSameWorldQuery",
            roomsFromSameWorldQuery: RoomsFromSameWorldQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.query = { $case: "sendEventQuery", sendEventQuery: SendEventQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.query = {
            $case: "searchMemberQuery",
            searchMemberQuery: SearchMemberQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.query = { $case: "getMemberQuery", getMemberQuery: GetMemberQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.query = {
            $case: "iceServersQuery",
            iceServersQuery: IceServersQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.query = {
            $case: "chatMembersQuery",
            chatMembersQuery: ChatMembersQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.query = {
            $case: "searchTagsQuery",
            searchTagsQuery: SearchTagsQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.query = {
            $case: "oauthRefreshTokenQuery",
            oauthRefreshTokenQuery: OauthRefreshTokenQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.query = {
            $case: "enterChatRoomAreaQuery",
            enterChatRoomAreaQuery: EnterChatRoomAreaQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.query = { $case: "joinSpaceQuery", joinSpaceQuery: JoinSpaceQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.query = {
            $case: "leaveSpaceQuery",
            leaveSpaceQuery: LeaveSpaceQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.query = {
            $case: "mapStorageJwtQuery",
            mapStorageJwtQuery: MapStorageJwtQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.query = {
            $case: "getRecordingsQuery",
            getRecordingsQuery: GetRecordingsQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.query = {
            $case: "deleteRecordingQuery",
            deleteRecordingQuery: DeleteRecordingQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.query = {
            $case: "getSignedUrlQuery",
            getSignedUrlQuery: GetSignedUrlQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.query = {
            $case: "getRecordingThumbnailsQuery",
            getRecordingThumbnailsQuery: GetRecordingThumbnailsQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.query = {
            $case: "banIpPreviewQuery",
            banIpPreviewQuery: BanIpPreviewQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.query = {
            $case: "spaceStateQuery",
            spaceStateQuery: SpaceStateQueryFrontToPusher.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QueryMessage {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      query: isSet(object.jitsiJwtQuery)
        ? { $case: "jitsiJwtQuery", jitsiJwtQuery: JitsiJwtQuery.fromJSON(object.jitsiJwtQuery) }
        : isSet(object.joinBBBMeetingQuery)
        ? {
          $case: "joinBBBMeetingQuery",
          joinBBBMeetingQuery: JoinBBBMeetingQuery.fromJSON(object.joinBBBMeetingQuery),
        }
        : isSet(object.roomTagsQuery)
        ? { $case: "roomTagsQuery", roomTagsQuery: RoomTagsQuery.fromJSON(object.roomTagsQuery) }
        : isSet(object.embeddableWebsiteQuery)
        ? {
          $case: "embeddableWebsiteQuery",
          embeddableWebsiteQuery: EmbeddableWebsiteQuery.fromJSON(object.embeddableWebsiteQuery),
        }
        : isSet(object.roomsFromSameWorldQuery)
        ? {
          $case: "roomsFromSameWorldQuery",
          roomsFromSameWorldQuery: RoomsFromSameWorldQuery.fromJSON(object.roomsFromSameWorldQuery),
        }
        : isSet(object.sendEventQuery)
        ? { $case: "sendEventQuery", sendEventQuery: SendEventQuery.fromJSON(object.sendEventQuery) }
        : isSet(object.searchMemberQuery)
        ? { $case: "searchMemberQuery", searchMemberQuery: SearchMemberQuery.fromJSON(object.searchMemberQuery) }
        : isSet(object.getMemberQuery)
        ? { $case: "getMemberQuery", getMemberQuery: GetMemberQuery.fromJSON(object.getMemberQuery) }
        : isSet(object.iceServersQuery)
        ? { $case: "iceServersQuery", iceServersQuery: IceServersQuery.fromJSON(object.iceServersQuery) }
        : isSet(object.chatMembersQuery)
        ? { $case: "chatMembersQuery", chatMembersQuery: ChatMembersQuery.fromJSON(object.chatMembersQuery) }
        : isSet(object.searchTagsQuery)
        ? { $case: "searchTagsQuery", searchTagsQuery: SearchTagsQuery.fromJSON(object.searchTagsQuery) }
        : isSet(object.oauthRefreshTokenQuery)
        ? {
          $case: "oauthRefreshTokenQuery",
          oauthRefreshTokenQuery: OauthRefreshTokenQuery.fromJSON(object.oauthRefreshTokenQuery),
        }
        : isSet(object.enterChatRoomAreaQuery)
        ? {
          $case: "enterChatRoomAreaQuery",
          enterChatRoomAreaQuery: EnterChatRoomAreaQuery.fromJSON(object.enterChatRoomAreaQuery),
        }
        : isSet(object.joinSpaceQuery)
        ? { $case: "joinSpaceQuery", joinSpaceQuery: JoinSpaceQuery.fromJSON(object.joinSpaceQuery) }
        : isSet(object.leaveSpaceQuery)
        ? { $case: "leaveSpaceQuery", leaveSpaceQuery: LeaveSpaceQuery.fromJSON(object.leaveSpaceQuery) }
        : isSet(object.mapStorageJwtQuery)
        ? { $case: "mapStorageJwtQuery", mapStorageJwtQuery: MapStorageJwtQuery.fromJSON(object.mapStorageJwtQuery) }
        : isSet(object.getRecordingsQuery)
        ? { $case: "getRecordingsQuery", getRecordingsQuery: GetRecordingsQuery.fromJSON(object.getRecordingsQuery) }
        : isSet(object.deleteRecordingQuery)
        ? {
          $case: "deleteRecordingQuery",
          deleteRecordingQuery: DeleteRecordingQuery.fromJSON(object.deleteRecordingQuery),
        }
        : isSet(object.getSignedUrlQuery)
        ? { $case: "getSignedUrlQuery", getSignedUrlQuery: GetSignedUrlQuery.fromJSON(object.getSignedUrlQuery) }
        : isSet(object.getRecordingThumbnailsQuery)
        ? {
          $case: "getRecordingThumbnailsQuery",
          getRecordingThumbnailsQuery: GetRecordingThumbnailsQuery.fromJSON(object.getRecordingThumbnailsQuery),
        }
        : isSet(object.banIpPreviewQuery)
        ? { $case: "banIpPreviewQuery", banIpPreviewQuery: BanIpPreviewQuery.fromJSON(object.banIpPreviewQuery) }
        : isSet(object.spaceStateQuery)
        ? { $case: "spaceStateQuery", spaceStateQuery: SpaceStateQueryFrontToPusher.fromJSON(object.spaceStateQuery) }
        : undefined,
    };
  },

  toJSON(message: QueryMessage): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.query?.$case === "jitsiJwtQuery") {
      obj.jitsiJwtQuery = JitsiJwtQuery.toJSON(message.query.jitsiJwtQuery);
    } else if (message.query?.$case === "joinBBBMeetingQuery") {
      obj.joinBBBMeetingQuery = JoinBBBMeetingQuery.toJSON(message.query.joinBBBMeetingQuery);
    } else if (message.query?.$case === "roomTagsQuery") {
      obj.roomTagsQuery = RoomTagsQuery.toJSON(message.query.roomTagsQuery);
    } else if (message.query?.$case === "embeddableWebsiteQuery") {
      obj.embeddableWebsiteQuery = EmbeddableWebsiteQuery.toJSON(message.query.embeddableWebsiteQuery);
    } else if (message.query?.$case === "roomsFromSameWorldQuery") {
      obj.roomsFromSameWorldQuery = RoomsFromSameWorldQuery.toJSON(message.query.roomsFromSameWorldQuery);
    } else if (message.query?.$case === "sendEventQuery") {
      obj.sendEventQuery = SendEventQuery.toJSON(message.query.sendEventQuery);
    } else if (message.query?.$case === "searchMemberQuery") {
      obj.searchMemberQuery = SearchMemberQuery.toJSON(message.query.searchMemberQuery);
    } else if (message.query?.$case === "getMemberQuery") {
      obj.getMemberQuery = GetMemberQuery.toJSON(message.query.getMemberQuery);
    } else if (message.query?.$case === "iceServersQuery") {
      obj.iceServersQuery = IceServersQuery.toJSON(message.query.iceServersQuery);
    } else if (message.query?.$case === "chatMembersQuery") {
      obj.chatMembersQuery = ChatMembersQuery.toJSON(message.query.chatMembersQuery);
    } else if (message.query?.$case === "searchTagsQuery") {
      obj.searchTagsQuery = SearchTagsQuery.toJSON(message.query.searchTagsQuery);
    } else if (message.query?.$case === "oauthRefreshTokenQuery") {
      obj.oauthRefreshTokenQuery = OauthRefreshTokenQuery.toJSON(message.query.oauthRefreshTokenQuery);
    } else if (message.query?.$case === "enterChatRoomAreaQuery") {
      obj.enterChatRoomAreaQuery = EnterChatRoomAreaQuery.toJSON(message.query.enterChatRoomAreaQuery);
    } else if (message.query?.$case === "joinSpaceQuery") {
      obj.joinSpaceQuery = JoinSpaceQuery.toJSON(message.query.joinSpaceQuery);
    } else if (message.query?.$case === "leaveSpaceQuery") {
      obj.leaveSpaceQuery = LeaveSpaceQuery.toJSON(message.query.leaveSpaceQuery);
    } else if (message.query?.$case === "mapStorageJwtQuery") {
      obj.mapStorageJwtQuery = MapStorageJwtQuery.toJSON(message.query.mapStorageJwtQuery);
    } else if (message.query?.$case === "getRecordingsQuery") {
      obj.getRecordingsQuery = GetRecordingsQuery.toJSON(message.query.getRecordingsQuery);
    } else if (message.query?.$case === "deleteRecordingQuery") {
      obj.deleteRecordingQuery = DeleteRecordingQuery.toJSON(message.query.deleteRecordingQuery);
    } else if (message.query?.$case === "getSignedUrlQuery") {
      obj.getSignedUrlQuery = GetSignedUrlQuery.toJSON(message.query.getSignedUrlQuery);
    } else if (message.query?.$case === "getRecordingThumbnailsQuery") {
      obj.getRecordingThumbnailsQuery = GetRecordingThumbnailsQuery.toJSON(message.query.getRecordingThumbnailsQuery);
    } else if (message.query?.$case === "banIpPreviewQuery") {
      obj.banIpPreviewQuery = BanIpPreviewQuery.toJSON(message.query.banIpPreviewQuery);
    } else if (message.query?.$case === "spaceStateQuery") {
      obj.spaceStateQuery = SpaceStateQueryFrontToPusher.toJSON(message.query.spaceStateQuery);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QueryMessage>, I>>(base?: I): QueryMessage {
    return QueryMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QueryMessage>, I>>(object: I): QueryMessage {
    const message = createBaseQueryMessage();
    message.id = object.id ?? 0;
    switch (object.query?.$case) {
      case "jitsiJwtQuery": {
        if (object.query?.jitsiJwtQuery !== undefined && object.query?.jitsiJwtQuery !== null) {
          message.query = {
            $case: "jitsiJwtQuery",
            jitsiJwtQuery: JitsiJwtQuery.fromPartial(object.query.jitsiJwtQuery),
          };
        }
        break;
      }
      case "joinBBBMeetingQuery": {
        if (object.query?.joinBBBMeetingQuery !== undefined && object.query?.joinBBBMeetingQuery !== null) {
          message.query = {
            $case: "joinBBBMeetingQuery",
            joinBBBMeetingQuery: JoinBBBMeetingQuery.fromPartial(object.query.joinBBBMeetingQuery),
          };
        }
        break;
      }
      case "roomTagsQuery": {
        if (object.query?.roomTagsQuery !== undefined && object.query?.roomTagsQuery !== null) {
          message.query = {
            $case: "roomTagsQuery",
            roomTagsQuery: RoomTagsQuery.fromPartial(object.query.roomTagsQuery),
          };
        }
        break;
      }
      case "embeddableWebsiteQuery": {
        if (object.query?.embeddableWebsiteQuery !== undefined && object.query?.embeddableWebsiteQuery !== null) {
          message.query = {
            $case: "embeddableWebsiteQuery",
            embeddableWebsiteQuery: EmbeddableWebsiteQuery.fromPartial(object.query.embeddableWebsiteQuery),
          };
        }
        break;
      }
      case "roomsFromSameWorldQuery": {
        if (object.query?.roomsFromSameWorldQuery !== undefined && object.query?.roomsFromSameWorldQuery !== null) {
          message.query = {
            $case: "roomsFromSameWorldQuery",
            roomsFromSameWorldQuery: RoomsFromSameWorldQuery.fromPartial(object.query.roomsFromSameWorldQuery),
          };
        }
        break;
      }
      case "sendEventQuery": {
        if (object.query?.sendEventQuery !== undefined && object.query?.sendEventQuery !== null) {
          message.query = {
            $case: "sendEventQuery",
            sendEventQuery: SendEventQuery.fromPartial(object.query.sendEventQuery),
          };
        }
        break;
      }
      case "searchMemberQuery": {
        if (object.query?.searchMemberQuery !== undefined && object.query?.searchMemberQuery !== null) {
          message.query = {
            $case: "searchMemberQuery",
            searchMemberQuery: SearchMemberQuery.fromPartial(object.query.searchMemberQuery),
          };
        }
        break;
      }
      case "getMemberQuery": {
        if (object.query?.getMemberQuery !== undefined && object.query?.getMemberQuery !== null) {
          message.query = {
            $case: "getMemberQuery",
            getMemberQuery: GetMemberQuery.fromPartial(object.query.getMemberQuery),
          };
        }
        break;
      }
      case "iceServersQuery": {
        if (object.query?.iceServersQuery !== undefined && object.query?.iceServersQuery !== null) {
          message.query = {
            $case: "iceServersQuery",
            iceServersQuery: IceServersQuery.fromPartial(object.query.iceServersQuery),
          };
        }
        break;
      }
      case "chatMembersQuery": {
        if (object.query?.chatMembersQuery !== undefined && object.query?.chatMembersQuery !== null) {
          message.query = {
            $case: "chatMembersQuery",
            chatMembersQuery: ChatMembersQuery.fromPartial(object.query.chatMembersQuery),
          };
        }
        break;
      }
      case "searchTagsQuery": {
        if (object.query?.searchTagsQuery !== undefined && object.query?.searchTagsQuery !== null) {
          message.query = {
            $case: "searchTagsQuery",
            searchTagsQuery: SearchTagsQuery.fromPartial(object.query.searchTagsQuery),
          };
        }
        break;
      }
      case "oauthRefreshTokenQuery": {
        if (object.query?.oauthRefreshTokenQuery !== undefined && object.query?.oauthRefreshTokenQuery !== null) {
          message.query = {
            $case: "oauthRefreshTokenQuery",
            oauthRefreshTokenQuery: OauthRefreshTokenQuery.fromPartial(object.query.oauthRefreshTokenQuery),
          };
        }
        break;
      }
      case "enterChatRoomAreaQuery": {
        if (object.query?.enterChatRoomAreaQuery !== undefined && object.query?.enterChatRoomAreaQuery !== null) {
          message.query = {
            $case: "enterChatRoomAreaQuery",
            enterChatRoomAreaQuery: EnterChatRoomAreaQuery.fromPartial(object.query.enterChatRoomAreaQuery),
          };
        }
        break;
      }
      case "joinSpaceQuery": {
        if (object.query?.joinSpaceQuery !== undefined && object.query?.joinSpaceQuery !== null) {
          message.query = {
            $case: "joinSpaceQuery",
            joinSpaceQuery: JoinSpaceQuery.fromPartial(object.query.joinSpaceQuery),
          };
        }
        break;
      }
      case "leaveSpaceQuery": {
        if (object.query?.leaveSpaceQuery !== undefined && object.query?.leaveSpaceQuery !== null) {
          message.query = {
            $case: "leaveSpaceQuery",
            leaveSpaceQuery: LeaveSpaceQuery.fromPartial(object.query.leaveSpaceQuery),
          };
        }
        break;
      }
      case "mapStorageJwtQuery": {
        if (object.query?.mapStorageJwtQuery !== undefined && object.query?.mapStorageJwtQuery !== null) {
          message.query = {
            $case: "mapStorageJwtQuery",
            mapStorageJwtQuery: MapStorageJwtQuery.fromPartial(object.query.mapStorageJwtQuery),
          };
        }
        break;
      }
      case "getRecordingsQuery": {
        if (object.query?.getRecordingsQuery !== undefined && object.query?.getRecordingsQuery !== null) {
          message.query = {
            $case: "getRecordingsQuery",
            getRecordingsQuery: GetRecordingsQuery.fromPartial(object.query.getRecordingsQuery),
          };
        }
        break;
      }
      case "deleteRecordingQuery": {
        if (object.query?.deleteRecordingQuery !== undefined && object.query?.deleteRecordingQuery !== null) {
          message.query = {
            $case: "deleteRecordingQuery",
            deleteRecordingQuery: DeleteRecordingQuery.fromPartial(object.query.deleteRecordingQuery),
          };
        }
        break;
      }
      case "getSignedUrlQuery": {
        if (object.query?.getSignedUrlQuery !== undefined && object.query?.getSignedUrlQuery !== null) {
          message.query = {
            $case: "getSignedUrlQuery",
            getSignedUrlQuery: GetSignedUrlQuery.fromPartial(object.query.getSignedUrlQuery),
          };
        }
        break;
      }
      case "getRecordingThumbnailsQuery": {
        if (
          object.query?.getRecordingThumbnailsQuery !== undefined && object.query?.getRecordingThumbnailsQuery !== null
        ) {
          message.query = {
            $case: "getRecordingThumbnailsQuery",
            getRecordingThumbnailsQuery: GetRecordingThumbnailsQuery.fromPartial(
              object.query.getRecordingThumbnailsQuery,
            ),
          };
        }
        break;
      }
      case "banIpPreviewQuery": {
        if (object.query?.banIpPreviewQuery !== undefined && object.query?.banIpPreviewQuery !== null) {
          message.query = {
            $case: "banIpPreviewQuery",
            banIpPreviewQuery: BanIpPreviewQuery.fromPartial(object.query.banIpPreviewQuery),
          };
        }
        break;
      }
      case "spaceStateQuery": {
        if (object.query?.spaceStateQuery !== undefined && object.query?.spaceStateQuery !== null) {
          message.query = {
            $case: "spaceStateQuery",
            spaceStateQuery: SpaceStateQueryFrontToPusher.fromPartial(object.query.spaceStateQuery),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseGetSignedUrlQuery(): GetSignedUrlQuery {
  return { key: "" };
}

export const GetSignedUrlQuery: MessageFns<GetSignedUrlQuery> = {
  encode(message: GetSignedUrlQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSignedUrlQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSignedUrlQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSignedUrlQuery {
    return { key: isSet(object.key) ? globalThis.String(object.key) : "" };
  },

  toJSON(message: GetSignedUrlQuery): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSignedUrlQuery>, I>>(base?: I): GetSignedUrlQuery {
    return GetSignedUrlQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSignedUrlQuery>, I>>(object: I): GetSignedUrlQuery {
    const message = createBaseGetSignedUrlQuery();
    message.key = object.key ?? "";
    return message;
  },
};

function createBaseAbortQueryMessage(): AbortQueryMessage {
  return { id: 0 };
}

export const AbortQueryMessage: MessageFns<AbortQueryMessage> = {
  encode(message: AbortQueryMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AbortQueryMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAbortQueryMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AbortQueryMessage {
    return { id: isSet(object.id) ? globalThis.Number(object.id) : 0 };
  },

  toJSON(message: AbortQueryMessage): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AbortQueryMessage>, I>>(base?: I): AbortQueryMessage {
    return AbortQueryMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AbortQueryMessage>, I>>(object: I): AbortQueryMessage {
    const message = createBaseAbortQueryMessage();
    message.id = object.id ?? 0;
    return message;
  },
};

function createBaseMapStorageJwtQuery(): MapStorageJwtQuery {
  return {};
}

export const MapStorageJwtQuery: MessageFns<MapStorageJwtQuery> = {
  encode(_: MapStorageJwtQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MapStorageJwtQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMapStorageJwtQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MapStorageJwtQuery {
    return {};
  },

  toJSON(_: MapStorageJwtQuery): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MapStorageJwtQuery>, I>>(base?: I): MapStorageJwtQuery {
    return MapStorageJwtQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MapStorageJwtQuery>, I>>(_: I): MapStorageJwtQuery {
    const message = createBaseMapStorageJwtQuery();
    return message;
  },
};

function createBaseJitsiJwtQuery(): JitsiJwtQuery {
  return { jitsiRoom: "" };
}

export const JitsiJwtQuery: MessageFns<JitsiJwtQuery> = {
  encode(message: JitsiJwtQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jitsiRoom !== "") {
      writer.uint32(10).string(message.jitsiRoom);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JitsiJwtQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJitsiJwtQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jitsiRoom = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JitsiJwtQuery {
    return { jitsiRoom: isSet(object.jitsiRoom) ? globalThis.String(object.jitsiRoom) : "" };
  },

  toJSON(message: JitsiJwtQuery): unknown {
    const obj: any = {};
    if (message.jitsiRoom !== "") {
      obj.jitsiRoom = message.jitsiRoom;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JitsiJwtQuery>, I>>(base?: I): JitsiJwtQuery {
    return JitsiJwtQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JitsiJwtQuery>, I>>(object: I): JitsiJwtQuery {
    const message = createBaseJitsiJwtQuery();
    message.jitsiRoom = object.jitsiRoom ?? "";
    return message;
  },
};

function createBaseJoinBBBMeetingQuery(): JoinBBBMeetingQuery {
  return { meetingId: "", localMeetingId: "", meetingName: "" };
}

export const JoinBBBMeetingQuery: MessageFns<JoinBBBMeetingQuery> = {
  encode(message: JoinBBBMeetingQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.meetingId !== "") {
      writer.uint32(10).string(message.meetingId);
    }
    if (message.localMeetingId !== "") {
      writer.uint32(18).string(message.localMeetingId);
    }
    if (message.meetingName !== "") {
      writer.uint32(26).string(message.meetingName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JoinBBBMeetingQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinBBBMeetingQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.meetingId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.localMeetingId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meetingName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JoinBBBMeetingQuery {
    return {
      meetingId: isSet(object.meetingId) ? globalThis.String(object.meetingId) : "",
      localMeetingId: isSet(object.localMeetingId) ? globalThis.String(object.localMeetingId) : "",
      meetingName: isSet(object.meetingName) ? globalThis.String(object.meetingName) : "",
    };
  },

  toJSON(message: JoinBBBMeetingQuery): unknown {
    const obj: any = {};
    if (message.meetingId !== "") {
      obj.meetingId = message.meetingId;
    }
    if (message.localMeetingId !== "") {
      obj.localMeetingId = message.localMeetingId;
    }
    if (message.meetingName !== "") {
      obj.meetingName = message.meetingName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JoinBBBMeetingQuery>, I>>(base?: I): JoinBBBMeetingQuery {
    return JoinBBBMeetingQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoinBBBMeetingQuery>, I>>(object: I): JoinBBBMeetingQuery {
    const message = createBaseJoinBBBMeetingQuery();
    message.meetingId = object.meetingId ?? "";
    message.localMeetingId = object.localMeetingId ?? "";
    message.meetingName = object.meetingName ?? "";
    return message;
  },
};

function createBaseRoomTagsQuery(): RoomTagsQuery {
  return {};
}

export const RoomTagsQuery: MessageFns<RoomTagsQuery> = {
  encode(_: RoomTagsQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoomTagsQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomTagsQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RoomTagsQuery {
    return {};
  },

  toJSON(_: RoomTagsQuery): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RoomTagsQuery>, I>>(base?: I): RoomTagsQuery {
    return RoomTagsQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoomTagsQuery>, I>>(_: I): RoomTagsQuery {
    const message = createBaseRoomTagsQuery();
    return message;
  },
};

function createBaseEmbeddableWebsiteQuery(): EmbeddableWebsiteQuery {
  return { url: "" };
}

export const EmbeddableWebsiteQuery: MessageFns<EmbeddableWebsiteQuery> = {
  encode(message: EmbeddableWebsiteQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmbeddableWebsiteQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmbeddableWebsiteQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EmbeddableWebsiteQuery {
    return { url: isSet(object.url) ? globalThis.String(object.url) : "" };
  },

  toJSON(message: EmbeddableWebsiteQuery): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EmbeddableWebsiteQuery>, I>>(base?: I): EmbeddableWebsiteQuery {
    return EmbeddableWebsiteQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmbeddableWebsiteQuery>, I>>(object: I): EmbeddableWebsiteQuery {
    const message = createBaseEmbeddableWebsiteQuery();
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseRoomsFromSameWorldQuery(): RoomsFromSameWorldQuery {
  return {};
}

export const RoomsFromSameWorldQuery: MessageFns<RoomsFromSameWorldQuery> = {
  encode(_: RoomsFromSameWorldQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoomsFromSameWorldQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomsFromSameWorldQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RoomsFromSameWorldQuery {
    return {};
  },

  toJSON(_: RoomsFromSameWorldQuery): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RoomsFromSameWorldQuery>, I>>(base?: I): RoomsFromSameWorldQuery {
    return RoomsFromSameWorldQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoomsFromSameWorldQuery>, I>>(_: I): RoomsFromSameWorldQuery {
    const message = createBaseRoomsFromSameWorldQuery();
    return message;
  },
};

function createBaseSendEventQuery(): SendEventQuery {
  return { name: "", data: undefined, targetUserIds: [] };
}

export const SendEventQuery: MessageFns<SendEventQuery> = {
  encode(message: SendEventQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.data !== undefined) {
      Value.encode(Value.wrap(message.data), writer.uint32(18).fork()).join();
    }
    writer.uint32(26).fork();
    for (const v of message.targetUserIds) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendEventQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendEventQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.targetUserIds.push(reader.int32());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.targetUserIds.push(reader.int32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendEventQuery {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      data: isSet(object?.data) ? object.data : undefined,
      targetUserIds: globalThis.Array.isArray(object?.targetUserIds)
        ? object.targetUserIds.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: SendEventQuery): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.data !== undefined) {
      obj.data = message.data;
    }
    if (message.targetUserIds?.length) {
      obj.targetUserIds = message.targetUserIds.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendEventQuery>, I>>(base?: I): SendEventQuery {
    return SendEventQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendEventQuery>, I>>(object: I): SendEventQuery {
    const message = createBaseSendEventQuery();
    message.name = object.name ?? "";
    message.data = object.data ?? undefined;
    message.targetUserIds = object.targetUserIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseSearchMemberQuery(): SearchMemberQuery {
  return { searchText: "" };
}

export const SearchMemberQuery: MessageFns<SearchMemberQuery> = {
  encode(message: SearchMemberQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.searchText !== "") {
      writer.uint32(10).string(message.searchText);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchMemberQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchMemberQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.searchText = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchMemberQuery {
    return { searchText: isSet(object.searchText) ? globalThis.String(object.searchText) : "" };
  },

  toJSON(message: SearchMemberQuery): unknown {
    const obj: any = {};
    if (message.searchText !== "") {
      obj.searchText = message.searchText;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchMemberQuery>, I>>(base?: I): SearchMemberQuery {
    return SearchMemberQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchMemberQuery>, I>>(object: I): SearchMemberQuery {
    const message = createBaseSearchMemberQuery();
    message.searchText = object.searchText ?? "";
    return message;
  },
};

function createBaseGetMemberQuery(): GetMemberQuery {
  return { uuid: "" };
}

export const GetMemberQuery: MessageFns<GetMemberQuery> = {
  encode(message: GetMemberQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uuid !== "") {
      writer.uint32(10).string(message.uuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMemberQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMemberQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMemberQuery {
    return { uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "" };
  },

  toJSON(message: GetMemberQuery): unknown {
    const obj: any = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMemberQuery>, I>>(base?: I): GetMemberQuery {
    return GetMemberQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMemberQuery>, I>>(object: I): GetMemberQuery {
    const message = createBaseGetMemberQuery();
    message.uuid = object.uuid ?? "";
    return message;
  },
};

function createBaseChatMembersQuery(): ChatMembersQuery {
  return { searchText: "" };
}

export const ChatMembersQuery: MessageFns<ChatMembersQuery> = {
  encode(message: ChatMembersQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.searchText !== "") {
      writer.uint32(10).string(message.searchText);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatMembersQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatMembersQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.searchText = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatMembersQuery {
    return { searchText: isSet(object.searchText) ? globalThis.String(object.searchText) : "" };
  },

  toJSON(message: ChatMembersQuery): unknown {
    const obj: any = {};
    if (message.searchText !== "") {
      obj.searchText = message.searchText;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatMembersQuery>, I>>(base?: I): ChatMembersQuery {
    return ChatMembersQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatMembersQuery>, I>>(object: I): ChatMembersQuery {
    const message = createBaseChatMembersQuery();
    message.searchText = object.searchText ?? "";
    return message;
  },
};

function createBaseOauthRefreshTokenQuery(): OauthRefreshTokenQuery {
  return { tokenToRefresh: "", provider: undefined, userIdentifier: undefined };
}

export const OauthRefreshTokenQuery: MessageFns<OauthRefreshTokenQuery> = {
  encode(message: OauthRefreshTokenQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tokenToRefresh !== "") {
      writer.uint32(10).string(message.tokenToRefresh);
    }
    if (message.provider !== undefined) {
      writer.uint32(18).string(message.provider);
    }
    if (message.userIdentifier !== undefined) {
      writer.uint32(26).string(message.userIdentifier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OauthRefreshTokenQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOauthRefreshTokenQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tokenToRefresh = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.userIdentifier = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OauthRefreshTokenQuery {
    return {
      tokenToRefresh: isSet(object.tokenToRefresh) ? globalThis.String(object.tokenToRefresh) : "",
      provider: isSet(object.provider) ? globalThis.String(object.provider) : undefined,
      userIdentifier: isSet(object.userIdentifier) ? globalThis.String(object.userIdentifier) : undefined,
    };
  },

  toJSON(message: OauthRefreshTokenQuery): unknown {
    const obj: any = {};
    if (message.tokenToRefresh !== "") {
      obj.tokenToRefresh = message.tokenToRefresh;
    }
    if (message.provider !== undefined) {
      obj.provider = message.provider;
    }
    if (message.userIdentifier !== undefined) {
      obj.userIdentifier = message.userIdentifier;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OauthRefreshTokenQuery>, I>>(base?: I): OauthRefreshTokenQuery {
    return OauthRefreshTokenQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OauthRefreshTokenQuery>, I>>(object: I): OauthRefreshTokenQuery {
    const message = createBaseOauthRefreshTokenQuery();
    message.tokenToRefresh = object.tokenToRefresh ?? "";
    message.provider = object.provider ?? undefined;
    message.userIdentifier = object.userIdentifier ?? undefined;
    return message;
  },
};

function createBaseSearchTagsQuery(): SearchTagsQuery {
  return { searchText: "" };
}

export const SearchTagsQuery: MessageFns<SearchTagsQuery> = {
  encode(message: SearchTagsQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.searchText !== "") {
      writer.uint32(10).string(message.searchText);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchTagsQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchTagsQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.searchText = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchTagsQuery {
    return { searchText: isSet(object.searchText) ? globalThis.String(object.searchText) : "" };
  },

  toJSON(message: SearchTagsQuery): unknown {
    const obj: any = {};
    if (message.searchText !== "") {
      obj.searchText = message.searchText;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchTagsQuery>, I>>(base?: I): SearchTagsQuery {
    return SearchTagsQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchTagsQuery>, I>>(object: I): SearchTagsQuery {
    const message = createBaseSearchTagsQuery();
    message.searchText = object.searchText ?? "";
    return message;
  },
};

function createBaseEnterChatRoomAreaQuery(): EnterChatRoomAreaQuery {
  return { roomID: "" };
}

export const EnterChatRoomAreaQuery: MessageFns<EnterChatRoomAreaQuery> = {
  encode(message: EnterChatRoomAreaQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.roomID !== "") {
      writer.uint32(10).string(message.roomID);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnterChatRoomAreaQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnterChatRoomAreaQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roomID = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnterChatRoomAreaQuery {
    return { roomID: isSet(object.roomID) ? globalThis.String(object.roomID) : "" };
  },

  toJSON(message: EnterChatRoomAreaQuery): unknown {
    const obj: any = {};
    if (message.roomID !== "") {
      obj.roomID = message.roomID;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnterChatRoomAreaQuery>, I>>(base?: I): EnterChatRoomAreaQuery {
    return EnterChatRoomAreaQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnterChatRoomAreaQuery>, I>>(object: I): EnterChatRoomAreaQuery {
    const message = createBaseEnterChatRoomAreaQuery();
    message.roomID = object.roomID ?? "";
    return message;
  },
};

function createBaseJoinSpaceQuery(): JoinSpaceQuery {
  return { spaceName: "", filterType: 0, propertiesToSync: [] };
}

export const JoinSpaceQuery: MessageFns<JoinSpaceQuery> = {
  encode(message: JoinSpaceQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.filterType !== 0) {
      writer.uint32(16).int32(message.filterType);
    }
    for (const v of message.propertiesToSync) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JoinSpaceQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinSpaceQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.filterType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.propertiesToSync.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JoinSpaceQuery {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      filterType: isSet(object.filterType) ? filterTypeFromJSON(object.filterType) : 0,
      propertiesToSync: globalThis.Array.isArray(object?.propertiesToSync)
        ? object.propertiesToSync.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: JoinSpaceQuery): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.filterType !== 0) {
      obj.filterType = filterTypeToJSON(message.filterType);
    }
    if (message.propertiesToSync?.length) {
      obj.propertiesToSync = message.propertiesToSync;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JoinSpaceQuery>, I>>(base?: I): JoinSpaceQuery {
    return JoinSpaceQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoinSpaceQuery>, I>>(object: I): JoinSpaceQuery {
    const message = createBaseJoinSpaceQuery();
    message.spaceName = object.spaceName ?? "";
    message.filterType = object.filterType ?? 0;
    message.propertiesToSync = object.propertiesToSync?.map((e) => e) || [];
    return message;
  },
};

function createBaseLeaveSpaceQuery(): LeaveSpaceQuery {
  return { spaceName: "" };
}

export const LeaveSpaceQuery: MessageFns<LeaveSpaceQuery> = {
  encode(message: LeaveSpaceQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LeaveSpaceQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeaveSpaceQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LeaveSpaceQuery {
    return { spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "" };
  },

  toJSON(message: LeaveSpaceQuery): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LeaveSpaceQuery>, I>>(base?: I): LeaveSpaceQuery {
    return LeaveSpaceQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LeaveSpaceQuery>, I>>(object: I): LeaveSpaceQuery {
    const message = createBaseLeaveSpaceQuery();
    message.spaceName = object.spaceName ?? "";
    return message;
  },
};

function createBaseGetRecordingsQuery(): GetRecordingsQuery {
  return { uuid: undefined };
}

export const GetRecordingsQuery: MessageFns<GetRecordingsQuery> = {
  encode(message: GetRecordingsQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uuid !== undefined) {
      writer.uint32(18).string(message.uuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRecordingsQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRecordingsQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRecordingsQuery {
    return { uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : undefined };
  },

  toJSON(message: GetRecordingsQuery): unknown {
    const obj: any = {};
    if (message.uuid !== undefined) {
      obj.uuid = message.uuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRecordingsQuery>, I>>(base?: I): GetRecordingsQuery {
    return GetRecordingsQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRecordingsQuery>, I>>(object: I): GetRecordingsQuery {
    const message = createBaseGetRecordingsQuery();
    message.uuid = object.uuid ?? undefined;
    return message;
  },
};

function createBaseGetRecordingThumbnailsQuery(): GetRecordingThumbnailsQuery {
  return { baseFilename: "" };
}

export const GetRecordingThumbnailsQuery: MessageFns<GetRecordingThumbnailsQuery> = {
  encode(message: GetRecordingThumbnailsQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseFilename !== "") {
      writer.uint32(10).string(message.baseFilename);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRecordingThumbnailsQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRecordingThumbnailsQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseFilename = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRecordingThumbnailsQuery {
    return { baseFilename: isSet(object.baseFilename) ? globalThis.String(object.baseFilename) : "" };
  },

  toJSON(message: GetRecordingThumbnailsQuery): unknown {
    const obj: any = {};
    if (message.baseFilename !== "") {
      obj.baseFilename = message.baseFilename;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRecordingThumbnailsQuery>, I>>(base?: I): GetRecordingThumbnailsQuery {
    return GetRecordingThumbnailsQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRecordingThumbnailsQuery>, I>>(object: I): GetRecordingThumbnailsQuery {
    const message = createBaseGetRecordingThumbnailsQuery();
    message.baseFilename = object.baseFilename ?? "";
    return message;
  },
};

function createBaseDeleteRecordingQuery(): DeleteRecordingQuery {
  return { recordingId: "" };
}

export const DeleteRecordingQuery: MessageFns<DeleteRecordingQuery> = {
  encode(message: DeleteRecordingQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.recordingId !== "") {
      writer.uint32(10).string(message.recordingId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteRecordingQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteRecordingQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.recordingId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteRecordingQuery {
    return { recordingId: isSet(object.recordingId) ? globalThis.String(object.recordingId) : "" };
  },

  toJSON(message: DeleteRecordingQuery): unknown {
    const obj: any = {};
    if (message.recordingId !== "") {
      obj.recordingId = message.recordingId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteRecordingQuery>, I>>(base?: I): DeleteRecordingQuery {
    return DeleteRecordingQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteRecordingQuery>, I>>(object: I): DeleteRecordingQuery {
    const message = createBaseDeleteRecordingQuery();
    message.recordingId = object.recordingId ?? "";
    return message;
  },
};

function createBaseAnswerMessage(): AnswerMessage {
  return { id: 0, answer: undefined };
}

export const AnswerMessage: MessageFns<AnswerMessage> = {
  encode(message: AnswerMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    switch (message.answer?.$case) {
      case "error":
        ErrorMessage.encode(message.answer.error, writer.uint32(18).fork()).join();
        break;
      case "jitsiJwtAnswer":
        JitsiJwtAnswer.encode(message.answer.jitsiJwtAnswer, writer.uint32(26).fork()).join();
        break;
      case "joinBBBMeetingAnswer":
        JoinBBBMeetingAnswer.encode(message.answer.joinBBBMeetingAnswer, writer.uint32(34).fork()).join();
        break;
      case "roomTagsAnswer":
        RoomTagsAnswer.encode(message.answer.roomTagsAnswer, writer.uint32(42).fork()).join();
        break;
      case "embeddableWebsiteAnswer":
        EmbeddableWebsiteAnswer.encode(message.answer.embeddableWebsiteAnswer, writer.uint32(50).fork()).join();
        break;
      case "roomsFromSameWorldAnswer":
        RoomsFromSameWorldAnswer.encode(message.answer.roomsFromSameWorldAnswer, writer.uint32(58).fork()).join();
        break;
      case "sendEventAnswer":
        SendEventAnswer.encode(message.answer.sendEventAnswer, writer.uint32(66).fork()).join();
        break;
      case "searchMemberAnswer":
        SearchMemberAnswer.encode(message.answer.searchMemberAnswer, writer.uint32(74).fork()).join();
        break;
      case "getMemberAnswer":
        GetMemberAnswer.encode(message.answer.getMemberAnswer, writer.uint32(82).fork()).join();
        break;
      case "iceServersAnswer":
        IceServersAnswer.encode(message.answer.iceServersAnswer, writer.uint32(90).fork()).join();
        break;
      case "chatMembersAnswer":
        ChatMembersAnswer.encode(message.answer.chatMembersAnswer, writer.uint32(98).fork()).join();
        break;
      case "searchTagsAnswer":
        SearchTagsAnswer.encode(message.answer.searchTagsAnswer, writer.uint32(106).fork()).join();
        break;
      case "oauthRefreshTokenAnswer":
        OauthRefreshTokenAnswer.encode(message.answer.oauthRefreshTokenAnswer, writer.uint32(114).fork()).join();
        break;
      case "enterChatRoomAreaAnswer":
        EnterChatRoomAreaAnswer.encode(message.answer.enterChatRoomAreaAnswer, writer.uint32(122).fork()).join();
        break;
      case "joinSpaceAnswer":
        JoinSpaceAnswer.encode(message.answer.joinSpaceAnswer, writer.uint32(130).fork()).join();
        break;
      case "leaveSpaceAnswer":
        LeaveSpaceAnswer.encode(message.answer.leaveSpaceAnswer, writer.uint32(138).fork()).join();
        break;
      case "mapStorageJwtAnswer":
        MapStorageJwtAnswer.encode(message.answer.mapStorageJwtAnswer, writer.uint32(146).fork()).join();
        break;
      case "getRecordingsAnswer":
        GetRecordingsAnswer.encode(message.answer.getRecordingsAnswer, writer.uint32(154).fork()).join();
        break;
      case "deleteRecordingAnswer":
        DeleteRecordingAnswer.encode(message.answer.deleteRecordingAnswer, writer.uint32(162).fork()).join();
        break;
      case "getSignedUrlAnswer":
        GetSignedUrlAnswer.encode(message.answer.getSignedUrlAnswer, writer.uint32(170).fork()).join();
        break;
      case "getRecordingThumbnailsAnswer":
        GetRecordingThumbnailsAnswer.encode(message.answer.getRecordingThumbnailsAnswer, writer.uint32(194).fork())
          .join();
        break;
      case "banIpPreviewAnswer":
        BanIpPreviewAnswer.encode(message.answer.banIpPreviewAnswer, writer.uint32(202).fork()).join();
        break;
      case "spaceStateAnswer":
        SpaceStateAnswer.encode(message.answer.spaceStateAnswer, writer.uint32(210).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnswerMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnswerMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.answer = { $case: "error", error: ErrorMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.answer = { $case: "jitsiJwtAnswer", jitsiJwtAnswer: JitsiJwtAnswer.decode(reader, reader.uint32()) };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.answer = {
            $case: "joinBBBMeetingAnswer",
            joinBBBMeetingAnswer: JoinBBBMeetingAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.answer = { $case: "roomTagsAnswer", roomTagsAnswer: RoomTagsAnswer.decode(reader, reader.uint32()) };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.answer = {
            $case: "embeddableWebsiteAnswer",
            embeddableWebsiteAnswer: EmbeddableWebsiteAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.answer = {
            $case: "roomsFromSameWorldAnswer",
            roomsFromSameWorldAnswer: RoomsFromSameWorldAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.answer = {
            $case: "sendEventAnswer",
            sendEventAnswer: SendEventAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.answer = {
            $case: "searchMemberAnswer",
            searchMemberAnswer: SearchMemberAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.answer = {
            $case: "getMemberAnswer",
            getMemberAnswer: GetMemberAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.answer = {
            $case: "iceServersAnswer",
            iceServersAnswer: IceServersAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.answer = {
            $case: "chatMembersAnswer",
            chatMembersAnswer: ChatMembersAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.answer = {
            $case: "searchTagsAnswer",
            searchTagsAnswer: SearchTagsAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.answer = {
            $case: "oauthRefreshTokenAnswer",
            oauthRefreshTokenAnswer: OauthRefreshTokenAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.answer = {
            $case: "enterChatRoomAreaAnswer",
            enterChatRoomAreaAnswer: EnterChatRoomAreaAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.answer = {
            $case: "joinSpaceAnswer",
            joinSpaceAnswer: JoinSpaceAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.answer = {
            $case: "leaveSpaceAnswer",
            leaveSpaceAnswer: LeaveSpaceAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.answer = {
            $case: "mapStorageJwtAnswer",
            mapStorageJwtAnswer: MapStorageJwtAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.answer = {
            $case: "getRecordingsAnswer",
            getRecordingsAnswer: GetRecordingsAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.answer = {
            $case: "deleteRecordingAnswer",
            deleteRecordingAnswer: DeleteRecordingAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.answer = {
            $case: "getSignedUrlAnswer",
            getSignedUrlAnswer: GetSignedUrlAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.answer = {
            $case: "getRecordingThumbnailsAnswer",
            getRecordingThumbnailsAnswer: GetRecordingThumbnailsAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.answer = {
            $case: "banIpPreviewAnswer",
            banIpPreviewAnswer: BanIpPreviewAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.answer = {
            $case: "spaceStateAnswer",
            spaceStateAnswer: SpaceStateAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnswerMessage {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      answer: isSet(object.error)
        ? { $case: "error", error: ErrorMessage.fromJSON(object.error) }
        : isSet(object.jitsiJwtAnswer)
        ? { $case: "jitsiJwtAnswer", jitsiJwtAnswer: JitsiJwtAnswer.fromJSON(object.jitsiJwtAnswer) }
        : isSet(object.joinBBBMeetingAnswer)
        ? {
          $case: "joinBBBMeetingAnswer",
          joinBBBMeetingAnswer: JoinBBBMeetingAnswer.fromJSON(object.joinBBBMeetingAnswer),
        }
        : isSet(object.roomTagsAnswer)
        ? { $case: "roomTagsAnswer", roomTagsAnswer: RoomTagsAnswer.fromJSON(object.roomTagsAnswer) }
        : isSet(object.embeddableWebsiteAnswer)
        ? {
          $case: "embeddableWebsiteAnswer",
          embeddableWebsiteAnswer: EmbeddableWebsiteAnswer.fromJSON(object.embeddableWebsiteAnswer),
        }
        : isSet(object.roomsFromSameWorldAnswer)
        ? {
          $case: "roomsFromSameWorldAnswer",
          roomsFromSameWorldAnswer: RoomsFromSameWorldAnswer.fromJSON(object.roomsFromSameWorldAnswer),
        }
        : isSet(object.sendEventAnswer)
        ? { $case: "sendEventAnswer", sendEventAnswer: SendEventAnswer.fromJSON(object.sendEventAnswer) }
        : isSet(object.searchMemberAnswer)
        ? { $case: "searchMemberAnswer", searchMemberAnswer: SearchMemberAnswer.fromJSON(object.searchMemberAnswer) }
        : isSet(object.getMemberAnswer)
        ? { $case: "getMemberAnswer", getMemberAnswer: GetMemberAnswer.fromJSON(object.getMemberAnswer) }
        : isSet(object.iceServersAnswer)
        ? { $case: "iceServersAnswer", iceServersAnswer: IceServersAnswer.fromJSON(object.iceServersAnswer) }
        : isSet(object.chatMembersAnswer)
        ? { $case: "chatMembersAnswer", chatMembersAnswer: ChatMembersAnswer.fromJSON(object.chatMembersAnswer) }
        : isSet(object.searchTagsAnswer)
        ? { $case: "searchTagsAnswer", searchTagsAnswer: SearchTagsAnswer.fromJSON(object.searchTagsAnswer) }
        : isSet(object.oauthRefreshTokenAnswer)
        ? {
          $case: "oauthRefreshTokenAnswer",
          oauthRefreshTokenAnswer: OauthRefreshTokenAnswer.fromJSON(object.oauthRefreshTokenAnswer),
        }
        : isSet(object.enterChatRoomAreaAnswer)
        ? {
          $case: "enterChatRoomAreaAnswer",
          enterChatRoomAreaAnswer: EnterChatRoomAreaAnswer.fromJSON(object.enterChatRoomAreaAnswer),
        }
        : isSet(object.joinSpaceAnswer)
        ? { $case: "joinSpaceAnswer", joinSpaceAnswer: JoinSpaceAnswer.fromJSON(object.joinSpaceAnswer) }
        : isSet(object.leaveSpaceAnswer)
        ? { $case: "leaveSpaceAnswer", leaveSpaceAnswer: LeaveSpaceAnswer.fromJSON(object.leaveSpaceAnswer) }
        : isSet(object.mapStorageJwtAnswer)
        ? {
          $case: "mapStorageJwtAnswer",
          mapStorageJwtAnswer: MapStorageJwtAnswer.fromJSON(object.mapStorageJwtAnswer),
        }
        : isSet(object.getRecordingsAnswer)
        ? {
          $case: "getRecordingsAnswer",
          getRecordingsAnswer: GetRecordingsAnswer.fromJSON(object.getRecordingsAnswer),
        }
        : isSet(object.deleteRecordingAnswer)
        ? {
          $case: "deleteRecordingAnswer",
          deleteRecordingAnswer: DeleteRecordingAnswer.fromJSON(object.deleteRecordingAnswer),
        }
        : isSet(object.getSignedUrlAnswer)
        ? { $case: "getSignedUrlAnswer", getSignedUrlAnswer: GetSignedUrlAnswer.fromJSON(object.getSignedUrlAnswer) }
        : isSet(object.getRecordingThumbnailsAnswer)
        ? {
          $case: "getRecordingThumbnailsAnswer",
          getRecordingThumbnailsAnswer: GetRecordingThumbnailsAnswer.fromJSON(object.getRecordingThumbnailsAnswer),
        }
        : isSet(object.banIpPreviewAnswer)
        ? { $case: "banIpPreviewAnswer", banIpPreviewAnswer: BanIpPreviewAnswer.fromJSON(object.banIpPreviewAnswer) }
        : isSet(object.spaceStateAnswer)
        ? { $case: "spaceStateAnswer", spaceStateAnswer: SpaceStateAnswer.fromJSON(object.spaceStateAnswer) }
        : undefined,
    };
  },

  toJSON(message: AnswerMessage): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.answer?.$case === "error") {
      obj.error = ErrorMessage.toJSON(message.answer.error);
    } else if (message.answer?.$case === "jitsiJwtAnswer") {
      obj.jitsiJwtAnswer = JitsiJwtAnswer.toJSON(message.answer.jitsiJwtAnswer);
    } else if (message.answer?.$case === "joinBBBMeetingAnswer") {
      obj.joinBBBMeetingAnswer = JoinBBBMeetingAnswer.toJSON(message.answer.joinBBBMeetingAnswer);
    } else if (message.answer?.$case === "roomTagsAnswer") {
      obj.roomTagsAnswer = RoomTagsAnswer.toJSON(message.answer.roomTagsAnswer);
    } else if (message.answer?.$case === "embeddableWebsiteAnswer") {
      obj.embeddableWebsiteAnswer = EmbeddableWebsiteAnswer.toJSON(message.answer.embeddableWebsiteAnswer);
    } else if (message.answer?.$case === "roomsFromSameWorldAnswer") {
      obj.roomsFromSameWorldAnswer = RoomsFromSameWorldAnswer.toJSON(message.answer.roomsFromSameWorldAnswer);
    } else if (message.answer?.$case === "sendEventAnswer") {
      obj.sendEventAnswer = SendEventAnswer.toJSON(message.answer.sendEventAnswer);
    } else if (message.answer?.$case === "searchMemberAnswer") {
      obj.searchMemberAnswer = SearchMemberAnswer.toJSON(message.answer.searchMemberAnswer);
    } else if (message.answer?.$case === "getMemberAnswer") {
      obj.getMemberAnswer = GetMemberAnswer.toJSON(message.answer.getMemberAnswer);
    } else if (message.answer?.$case === "iceServersAnswer") {
      obj.iceServersAnswer = IceServersAnswer.toJSON(message.answer.iceServersAnswer);
    } else if (message.answer?.$case === "chatMembersAnswer") {
      obj.chatMembersAnswer = ChatMembersAnswer.toJSON(message.answer.chatMembersAnswer);
    } else if (message.answer?.$case === "searchTagsAnswer") {
      obj.searchTagsAnswer = SearchTagsAnswer.toJSON(message.answer.searchTagsAnswer);
    } else if (message.answer?.$case === "oauthRefreshTokenAnswer") {
      obj.oauthRefreshTokenAnswer = OauthRefreshTokenAnswer.toJSON(message.answer.oauthRefreshTokenAnswer);
    } else if (message.answer?.$case === "enterChatRoomAreaAnswer") {
      obj.enterChatRoomAreaAnswer = EnterChatRoomAreaAnswer.toJSON(message.answer.enterChatRoomAreaAnswer);
    } else if (message.answer?.$case === "joinSpaceAnswer") {
      obj.joinSpaceAnswer = JoinSpaceAnswer.toJSON(message.answer.joinSpaceAnswer);
    } else if (message.answer?.$case === "leaveSpaceAnswer") {
      obj.leaveSpaceAnswer = LeaveSpaceAnswer.toJSON(message.answer.leaveSpaceAnswer);
    } else if (message.answer?.$case === "mapStorageJwtAnswer") {
      obj.mapStorageJwtAnswer = MapStorageJwtAnswer.toJSON(message.answer.mapStorageJwtAnswer);
    } else if (message.answer?.$case === "getRecordingsAnswer") {
      obj.getRecordingsAnswer = GetRecordingsAnswer.toJSON(message.answer.getRecordingsAnswer);
    } else if (message.answer?.$case === "deleteRecordingAnswer") {
      obj.deleteRecordingAnswer = DeleteRecordingAnswer.toJSON(message.answer.deleteRecordingAnswer);
    } else if (message.answer?.$case === "getSignedUrlAnswer") {
      obj.getSignedUrlAnswer = GetSignedUrlAnswer.toJSON(message.answer.getSignedUrlAnswer);
    } else if (message.answer?.$case === "getRecordingThumbnailsAnswer") {
      obj.getRecordingThumbnailsAnswer = GetRecordingThumbnailsAnswer.toJSON(
        message.answer.getRecordingThumbnailsAnswer,
      );
    } else if (message.answer?.$case === "banIpPreviewAnswer") {
      obj.banIpPreviewAnswer = BanIpPreviewAnswer.toJSON(message.answer.banIpPreviewAnswer);
    } else if (message.answer?.$case === "spaceStateAnswer") {
      obj.spaceStateAnswer = SpaceStateAnswer.toJSON(message.answer.spaceStateAnswer);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnswerMessage>, I>>(base?: I): AnswerMessage {
    return AnswerMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnswerMessage>, I>>(object: I): AnswerMessage {
    const message = createBaseAnswerMessage();
    message.id = object.id ?? 0;
    switch (object.answer?.$case) {
      case "error": {
        if (object.answer?.error !== undefined && object.answer?.error !== null) {
          message.answer = { $case: "error", error: ErrorMessage.fromPartial(object.answer.error) };
        }
        break;
      }
      case "jitsiJwtAnswer": {
        if (object.answer?.jitsiJwtAnswer !== undefined && object.answer?.jitsiJwtAnswer !== null) {
          message.answer = {
            $case: "jitsiJwtAnswer",
            jitsiJwtAnswer: JitsiJwtAnswer.fromPartial(object.answer.jitsiJwtAnswer),
          };
        }
        break;
      }
      case "joinBBBMeetingAnswer": {
        if (object.answer?.joinBBBMeetingAnswer !== undefined && object.answer?.joinBBBMeetingAnswer !== null) {
          message.answer = {
            $case: "joinBBBMeetingAnswer",
            joinBBBMeetingAnswer: JoinBBBMeetingAnswer.fromPartial(object.answer.joinBBBMeetingAnswer),
          };
        }
        break;
      }
      case "roomTagsAnswer": {
        if (object.answer?.roomTagsAnswer !== undefined && object.answer?.roomTagsAnswer !== null) {
          message.answer = {
            $case: "roomTagsAnswer",
            roomTagsAnswer: RoomTagsAnswer.fromPartial(object.answer.roomTagsAnswer),
          };
        }
        break;
      }
      case "embeddableWebsiteAnswer": {
        if (object.answer?.embeddableWebsiteAnswer !== undefined && object.answer?.embeddableWebsiteAnswer !== null) {
          message.answer = {
            $case: "embeddableWebsiteAnswer",
            embeddableWebsiteAnswer: EmbeddableWebsiteAnswer.fromPartial(object.answer.embeddableWebsiteAnswer),
          };
        }
        break;
      }
      case "roomsFromSameWorldAnswer": {
        if (object.answer?.roomsFromSameWorldAnswer !== undefined && object.answer?.roomsFromSameWorldAnswer !== null) {
          message.answer = {
            $case: "roomsFromSameWorldAnswer",
            roomsFromSameWorldAnswer: RoomsFromSameWorldAnswer.fromPartial(object.answer.roomsFromSameWorldAnswer),
          };
        }
        break;
      }
      case "sendEventAnswer": {
        if (object.answer?.sendEventAnswer !== undefined && object.answer?.sendEventAnswer !== null) {
          message.answer = {
            $case: "sendEventAnswer",
            sendEventAnswer: SendEventAnswer.fromPartial(object.answer.sendEventAnswer),
          };
        }
        break;
      }
      case "searchMemberAnswer": {
        if (object.answer?.searchMemberAnswer !== undefined && object.answer?.searchMemberAnswer !== null) {
          message.answer = {
            $case: "searchMemberAnswer",
            searchMemberAnswer: SearchMemberAnswer.fromPartial(object.answer.searchMemberAnswer),
          };
        }
        break;
      }
      case "getMemberAnswer": {
        if (object.answer?.getMemberAnswer !== undefined && object.answer?.getMemberAnswer !== null) {
          message.answer = {
            $case: "getMemberAnswer",
            getMemberAnswer: GetMemberAnswer.fromPartial(object.answer.getMemberAnswer),
          };
        }
        break;
      }
      case "iceServersAnswer": {
        if (object.answer?.iceServersAnswer !== undefined && object.answer?.iceServersAnswer !== null) {
          message.answer = {
            $case: "iceServersAnswer",
            iceServersAnswer: IceServersAnswer.fromPartial(object.answer.iceServersAnswer),
          };
        }
        break;
      }
      case "chatMembersAnswer": {
        if (object.answer?.chatMembersAnswer !== undefined && object.answer?.chatMembersAnswer !== null) {
          message.answer = {
            $case: "chatMembersAnswer",
            chatMembersAnswer: ChatMembersAnswer.fromPartial(object.answer.chatMembersAnswer),
          };
        }
        break;
      }
      case "searchTagsAnswer": {
        if (object.answer?.searchTagsAnswer !== undefined && object.answer?.searchTagsAnswer !== null) {
          message.answer = {
            $case: "searchTagsAnswer",
            searchTagsAnswer: SearchTagsAnswer.fromPartial(object.answer.searchTagsAnswer),
          };
        }
        break;
      }
      case "oauthRefreshTokenAnswer": {
        if (object.answer?.oauthRefreshTokenAnswer !== undefined && object.answer?.oauthRefreshTokenAnswer !== null) {
          message.answer = {
            $case: "oauthRefreshTokenAnswer",
            oauthRefreshTokenAnswer: OauthRefreshTokenAnswer.fromPartial(object.answer.oauthRefreshTokenAnswer),
          };
        }
        break;
      }
      case "enterChatRoomAreaAnswer": {
        if (object.answer?.enterChatRoomAreaAnswer !== undefined && object.answer?.enterChatRoomAreaAnswer !== null) {
          message.answer = {
            $case: "enterChatRoomAreaAnswer",
            enterChatRoomAreaAnswer: EnterChatRoomAreaAnswer.fromPartial(object.answer.enterChatRoomAreaAnswer),
          };
        }
        break;
      }
      case "joinSpaceAnswer": {
        if (object.answer?.joinSpaceAnswer !== undefined && object.answer?.joinSpaceAnswer !== null) {
          message.answer = {
            $case: "joinSpaceAnswer",
            joinSpaceAnswer: JoinSpaceAnswer.fromPartial(object.answer.joinSpaceAnswer),
          };
        }
        break;
      }
      case "leaveSpaceAnswer": {
        if (object.answer?.leaveSpaceAnswer !== undefined && object.answer?.leaveSpaceAnswer !== null) {
          message.answer = {
            $case: "leaveSpaceAnswer",
            leaveSpaceAnswer: LeaveSpaceAnswer.fromPartial(object.answer.leaveSpaceAnswer),
          };
        }
        break;
      }
      case "mapStorageJwtAnswer": {
        if (object.answer?.mapStorageJwtAnswer !== undefined && object.answer?.mapStorageJwtAnswer !== null) {
          message.answer = {
            $case: "mapStorageJwtAnswer",
            mapStorageJwtAnswer: MapStorageJwtAnswer.fromPartial(object.answer.mapStorageJwtAnswer),
          };
        }
        break;
      }
      case "getRecordingsAnswer": {
        if (object.answer?.getRecordingsAnswer !== undefined && object.answer?.getRecordingsAnswer !== null) {
          message.answer = {
            $case: "getRecordingsAnswer",
            getRecordingsAnswer: GetRecordingsAnswer.fromPartial(object.answer.getRecordingsAnswer),
          };
        }
        break;
      }
      case "deleteRecordingAnswer": {
        if (object.answer?.deleteRecordingAnswer !== undefined && object.answer?.deleteRecordingAnswer !== null) {
          message.answer = {
            $case: "deleteRecordingAnswer",
            deleteRecordingAnswer: DeleteRecordingAnswer.fromPartial(object.answer.deleteRecordingAnswer),
          };
        }
        break;
      }
      case "getSignedUrlAnswer": {
        if (object.answer?.getSignedUrlAnswer !== undefined && object.answer?.getSignedUrlAnswer !== null) {
          message.answer = {
            $case: "getSignedUrlAnswer",
            getSignedUrlAnswer: GetSignedUrlAnswer.fromPartial(object.answer.getSignedUrlAnswer),
          };
        }
        break;
      }
      case "getRecordingThumbnailsAnswer": {
        if (
          object.answer?.getRecordingThumbnailsAnswer !== undefined &&
          object.answer?.getRecordingThumbnailsAnswer !== null
        ) {
          message.answer = {
            $case: "getRecordingThumbnailsAnswer",
            getRecordingThumbnailsAnswer: GetRecordingThumbnailsAnswer.fromPartial(
              object.answer.getRecordingThumbnailsAnswer,
            ),
          };
        }
        break;
      }
      case "banIpPreviewAnswer": {
        if (object.answer?.banIpPreviewAnswer !== undefined && object.answer?.banIpPreviewAnswer !== null) {
          message.answer = {
            $case: "banIpPreviewAnswer",
            banIpPreviewAnswer: BanIpPreviewAnswer.fromPartial(object.answer.banIpPreviewAnswer),
          };
        }
        break;
      }
      case "spaceStateAnswer": {
        if (object.answer?.spaceStateAnswer !== undefined && object.answer?.spaceStateAnswer !== null) {
          message.answer = {
            $case: "spaceStateAnswer",
            spaceStateAnswer: SpaceStateAnswer.fromPartial(object.answer.spaceStateAnswer),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseJitsiJwtAnswer(): JitsiJwtAnswer {
  return { jwt: "", url: "" };
}

export const JitsiJwtAnswer: MessageFns<JitsiJwtAnswer> = {
  encode(message: JitsiJwtAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jwt !== "") {
      writer.uint32(10).string(message.jwt);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JitsiJwtAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJitsiJwtAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jwt = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JitsiJwtAnswer {
    return {
      jwt: isSet(object.jwt) ? globalThis.String(object.jwt) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: JitsiJwtAnswer): unknown {
    const obj: any = {};
    if (message.jwt !== "") {
      obj.jwt = message.jwt;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JitsiJwtAnswer>, I>>(base?: I): JitsiJwtAnswer {
    return JitsiJwtAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JitsiJwtAnswer>, I>>(object: I): JitsiJwtAnswer {
    const message = createBaseJitsiJwtAnswer();
    message.jwt = object.jwt ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseMapStorageJwtAnswer(): MapStorageJwtAnswer {
  return { jwt: "" };
}

export const MapStorageJwtAnswer: MessageFns<MapStorageJwtAnswer> = {
  encode(message: MapStorageJwtAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jwt !== "") {
      writer.uint32(10).string(message.jwt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MapStorageJwtAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMapStorageJwtAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jwt = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MapStorageJwtAnswer {
    return { jwt: isSet(object.jwt) ? globalThis.String(object.jwt) : "" };
  },

  toJSON(message: MapStorageJwtAnswer): unknown {
    const obj: any = {};
    if (message.jwt !== "") {
      obj.jwt = message.jwt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MapStorageJwtAnswer>, I>>(base?: I): MapStorageJwtAnswer {
    return MapStorageJwtAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MapStorageJwtAnswer>, I>>(object: I): MapStorageJwtAnswer {
    const message = createBaseMapStorageJwtAnswer();
    message.jwt = object.jwt ?? "";
    return message;
  },
};

function createBaseJoinBBBMeetingAnswer(): JoinBBBMeetingAnswer {
  return { meetingId: "", clientURL: "" };
}

export const JoinBBBMeetingAnswer: MessageFns<JoinBBBMeetingAnswer> = {
  encode(message: JoinBBBMeetingAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.meetingId !== "") {
      writer.uint32(10).string(message.meetingId);
    }
    if (message.clientURL !== "") {
      writer.uint32(18).string(message.clientURL);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JoinBBBMeetingAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinBBBMeetingAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.meetingId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.clientURL = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JoinBBBMeetingAnswer {
    return {
      meetingId: isSet(object.meetingId) ? globalThis.String(object.meetingId) : "",
      clientURL: isSet(object.clientURL) ? globalThis.String(object.clientURL) : "",
    };
  },

  toJSON(message: JoinBBBMeetingAnswer): unknown {
    const obj: any = {};
    if (message.meetingId !== "") {
      obj.meetingId = message.meetingId;
    }
    if (message.clientURL !== "") {
      obj.clientURL = message.clientURL;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JoinBBBMeetingAnswer>, I>>(base?: I): JoinBBBMeetingAnswer {
    return JoinBBBMeetingAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoinBBBMeetingAnswer>, I>>(object: I): JoinBBBMeetingAnswer {
    const message = createBaseJoinBBBMeetingAnswer();
    message.meetingId = object.meetingId ?? "";
    message.clientURL = object.clientURL ?? "";
    return message;
  },
};

function createBaseRoomTagsAnswer(): RoomTagsAnswer {
  return { tags: [] };
}

export const RoomTagsAnswer: MessageFns<RoomTagsAnswer> = {
  encode(message: RoomTagsAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tags) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoomTagsAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomTagsAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoomTagsAnswer {
    return { tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: RoomTagsAnswer): unknown {
    const obj: any = {};
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoomTagsAnswer>, I>>(base?: I): RoomTagsAnswer {
    return RoomTagsAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoomTagsAnswer>, I>>(object: I): RoomTagsAnswer {
    const message = createBaseRoomTagsAnswer();
    message.tags = object.tags?.map((e) => e) || [];
    return message;
  },
};

function createBaseEmbeddableWebsiteAnswer(): EmbeddableWebsiteAnswer {
  return { url: "", state: false, embeddable: false, message: undefined };
}

export const EmbeddableWebsiteAnswer: MessageFns<EmbeddableWebsiteAnswer> = {
  encode(message: EmbeddableWebsiteAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.state !== false) {
      writer.uint32(16).bool(message.state);
    }
    if (message.embeddable !== false) {
      writer.uint32(24).bool(message.embeddable);
    }
    if (message.message !== undefined) {
      writer.uint32(34).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmbeddableWebsiteAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmbeddableWebsiteAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.state = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.embeddable = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EmbeddableWebsiteAnswer {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      state: isSet(object.state) ? globalThis.Boolean(object.state) : false,
      embeddable: isSet(object.embeddable) ? globalThis.Boolean(object.embeddable) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : undefined,
    };
  },

  toJSON(message: EmbeddableWebsiteAnswer): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.state !== false) {
      obj.state = message.state;
    }
    if (message.embeddable !== false) {
      obj.embeddable = message.embeddable;
    }
    if (message.message !== undefined) {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EmbeddableWebsiteAnswer>, I>>(base?: I): EmbeddableWebsiteAnswer {
    return EmbeddableWebsiteAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmbeddableWebsiteAnswer>, I>>(object: I): EmbeddableWebsiteAnswer {
    const message = createBaseEmbeddableWebsiteAnswer();
    message.url = object.url ?? "";
    message.state = object.state ?? false;
    message.embeddable = object.embeddable ?? false;
    message.message = object.message ?? undefined;
    return message;
  },
};

function createBaseRoomShortDescription(): RoomShortDescription {
  return {
    name: "",
    roomUrl: "",
    wamUrl: undefined,
    description: undefined,
    copyright: undefined,
    thumbnail: undefined,
    areasSearchable: undefined,
    entitiesSearchable: undefined,
  };
}

export const RoomShortDescription: MessageFns<RoomShortDescription> = {
  encode(message: RoomShortDescription, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.roomUrl !== "") {
      writer.uint32(18).string(message.roomUrl);
    }
    if (message.wamUrl !== undefined) {
      writer.uint32(26).string(message.wamUrl);
    }
    if (message.description !== undefined) {
      writer.uint32(34).string(message.description);
    }
    if (message.copyright !== undefined) {
      writer.uint32(42).string(message.copyright);
    }
    if (message.thumbnail !== undefined) {
      writer.uint32(50).string(message.thumbnail);
    }
    if (message.areasSearchable !== undefined) {
      writer.uint32(56).int32(message.areasSearchable);
    }
    if (message.entitiesSearchable !== undefined) {
      writer.uint32(64).int32(message.entitiesSearchable);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoomShortDescription {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomShortDescription();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.roomUrl = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.wamUrl = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.copyright = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.thumbnail = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.areasSearchable = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.entitiesSearchable = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoomShortDescription {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      roomUrl: isSet(object.roomUrl) ? globalThis.String(object.roomUrl) : "",
      wamUrl: isSet(object.wamUrl) ? globalThis.String(object.wamUrl) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      copyright: isSet(object.copyright) ? globalThis.String(object.copyright) : undefined,
      thumbnail: isSet(object.thumbnail) ? globalThis.String(object.thumbnail) : undefined,
      areasSearchable: isSet(object.areasSearchable) ? globalThis.Number(object.areasSearchable) : undefined,
      entitiesSearchable: isSet(object.entitiesSearchable) ? globalThis.Number(object.entitiesSearchable) : undefined,
    };
  },

  toJSON(message: RoomShortDescription): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.roomUrl !== "") {
      obj.roomUrl = message.roomUrl;
    }
    if (message.wamUrl !== undefined) {
      obj.wamUrl = message.wamUrl;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.copyright !== undefined) {
      obj.copyright = message.copyright;
    }
    if (message.thumbnail !== undefined) {
      obj.thumbnail = message.thumbnail;
    }
    if (message.areasSearchable !== undefined) {
      obj.areasSearchable = Math.round(message.areasSearchable);
    }
    if (message.entitiesSearchable !== undefined) {
      obj.entitiesSearchable = Math.round(message.entitiesSearchable);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoomShortDescription>, I>>(base?: I): RoomShortDescription {
    return RoomShortDescription.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoomShortDescription>, I>>(object: I): RoomShortDescription {
    const message = createBaseRoomShortDescription();
    message.name = object.name ?? "";
    message.roomUrl = object.roomUrl ?? "";
    message.wamUrl = object.wamUrl ?? undefined;
    message.description = object.description ?? undefined;
    message.copyright = object.copyright ?? undefined;
    message.thumbnail = object.thumbnail ?? undefined;
    message.areasSearchable = object.areasSearchable ?? undefined;
    message.entitiesSearchable = object.entitiesSearchable ?? undefined;
    return message;
  },
};

function createBaseRoomsFromSameWorldAnswer(): RoomsFromSameWorldAnswer {
  return { roomDescriptions: [] };
}

export const RoomsFromSameWorldAnswer: MessageFns<RoomsFromSameWorldAnswer> = {
  encode(message: RoomsFromSameWorldAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.roomDescriptions) {
      RoomShortDescription.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoomsFromSameWorldAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomsFromSameWorldAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roomDescriptions.push(RoomShortDescription.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoomsFromSameWorldAnswer {
    return {
      roomDescriptions: globalThis.Array.isArray(object?.roomDescriptions)
        ? object.roomDescriptions.map((e: any) => RoomShortDescription.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RoomsFromSameWorldAnswer): unknown {
    const obj: any = {};
    if (message.roomDescriptions?.length) {
      obj.roomDescriptions = message.roomDescriptions.map((e) => RoomShortDescription.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoomsFromSameWorldAnswer>, I>>(base?: I): RoomsFromSameWorldAnswer {
    return RoomsFromSameWorldAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoomsFromSameWorldAnswer>, I>>(object: I): RoomsFromSameWorldAnswer {
    const message = createBaseRoomsFromSameWorldAnswer();
    message.roomDescriptions = object.roomDescriptions?.map((e) => RoomShortDescription.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSendEventAnswer(): SendEventAnswer {
  return {};
}

export const SendEventAnswer: MessageFns<SendEventAnswer> = {
  encode(_: SendEventAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendEventAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendEventAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SendEventAnswer {
    return {};
  },

  toJSON(_: SendEventAnswer): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SendEventAnswer>, I>>(base?: I): SendEventAnswer {
    return SendEventAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendEventAnswer>, I>>(_: I): SendEventAnswer {
    const message = createBaseSendEventAnswer();
    return message;
  },
};

function createBaseSearchMemberAnswer(): SearchMemberAnswer {
  return { members: [] };
}

export const SearchMemberAnswer: MessageFns<SearchMemberAnswer> = {
  encode(message: SearchMemberAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.members) {
      Member.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchMemberAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchMemberAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.members.push(Member.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchMemberAnswer {
    return {
      members: globalThis.Array.isArray(object?.members) ? object.members.map((e: any) => Member.fromJSON(e)) : [],
    };
  },

  toJSON(message: SearchMemberAnswer): unknown {
    const obj: any = {};
    if (message.members?.length) {
      obj.members = message.members.map((e) => Member.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchMemberAnswer>, I>>(base?: I): SearchMemberAnswer {
    return SearchMemberAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchMemberAnswer>, I>>(object: I): SearchMemberAnswer {
    const message = createBaseSearchMemberAnswer();
    message.members = object.members?.map((e) => Member.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetMemberAnswer(): GetMemberAnswer {
  return { member: undefined };
}

export const GetMemberAnswer: MessageFns<GetMemberAnswer> = {
  encode(message: GetMemberAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.member !== undefined) {
      Member.encode(message.member, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMemberAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMemberAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.member = Member.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMemberAnswer {
    return { member: isSet(object.member) ? Member.fromJSON(object.member) : undefined };
  },

  toJSON(message: GetMemberAnswer): unknown {
    const obj: any = {};
    if (message.member !== undefined) {
      obj.member = Member.toJSON(message.member);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMemberAnswer>, I>>(base?: I): GetMemberAnswer {
    return GetMemberAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMemberAnswer>, I>>(object: I): GetMemberAnswer {
    const message = createBaseGetMemberAnswer();
    message.member = (object.member !== undefined && object.member !== null)
      ? Member.fromPartial(object.member)
      : undefined;
    return message;
  },
};

function createBaseChatMembersAnswer(): ChatMembersAnswer {
  return { total: 0, members: [] };
}

export const ChatMembersAnswer: MessageFns<ChatMembersAnswer> = {
  encode(message: ChatMembersAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.total !== 0) {
      writer.uint32(8).int64(message.total);
    }
    for (const v of message.members) {
      ChatMember.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatMembersAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatMembersAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.total = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.members.push(ChatMember.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatMembersAnswer {
    return {
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
      members: globalThis.Array.isArray(object?.members) ? object.members.map((e: any) => ChatMember.fromJSON(e)) : [],
    };
  },

  toJSON(message: ChatMembersAnswer): unknown {
    const obj: any = {};
    if (message.total !== 0) {
      obj.total = Math.round(message.total);
    }
    if (message.members?.length) {
      obj.members = message.members.map((e) => ChatMember.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatMembersAnswer>, I>>(base?: I): ChatMembersAnswer {
    return ChatMembersAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatMembersAnswer>, I>>(object: I): ChatMembersAnswer {
    const message = createBaseChatMembersAnswer();
    message.total = object.total ?? 0;
    message.members = object.members?.map((e) => ChatMember.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOauthRefreshTokenAnswer(): OauthRefreshTokenAnswer {
  return { message: "", token: "" };
}

export const OauthRefreshTokenAnswer: MessageFns<OauthRefreshTokenAnswer> = {
  encode(message: OauthRefreshTokenAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    if (message.token !== "") {
      writer.uint32(18).string(message.token);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OauthRefreshTokenAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOauthRefreshTokenAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.token = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OauthRefreshTokenAnswer {
    return {
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      token: isSet(object.token) ? globalThis.String(object.token) : "",
    };
  },

  toJSON(message: OauthRefreshTokenAnswer): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.token !== "") {
      obj.token = message.token;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OauthRefreshTokenAnswer>, I>>(base?: I): OauthRefreshTokenAnswer {
    return OauthRefreshTokenAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OauthRefreshTokenAnswer>, I>>(object: I): OauthRefreshTokenAnswer {
    const message = createBaseOauthRefreshTokenAnswer();
    message.message = object.message ?? "";
    message.token = object.token ?? "";
    return message;
  },
};

function createBaseEnterChatRoomAreaAnswer(): EnterChatRoomAreaAnswer {
  return {};
}

export const EnterChatRoomAreaAnswer: MessageFns<EnterChatRoomAreaAnswer> = {
  encode(_: EnterChatRoomAreaAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnterChatRoomAreaAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnterChatRoomAreaAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EnterChatRoomAreaAnswer {
    return {};
  },

  toJSON(_: EnterChatRoomAreaAnswer): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EnterChatRoomAreaAnswer>, I>>(base?: I): EnterChatRoomAreaAnswer {
    return EnterChatRoomAreaAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnterChatRoomAreaAnswer>, I>>(_: I): EnterChatRoomAreaAnswer {
    const message = createBaseEnterChatRoomAreaAnswer();
    return message;
  },
};

function createBaseJoinSpaceAnswer(): JoinSpaceAnswer {
  return { spaceUserId: "" };
}

export const JoinSpaceAnswer: MessageFns<JoinSpaceAnswer> = {
  encode(message: JoinSpaceAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceUserId !== "") {
      writer.uint32(10).string(message.spaceUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JoinSpaceAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinSpaceAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JoinSpaceAnswer {
    return { spaceUserId: isSet(object.spaceUserId) ? globalThis.String(object.spaceUserId) : "" };
  },

  toJSON(message: JoinSpaceAnswer): unknown {
    const obj: any = {};
    if (message.spaceUserId !== "") {
      obj.spaceUserId = message.spaceUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JoinSpaceAnswer>, I>>(base?: I): JoinSpaceAnswer {
    return JoinSpaceAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoinSpaceAnswer>, I>>(object: I): JoinSpaceAnswer {
    const message = createBaseJoinSpaceAnswer();
    message.spaceUserId = object.spaceUserId ?? "";
    return message;
  },
};

function createBaseLeaveSpaceAnswer(): LeaveSpaceAnswer {
  return {};
}

export const LeaveSpaceAnswer: MessageFns<LeaveSpaceAnswer> = {
  encode(_: LeaveSpaceAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LeaveSpaceAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeaveSpaceAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LeaveSpaceAnswer {
    return {};
  },

  toJSON(_: LeaveSpaceAnswer): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LeaveSpaceAnswer>, I>>(base?: I): LeaveSpaceAnswer {
    return LeaveSpaceAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LeaveSpaceAnswer>, I>>(_: I): LeaveSpaceAnswer {
    const message = createBaseLeaveSpaceAnswer();
    return message;
  },
};

function createBaseSearchTagsAnswer(): SearchTagsAnswer {
  return { tags: [] };
}

export const SearchTagsAnswer: MessageFns<SearchTagsAnswer> = {
  encode(message: SearchTagsAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tags) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchTagsAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchTagsAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchTagsAnswer {
    return { tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: SearchTagsAnswer): unknown {
    const obj: any = {};
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchTagsAnswer>, I>>(base?: I): SearchTagsAnswer {
    return SearchTagsAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchTagsAnswer>, I>>(object: I): SearchTagsAnswer {
    const message = createBaseSearchTagsAnswer();
    message.tags = object.tags?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetRecordingsAnswer(): GetRecordingsAnswer {
  return { recordings: [] };
}

export const GetRecordingsAnswer: MessageFns<GetRecordingsAnswer> = {
  encode(message: GetRecordingsAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.recordings) {
      Recording.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRecordingsAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRecordingsAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.recordings.push(Recording.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRecordingsAnswer {
    return {
      recordings: globalThis.Array.isArray(object?.recordings)
        ? object.recordings.map((e: any) => Recording.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetRecordingsAnswer): unknown {
    const obj: any = {};
    if (message.recordings?.length) {
      obj.recordings = message.recordings.map((e) => Recording.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRecordingsAnswer>, I>>(base?: I): GetRecordingsAnswer {
    return GetRecordingsAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRecordingsAnswer>, I>>(object: I): GetRecordingsAnswer {
    const message = createBaseGetRecordingsAnswer();
    message.recordings = object.recordings?.map((e) => Recording.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetRecordingThumbnailsAnswer(): GetRecordingThumbnailsAnswer {
  return { urls: [] };
}

export const GetRecordingThumbnailsAnswer: MessageFns<GetRecordingThumbnailsAnswer> = {
  encode(message: GetRecordingThumbnailsAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.urls) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRecordingThumbnailsAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRecordingThumbnailsAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.urls.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRecordingThumbnailsAnswer {
    return { urls: globalThis.Array.isArray(object?.urls) ? object.urls.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: GetRecordingThumbnailsAnswer): unknown {
    const obj: any = {};
    if (message.urls?.length) {
      obj.urls = message.urls;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRecordingThumbnailsAnswer>, I>>(base?: I): GetRecordingThumbnailsAnswer {
    return GetRecordingThumbnailsAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRecordingThumbnailsAnswer>, I>>(object: I): GetRecordingThumbnailsAnswer {
    const message = createBaseGetRecordingThumbnailsAnswer();
    message.urls = object.urls?.map((e) => e) || [];
    return message;
  },
};

function createBaseDeleteRecordingAnswer(): DeleteRecordingAnswer {
  return { success: false, errorMessage: undefined };
}

export const DeleteRecordingAnswer: MessageFns<DeleteRecordingAnswer> = {
  encode(message: DeleteRecordingAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteRecordingAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteRecordingAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteRecordingAnswer {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : undefined,
    };
  },

  toJSON(message: DeleteRecordingAnswer): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteRecordingAnswer>, I>>(base?: I): DeleteRecordingAnswer {
    return DeleteRecordingAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteRecordingAnswer>, I>>(object: I): DeleteRecordingAnswer {
    const message = createBaseDeleteRecordingAnswer();
    message.success = object.success ?? false;
    message.errorMessage = object.errorMessage ?? undefined;
    return message;
  },
};

function createBaseGetSignedUrlAnswer(): GetSignedUrlAnswer {
  return { signedUrl: "" };
}

export const GetSignedUrlAnswer: MessageFns<GetSignedUrlAnswer> = {
  encode(message: GetSignedUrlAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.signedUrl !== "") {
      writer.uint32(10).string(message.signedUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSignedUrlAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSignedUrlAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.signedUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSignedUrlAnswer {
    return { signedUrl: isSet(object.signedUrl) ? globalThis.String(object.signedUrl) : "" };
  },

  toJSON(message: GetSignedUrlAnswer): unknown {
    const obj: any = {};
    if (message.signedUrl !== "") {
      obj.signedUrl = message.signedUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSignedUrlAnswer>, I>>(base?: I): GetSignedUrlAnswer {
    return GetSignedUrlAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSignedUrlAnswer>, I>>(object: I): GetSignedUrlAnswer {
    const message = createBaseGetSignedUrlAnswer();
    message.signedUrl = object.signedUrl ?? "";
    return message;
  },
};

function createBaseBanIpPreviewQuery(): BanIpPreviewQuery {
  return { banUserUuid: "" };
}

export const BanIpPreviewQuery: MessageFns<BanIpPreviewQuery> = {
  encode(message: BanIpPreviewQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.banUserUuid !== "") {
      writer.uint32(10).string(message.banUserUuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BanIpPreviewQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBanIpPreviewQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.banUserUuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BanIpPreviewQuery {
    return { banUserUuid: isSet(object.banUserUuid) ? globalThis.String(object.banUserUuid) : "" };
  },

  toJSON(message: BanIpPreviewQuery): unknown {
    const obj: any = {};
    if (message.banUserUuid !== "") {
      obj.banUserUuid = message.banUserUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BanIpPreviewQuery>, I>>(base?: I): BanIpPreviewQuery {
    return BanIpPreviewQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BanIpPreviewQuery>, I>>(object: I): BanIpPreviewQuery {
    const message = createBaseBanIpPreviewQuery();
    message.banUserUuid = object.banUserUuid ?? "";
    return message;
  },
};

function createBaseBanIpPreviewUser(): BanIpPreviewUser {
  return { name: "" };
}

export const BanIpPreviewUser: MessageFns<BanIpPreviewUser> = {
  encode(message: BanIpPreviewUser, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BanIpPreviewUser {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBanIpPreviewUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BanIpPreviewUser {
    return { name: isSet(object.name) ? globalThis.String(object.name) : "" };
  },

  toJSON(message: BanIpPreviewUser): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BanIpPreviewUser>, I>>(base?: I): BanIpPreviewUser {
    return BanIpPreviewUser.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BanIpPreviewUser>, I>>(object: I): BanIpPreviewUser {
    const message = createBaseBanIpPreviewUser();
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseBanIpPreviewAnswer(): BanIpPreviewAnswer {
  return { ipKnown: false, includesModerator: false, users: [] };
}

export const BanIpPreviewAnswer: MessageFns<BanIpPreviewAnswer> = {
  encode(message: BanIpPreviewAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ipKnown !== false) {
      writer.uint32(8).bool(message.ipKnown);
    }
    if (message.includesModerator !== false) {
      writer.uint32(16).bool(message.includesModerator);
    }
    for (const v of message.users) {
      BanIpPreviewUser.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BanIpPreviewAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBanIpPreviewAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.ipKnown = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.includesModerator = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.users.push(BanIpPreviewUser.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BanIpPreviewAnswer {
    return {
      ipKnown: isSet(object.ipKnown) ? globalThis.Boolean(object.ipKnown) : false,
      includesModerator: isSet(object.includesModerator) ? globalThis.Boolean(object.includesModerator) : false,
      users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => BanIpPreviewUser.fromJSON(e)) : [],
    };
  },

  toJSON(message: BanIpPreviewAnswer): unknown {
    const obj: any = {};
    if (message.ipKnown !== false) {
      obj.ipKnown = message.ipKnown;
    }
    if (message.includesModerator !== false) {
      obj.includesModerator = message.includesModerator;
    }
    if (message.users?.length) {
      obj.users = message.users.map((e) => BanIpPreviewUser.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BanIpPreviewAnswer>, I>>(base?: I): BanIpPreviewAnswer {
    return BanIpPreviewAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BanIpPreviewAnswer>, I>>(object: I): BanIpPreviewAnswer {
    const message = createBaseBanIpPreviewAnswer();
    message.ipKnown = object.ipKnown ?? false;
    message.includesModerator = object.includesModerator ?? false;
    message.users = object.users?.map((e) => BanIpPreviewUser.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMember(): Member {
  return { id: "", name: undefined, email: undefined, visitCardUrl: undefined, chatID: undefined };
}

export const Member: MessageFns<Member> = {
  encode(message: Member, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.email !== undefined) {
      writer.uint32(26).string(message.email);
    }
    if (message.visitCardUrl !== undefined) {
      writer.uint32(34).string(message.visitCardUrl);
    }
    if (message.chatID !== undefined) {
      writer.uint32(42).string(message.chatID);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Member {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMember();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.visitCardUrl = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.chatID = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Member {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      email: isSet(object.email) ? globalThis.String(object.email) : undefined,
      visitCardUrl: isSet(object.visitCardUrl) ? globalThis.String(object.visitCardUrl) : undefined,
      chatID: isSet(object.chatID) ? globalThis.String(object.chatID) : undefined,
    };
  },

  toJSON(message: Member): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.email !== undefined) {
      obj.email = message.email;
    }
    if (message.visitCardUrl !== undefined) {
      obj.visitCardUrl = message.visitCardUrl;
    }
    if (message.chatID !== undefined) {
      obj.chatID = message.chatID;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Member>, I>>(base?: I): Member {
    return Member.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Member>, I>>(object: I): Member {
    const message = createBaseMember();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.email = object.email ?? undefined;
    message.visitCardUrl = object.visitCardUrl ?? undefined;
    message.chatID = object.chatID ?? undefined;
    return message;
  },
};

function createBaseIceServer(): IceServer {
  return { urls: [], username: undefined, credential: undefined, credentialType: undefined };
}

export const IceServer: MessageFns<IceServer> = {
  encode(message: IceServer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.urls) {
      writer.uint32(10).string(v!);
    }
    if (message.username !== undefined) {
      writer.uint32(18).string(message.username);
    }
    if (message.credential !== undefined) {
      writer.uint32(26).string(message.credential);
    }
    if (message.credentialType !== undefined) {
      writer.uint32(34).string(message.credentialType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IceServer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIceServer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.urls.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.username = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.credential = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.credentialType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IceServer {
    return {
      urls: globalThis.Array.isArray(object?.urls) ? object.urls.map((e: any) => globalThis.String(e)) : [],
      username: isSet(object.username) ? globalThis.String(object.username) : undefined,
      credential: isSet(object.credential) ? globalThis.String(object.credential) : undefined,
      credentialType: isSet(object.credentialType) ? globalThis.String(object.credentialType) : undefined,
    };
  },

  toJSON(message: IceServer): unknown {
    const obj: any = {};
    if (message.urls?.length) {
      obj.urls = message.urls;
    }
    if (message.username !== undefined) {
      obj.username = message.username;
    }
    if (message.credential !== undefined) {
      obj.credential = message.credential;
    }
    if (message.credentialType !== undefined) {
      obj.credentialType = message.credentialType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IceServer>, I>>(base?: I): IceServer {
    return IceServer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IceServer>, I>>(object: I): IceServer {
    const message = createBaseIceServer();
    message.urls = object.urls?.map((e) => e) || [];
    message.username = object.username ?? undefined;
    message.credential = object.credential ?? undefined;
    message.credentialType = object.credentialType ?? undefined;
    return message;
  },
};

function createBaseIceServersAnswer(): IceServersAnswer {
  return { iceServers: [] };
}

export const IceServersAnswer: MessageFns<IceServersAnswer> = {
  encode(message: IceServersAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.iceServers) {
      IceServer.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IceServersAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIceServersAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.iceServers.push(IceServer.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IceServersAnswer {
    return {
      iceServers: globalThis.Array.isArray(object?.iceServers)
        ? object.iceServers.map((e: any) => IceServer.fromJSON(e))
        : [],
    };
  },

  toJSON(message: IceServersAnswer): unknown {
    const obj: any = {};
    if (message.iceServers?.length) {
      obj.iceServers = message.iceServers.map((e) => IceServer.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IceServersAnswer>, I>>(base?: I): IceServersAnswer {
    return IceServersAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IceServersAnswer>, I>>(object: I): IceServersAnswer {
    const message = createBaseIceServersAnswer();
    message.iceServers = object.iceServers?.map((e) => IceServer.fromPartial(e)) || [];
    return message;
  },
};

function createBaseIceServersQuery(): IceServersQuery {
  return {};
}

export const IceServersQuery: MessageFns<IceServersQuery> = {
  encode(_: IceServersQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IceServersQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIceServersQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): IceServersQuery {
    return {};
  },

  toJSON(_: IceServersQuery): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<IceServersQuery>, I>>(base?: I): IceServersQuery {
    return IceServersQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IceServersQuery>, I>>(_: I): IceServersQuery {
    const message = createBaseIceServersQuery();
    return message;
  },
};

function createBaseChatMember(): ChatMember {
  return { uuid: "", wokaName: undefined, email: undefined, chatId: undefined, tags: [] };
}

export const ChatMember: MessageFns<ChatMember> = {
  encode(message: ChatMember, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uuid !== "") {
      writer.uint32(10).string(message.uuid);
    }
    if (message.wokaName !== undefined) {
      writer.uint32(18).string(message.wokaName);
    }
    if (message.email !== undefined) {
      writer.uint32(26).string(message.email);
    }
    if (message.chatId !== undefined) {
      writer.uint32(34).string(message.chatId);
    }
    for (const v of message.tags) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatMember {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatMember();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.wokaName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.chatId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatMember {
    return {
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      wokaName: isSet(object.wokaName) ? globalThis.String(object.wokaName) : undefined,
      email: isSet(object.email) ? globalThis.String(object.email) : undefined,
      chatId: isSet(object.chatId) ? globalThis.String(object.chatId) : undefined,
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ChatMember): unknown {
    const obj: any = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.wokaName !== undefined) {
      obj.wokaName = message.wokaName;
    }
    if (message.email !== undefined) {
      obj.email = message.email;
    }
    if (message.chatId !== undefined) {
      obj.chatId = message.chatId;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatMember>, I>>(base?: I): ChatMember {
    return ChatMember.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatMember>, I>>(object: I): ChatMember {
    const message = createBaseChatMember();
    message.uuid = object.uuid ?? "";
    message.wokaName = object.wokaName ?? undefined;
    message.email = object.email ?? undefined;
    message.chatId = object.chatId ?? undefined;
    message.tags = object.tags?.map((e) => e) || [];
    return message;
  },
};

function createBaseRecording(): Recording {
  return { timestamp: "", baseFilename: "", videoFile: undefined, posterUrl: "" };
}

export const Recording: MessageFns<Recording> = {
  encode(message: Recording, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== "") {
      writer.uint32(10).string(message.timestamp);
    }
    if (message.baseFilename !== "") {
      writer.uint32(18).string(message.baseFilename);
    }
    if (message.videoFile !== undefined) {
      VideoFile.encode(message.videoFile, writer.uint32(26).fork()).join();
    }
    if (message.posterUrl !== "") {
      writer.uint32(34).string(message.posterUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Recording {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecording();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.timestamp = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.baseFilename = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.videoFile = VideoFile.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.posterUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Recording {
    return {
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : "",
      baseFilename: isSet(object.baseFilename) ? globalThis.String(object.baseFilename) : "",
      videoFile: isSet(object.videoFile) ? VideoFile.fromJSON(object.videoFile) : undefined,
      posterUrl: isSet(object.posterUrl) ? globalThis.String(object.posterUrl) : "",
    };
  },

  toJSON(message: Recording): unknown {
    const obj: any = {};
    if (message.timestamp !== "") {
      obj.timestamp = message.timestamp;
    }
    if (message.baseFilename !== "") {
      obj.baseFilename = message.baseFilename;
    }
    if (message.videoFile !== undefined) {
      obj.videoFile = VideoFile.toJSON(message.videoFile);
    }
    if (message.posterUrl !== "") {
      obj.posterUrl = message.posterUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Recording>, I>>(base?: I): Recording {
    return Recording.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Recording>, I>>(object: I): Recording {
    const message = createBaseRecording();
    message.timestamp = object.timestamp ?? "";
    message.baseFilename = object.baseFilename ?? "";
    message.videoFile = (object.videoFile !== undefined && object.videoFile !== null)
      ? VideoFile.fromPartial(object.videoFile)
      : undefined;
    message.posterUrl = object.posterUrl ?? "";
    return message;
  },
};

function createBaseVideoFile(): VideoFile {
  return { key: "", filename: "", size: undefined };
}

export const VideoFile: MessageFns<VideoFile> = {
  encode(message: VideoFile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.filename !== "") {
      writer.uint32(18).string(message.filename);
    }
    if (message.size !== undefined) {
      writer.uint32(24).uint64(message.size);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VideoFile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVideoFile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.size = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VideoFile {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
      size: isSet(object.size) ? globalThis.Number(object.size) : undefined,
    };
  },

  toJSON(message: VideoFile): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    if (message.size !== undefined) {
      obj.size = Math.round(message.size);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VideoFile>, I>>(base?: I): VideoFile {
    return VideoFile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VideoFile>, I>>(object: I): VideoFile {
    const message = createBaseVideoFile();
    message.key = object.key ?? "";
    message.filename = object.filename ?? "";
    message.size = object.size ?? undefined;
    return message;
  },
};

function createBaseSpaceQueryMessage(): SpaceQueryMessage {
  return { id: 0, spaceName: "", query: undefined };
}

export const SpaceQueryMessage: MessageFns<SpaceQueryMessage> = {
  encode(message: SpaceQueryMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    if (message.spaceName !== "") {
      writer.uint32(18).string(message.spaceName);
    }
    switch (message.query?.$case) {
      case "addSpaceUserQuery":
        AddSpaceUserQuery.encode(message.query.addSpaceUserQuery, writer.uint32(42).fork()).join();
        break;
      case "removeSpaceUserQuery":
        RemoveSpaceUserQuery.encode(message.query.removeSpaceUserQuery, writer.uint32(50).fork()).join();
        break;
      case "spaceStateQuery":
        SpaceStateQueryPusherToBack.encode(message.query.spaceStateQuery, writer.uint32(74).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceQueryMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceQueryMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.query = {
            $case: "addSpaceUserQuery",
            addSpaceUserQuery: AddSpaceUserQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.query = {
            $case: "removeSpaceUserQuery",
            removeSpaceUserQuery: RemoveSpaceUserQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.query = {
            $case: "spaceStateQuery",
            spaceStateQuery: SpaceStateQueryPusherToBack.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceQueryMessage {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      query: isSet(object.addSpaceUserQuery)
        ? { $case: "addSpaceUserQuery", addSpaceUserQuery: AddSpaceUserQuery.fromJSON(object.addSpaceUserQuery) }
        : isSet(object.removeSpaceUserQuery)
        ? {
          $case: "removeSpaceUserQuery",
          removeSpaceUserQuery: RemoveSpaceUserQuery.fromJSON(object.removeSpaceUserQuery),
        }
        : isSet(object.spaceStateQuery)
        ? { $case: "spaceStateQuery", spaceStateQuery: SpaceStateQueryPusherToBack.fromJSON(object.spaceStateQuery) }
        : undefined,
    };
  },

  toJSON(message: SpaceQueryMessage): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.query?.$case === "addSpaceUserQuery") {
      obj.addSpaceUserQuery = AddSpaceUserQuery.toJSON(message.query.addSpaceUserQuery);
    } else if (message.query?.$case === "removeSpaceUserQuery") {
      obj.removeSpaceUserQuery = RemoveSpaceUserQuery.toJSON(message.query.removeSpaceUserQuery);
    } else if (message.query?.$case === "spaceStateQuery") {
      obj.spaceStateQuery = SpaceStateQueryPusherToBack.toJSON(message.query.spaceStateQuery);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceQueryMessage>, I>>(base?: I): SpaceQueryMessage {
    return SpaceQueryMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceQueryMessage>, I>>(object: I): SpaceQueryMessage {
    const message = createBaseSpaceQueryMessage();
    message.id = object.id ?? 0;
    message.spaceName = object.spaceName ?? "";
    switch (object.query?.$case) {
      case "addSpaceUserQuery": {
        if (object.query?.addSpaceUserQuery !== undefined && object.query?.addSpaceUserQuery !== null) {
          message.query = {
            $case: "addSpaceUserQuery",
            addSpaceUserQuery: AddSpaceUserQuery.fromPartial(object.query.addSpaceUserQuery),
          };
        }
        break;
      }
      case "removeSpaceUserQuery": {
        if (object.query?.removeSpaceUserQuery !== undefined && object.query?.removeSpaceUserQuery !== null) {
          message.query = {
            $case: "removeSpaceUserQuery",
            removeSpaceUserQuery: RemoveSpaceUserQuery.fromPartial(object.query.removeSpaceUserQuery),
          };
        }
        break;
      }
      case "spaceStateQuery": {
        if (object.query?.spaceStateQuery !== undefined && object.query?.spaceStateQuery !== null) {
          message.query = {
            $case: "spaceStateQuery",
            spaceStateQuery: SpaceStateQueryPusherToBack.fromPartial(object.query.spaceStateQuery),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseAddSpaceUserQuery(): AddSpaceUserQuery {
  return { spaceName: "", user: undefined, filterType: 0 };
}

export const AddSpaceUserQuery: MessageFns<AddSpaceUserQuery> = {
  encode(message: AddSpaceUserQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.user !== undefined) {
      SpaceUser.encode(message.user, writer.uint32(18).fork()).join();
    }
    if (message.filterType !== 0) {
      writer.uint32(24).int32(message.filterType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddSpaceUserQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSpaceUserQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = SpaceUser.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.filterType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSpaceUserQuery {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      user: isSet(object.user) ? SpaceUser.fromJSON(object.user) : undefined,
      filterType: isSet(object.filterType) ? filterTypeFromJSON(object.filterType) : 0,
    };
  },

  toJSON(message: AddSpaceUserQuery): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.user !== undefined) {
      obj.user = SpaceUser.toJSON(message.user);
    }
    if (message.filterType !== 0) {
      obj.filterType = filterTypeToJSON(message.filterType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSpaceUserQuery>, I>>(base?: I): AddSpaceUserQuery {
    return AddSpaceUserQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSpaceUserQuery>, I>>(object: I): AddSpaceUserQuery {
    const message = createBaseAddSpaceUserQuery();
    message.spaceName = object.spaceName ?? "";
    message.user = (object.user !== undefined && object.user !== null) ? SpaceUser.fromPartial(object.user) : undefined;
    message.filterType = object.filterType ?? 0;
    return message;
  },
};

function createBaseRemoveSpaceUserQuery(): RemoveSpaceUserQuery {
  return { spaceName: "", spaceUserId: "" };
}

export const RemoveSpaceUserQuery: MessageFns<RemoveSpaceUserQuery> = {
  encode(message: RemoveSpaceUserQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.spaceUserId !== "") {
      writer.uint32(18).string(message.spaceUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveSpaceUserQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveSpaceUserQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spaceUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveSpaceUserQuery {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      spaceUserId: isSet(object.spaceUserId) ? globalThis.String(object.spaceUserId) : "",
    };
  },

  toJSON(message: RemoveSpaceUserQuery): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.spaceUserId !== "") {
      obj.spaceUserId = message.spaceUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveSpaceUserQuery>, I>>(base?: I): RemoveSpaceUserQuery {
    return RemoveSpaceUserQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveSpaceUserQuery>, I>>(object: I): RemoveSpaceUserQuery {
    const message = createBaseRemoveSpaceUserQuery();
    message.spaceName = object.spaceName ?? "";
    message.spaceUserId = object.spaceUserId ?? "";
    return message;
  },
};

function createBaseSpaceStateQuery(): SpaceStateQuery {
  return { query: undefined };
}

export const SpaceStateQuery: MessageFns<SpaceStateQuery> = {
  encode(message: SpaceStateQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.query?.$case) {
      case "raiseHand":
        RaiseHandQuery.encode(message.query.raiseHand, writer.uint32(10).fork()).join();
        break;
      case "lowerHand":
        LowerHandQuery.encode(message.query.lowerHand, writer.uint32(18).fork()).join();
        break;
      case "giveFloor":
        GiveFloorQuery.encode(message.query.giveFloor, writer.uint32(26).fork()).join();
        break;
      case "revokeFloor":
        RevokeFloorQuery.encode(message.query.revokeFloor, writer.uint32(34).fork()).join();
        break;
      case "startRecording":
        StartRecordingQuery.encode(message.query.startRecording, writer.uint32(42).fork()).join();
        break;
      case "stopRecording":
        StopRecordingQuery.encode(message.query.stopRecording, writer.uint32(50).fork()).join();
        break;
      case "createPoll":
        CreatePollQuery.encode(message.query.createPoll, writer.uint32(58).fork()).join();
        break;
      case "votePoll":
        VotePollQuery.encode(message.query.votePoll, writer.uint32(66).fork()).join();
        break;
      case "closePoll":
        ClosePollQuery.encode(message.query.closePoll, writer.uint32(74).fork()).join();
        break;
      case "deletePoll":
        DeletePollQuery.encode(message.query.deletePoll, writer.uint32(82).fork()).join();
        break;
      case "askQuestion":
        AskQuestionQuery.encode(message.query.askQuestion, writer.uint32(90).fork()).join();
        break;
      case "upvoteQuestion":
        UpvoteQuestionQuery.encode(message.query.upvoteQuestion, writer.uint32(98).fork()).join();
        break;
      case "answerQuestion":
        AnswerQuestionQuery.encode(message.query.answerQuestion, writer.uint32(106).fork()).join();
        break;
      case "deleteQuestion":
        DeleteQuestionQuery.encode(message.query.deleteQuestion, writer.uint32(114).fork()).join();
        break;
      case "setKind":
        SetSpaceKindQuery.encode(message.query.setKind, writer.uint32(122).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceStateQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceStateQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.query = { $case: "raiseHand", raiseHand: RaiseHandQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.query = { $case: "lowerHand", lowerHand: LowerHandQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.query = { $case: "giveFloor", giveFloor: GiveFloorQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.query = { $case: "revokeFloor", revokeFloor: RevokeFloorQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.query = {
            $case: "startRecording",
            startRecording: StartRecordingQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.query = { $case: "stopRecording", stopRecording: StopRecordingQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.query = { $case: "createPoll", createPoll: CreatePollQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.query = { $case: "votePoll", votePoll: VotePollQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.query = { $case: "closePoll", closePoll: ClosePollQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.query = { $case: "deletePoll", deletePoll: DeletePollQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.query = { $case: "askQuestion", askQuestion: AskQuestionQuery.decode(reader, reader.uint32()) };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.query = {
            $case: "upvoteQuestion",
            upvoteQuestion: UpvoteQuestionQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.query = {
            $case: "answerQuestion",
            answerQuestion: AnswerQuestionQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.query = {
            $case: "deleteQuestion",
            deleteQuestion: DeleteQuestionQuery.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.query = { $case: "setKind", setKind: SetSpaceKindQuery.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceStateQuery {
    return {
      query: isSet(object.raiseHand)
        ? { $case: "raiseHand", raiseHand: RaiseHandQuery.fromJSON(object.raiseHand) }
        : isSet(object.lowerHand)
        ? { $case: "lowerHand", lowerHand: LowerHandQuery.fromJSON(object.lowerHand) }
        : isSet(object.giveFloor)
        ? { $case: "giveFloor", giveFloor: GiveFloorQuery.fromJSON(object.giveFloor) }
        : isSet(object.revokeFloor)
        ? { $case: "revokeFloor", revokeFloor: RevokeFloorQuery.fromJSON(object.revokeFloor) }
        : isSet(object.startRecording)
        ? { $case: "startRecording", startRecording: StartRecordingQuery.fromJSON(object.startRecording) }
        : isSet(object.stopRecording)
        ? { $case: "stopRecording", stopRecording: StopRecordingQuery.fromJSON(object.stopRecording) }
        : isSet(object.createPoll)
        ? { $case: "createPoll", createPoll: CreatePollQuery.fromJSON(object.createPoll) }
        : isSet(object.votePoll)
        ? { $case: "votePoll", votePoll: VotePollQuery.fromJSON(object.votePoll) }
        : isSet(object.closePoll)
        ? { $case: "closePoll", closePoll: ClosePollQuery.fromJSON(object.closePoll) }
        : isSet(object.deletePoll)
        ? { $case: "deletePoll", deletePoll: DeletePollQuery.fromJSON(object.deletePoll) }
        : isSet(object.askQuestion)
        ? { $case: "askQuestion", askQuestion: AskQuestionQuery.fromJSON(object.askQuestion) }
        : isSet(object.upvoteQuestion)
        ? { $case: "upvoteQuestion", upvoteQuestion: UpvoteQuestionQuery.fromJSON(object.upvoteQuestion) }
        : isSet(object.answerQuestion)
        ? { $case: "answerQuestion", answerQuestion: AnswerQuestionQuery.fromJSON(object.answerQuestion) }
        : isSet(object.deleteQuestion)
        ? { $case: "deleteQuestion", deleteQuestion: DeleteQuestionQuery.fromJSON(object.deleteQuestion) }
        : isSet(object.setKind)
        ? { $case: "setKind", setKind: SetSpaceKindQuery.fromJSON(object.setKind) }
        : undefined,
    };
  },

  toJSON(message: SpaceStateQuery): unknown {
    const obj: any = {};
    if (message.query?.$case === "raiseHand") {
      obj.raiseHand = RaiseHandQuery.toJSON(message.query.raiseHand);
    } else if (message.query?.$case === "lowerHand") {
      obj.lowerHand = LowerHandQuery.toJSON(message.query.lowerHand);
    } else if (message.query?.$case === "giveFloor") {
      obj.giveFloor = GiveFloorQuery.toJSON(message.query.giveFloor);
    } else if (message.query?.$case === "revokeFloor") {
      obj.revokeFloor = RevokeFloorQuery.toJSON(message.query.revokeFloor);
    } else if (message.query?.$case === "startRecording") {
      obj.startRecording = StartRecordingQuery.toJSON(message.query.startRecording);
    } else if (message.query?.$case === "stopRecording") {
      obj.stopRecording = StopRecordingQuery.toJSON(message.query.stopRecording);
    } else if (message.query?.$case === "createPoll") {
      obj.createPoll = CreatePollQuery.toJSON(message.query.createPoll);
    } else if (message.query?.$case === "votePoll") {
      obj.votePoll = VotePollQuery.toJSON(message.query.votePoll);
    } else if (message.query?.$case === "closePoll") {
      obj.closePoll = ClosePollQuery.toJSON(message.query.closePoll);
    } else if (message.query?.$case === "deletePoll") {
      obj.deletePoll = DeletePollQuery.toJSON(message.query.deletePoll);
    } else if (message.query?.$case === "askQuestion") {
      obj.askQuestion = AskQuestionQuery.toJSON(message.query.askQuestion);
    } else if (message.query?.$case === "upvoteQuestion") {
      obj.upvoteQuestion = UpvoteQuestionQuery.toJSON(message.query.upvoteQuestion);
    } else if (message.query?.$case === "answerQuestion") {
      obj.answerQuestion = AnswerQuestionQuery.toJSON(message.query.answerQuestion);
    } else if (message.query?.$case === "deleteQuestion") {
      obj.deleteQuestion = DeleteQuestionQuery.toJSON(message.query.deleteQuestion);
    } else if (message.query?.$case === "setKind") {
      obj.setKind = SetSpaceKindQuery.toJSON(message.query.setKind);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceStateQuery>, I>>(base?: I): SpaceStateQuery {
    return SpaceStateQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceStateQuery>, I>>(object: I): SpaceStateQuery {
    const message = createBaseSpaceStateQuery();
    switch (object.query?.$case) {
      case "raiseHand": {
        if (object.query?.raiseHand !== undefined && object.query?.raiseHand !== null) {
          message.query = { $case: "raiseHand", raiseHand: RaiseHandQuery.fromPartial(object.query.raiseHand) };
        }
        break;
      }
      case "lowerHand": {
        if (object.query?.lowerHand !== undefined && object.query?.lowerHand !== null) {
          message.query = { $case: "lowerHand", lowerHand: LowerHandQuery.fromPartial(object.query.lowerHand) };
        }
        break;
      }
      case "giveFloor": {
        if (object.query?.giveFloor !== undefined && object.query?.giveFloor !== null) {
          message.query = { $case: "giveFloor", giveFloor: GiveFloorQuery.fromPartial(object.query.giveFloor) };
        }
        break;
      }
      case "revokeFloor": {
        if (object.query?.revokeFloor !== undefined && object.query?.revokeFloor !== null) {
          message.query = { $case: "revokeFloor", revokeFloor: RevokeFloorQuery.fromPartial(object.query.revokeFloor) };
        }
        break;
      }
      case "startRecording": {
        if (object.query?.startRecording !== undefined && object.query?.startRecording !== null) {
          message.query = {
            $case: "startRecording",
            startRecording: StartRecordingQuery.fromPartial(object.query.startRecording),
          };
        }
        break;
      }
      case "stopRecording": {
        if (object.query?.stopRecording !== undefined && object.query?.stopRecording !== null) {
          message.query = {
            $case: "stopRecording",
            stopRecording: StopRecordingQuery.fromPartial(object.query.stopRecording),
          };
        }
        break;
      }
      case "createPoll": {
        if (object.query?.createPoll !== undefined && object.query?.createPoll !== null) {
          message.query = { $case: "createPoll", createPoll: CreatePollQuery.fromPartial(object.query.createPoll) };
        }
        break;
      }
      case "votePoll": {
        if (object.query?.votePoll !== undefined && object.query?.votePoll !== null) {
          message.query = { $case: "votePoll", votePoll: VotePollQuery.fromPartial(object.query.votePoll) };
        }
        break;
      }
      case "closePoll": {
        if (object.query?.closePoll !== undefined && object.query?.closePoll !== null) {
          message.query = { $case: "closePoll", closePoll: ClosePollQuery.fromPartial(object.query.closePoll) };
        }
        break;
      }
      case "deletePoll": {
        if (object.query?.deletePoll !== undefined && object.query?.deletePoll !== null) {
          message.query = { $case: "deletePoll", deletePoll: DeletePollQuery.fromPartial(object.query.deletePoll) };
        }
        break;
      }
      case "askQuestion": {
        if (object.query?.askQuestion !== undefined && object.query?.askQuestion !== null) {
          message.query = { $case: "askQuestion", askQuestion: AskQuestionQuery.fromPartial(object.query.askQuestion) };
        }
        break;
      }
      case "upvoteQuestion": {
        if (object.query?.upvoteQuestion !== undefined && object.query?.upvoteQuestion !== null) {
          message.query = {
            $case: "upvoteQuestion",
            upvoteQuestion: UpvoteQuestionQuery.fromPartial(object.query.upvoteQuestion),
          };
        }
        break;
      }
      case "answerQuestion": {
        if (object.query?.answerQuestion !== undefined && object.query?.answerQuestion !== null) {
          message.query = {
            $case: "answerQuestion",
            answerQuestion: AnswerQuestionQuery.fromPartial(object.query.answerQuestion),
          };
        }
        break;
      }
      case "deleteQuestion": {
        if (object.query?.deleteQuestion !== undefined && object.query?.deleteQuestion !== null) {
          message.query = {
            $case: "deleteQuestion",
            deleteQuestion: DeleteQuestionQuery.fromPartial(object.query.deleteQuestion),
          };
        }
        break;
      }
      case "setKind": {
        if (object.query?.setKind !== undefined && object.query?.setKind !== null) {
          message.query = { $case: "setKind", setKind: SetSpaceKindQuery.fromPartial(object.query.setKind) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseSetSpaceKindQuery(): SetSpaceKindQuery {
  return { kind: "" };
}

export const SetSpaceKindQuery: MessageFns<SetSpaceKindQuery> = {
  encode(message: SetSpaceKindQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== "") {
      writer.uint32(10).string(message.kind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetSpaceKindQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetSpaceKindQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.kind = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetSpaceKindQuery {
    return { kind: isSet(object.kind) ? globalThis.String(object.kind) : "" };
  },

  toJSON(message: SetSpaceKindQuery): unknown {
    const obj: any = {};
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetSpaceKindQuery>, I>>(base?: I): SetSpaceKindQuery {
    return SetSpaceKindQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetSpaceKindQuery>, I>>(object: I): SetSpaceKindQuery {
    const message = createBaseSetSpaceKindQuery();
    message.kind = object.kind ?? "";
    return message;
  },
};

function createBaseRaiseHandQuery(): RaiseHandQuery {
  return { raised: false };
}

export const RaiseHandQuery: MessageFns<RaiseHandQuery> = {
  encode(message: RaiseHandQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.raised !== false) {
      writer.uint32(8).bool(message.raised);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RaiseHandQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRaiseHandQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.raised = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RaiseHandQuery {
    return { raised: isSet(object.raised) ? globalThis.Boolean(object.raised) : false };
  },

  toJSON(message: RaiseHandQuery): unknown {
    const obj: any = {};
    if (message.raised !== false) {
      obj.raised = message.raised;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RaiseHandQuery>, I>>(base?: I): RaiseHandQuery {
    return RaiseHandQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RaiseHandQuery>, I>>(object: I): RaiseHandQuery {
    const message = createBaseRaiseHandQuery();
    message.raised = object.raised ?? false;
    return message;
  },
};

function createBaseLowerHandQuery(): LowerHandQuery {
  return { targetSpaceUserId: "" };
}

export const LowerHandQuery: MessageFns<LowerHandQuery> = {
  encode(message: LowerHandQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.targetSpaceUserId !== "") {
      writer.uint32(10).string(message.targetSpaceUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LowerHandQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLowerHandQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.targetSpaceUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LowerHandQuery {
    return { targetSpaceUserId: isSet(object.targetSpaceUserId) ? globalThis.String(object.targetSpaceUserId) : "" };
  },

  toJSON(message: LowerHandQuery): unknown {
    const obj: any = {};
    if (message.targetSpaceUserId !== "") {
      obj.targetSpaceUserId = message.targetSpaceUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LowerHandQuery>, I>>(base?: I): LowerHandQuery {
    return LowerHandQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LowerHandQuery>, I>>(object: I): LowerHandQuery {
    const message = createBaseLowerHandQuery();
    message.targetSpaceUserId = object.targetSpaceUserId ?? "";
    return message;
  },
};

function createBaseGiveFloorQuery(): GiveFloorQuery {
  return { targetSpaceUserId: "" };
}

export const GiveFloorQuery: MessageFns<GiveFloorQuery> = {
  encode(message: GiveFloorQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.targetSpaceUserId !== "") {
      writer.uint32(10).string(message.targetSpaceUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GiveFloorQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGiveFloorQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.targetSpaceUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GiveFloorQuery {
    return { targetSpaceUserId: isSet(object.targetSpaceUserId) ? globalThis.String(object.targetSpaceUserId) : "" };
  },

  toJSON(message: GiveFloorQuery): unknown {
    const obj: any = {};
    if (message.targetSpaceUserId !== "") {
      obj.targetSpaceUserId = message.targetSpaceUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GiveFloorQuery>, I>>(base?: I): GiveFloorQuery {
    return GiveFloorQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GiveFloorQuery>, I>>(object: I): GiveFloorQuery {
    const message = createBaseGiveFloorQuery();
    message.targetSpaceUserId = object.targetSpaceUserId ?? "";
    return message;
  },
};

function createBaseRevokeFloorQuery(): RevokeFloorQuery {
  return { targetSpaceUserId: "" };
}

export const RevokeFloorQuery: MessageFns<RevokeFloorQuery> = {
  encode(message: RevokeFloorQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.targetSpaceUserId !== "") {
      writer.uint32(10).string(message.targetSpaceUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevokeFloorQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRevokeFloorQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.targetSpaceUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RevokeFloorQuery {
    return { targetSpaceUserId: isSet(object.targetSpaceUserId) ? globalThis.String(object.targetSpaceUserId) : "" };
  },

  toJSON(message: RevokeFloorQuery): unknown {
    const obj: any = {};
    if (message.targetSpaceUserId !== "") {
      obj.targetSpaceUserId = message.targetSpaceUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RevokeFloorQuery>, I>>(base?: I): RevokeFloorQuery {
    return RevokeFloorQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RevokeFloorQuery>, I>>(object: I): RevokeFloorQuery {
    const message = createBaseRevokeFloorQuery();
    message.targetSpaceUserId = object.targetSpaceUserId ?? "";
    return message;
  },
};

function createBaseStartRecordingQuery(): StartRecordingQuery {
  return {};
}

export const StartRecordingQuery: MessageFns<StartRecordingQuery> = {
  encode(_: StartRecordingQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartRecordingQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartRecordingQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): StartRecordingQuery {
    return {};
  },

  toJSON(_: StartRecordingQuery): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<StartRecordingQuery>, I>>(base?: I): StartRecordingQuery {
    return StartRecordingQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartRecordingQuery>, I>>(_: I): StartRecordingQuery {
    const message = createBaseStartRecordingQuery();
    return message;
  },
};

function createBaseStopRecordingQuery(): StopRecordingQuery {
  return {};
}

export const StopRecordingQuery: MessageFns<StopRecordingQuery> = {
  encode(_: StopRecordingQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopRecordingQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopRecordingQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): StopRecordingQuery {
    return {};
  },

  toJSON(_: StopRecordingQuery): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<StopRecordingQuery>, I>>(base?: I): StopRecordingQuery {
    return StopRecordingQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopRecordingQuery>, I>>(_: I): StopRecordingQuery {
    const message = createBaseStopRecordingQuery();
    return message;
  },
};

function createBaseCreatePollQuery(): CreatePollQuery {
  return { question: "", kind: "", answers: [], maxSelections: 0 };
}

export const CreatePollQuery: MessageFns<CreatePollQuery> = {
  encode(message: CreatePollQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.question !== "") {
      writer.uint32(10).string(message.question);
    }
    if (message.kind !== "") {
      writer.uint32(18).string(message.kind);
    }
    for (const v of message.answers) {
      writer.uint32(26).string(v!);
    }
    if (message.maxSelections !== 0) {
      writer.uint32(32).int32(message.maxSelections);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePollQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreatePollQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.question = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.kind = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.answers.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxSelections = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreatePollQuery {
    return {
      question: isSet(object.question) ? globalThis.String(object.question) : "",
      kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
      answers: globalThis.Array.isArray(object?.answers) ? object.answers.map((e: any) => globalThis.String(e)) : [],
      maxSelections: isSet(object.maxSelections) ? globalThis.Number(object.maxSelections) : 0,
    };
  },

  toJSON(message: CreatePollQuery): unknown {
    const obj: any = {};
    if (message.question !== "") {
      obj.question = message.question;
    }
    if (message.kind !== "") {
      obj.kind = message.kind;
    }
    if (message.answers?.length) {
      obj.answers = message.answers;
    }
    if (message.maxSelections !== 0) {
      obj.maxSelections = Math.round(message.maxSelections);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreatePollQuery>, I>>(base?: I): CreatePollQuery {
    return CreatePollQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreatePollQuery>, I>>(object: I): CreatePollQuery {
    const message = createBaseCreatePollQuery();
    message.question = object.question ?? "";
    message.kind = object.kind ?? "";
    message.answers = object.answers?.map((e) => e) || [];
    message.maxSelections = object.maxSelections ?? 0;
    return message;
  },
};

function createBaseVotePollQuery(): VotePollQuery {
  return { pollId: "", answerIds: [] };
}

export const VotePollQuery: MessageFns<VotePollQuery> = {
  encode(message: VotePollQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pollId !== "") {
      writer.uint32(10).string(message.pollId);
    }
    for (const v of message.answerIds) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VotePollQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVotePollQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pollId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.answerIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VotePollQuery {
    return {
      pollId: isSet(object.pollId) ? globalThis.String(object.pollId) : "",
      answerIds: globalThis.Array.isArray(object?.answerIds)
        ? object.answerIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: VotePollQuery): unknown {
    const obj: any = {};
    if (message.pollId !== "") {
      obj.pollId = message.pollId;
    }
    if (message.answerIds?.length) {
      obj.answerIds = message.answerIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VotePollQuery>, I>>(base?: I): VotePollQuery {
    return VotePollQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VotePollQuery>, I>>(object: I): VotePollQuery {
    const message = createBaseVotePollQuery();
    message.pollId = object.pollId ?? "";
    message.answerIds = object.answerIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseClosePollQuery(): ClosePollQuery {
  return { pollId: "", closingMessage: undefined };
}

export const ClosePollQuery: MessageFns<ClosePollQuery> = {
  encode(message: ClosePollQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pollId !== "") {
      writer.uint32(10).string(message.pollId);
    }
    if (message.closingMessage !== undefined) {
      writer.uint32(18).string(message.closingMessage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClosePollQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClosePollQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pollId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.closingMessage = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClosePollQuery {
    return {
      pollId: isSet(object.pollId) ? globalThis.String(object.pollId) : "",
      closingMessage: isSet(object.closingMessage) ? globalThis.String(object.closingMessage) : undefined,
    };
  },

  toJSON(message: ClosePollQuery): unknown {
    const obj: any = {};
    if (message.pollId !== "") {
      obj.pollId = message.pollId;
    }
    if (message.closingMessage !== undefined) {
      obj.closingMessage = message.closingMessage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClosePollQuery>, I>>(base?: I): ClosePollQuery {
    return ClosePollQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClosePollQuery>, I>>(object: I): ClosePollQuery {
    const message = createBaseClosePollQuery();
    message.pollId = object.pollId ?? "";
    message.closingMessage = object.closingMessage ?? undefined;
    return message;
  },
};

function createBaseDeletePollQuery(): DeletePollQuery {
  return { pollId: "" };
}

export const DeletePollQuery: MessageFns<DeletePollQuery> = {
  encode(message: DeletePollQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pollId !== "") {
      writer.uint32(10).string(message.pollId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePollQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePollQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pollId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeletePollQuery {
    return { pollId: isSet(object.pollId) ? globalThis.String(object.pollId) : "" };
  },

  toJSON(message: DeletePollQuery): unknown {
    const obj: any = {};
    if (message.pollId !== "") {
      obj.pollId = message.pollId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePollQuery>, I>>(base?: I): DeletePollQuery {
    return DeletePollQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePollQuery>, I>>(object: I): DeletePollQuery {
    const message = createBaseDeletePollQuery();
    message.pollId = object.pollId ?? "";
    return message;
  },
};

function createBaseAskQuestionQuery(): AskQuestionQuery {
  return { body: "" };
}

export const AskQuestionQuery: MessageFns<AskQuestionQuery> = {
  encode(message: AskQuestionQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.body !== "") {
      writer.uint32(10).string(message.body);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AskQuestionQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAskQuestionQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.body = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AskQuestionQuery {
    return { body: isSet(object.body) ? globalThis.String(object.body) : "" };
  },

  toJSON(message: AskQuestionQuery): unknown {
    const obj: any = {};
    if (message.body !== "") {
      obj.body = message.body;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AskQuestionQuery>, I>>(base?: I): AskQuestionQuery {
    return AskQuestionQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AskQuestionQuery>, I>>(object: I): AskQuestionQuery {
    const message = createBaseAskQuestionQuery();
    message.body = object.body ?? "";
    return message;
  },
};

function createBaseUpvoteQuestionQuery(): UpvoteQuestionQuery {
  return { questionId: "", upvoted: false };
}

export const UpvoteQuestionQuery: MessageFns<UpvoteQuestionQuery> = {
  encode(message: UpvoteQuestionQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.questionId !== "") {
      writer.uint32(10).string(message.questionId);
    }
    if (message.upvoted !== false) {
      writer.uint32(16).bool(message.upvoted);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpvoteQuestionQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpvoteQuestionQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.questionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.upvoted = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpvoteQuestionQuery {
    return {
      questionId: isSet(object.questionId) ? globalThis.String(object.questionId) : "",
      upvoted: isSet(object.upvoted) ? globalThis.Boolean(object.upvoted) : false,
    };
  },

  toJSON(message: UpvoteQuestionQuery): unknown {
    const obj: any = {};
    if (message.questionId !== "") {
      obj.questionId = message.questionId;
    }
    if (message.upvoted !== false) {
      obj.upvoted = message.upvoted;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpvoteQuestionQuery>, I>>(base?: I): UpvoteQuestionQuery {
    return UpvoteQuestionQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpvoteQuestionQuery>, I>>(object: I): UpvoteQuestionQuery {
    const message = createBaseUpvoteQuestionQuery();
    message.questionId = object.questionId ?? "";
    message.upvoted = object.upvoted ?? false;
    return message;
  },
};

function createBaseAnswerQuestionQuery(): AnswerQuestionQuery {
  return { questionId: "" };
}

export const AnswerQuestionQuery: MessageFns<AnswerQuestionQuery> = {
  encode(message: AnswerQuestionQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.questionId !== "") {
      writer.uint32(10).string(message.questionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnswerQuestionQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnswerQuestionQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.questionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnswerQuestionQuery {
    return { questionId: isSet(object.questionId) ? globalThis.String(object.questionId) : "" };
  },

  toJSON(message: AnswerQuestionQuery): unknown {
    const obj: any = {};
    if (message.questionId !== "") {
      obj.questionId = message.questionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnswerQuestionQuery>, I>>(base?: I): AnswerQuestionQuery {
    return AnswerQuestionQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnswerQuestionQuery>, I>>(object: I): AnswerQuestionQuery {
    const message = createBaseAnswerQuestionQuery();
    message.questionId = object.questionId ?? "";
    return message;
  },
};

function createBaseDeleteQuestionQuery(): DeleteQuestionQuery {
  return { questionId: "" };
}

export const DeleteQuestionQuery: MessageFns<DeleteQuestionQuery> = {
  encode(message: DeleteQuestionQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.questionId !== "") {
      writer.uint32(10).string(message.questionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteQuestionQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteQuestionQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.questionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteQuestionQuery {
    return { questionId: isSet(object.questionId) ? globalThis.String(object.questionId) : "" };
  },

  toJSON(message: DeleteQuestionQuery): unknown {
    const obj: any = {};
    if (message.questionId !== "") {
      obj.questionId = message.questionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteQuestionQuery>, I>>(base?: I): DeleteQuestionQuery {
    return DeleteQuestionQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteQuestionQuery>, I>>(object: I): DeleteQuestionQuery {
    const message = createBaseDeleteQuestionQuery();
    message.questionId = object.questionId ?? "";
    return message;
  },
};

function createBaseSpaceStateQueryFrontToPusher(): SpaceStateQueryFrontToPusher {
  return { spaceName: "", query: undefined };
}

export const SpaceStateQueryFrontToPusher: MessageFns<SpaceStateQueryFrontToPusher> = {
  encode(message: SpaceStateQueryFrontToPusher, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.query !== undefined) {
      SpaceStateQuery.encode(message.query, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceStateQueryFrontToPusher {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceStateQueryFrontToPusher();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.query = SpaceStateQuery.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceStateQueryFrontToPusher {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      query: isSet(object.query) ? SpaceStateQuery.fromJSON(object.query) : undefined,
    };
  },

  toJSON(message: SpaceStateQueryFrontToPusher): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.query !== undefined) {
      obj.query = SpaceStateQuery.toJSON(message.query);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceStateQueryFrontToPusher>, I>>(base?: I): SpaceStateQueryFrontToPusher {
    return SpaceStateQueryFrontToPusher.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceStateQueryFrontToPusher>, I>>(object: I): SpaceStateQueryFrontToPusher {
    const message = createBaseSpaceStateQueryFrontToPusher();
    message.spaceName = object.spaceName ?? "";
    message.query = (object.query !== undefined && object.query !== null)
      ? SpaceStateQuery.fromPartial(object.query)
      : undefined;
    return message;
  },
};

function createBaseSpaceStateQueryPusherToBack(): SpaceStateQueryPusherToBack {
  return { spaceUserId: "", query: undefined };
}

export const SpaceStateQueryPusherToBack: MessageFns<SpaceStateQueryPusherToBack> = {
  encode(message: SpaceStateQueryPusherToBack, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceUserId !== "") {
      writer.uint32(10).string(message.spaceUserId);
    }
    if (message.query !== undefined) {
      SpaceStateQuery.encode(message.query, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceStateQueryPusherToBack {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceStateQueryPusherToBack();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceUserId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.query = SpaceStateQuery.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceStateQueryPusherToBack {
    return {
      spaceUserId: isSet(object.spaceUserId) ? globalThis.String(object.spaceUserId) : "",
      query: isSet(object.query) ? SpaceStateQuery.fromJSON(object.query) : undefined,
    };
  },

  toJSON(message: SpaceStateQueryPusherToBack): unknown {
    const obj: any = {};
    if (message.spaceUserId !== "") {
      obj.spaceUserId = message.spaceUserId;
    }
    if (message.query !== undefined) {
      obj.query = SpaceStateQuery.toJSON(message.query);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceStateQueryPusherToBack>, I>>(base?: I): SpaceStateQueryPusherToBack {
    return SpaceStateQueryPusherToBack.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceStateQueryPusherToBack>, I>>(object: I): SpaceStateQueryPusherToBack {
    const message = createBaseSpaceStateQueryPusherToBack();
    message.spaceUserId = object.spaceUserId ?? "";
    message.query = (object.query !== undefined && object.query !== null)
      ? SpaceStateQuery.fromPartial(object.query)
      : undefined;
    return message;
  },
};

function createBaseSpaceStateAnswer(): SpaceStateAnswer {
  return {};
}

export const SpaceStateAnswer: MessageFns<SpaceStateAnswer> = {
  encode(_: SpaceStateAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceStateAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceStateAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpaceStateAnswer {
    return {};
  },

  toJSON(_: SpaceStateAnswer): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceStateAnswer>, I>>(base?: I): SpaceStateAnswer {
    return SpaceStateAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceStateAnswer>, I>>(_: I): SpaceStateAnswer {
    const message = createBaseSpaceStateAnswer();
    return message;
  },
};

function createBaseSpaceStatePatchMessage(): SpaceStatePatchMessage {
  return { spaceName: "", patch: "" };
}

export const SpaceStatePatchMessage: MessageFns<SpaceStatePatchMessage> = {
  encode(message: SpaceStatePatchMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.patch !== "") {
      writer.uint32(18).string(message.patch);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceStatePatchMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceStatePatchMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.patch = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceStatePatchMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      patch: isSet(object.patch) ? globalThis.String(object.patch) : "",
    };
  },

  toJSON(message: SpaceStatePatchMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.patch !== "") {
      obj.patch = message.patch;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceStatePatchMessage>, I>>(base?: I): SpaceStatePatchMessage {
    return SpaceStatePatchMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceStatePatchMessage>, I>>(object: I): SpaceStatePatchMessage {
    const message = createBaseSpaceStatePatchMessage();
    message.spaceName = object.spaceName ?? "";
    message.patch = object.patch ?? "";
    return message;
  },
};

function createBaseSpaceAnswerMessage(): SpaceAnswerMessage {
  return { id: 0, spaceName: "", answer: undefined };
}

export const SpaceAnswerMessage: MessageFns<SpaceAnswerMessage> = {
  encode(message: SpaceAnswerMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).int32(message.id);
    }
    if (message.spaceName !== "") {
      writer.uint32(18).string(message.spaceName);
    }
    switch (message.answer?.$case) {
      case "error":
        ErrorMessage.encode(message.answer.error, writer.uint32(26).fork()).join();
        break;
      case "addSpaceUserAnswer":
        AddSpaceUserAnswer.encode(message.answer.addSpaceUserAnswer, writer.uint32(34).fork()).join();
        break;
      case "removeSpaceUserAnswer":
        RemoveSpaceUserAnswer.encode(message.answer.removeSpaceUserAnswer, writer.uint32(42).fork()).join();
        break;
      case "joinSpaceAnswer":
        JoinSpaceAnswer.encode(message.answer.joinSpaceAnswer, writer.uint32(50).fork()).join();
        break;
      case "leaveSpaceAnswer":
        LeaveSpaceAnswer.encode(message.answer.leaveSpaceAnswer, writer.uint32(58).fork()).join();
        break;
      case "spaceStateAnswer":
        SpaceStateAnswer.encode(message.answer.spaceStateAnswer, writer.uint32(82).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceAnswerMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceAnswerMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.answer = { $case: "error", error: ErrorMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.answer = {
            $case: "addSpaceUserAnswer",
            addSpaceUserAnswer: AddSpaceUserAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.answer = {
            $case: "removeSpaceUserAnswer",
            removeSpaceUserAnswer: RemoveSpaceUserAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.answer = {
            $case: "joinSpaceAnswer",
            joinSpaceAnswer: JoinSpaceAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.answer = {
            $case: "leaveSpaceAnswer",
            leaveSpaceAnswer: LeaveSpaceAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.answer = {
            $case: "spaceStateAnswer",
            spaceStateAnswer: SpaceStateAnswer.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceAnswerMessage {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      answer: isSet(object.error)
        ? { $case: "error", error: ErrorMessage.fromJSON(object.error) }
        : isSet(object.addSpaceUserAnswer)
        ? { $case: "addSpaceUserAnswer", addSpaceUserAnswer: AddSpaceUserAnswer.fromJSON(object.addSpaceUserAnswer) }
        : isSet(object.removeSpaceUserAnswer)
        ? {
          $case: "removeSpaceUserAnswer",
          removeSpaceUserAnswer: RemoveSpaceUserAnswer.fromJSON(object.removeSpaceUserAnswer),
        }
        : isSet(object.joinSpaceAnswer)
        ? { $case: "joinSpaceAnswer", joinSpaceAnswer: JoinSpaceAnswer.fromJSON(object.joinSpaceAnswer) }
        : isSet(object.leaveSpaceAnswer)
        ? { $case: "leaveSpaceAnswer", leaveSpaceAnswer: LeaveSpaceAnswer.fromJSON(object.leaveSpaceAnswer) }
        : isSet(object.spaceStateAnswer)
        ? { $case: "spaceStateAnswer", spaceStateAnswer: SpaceStateAnswer.fromJSON(object.spaceStateAnswer) }
        : undefined,
    };
  },

  toJSON(message: SpaceAnswerMessage): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.answer?.$case === "error") {
      obj.error = ErrorMessage.toJSON(message.answer.error);
    } else if (message.answer?.$case === "addSpaceUserAnswer") {
      obj.addSpaceUserAnswer = AddSpaceUserAnswer.toJSON(message.answer.addSpaceUserAnswer);
    } else if (message.answer?.$case === "removeSpaceUserAnswer") {
      obj.removeSpaceUserAnswer = RemoveSpaceUserAnswer.toJSON(message.answer.removeSpaceUserAnswer);
    } else if (message.answer?.$case === "joinSpaceAnswer") {
      obj.joinSpaceAnswer = JoinSpaceAnswer.toJSON(message.answer.joinSpaceAnswer);
    } else if (message.answer?.$case === "leaveSpaceAnswer") {
      obj.leaveSpaceAnswer = LeaveSpaceAnswer.toJSON(message.answer.leaveSpaceAnswer);
    } else if (message.answer?.$case === "spaceStateAnswer") {
      obj.spaceStateAnswer = SpaceStateAnswer.toJSON(message.answer.spaceStateAnswer);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceAnswerMessage>, I>>(base?: I): SpaceAnswerMessage {
    return SpaceAnswerMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceAnswerMessage>, I>>(object: I): SpaceAnswerMessage {
    const message = createBaseSpaceAnswerMessage();
    message.id = object.id ?? 0;
    message.spaceName = object.spaceName ?? "";
    switch (object.answer?.$case) {
      case "error": {
        if (object.answer?.error !== undefined && object.answer?.error !== null) {
          message.answer = { $case: "error", error: ErrorMessage.fromPartial(object.answer.error) };
        }
        break;
      }
      case "addSpaceUserAnswer": {
        if (object.answer?.addSpaceUserAnswer !== undefined && object.answer?.addSpaceUserAnswer !== null) {
          message.answer = {
            $case: "addSpaceUserAnswer",
            addSpaceUserAnswer: AddSpaceUserAnswer.fromPartial(object.answer.addSpaceUserAnswer),
          };
        }
        break;
      }
      case "removeSpaceUserAnswer": {
        if (object.answer?.removeSpaceUserAnswer !== undefined && object.answer?.removeSpaceUserAnswer !== null) {
          message.answer = {
            $case: "removeSpaceUserAnswer",
            removeSpaceUserAnswer: RemoveSpaceUserAnswer.fromPartial(object.answer.removeSpaceUserAnswer),
          };
        }
        break;
      }
      case "joinSpaceAnswer": {
        if (object.answer?.joinSpaceAnswer !== undefined && object.answer?.joinSpaceAnswer !== null) {
          message.answer = {
            $case: "joinSpaceAnswer",
            joinSpaceAnswer: JoinSpaceAnswer.fromPartial(object.answer.joinSpaceAnswer),
          };
        }
        break;
      }
      case "leaveSpaceAnswer": {
        if (object.answer?.leaveSpaceAnswer !== undefined && object.answer?.leaveSpaceAnswer !== null) {
          message.answer = {
            $case: "leaveSpaceAnswer",
            leaveSpaceAnswer: LeaveSpaceAnswer.fromPartial(object.answer.leaveSpaceAnswer),
          };
        }
        break;
      }
      case "spaceStateAnswer": {
        if (object.answer?.spaceStateAnswer !== undefined && object.answer?.spaceStateAnswer !== null) {
          message.answer = {
            $case: "spaceStateAnswer",
            spaceStateAnswer: SpaceStateAnswer.fromPartial(object.answer.spaceStateAnswer),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseAddSpaceUserAnswer(): AddSpaceUserAnswer {
  return { spaceName: "", spaceUserId: "" };
}

export const AddSpaceUserAnswer: MessageFns<AddSpaceUserAnswer> = {
  encode(message: AddSpaceUserAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.spaceUserId !== "") {
      writer.uint32(18).string(message.spaceUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddSpaceUserAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSpaceUserAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spaceUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSpaceUserAnswer {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      spaceUserId: isSet(object.spaceUserId) ? globalThis.String(object.spaceUserId) : "",
    };
  },

  toJSON(message: AddSpaceUserAnswer): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.spaceUserId !== "") {
      obj.spaceUserId = message.spaceUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSpaceUserAnswer>, I>>(base?: I): AddSpaceUserAnswer {
    return AddSpaceUserAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSpaceUserAnswer>, I>>(object: I): AddSpaceUserAnswer {
    const message = createBaseAddSpaceUserAnswer();
    message.spaceName = object.spaceName ?? "";
    message.spaceUserId = object.spaceUserId ?? "";
    return message;
  },
};

function createBaseRemoveSpaceUserAnswer(): RemoveSpaceUserAnswer {
  return { spaceName: "", spaceUserId: "" };
}

export const RemoveSpaceUserAnswer: MessageFns<RemoveSpaceUserAnswer> = {
  encode(message: RemoveSpaceUserAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.spaceUserId !== "") {
      writer.uint32(18).string(message.spaceUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveSpaceUserAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveSpaceUserAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spaceUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveSpaceUserAnswer {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      spaceUserId: isSet(object.spaceUserId) ? globalThis.String(object.spaceUserId) : "",
    };
  },

  toJSON(message: RemoveSpaceUserAnswer): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.spaceUserId !== "") {
      obj.spaceUserId = message.spaceUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveSpaceUserAnswer>, I>>(base?: I): RemoveSpaceUserAnswer {
    return RemoveSpaceUserAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveSpaceUserAnswer>, I>>(object: I): RemoveSpaceUserAnswer {
    const message = createBaseRemoveSpaceUserAnswer();
    message.spaceName = object.spaceName ?? "";
    message.spaceUserId = object.spaceUserId ?? "";
    return message;
  },
};

function createBaseHandleRecordingWebhookRequest(): HandleRecordingWebhookRequest {
  return {
    spaceName: "",
    eventId: "",
    recordingSessionId: "",
    egressId: "",
    roomName: "",
    phase: 0,
    status: "",
    error: "",
    createdAt: 0,
    startedAtMs: 0,
    endedAtMs: 0,
    fileResults: [],
  };
}

export const HandleRecordingWebhookRequest: MessageFns<HandleRecordingWebhookRequest> = {
  encode(message: HandleRecordingWebhookRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.eventId !== "") {
      writer.uint32(18).string(message.eventId);
    }
    if (message.recordingSessionId !== "") {
      writer.uint32(26).string(message.recordingSessionId);
    }
    if (message.egressId !== "") {
      writer.uint32(34).string(message.egressId);
    }
    if (message.roomName !== "") {
      writer.uint32(42).string(message.roomName);
    }
    if (message.phase !== 0) {
      writer.uint32(48).int32(message.phase);
    }
    if (message.status !== "") {
      writer.uint32(58).string(message.status);
    }
    if (message.error !== "") {
      writer.uint32(66).string(message.error);
    }
    if (message.createdAt !== 0) {
      writer.uint32(72).int64(message.createdAt);
    }
    if (message.startedAtMs !== 0) {
      writer.uint32(80).int64(message.startedAtMs);
    }
    if (message.endedAtMs !== 0) {
      writer.uint32(88).int64(message.endedAtMs);
    }
    for (const v of message.fileResults) {
      RecordingFileResult.encode(v!, writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HandleRecordingWebhookRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandleRecordingWebhookRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.eventId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.recordingSessionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.egressId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.roomName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.phase = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.error = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.createdAt = longToNumber(reader.int64());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.startedAtMs = longToNumber(reader.int64());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.endedAtMs = longToNumber(reader.int64());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.fileResults.push(RecordingFileResult.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandleRecordingWebhookRequest {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      eventId: isSet(object.eventId) ? globalThis.String(object.eventId) : "",
      recordingSessionId: isSet(object.recordingSessionId) ? globalThis.String(object.recordingSessionId) : "",
      egressId: isSet(object.egressId) ? globalThis.String(object.egressId) : "",
      roomName: isSet(object.roomName) ? globalThis.String(object.roomName) : "",
      phase: isSet(object.phase) ? recordingWebhookPhaseFromJSON(object.phase) : 0,
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      error: isSet(object.error) ? globalThis.String(object.error) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      startedAtMs: isSet(object.startedAtMs) ? globalThis.Number(object.startedAtMs) : 0,
      endedAtMs: isSet(object.endedAtMs) ? globalThis.Number(object.endedAtMs) : 0,
      fileResults: globalThis.Array.isArray(object?.fileResults)
        ? object.fileResults.map((e: any) => RecordingFileResult.fromJSON(e))
        : [],
    };
  },

  toJSON(message: HandleRecordingWebhookRequest): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.eventId !== "") {
      obj.eventId = message.eventId;
    }
    if (message.recordingSessionId !== "") {
      obj.recordingSessionId = message.recordingSessionId;
    }
    if (message.egressId !== "") {
      obj.egressId = message.egressId;
    }
    if (message.roomName !== "") {
      obj.roomName = message.roomName;
    }
    if (message.phase !== 0) {
      obj.phase = recordingWebhookPhaseToJSON(message.phase);
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.error !== "") {
      obj.error = message.error;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.startedAtMs !== 0) {
      obj.startedAtMs = Math.round(message.startedAtMs);
    }
    if (message.endedAtMs !== 0) {
      obj.endedAtMs = Math.round(message.endedAtMs);
    }
    if (message.fileResults?.length) {
      obj.fileResults = message.fileResults.map((e) => RecordingFileResult.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HandleRecordingWebhookRequest>, I>>(base?: I): HandleRecordingWebhookRequest {
    return HandleRecordingWebhookRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HandleRecordingWebhookRequest>, I>>(
    object: I,
  ): HandleRecordingWebhookRequest {
    const message = createBaseHandleRecordingWebhookRequest();
    message.spaceName = object.spaceName ?? "";
    message.eventId = object.eventId ?? "";
    message.recordingSessionId = object.recordingSessionId ?? "";
    message.egressId = object.egressId ?? "";
    message.roomName = object.roomName ?? "";
    message.phase = object.phase ?? 0;
    message.status = object.status ?? "";
    message.error = object.error ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.startedAtMs = object.startedAtMs ?? 0;
    message.endedAtMs = object.endedAtMs ?? 0;
    message.fileResults = object.fileResults?.map((e) => RecordingFileResult.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRecordingFileResult(): RecordingFileResult {
  return { filename: "", sizeBytes: 0, durationMs: 0 };
}

export const RecordingFileResult: MessageFns<RecordingFileResult> = {
  encode(message: RecordingFileResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filename !== "") {
      writer.uint32(10).string(message.filename);
    }
    if (message.sizeBytes !== 0) {
      writer.uint32(16).int64(message.sizeBytes);
    }
    if (message.durationMs !== 0) {
      writer.uint32(24).int64(message.durationMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecordingFileResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecordingFileResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sizeBytes = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.durationMs = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RecordingFileResult {
    return {
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
      sizeBytes: isSet(object.sizeBytes) ? globalThis.Number(object.sizeBytes) : 0,
      durationMs: isSet(object.durationMs) ? globalThis.Number(object.durationMs) : 0,
    };
  },

  toJSON(message: RecordingFileResult): unknown {
    const obj: any = {};
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    if (message.sizeBytes !== 0) {
      obj.sizeBytes = Math.round(message.sizeBytes);
    }
    if (message.durationMs !== 0) {
      obj.durationMs = Math.round(message.durationMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RecordingFileResult>, I>>(base?: I): RecordingFileResult {
    return RecordingFileResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RecordingFileResult>, I>>(object: I): RecordingFileResult {
    const message = createBaseRecordingFileResult();
    message.filename = object.filename ?? "";
    message.sizeBytes = object.sizeBytes ?? 0;
    message.durationMs = object.durationMs ?? 0;
    return message;
  },
};

function createBaseHandleLivekitWebhookRequest(): HandleLivekitWebhookRequest {
  return { spaceName: "", recordingSessionId: "", rawBody: new Uint8Array(0), authorizationHeader: "" };
}

export const HandleLivekitWebhookRequest: MessageFns<HandleLivekitWebhookRequest> = {
  encode(message: HandleLivekitWebhookRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.recordingSessionId !== "") {
      writer.uint32(18).string(message.recordingSessionId);
    }
    if (message.rawBody.length !== 0) {
      writer.uint32(26).bytes(message.rawBody);
    }
    if (message.authorizationHeader !== "") {
      writer.uint32(34).string(message.authorizationHeader);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HandleLivekitWebhookRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHandleLivekitWebhookRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.recordingSessionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rawBody = reader.bytes();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.authorizationHeader = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HandleLivekitWebhookRequest {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      recordingSessionId: isSet(object.recordingSessionId) ? globalThis.String(object.recordingSessionId) : "",
      rawBody: isSet(object.rawBody) ? bytesFromBase64(object.rawBody) : new Uint8Array(0),
      authorizationHeader: isSet(object.authorizationHeader) ? globalThis.String(object.authorizationHeader) : "",
    };
  },

  toJSON(message: HandleLivekitWebhookRequest): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.recordingSessionId !== "") {
      obj.recordingSessionId = message.recordingSessionId;
    }
    if (message.rawBody.length !== 0) {
      obj.rawBody = base64FromBytes(message.rawBody);
    }
    if (message.authorizationHeader !== "") {
      obj.authorizationHeader = message.authorizationHeader;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HandleLivekitWebhookRequest>, I>>(base?: I): HandleLivekitWebhookRequest {
    return HandleLivekitWebhookRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HandleLivekitWebhookRequest>, I>>(object: I): HandleLivekitWebhookRequest {
    const message = createBaseHandleLivekitWebhookRequest();
    message.spaceName = object.spaceName ?? "";
    message.recordingSessionId = object.recordingSessionId ?? "";
    message.rawBody = object.rawBody ?? new Uint8Array(0);
    message.authorizationHeader = object.authorizationHeader ?? "";
    return message;
  },
};

function createBaseUserMovedMessage(): UserMovedMessage {
  return { userId: 0, position: undefined };
}

export const UserMovedMessage: MessageFns<UserMovedMessage> = {
  encode(message: UserMovedMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== 0) {
      writer.uint32(8).int32(message.userId);
    }
    if (message.position !== undefined) {
      PositionMessage.encode(message.position, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserMovedMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserMovedMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.userId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.position = PositionMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserMovedMessage {
    return {
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0,
      position: isSet(object.position) ? PositionMessage.fromJSON(object.position) : undefined,
    };
  },

  toJSON(message: UserMovedMessage): unknown {
    const obj: any = {};
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId);
    }
    if (message.position !== undefined) {
      obj.position = PositionMessage.toJSON(message.position);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserMovedMessage>, I>>(base?: I): UserMovedMessage {
    return UserMovedMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserMovedMessage>, I>>(object: I): UserMovedMessage {
    const message = createBaseUserMovedMessage();
    message.userId = object.userId ?? 0;
    message.position = (object.position !== undefined && object.position !== null)
      ? PositionMessage.fromPartial(object.position)
      : undefined;
    return message;
  },
};

function createBaseMoveToPositionMessage(): MoveToPositionMessage {
  return { position: undefined };
}

export const MoveToPositionMessage: MessageFns<MoveToPositionMessage> = {
  encode(message: MoveToPositionMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.position !== undefined) {
      PositionMessage.encode(message.position, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveToPositionMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveToPositionMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.position = PositionMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveToPositionMessage {
    return { position: isSet(object.position) ? PositionMessage.fromJSON(object.position) : undefined };
  },

  toJSON(message: MoveToPositionMessage): unknown {
    const obj: any = {};
    if (message.position !== undefined) {
      obj.position = PositionMessage.toJSON(message.position);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MoveToPositionMessage>, I>>(base?: I): MoveToPositionMessage {
    return MoveToPositionMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MoveToPositionMessage>, I>>(object: I): MoveToPositionMessage {
    const message = createBaseMoveToPositionMessage();
    message.position = (object.position !== undefined && object.position !== null)
      ? PositionMessage.fromPartial(object.position)
      : undefined;
    return message;
  },
};

function createBaseLocatePositionMessage(): LocatePositionMessage {
  return { position: undefined, userId: 0, userUuid: "" };
}

export const LocatePositionMessage: MessageFns<LocatePositionMessage> = {
  encode(message: LocatePositionMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.position !== undefined) {
      PositionMessage.encode(message.position, writer.uint32(10).fork()).join();
    }
    if (message.userId !== 0) {
      writer.uint32(16).int32(message.userId);
    }
    if (message.userUuid !== "") {
      writer.uint32(26).string(message.userUuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocatePositionMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocatePositionMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.position = PositionMessage.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.userId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.userUuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocatePositionMessage {
    return {
      position: isSet(object.position) ? PositionMessage.fromJSON(object.position) : undefined,
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0,
      userUuid: isSet(object.userUuid) ? globalThis.String(object.userUuid) : "",
    };
  },

  toJSON(message: LocatePositionMessage): unknown {
    const obj: any = {};
    if (message.position !== undefined) {
      obj.position = PositionMessage.toJSON(message.position);
    }
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId);
    }
    if (message.userUuid !== "") {
      obj.userUuid = message.userUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocatePositionMessage>, I>>(base?: I): LocatePositionMessage {
    return LocatePositionMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocatePositionMessage>, I>>(object: I): LocatePositionMessage {
    const message = createBaseLocatePositionMessage();
    message.position = (object.position !== undefined && object.position !== null)
      ? PositionMessage.fromPartial(object.position)
      : undefined;
    message.userId = object.userId ?? 0;
    message.userUuid = object.userUuid ?? "";
    return message;
  },
};

function createBaseSubMessage(): SubMessage {
  return { message: undefined };
}

export const SubMessage: MessageFns<SubMessage> = {
  encode(message: SubMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "userMovedMessage":
        UserMovedMessage.encode(message.message.userMovedMessage, writer.uint32(10).fork()).join();
        break;
      case "groupUpdateMessage":
        GroupUpdateMessage.encode(message.message.groupUpdateMessage, writer.uint32(18).fork()).join();
        break;
      case "groupDeleteMessage":
        GroupDeleteMessage.encode(message.message.groupDeleteMessage, writer.uint32(26).fork()).join();
        break;
      case "userJoinedMessage":
        UserJoinedMessage.encode(message.message.userJoinedMessage, writer.uint32(34).fork()).join();
        break;
      case "userLeftMessage":
        UserLeftMessage.encode(message.message.userLeftMessage, writer.uint32(42).fork()).join();
        break;
      case "itemEventMessage":
        ItemEventMessage.encode(message.message.itemEventMessage, writer.uint32(50).fork()).join();
        break;
      case "emoteEventMessage":
        EmoteEventMessage.encode(message.message.emoteEventMessage, writer.uint32(58).fork()).join();
        break;
      case "variableMessage":
        VariableMessage.encode(message.message.variableMessage, writer.uint32(66).fork()).join();
        break;
      case "errorMessage":
        ErrorMessage.encode(message.message.errorMessage, writer.uint32(74).fork()).join();
        break;
      case "playerDetailsUpdatedMessage":
        PlayerDetailsUpdatedMessage.encode(message.message.playerDetailsUpdatedMessage, writer.uint32(82).fork())
          .join();
        break;
      case "pingMessage":
        PingMessage.encode(message.message.pingMessage, writer.uint32(90).fork()).join();
        break;
      case "editMapCommandMessage":
        EditMapCommandMessage.encode(message.message.editMapCommandMessage, writer.uint32(106).fork()).join();
        break;
      case "addSpaceUserMessage":
        AddSpaceUserMessage.encode(message.message.addSpaceUserMessage, writer.uint32(130).fork()).join();
        break;
      case "updateSpaceUserMessage":
        UpdateSpaceUserPusherToFrontMessage.encode(message.message.updateSpaceUserMessage, writer.uint32(138).fork())
          .join();
        break;
      case "removeSpaceUserMessage":
        RemoveSpaceUserPusherToFrontMessage.encode(message.message.removeSpaceUserMessage, writer.uint32(146).fork())
          .join();
        break;
      case "receivedEventMessage":
        ReceivedEventMessage.encode(message.message.receivedEventMessage, writer.uint32(162).fork()).join();
        break;
      case "updateSpaceMetadataMessage":
        UpdateSpaceMetadataMessage.encode(message.message.updateSpaceMetadataMessage, writer.uint32(170).fork()).join();
        break;
      case "groupUsersUpdateMessage":
        GroupUsersUpdateMessage.encode(message.message.groupUsersUpdateMessage, writer.uint32(194).fork()).join();
        break;
      case "kickOffMessage":
        KickOffMessage.encode(message.message.kickOffMessage, writer.uint32(178).fork()).join();
        break;
      case "publicEvent":
        PublicEvent.encode(message.message.publicEvent, writer.uint32(234).fork()).join();
        break;
      case "privateEvent":
        PrivateEventPusherToFront.encode(message.message.privateEvent, writer.uint32(242).fork()).join();
        break;
      case "spaceDestroyedMessage":
        SpaceDestroyedMessage.encode(message.message.spaceDestroyedMessage, writer.uint32(186).fork()).join();
        break;
      case "initSpaceUsersMessage":
        InitSpaceUsersMessage.encode(message.message.initSpaceUsersMessage, writer.uint32(202).fork()).join();
        break;
      case "areaPropertyVariableMessage":
        AreaPropertyVariableMessage.encode(message.message.areaPropertyVariableMessage, writer.uint32(210).fork())
          .join();
        break;
      case "duplicateUserConnectedMessage":
        DuplicateUserConnectedMessage.encode(message.message.duplicateUserConnectedMessage, writer.uint32(218).fork())
          .join();
        break;
      case "entityMessage":
        EntityMessage.encode(message.message.entityMessage, writer.uint32(250).fork()).join();
        break;
      case "spaceStatePatchMessage":
        SpaceStatePatchMessage.encode(message.message.spaceStatePatchMessage, writer.uint32(258).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = {
            $case: "userMovedMessage",
            userMovedMessage: UserMovedMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = {
            $case: "groupUpdateMessage",
            groupUpdateMessage: GroupUpdateMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = {
            $case: "groupDeleteMessage",
            groupDeleteMessage: GroupDeleteMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = {
            $case: "userJoinedMessage",
            userJoinedMessage: UserJoinedMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.message = {
            $case: "userLeftMessage",
            userLeftMessage: UserLeftMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.message = {
            $case: "itemEventMessage",
            itemEventMessage: ItemEventMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.message = {
            $case: "emoteEventMessage",
            emoteEventMessage: EmoteEventMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.message = {
            $case: "variableMessage",
            variableMessage: VariableMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.message = { $case: "errorMessage", errorMessage: ErrorMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.message = {
            $case: "playerDetailsUpdatedMessage",
            playerDetailsUpdatedMessage: PlayerDetailsUpdatedMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.message = { $case: "pingMessage", pingMessage: PingMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.message = {
            $case: "editMapCommandMessage",
            editMapCommandMessage: EditMapCommandMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.message = {
            $case: "addSpaceUserMessage",
            addSpaceUserMessage: AddSpaceUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.message = {
            $case: "updateSpaceUserMessage",
            updateSpaceUserMessage: UpdateSpaceUserPusherToFrontMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.message = {
            $case: "removeSpaceUserMessage",
            removeSpaceUserMessage: RemoveSpaceUserPusherToFrontMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.message = {
            $case: "receivedEventMessage",
            receivedEventMessage: ReceivedEventMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.message = {
            $case: "updateSpaceMetadataMessage",
            updateSpaceMetadataMessage: UpdateSpaceMetadataMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.message = {
            $case: "groupUsersUpdateMessage",
            groupUsersUpdateMessage: GroupUsersUpdateMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.message = { $case: "kickOffMessage", kickOffMessage: KickOffMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.message = { $case: "publicEvent", publicEvent: PublicEvent.decode(reader, reader.uint32()) };
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.message = {
            $case: "privateEvent",
            privateEvent: PrivateEventPusherToFront.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.message = {
            $case: "spaceDestroyedMessage",
            spaceDestroyedMessage: SpaceDestroyedMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.message = {
            $case: "initSpaceUsersMessage",
            initSpaceUsersMessage: InitSpaceUsersMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.message = {
            $case: "areaPropertyVariableMessage",
            areaPropertyVariableMessage: AreaPropertyVariableMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.message = {
            $case: "duplicateUserConnectedMessage",
            duplicateUserConnectedMessage: DuplicateUserConnectedMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.message = { $case: "entityMessage", entityMessage: EntityMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.message = {
            $case: "spaceStatePatchMessage",
            spaceStatePatchMessage: SpaceStatePatchMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubMessage {
    return {
      message: isSet(object.userMovedMessage)
        ? { $case: "userMovedMessage", userMovedMessage: UserMovedMessage.fromJSON(object.userMovedMessage) }
        : isSet(object.groupUpdateMessage)
        ? { $case: "groupUpdateMessage", groupUpdateMessage: GroupUpdateMessage.fromJSON(object.groupUpdateMessage) }
        : isSet(object.groupDeleteMessage)
        ? { $case: "groupDeleteMessage", groupDeleteMessage: GroupDeleteMessage.fromJSON(object.groupDeleteMessage) }
        : isSet(object.userJoinedMessage)
        ? { $case: "userJoinedMessage", userJoinedMessage: UserJoinedMessage.fromJSON(object.userJoinedMessage) }
        : isSet(object.userLeftMessage)
        ? { $case: "userLeftMessage", userLeftMessage: UserLeftMessage.fromJSON(object.userLeftMessage) }
        : isSet(object.itemEventMessage)
        ? { $case: "itemEventMessage", itemEventMessage: ItemEventMessage.fromJSON(object.itemEventMessage) }
        : isSet(object.emoteEventMessage)
        ? { $case: "emoteEventMessage", emoteEventMessage: EmoteEventMessage.fromJSON(object.emoteEventMessage) }
        : isSet(object.variableMessage)
        ? { $case: "variableMessage", variableMessage: VariableMessage.fromJSON(object.variableMessage) }
        : isSet(object.errorMessage)
        ? { $case: "errorMessage", errorMessage: ErrorMessage.fromJSON(object.errorMessage) }
        : isSet(object.playerDetailsUpdatedMessage)
        ? {
          $case: "playerDetailsUpdatedMessage",
          playerDetailsUpdatedMessage: PlayerDetailsUpdatedMessage.fromJSON(object.playerDetailsUpdatedMessage),
        }
        : isSet(object.pingMessage)
        ? { $case: "pingMessage", pingMessage: PingMessage.fromJSON(object.pingMessage) }
        : isSet(object.editMapCommandMessage)
        ? {
          $case: "editMapCommandMessage",
          editMapCommandMessage: EditMapCommandMessage.fromJSON(object.editMapCommandMessage),
        }
        : isSet(object.addSpaceUserMessage)
        ? {
          $case: "addSpaceUserMessage",
          addSpaceUserMessage: AddSpaceUserMessage.fromJSON(object.addSpaceUserMessage),
        }
        : isSet(object.updateSpaceUserMessage)
        ? {
          $case: "updateSpaceUserMessage",
          updateSpaceUserMessage: UpdateSpaceUserPusherToFrontMessage.fromJSON(object.updateSpaceUserMessage),
        }
        : isSet(object.removeSpaceUserMessage)
        ? {
          $case: "removeSpaceUserMessage",
          removeSpaceUserMessage: RemoveSpaceUserPusherToFrontMessage.fromJSON(object.removeSpaceUserMessage),
        }
        : isSet(object.receivedEventMessage)
        ? {
          $case: "receivedEventMessage",
          receivedEventMessage: ReceivedEventMessage.fromJSON(object.receivedEventMessage),
        }
        : isSet(object.updateSpaceMetadataMessage)
        ? {
          $case: "updateSpaceMetadataMessage",
          updateSpaceMetadataMessage: UpdateSpaceMetadataMessage.fromJSON(object.updateSpaceMetadataMessage),
        }
        : isSet(object.groupUsersUpdateMessage)
        ? {
          $case: "groupUsersUpdateMessage",
          groupUsersUpdateMessage: GroupUsersUpdateMessage.fromJSON(object.groupUsersUpdateMessage),
        }
        : isSet(object.kickOffMessage)
        ? { $case: "kickOffMessage", kickOffMessage: KickOffMessage.fromJSON(object.kickOffMessage) }
        : isSet(object.publicEvent)
        ? { $case: "publicEvent", publicEvent: PublicEvent.fromJSON(object.publicEvent) }
        : isSet(object.privateEvent)
        ? { $case: "privateEvent", privateEvent: PrivateEventPusherToFront.fromJSON(object.privateEvent) }
        : isSet(object.spaceDestroyedMessage)
        ? {
          $case: "spaceDestroyedMessage",
          spaceDestroyedMessage: SpaceDestroyedMessage.fromJSON(object.spaceDestroyedMessage),
        }
        : isSet(object.initSpaceUsersMessage)
        ? {
          $case: "initSpaceUsersMessage",
          initSpaceUsersMessage: InitSpaceUsersMessage.fromJSON(object.initSpaceUsersMessage),
        }
        : isSet(object.areaPropertyVariableMessage)
        ? {
          $case: "areaPropertyVariableMessage",
          areaPropertyVariableMessage: AreaPropertyVariableMessage.fromJSON(object.areaPropertyVariableMessage),
        }
        : isSet(object.duplicateUserConnectedMessage)
        ? {
          $case: "duplicateUserConnectedMessage",
          duplicateUserConnectedMessage: DuplicateUserConnectedMessage.fromJSON(object.duplicateUserConnectedMessage),
        }
        : isSet(object.entityMessage)
        ? { $case: "entityMessage", entityMessage: EntityMessage.fromJSON(object.entityMessage) }
        : isSet(object.spaceStatePatchMessage)
        ? {
          $case: "spaceStatePatchMessage",
          spaceStatePatchMessage: SpaceStatePatchMessage.fromJSON(object.spaceStatePatchMessage),
        }
        : undefined,
    };
  },

  toJSON(message: SubMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "userMovedMessage") {
      obj.userMovedMessage = UserMovedMessage.toJSON(message.message.userMovedMessage);
    } else if (message.message?.$case === "groupUpdateMessage") {
      obj.groupUpdateMessage = GroupUpdateMessage.toJSON(message.message.groupUpdateMessage);
    } else if (message.message?.$case === "groupDeleteMessage") {
      obj.groupDeleteMessage = GroupDeleteMessage.toJSON(message.message.groupDeleteMessage);
    } else if (message.message?.$case === "userJoinedMessage") {
      obj.userJoinedMessage = UserJoinedMessage.toJSON(message.message.userJoinedMessage);
    } else if (message.message?.$case === "userLeftMessage") {
      obj.userLeftMessage = UserLeftMessage.toJSON(message.message.userLeftMessage);
    } else if (message.message?.$case === "itemEventMessage") {
      obj.itemEventMessage = ItemEventMessage.toJSON(message.message.itemEventMessage);
    } else if (message.message?.$case === "emoteEventMessage") {
      obj.emoteEventMessage = EmoteEventMessage.toJSON(message.message.emoteEventMessage);
    } else if (message.message?.$case === "variableMessage") {
      obj.variableMessage = VariableMessage.toJSON(message.message.variableMessage);
    } else if (message.message?.$case === "errorMessage") {
      obj.errorMessage = ErrorMessage.toJSON(message.message.errorMessage);
    } else if (message.message?.$case === "playerDetailsUpdatedMessage") {
      obj.playerDetailsUpdatedMessage = PlayerDetailsUpdatedMessage.toJSON(message.message.playerDetailsUpdatedMessage);
    } else if (message.message?.$case === "pingMessage") {
      obj.pingMessage = PingMessage.toJSON(message.message.pingMessage);
    } else if (message.message?.$case === "editMapCommandMessage") {
      obj.editMapCommandMessage = EditMapCommandMessage.toJSON(message.message.editMapCommandMessage);
    } else if (message.message?.$case === "addSpaceUserMessage") {
      obj.addSpaceUserMessage = AddSpaceUserMessage.toJSON(message.message.addSpaceUserMessage);
    } else if (message.message?.$case === "updateSpaceUserMessage") {
      obj.updateSpaceUserMessage = UpdateSpaceUserPusherToFrontMessage.toJSON(message.message.updateSpaceUserMessage);
    } else if (message.message?.$case === "removeSpaceUserMessage") {
      obj.removeSpaceUserMessage = RemoveSpaceUserPusherToFrontMessage.toJSON(message.message.removeSpaceUserMessage);
    } else if (message.message?.$case === "receivedEventMessage") {
      obj.receivedEventMessage = ReceivedEventMessage.toJSON(message.message.receivedEventMessage);
    } else if (message.message?.$case === "updateSpaceMetadataMessage") {
      obj.updateSpaceMetadataMessage = UpdateSpaceMetadataMessage.toJSON(message.message.updateSpaceMetadataMessage);
    } else if (message.message?.$case === "groupUsersUpdateMessage") {
      obj.groupUsersUpdateMessage = GroupUsersUpdateMessage.toJSON(message.message.groupUsersUpdateMessage);
    } else if (message.message?.$case === "kickOffMessage") {
      obj.kickOffMessage = KickOffMessage.toJSON(message.message.kickOffMessage);
    } else if (message.message?.$case === "publicEvent") {
      obj.publicEvent = PublicEvent.toJSON(message.message.publicEvent);
    } else if (message.message?.$case === "privateEvent") {
      obj.privateEvent = PrivateEventPusherToFront.toJSON(message.message.privateEvent);
    } else if (message.message?.$case === "spaceDestroyedMessage") {
      obj.spaceDestroyedMessage = SpaceDestroyedMessage.toJSON(message.message.spaceDestroyedMessage);
    } else if (message.message?.$case === "initSpaceUsersMessage") {
      obj.initSpaceUsersMessage = InitSpaceUsersMessage.toJSON(message.message.initSpaceUsersMessage);
    } else if (message.message?.$case === "areaPropertyVariableMessage") {
      obj.areaPropertyVariableMessage = AreaPropertyVariableMessage.toJSON(message.message.areaPropertyVariableMessage);
    } else if (message.message?.$case === "duplicateUserConnectedMessage") {
      obj.duplicateUserConnectedMessage = DuplicateUserConnectedMessage.toJSON(
        message.message.duplicateUserConnectedMessage,
      );
    } else if (message.message?.$case === "entityMessage") {
      obj.entityMessage = EntityMessage.toJSON(message.message.entityMessage);
    } else if (message.message?.$case === "spaceStatePatchMessage") {
      obj.spaceStatePatchMessage = SpaceStatePatchMessage.toJSON(message.message.spaceStatePatchMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubMessage>, I>>(base?: I): SubMessage {
    return SubMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubMessage>, I>>(object: I): SubMessage {
    const message = createBaseSubMessage();
    switch (object.message?.$case) {
      case "userMovedMessage": {
        if (object.message?.userMovedMessage !== undefined && object.message?.userMovedMessage !== null) {
          message.message = {
            $case: "userMovedMessage",
            userMovedMessage: UserMovedMessage.fromPartial(object.message.userMovedMessage),
          };
        }
        break;
      }
      case "groupUpdateMessage": {
        if (object.message?.groupUpdateMessage !== undefined && object.message?.groupUpdateMessage !== null) {
          message.message = {
            $case: "groupUpdateMessage",
            groupUpdateMessage: GroupUpdateMessage.fromPartial(object.message.groupUpdateMessage),
          };
        }
        break;
      }
      case "groupDeleteMessage": {
        if (object.message?.groupDeleteMessage !== undefined && object.message?.groupDeleteMessage !== null) {
          message.message = {
            $case: "groupDeleteMessage",
            groupDeleteMessage: GroupDeleteMessage.fromPartial(object.message.groupDeleteMessage),
          };
        }
        break;
      }
      case "userJoinedMessage": {
        if (object.message?.userJoinedMessage !== undefined && object.message?.userJoinedMessage !== null) {
          message.message = {
            $case: "userJoinedMessage",
            userJoinedMessage: UserJoinedMessage.fromPartial(object.message.userJoinedMessage),
          };
        }
        break;
      }
      case "userLeftMessage": {
        if (object.message?.userLeftMessage !== undefined && object.message?.userLeftMessage !== null) {
          message.message = {
            $case: "userLeftMessage",
            userLeftMessage: UserLeftMessage.fromPartial(object.message.userLeftMessage),
          };
        }
        break;
      }
      case "itemEventMessage": {
        if (object.message?.itemEventMessage !== undefined && object.message?.itemEventMessage !== null) {
          message.message = {
            $case: "itemEventMessage",
            itemEventMessage: ItemEventMessage.fromPartial(object.message.itemEventMessage),
          };
        }
        break;
      }
      case "emoteEventMessage": {
        if (object.message?.emoteEventMessage !== undefined && object.message?.emoteEventMessage !== null) {
          message.message = {
            $case: "emoteEventMessage",
            emoteEventMessage: EmoteEventMessage.fromPartial(object.message.emoteEventMessage),
          };
        }
        break;
      }
      case "variableMessage": {
        if (object.message?.variableMessage !== undefined && object.message?.variableMessage !== null) {
          message.message = {
            $case: "variableMessage",
            variableMessage: VariableMessage.fromPartial(object.message.variableMessage),
          };
        }
        break;
      }
      case "errorMessage": {
        if (object.message?.errorMessage !== undefined && object.message?.errorMessage !== null) {
          message.message = {
            $case: "errorMessage",
            errorMessage: ErrorMessage.fromPartial(object.message.errorMessage),
          };
        }
        break;
      }
      case "playerDetailsUpdatedMessage": {
        if (
          object.message?.playerDetailsUpdatedMessage !== undefined &&
          object.message?.playerDetailsUpdatedMessage !== null
        ) {
          message.message = {
            $case: "playerDetailsUpdatedMessage",
            playerDetailsUpdatedMessage: PlayerDetailsUpdatedMessage.fromPartial(
              object.message.playerDetailsUpdatedMessage,
            ),
          };
        }
        break;
      }
      case "pingMessage": {
        if (object.message?.pingMessage !== undefined && object.message?.pingMessage !== null) {
          message.message = { $case: "pingMessage", pingMessage: PingMessage.fromPartial(object.message.pingMessage) };
        }
        break;
      }
      case "editMapCommandMessage": {
        if (object.message?.editMapCommandMessage !== undefined && object.message?.editMapCommandMessage !== null) {
          message.message = {
            $case: "editMapCommandMessage",
            editMapCommandMessage: EditMapCommandMessage.fromPartial(object.message.editMapCommandMessage),
          };
        }
        break;
      }
      case "addSpaceUserMessage": {
        if (object.message?.addSpaceUserMessage !== undefined && object.message?.addSpaceUserMessage !== null) {
          message.message = {
            $case: "addSpaceUserMessage",
            addSpaceUserMessage: AddSpaceUserMessage.fromPartial(object.message.addSpaceUserMessage),
          };
        }
        break;
      }
      case "updateSpaceUserMessage": {
        if (object.message?.updateSpaceUserMessage !== undefined && object.message?.updateSpaceUserMessage !== null) {
          message.message = {
            $case: "updateSpaceUserMessage",
            updateSpaceUserMessage: UpdateSpaceUserPusherToFrontMessage.fromPartial(
              object.message.updateSpaceUserMessage,
            ),
          };
        }
        break;
      }
      case "removeSpaceUserMessage": {
        if (object.message?.removeSpaceUserMessage !== undefined && object.message?.removeSpaceUserMessage !== null) {
          message.message = {
            $case: "removeSpaceUserMessage",
            removeSpaceUserMessage: RemoveSpaceUserPusherToFrontMessage.fromPartial(
              object.message.removeSpaceUserMessage,
            ),
          };
        }
        break;
      }
      case "receivedEventMessage": {
        if (object.message?.receivedEventMessage !== undefined && object.message?.receivedEventMessage !== null) {
          message.message = {
            $case: "receivedEventMessage",
            receivedEventMessage: ReceivedEventMessage.fromPartial(object.message.receivedEventMessage),
          };
        }
        break;
      }
      case "updateSpaceMetadataMessage": {
        if (
          object.message?.updateSpaceMetadataMessage !== undefined &&
          object.message?.updateSpaceMetadataMessage !== null
        ) {
          message.message = {
            $case: "updateSpaceMetadataMessage",
            updateSpaceMetadataMessage: UpdateSpaceMetadataMessage.fromPartial(
              object.message.updateSpaceMetadataMessage,
            ),
          };
        }
        break;
      }
      case "groupUsersUpdateMessage": {
        if (object.message?.groupUsersUpdateMessage !== undefined && object.message?.groupUsersUpdateMessage !== null) {
          message.message = {
            $case: "groupUsersUpdateMessage",
            groupUsersUpdateMessage: GroupUsersUpdateMessage.fromPartial(object.message.groupUsersUpdateMessage),
          };
        }
        break;
      }
      case "kickOffMessage": {
        if (object.message?.kickOffMessage !== undefined && object.message?.kickOffMessage !== null) {
          message.message = {
            $case: "kickOffMessage",
            kickOffMessage: KickOffMessage.fromPartial(object.message.kickOffMessage),
          };
        }
        break;
      }
      case "publicEvent": {
        if (object.message?.publicEvent !== undefined && object.message?.publicEvent !== null) {
          message.message = { $case: "publicEvent", publicEvent: PublicEvent.fromPartial(object.message.publicEvent) };
        }
        break;
      }
      case "privateEvent": {
        if (object.message?.privateEvent !== undefined && object.message?.privateEvent !== null) {
          message.message = {
            $case: "privateEvent",
            privateEvent: PrivateEventPusherToFront.fromPartial(object.message.privateEvent),
          };
        }
        break;
      }
      case "spaceDestroyedMessage": {
        if (object.message?.spaceDestroyedMessage !== undefined && object.message?.spaceDestroyedMessage !== null) {
          message.message = {
            $case: "spaceDestroyedMessage",
            spaceDestroyedMessage: SpaceDestroyedMessage.fromPartial(object.message.spaceDestroyedMessage),
          };
        }
        break;
      }
      case "initSpaceUsersMessage": {
        if (object.message?.initSpaceUsersMessage !== undefined && object.message?.initSpaceUsersMessage !== null) {
          message.message = {
            $case: "initSpaceUsersMessage",
            initSpaceUsersMessage: InitSpaceUsersMessage.fromPartial(object.message.initSpaceUsersMessage),
          };
        }
        break;
      }
      case "areaPropertyVariableMessage": {
        if (
          object.message?.areaPropertyVariableMessage !== undefined &&
          object.message?.areaPropertyVariableMessage !== null
        ) {
          message.message = {
            $case: "areaPropertyVariableMessage",
            areaPropertyVariableMessage: AreaPropertyVariableMessage.fromPartial(
              object.message.areaPropertyVariableMessage,
            ),
          };
        }
        break;
      }
      case "duplicateUserConnectedMessage": {
        if (
          object.message?.duplicateUserConnectedMessage !== undefined &&
          object.message?.duplicateUserConnectedMessage !== null
        ) {
          message.message = {
            $case: "duplicateUserConnectedMessage",
            duplicateUserConnectedMessage: DuplicateUserConnectedMessage.fromPartial(
              object.message.duplicateUserConnectedMessage,
            ),
          };
        }
        break;
      }
      case "entityMessage": {
        if (object.message?.entityMessage !== undefined && object.message?.entityMessage !== null) {
          message.message = {
            $case: "entityMessage",
            entityMessage: EntityMessage.fromPartial(object.message.entityMessage),
          };
        }
        break;
      }
      case "spaceStatePatchMessage": {
        if (object.message?.spaceStatePatchMessage !== undefined && object.message?.spaceStatePatchMessage !== null) {
          message.message = {
            $case: "spaceStatePatchMessage",
            spaceStatePatchMessage: SpaceStatePatchMessage.fromPartial(object.message.spaceStatePatchMessage),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseBatchMessage(): BatchMessage {
  return { event: "", payload: [] };
}

export const BatchMessage: MessageFns<BatchMessage> = {
  encode(message: BatchMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.event !== "") {
      writer.uint32(10).string(message.event);
    }
    for (const v of message.payload) {
      SubMessage.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BatchMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.event = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.payload.push(SubMessage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatchMessage {
    return {
      event: isSet(object.event) ? globalThis.String(object.event) : "",
      payload: globalThis.Array.isArray(object?.payload) ? object.payload.map((e: any) => SubMessage.fromJSON(e)) : [],
    };
  },

  toJSON(message: BatchMessage): unknown {
    const obj: any = {};
    if (message.event !== "") {
      obj.event = message.event;
    }
    if (message.payload?.length) {
      obj.payload = message.payload.map((e) => SubMessage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BatchMessage>, I>>(base?: I): BatchMessage {
    return BatchMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BatchMessage>, I>>(object: I): BatchMessage {
    const message = createBaseBatchMessage();
    message.event = object.event ?? "";
    message.payload = object.payload?.map((e) => SubMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGroupUpdateMessage(): GroupUpdateMessage {
  return { groupId: 0, position: undefined, groupSize: undefined, locked: undefined, userIds: [] };
}

export const GroupUpdateMessage: MessageFns<GroupUpdateMessage> = {
  encode(message: GroupUpdateMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.groupId !== 0) {
      writer.uint32(8).int32(message.groupId);
    }
    if (message.position !== undefined) {
      PointMessage.encode(message.position, writer.uint32(18).fork()).join();
    }
    if (message.groupSize !== undefined) {
      UInt32Value.encode({ value: message.groupSize! }, writer.uint32(26).fork()).join();
    }
    if (message.locked !== undefined) {
      BoolValue.encode({ value: message.locked! }, writer.uint32(34).fork()).join();
    }
    writer.uint32(42).fork();
    for (const v of message.userIds) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupUpdateMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupUpdateMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.groupId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.position = PointMessage.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupSize = UInt32Value.decode(reader, reader.uint32()).value;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.locked = BoolValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.userIds.push(reader.int32());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.userIds.push(reader.int32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupUpdateMessage {
    return {
      groupId: isSet(object.groupId) ? globalThis.Number(object.groupId) : 0,
      position: isSet(object.position) ? PointMessage.fromJSON(object.position) : undefined,
      groupSize: isSet(object.groupSize) ? Number(object.groupSize) : undefined,
      locked: isSet(object.locked) ? Boolean(object.locked) : undefined,
      userIds: globalThis.Array.isArray(object?.userIds) ? object.userIds.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: GroupUpdateMessage): unknown {
    const obj: any = {};
    if (message.groupId !== 0) {
      obj.groupId = Math.round(message.groupId);
    }
    if (message.position !== undefined) {
      obj.position = PointMessage.toJSON(message.position);
    }
    if (message.groupSize !== undefined) {
      obj.groupSize = message.groupSize;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.userIds?.length) {
      obj.userIds = message.userIds.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroupUpdateMessage>, I>>(base?: I): GroupUpdateMessage {
    return GroupUpdateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroupUpdateMessage>, I>>(object: I): GroupUpdateMessage {
    const message = createBaseGroupUpdateMessage();
    message.groupId = object.groupId ?? 0;
    message.position = (object.position !== undefined && object.position !== null)
      ? PointMessage.fromPartial(object.position)
      : undefined;
    message.groupSize = object.groupSize ?? undefined;
    message.locked = object.locked ?? undefined;
    message.userIds = object.userIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGroupDeleteMessage(): GroupDeleteMessage {
  return { groupId: 0 };
}

export const GroupDeleteMessage: MessageFns<GroupDeleteMessage> = {
  encode(message: GroupDeleteMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.groupId !== 0) {
      writer.uint32(8).int32(message.groupId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupDeleteMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupDeleteMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.groupId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupDeleteMessage {
    return { groupId: isSet(object.groupId) ? globalThis.Number(object.groupId) : 0 };
  },

  toJSON(message: GroupDeleteMessage): unknown {
    const obj: any = {};
    if (message.groupId !== 0) {
      obj.groupId = Math.round(message.groupId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroupDeleteMessage>, I>>(base?: I): GroupDeleteMessage {
    return GroupDeleteMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroupDeleteMessage>, I>>(object: I): GroupDeleteMessage {
    const message = createBaseGroupDeleteMessage();
    message.groupId = object.groupId ?? 0;
    return message;
  },
};

function createBaseUserJoinedMessage(): UserJoinedMessage {
  return {
    userId: 0,
    name: "",
    characterTextures: [],
    position: undefined,
    companionTexture: undefined,
    visitCardUrl: "",
    userUuid: "",
    outlineColor: 0,
    hasOutline: false,
    availabilityStatus: 0,
    variables: {},
    chatID: undefined,
    sayMessage: undefined,
  };
}

export const UserJoinedMessage: MessageFns<UserJoinedMessage> = {
  encode(message: UserJoinedMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== 0) {
      writer.uint32(8).int32(message.userId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    for (const v of message.characterTextures) {
      CharacterTextureMessage.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.position !== undefined) {
      PositionMessage.encode(message.position, writer.uint32(42).fork()).join();
    }
    if (message.companionTexture !== undefined) {
      CompanionTextureMessage.encode(message.companionTexture, writer.uint32(50).fork()).join();
    }
    if (message.visitCardUrl !== "") {
      writer.uint32(58).string(message.visitCardUrl);
    }
    if (message.userUuid !== "") {
      writer.uint32(66).string(message.userUuid);
    }
    if (message.outlineColor !== 0) {
      writer.uint32(72).uint32(message.outlineColor);
    }
    if (message.hasOutline !== false) {
      writer.uint32(80).bool(message.hasOutline);
    }
    if (message.availabilityStatus !== 0) {
      writer.uint32(88).int32(message.availabilityStatus);
    }
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, string]) => {
      UserJoinedMessage_VariablesEntry.encode({ key: key as any, value }, writer.uint32(98).fork()).join();
    });
    if (message.chatID !== undefined) {
      writer.uint32(106).string(message.chatID);
    }
    if (message.sayMessage !== undefined) {
      SayMessage.encode(message.sayMessage, writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserJoinedMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserJoinedMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.userId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.characterTextures.push(CharacterTextureMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.position = PositionMessage.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.companionTexture = CompanionTextureMessage.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.visitCardUrl = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.userUuid = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.outlineColor = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.hasOutline = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.availabilityStatus = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          const entry12 = UserJoinedMessage_VariablesEntry.decode(reader, reader.uint32());
          if (entry12.value !== undefined) {
            message.variables[entry12.key] = entry12.value;
          }
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.chatID = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.sayMessage = SayMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserJoinedMessage {
    return {
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      characterTextures: globalThis.Array.isArray(object?.characterTextures)
        ? object.characterTextures.map((e: any) => CharacterTextureMessage.fromJSON(e))
        : [],
      position: isSet(object.position) ? PositionMessage.fromJSON(object.position) : undefined,
      companionTexture: isSet(object.companionTexture)
        ? CompanionTextureMessage.fromJSON(object.companionTexture)
        : undefined,
      visitCardUrl: isSet(object.visitCardUrl) ? globalThis.String(object.visitCardUrl) : "",
      userUuid: isSet(object.userUuid) ? globalThis.String(object.userUuid) : "",
      outlineColor: isSet(object.outlineColor) ? globalThis.Number(object.outlineColor) : 0,
      hasOutline: isSet(object.hasOutline) ? globalThis.Boolean(object.hasOutline) : false,
      availabilityStatus: isSet(object.availabilityStatus) ? availabilityStatusFromJSON(object.availabilityStatus) : 0,
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
      chatID: isSet(object.chatID) ? globalThis.String(object.chatID) : undefined,
      sayMessage: isSet(object.sayMessage) ? SayMessage.fromJSON(object.sayMessage) : undefined,
    };
  },

  toJSON(message: UserJoinedMessage): unknown {
    const obj: any = {};
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.characterTextures?.length) {
      obj.characterTextures = message.characterTextures.map((e) => CharacterTextureMessage.toJSON(e));
    }
    if (message.position !== undefined) {
      obj.position = PositionMessage.toJSON(message.position);
    }
    if (message.companionTexture !== undefined) {
      obj.companionTexture = CompanionTextureMessage.toJSON(message.companionTexture);
    }
    if (message.visitCardUrl !== "") {
      obj.visitCardUrl = message.visitCardUrl;
    }
    if (message.userUuid !== "") {
      obj.userUuid = message.userUuid;
    }
    if (message.outlineColor !== 0) {
      obj.outlineColor = Math.round(message.outlineColor);
    }
    if (message.hasOutline !== false) {
      obj.hasOutline = message.hasOutline;
    }
    if (message.availabilityStatus !== 0) {
      obj.availabilityStatus = availabilityStatusToJSON(message.availabilityStatus);
    }
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, string][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    if (message.chatID !== undefined) {
      obj.chatID = message.chatID;
    }
    if (message.sayMessage !== undefined) {
      obj.sayMessage = SayMessage.toJSON(message.sayMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserJoinedMessage>, I>>(base?: I): UserJoinedMessage {
    return UserJoinedMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserJoinedMessage>, I>>(object: I): UserJoinedMessage {
    const message = createBaseUserJoinedMessage();
    message.userId = object.userId ?? 0;
    message.name = object.name ?? "";
    message.characterTextures = object.characterTextures?.map((e) => CharacterTextureMessage.fromPartial(e)) || [];
    message.position = (object.position !== undefined && object.position !== null)
      ? PositionMessage.fromPartial(object.position)
      : undefined;
    message.companionTexture = (object.companionTexture !== undefined && object.companionTexture !== null)
      ? CompanionTextureMessage.fromPartial(object.companionTexture)
      : undefined;
    message.visitCardUrl = object.visitCardUrl ?? "";
    message.userUuid = object.userUuid ?? "";
    message.outlineColor = object.outlineColor ?? 0;
    message.hasOutline = object.hasOutline ?? false;
    message.availabilityStatus = object.availabilityStatus ?? 0;
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.chatID = object.chatID ?? undefined;
    message.sayMessage = (object.sayMessage !== undefined && object.sayMessage !== null)
      ? SayMessage.fromPartial(object.sayMessage)
      : undefined;
    return message;
  },
};

function createBaseUserJoinedMessage_VariablesEntry(): UserJoinedMessage_VariablesEntry {
  return { key: "", value: "" };
}

export const UserJoinedMessage_VariablesEntry: MessageFns<UserJoinedMessage_VariablesEntry> = {
  encode(message: UserJoinedMessage_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserJoinedMessage_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserJoinedMessage_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserJoinedMessage_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: UserJoinedMessage_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserJoinedMessage_VariablesEntry>, I>>(
    base?: I,
  ): UserJoinedMessage_VariablesEntry {
    return UserJoinedMessage_VariablesEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserJoinedMessage_VariablesEntry>, I>>(
    object: I,
  ): UserJoinedMessage_VariablesEntry {
    const message = createBaseUserJoinedMessage_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseUserLeftMessage(): UserLeftMessage {
  return { userId: 0 };
}

export const UserLeftMessage: MessageFns<UserLeftMessage> = {
  encode(message: UserLeftMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== 0) {
      writer.uint32(8).int32(message.userId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserLeftMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserLeftMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.userId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserLeftMessage {
    return { userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0 };
  },

  toJSON(message: UserLeftMessage): unknown {
    const obj: any = {};
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserLeftMessage>, I>>(base?: I): UserLeftMessage {
    return UserLeftMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserLeftMessage>, I>>(object: I): UserLeftMessage {
    const message = createBaseUserLeftMessage();
    message.userId = object.userId ?? 0;
    return message;
  },
};

function createBaseErrorMessage(): ErrorMessage {
  return { message: "" };
}

export const ErrorMessage: MessageFns<ErrorMessage> = {
  encode(message: ErrorMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ErrorMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseErrorMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ErrorMessage {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: ErrorMessage): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ErrorMessage>, I>>(base?: I): ErrorMessage {
    return ErrorMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ErrorMessage>, I>>(object: I): ErrorMessage {
    const message = createBaseErrorMessage();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseErrorScreenMessage(): ErrorScreenMessage {
  return {
    type: "",
    code: undefined,
    title: undefined,
    subtitle: undefined,
    details: undefined,
    timeToRetry: undefined,
    canRetryManual: undefined,
    urlToRedirect: undefined,
    buttonTitle: undefined,
    image: undefined,
    imageLogo: undefined,
  };
}

export const ErrorScreenMessage: MessageFns<ErrorScreenMessage> = {
  encode(message: ErrorScreenMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.code !== undefined) {
      StringValue.encode({ value: message.code! }, writer.uint32(18).fork()).join();
    }
    if (message.title !== undefined) {
      StringValue.encode({ value: message.title! }, writer.uint32(26).fork()).join();
    }
    if (message.subtitle !== undefined) {
      StringValue.encode({ value: message.subtitle! }, writer.uint32(34).fork()).join();
    }
    if (message.details !== undefined) {
      StringValue.encode({ value: message.details! }, writer.uint32(42).fork()).join();
    }
    if (message.timeToRetry !== undefined) {
      Int32Value.encode({ value: message.timeToRetry! }, writer.uint32(50).fork()).join();
    }
    if (message.canRetryManual !== undefined) {
      BoolValue.encode({ value: message.canRetryManual! }, writer.uint32(58).fork()).join();
    }
    if (message.urlToRedirect !== undefined) {
      StringValue.encode({ value: message.urlToRedirect! }, writer.uint32(66).fork()).join();
    }
    if (message.buttonTitle !== undefined) {
      StringValue.encode({ value: message.buttonTitle! }, writer.uint32(74).fork()).join();
    }
    if (message.image !== undefined) {
      StringValue.encode({ value: message.image! }, writer.uint32(82).fork()).join();
    }
    if (message.imageLogo !== undefined) {
      StringValue.encode({ value: message.imageLogo! }, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ErrorScreenMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseErrorScreenMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.code = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subtitle = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.details = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.timeToRetry = Int32Value.decode(reader, reader.uint32()).value;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.canRetryManual = BoolValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.urlToRedirect = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.buttonTitle = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.image = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.imageLogo = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ErrorScreenMessage {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      code: isSet(object.code) ? String(object.code) : undefined,
      title: isSet(object.title) ? String(object.title) : undefined,
      subtitle: isSet(object.subtitle) ? String(object.subtitle) : undefined,
      details: isSet(object.details) ? String(object.details) : undefined,
      timeToRetry: isSet(object.timeToRetry) ? Number(object.timeToRetry) : undefined,
      canRetryManual: isSet(object.canRetryManual) ? Boolean(object.canRetryManual) : undefined,
      urlToRedirect: isSet(object.urlToRedirect) ? String(object.urlToRedirect) : undefined,
      buttonTitle: isSet(object.buttonTitle) ? String(object.buttonTitle) : undefined,
      image: isSet(object.image) ? String(object.image) : undefined,
      imageLogo: isSet(object.imageLogo) ? String(object.imageLogo) : undefined,
    };
  },

  toJSON(message: ErrorScreenMessage): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.code !== undefined) {
      obj.code = message.code;
    }
    if (message.title !== undefined) {
      obj.title = message.title;
    }
    if (message.subtitle !== undefined) {
      obj.subtitle = message.subtitle;
    }
    if (message.details !== undefined) {
      obj.details = message.details;
    }
    if (message.timeToRetry !== undefined) {
      obj.timeToRetry = message.timeToRetry;
    }
    if (message.canRetryManual !== undefined) {
      obj.canRetryManual = message.canRetryManual;
    }
    if (message.urlToRedirect !== undefined) {
      obj.urlToRedirect = message.urlToRedirect;
    }
    if (message.buttonTitle !== undefined) {
      obj.buttonTitle = message.buttonTitle;
    }
    if (message.image !== undefined) {
      obj.image = message.image;
    }
    if (message.imageLogo !== undefined) {
      obj.imageLogo = message.imageLogo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ErrorScreenMessage>, I>>(base?: I): ErrorScreenMessage {
    return ErrorScreenMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ErrorScreenMessage>, I>>(object: I): ErrorScreenMessage {
    const message = createBaseErrorScreenMessage();
    message.type = object.type ?? "";
    message.code = object.code ?? undefined;
    message.title = object.title ?? undefined;
    message.subtitle = object.subtitle ?? undefined;
    message.details = object.details ?? undefined;
    message.timeToRetry = object.timeToRetry ?? undefined;
    message.canRetryManual = object.canRetryManual ?? undefined;
    message.urlToRedirect = object.urlToRedirect ?? undefined;
    message.buttonTitle = object.buttonTitle ?? undefined;
    message.image = object.image ?? undefined;
    message.imageLogo = object.imageLogo ?? undefined;
    return message;
  },
};

function createBaseItemStateMessage(): ItemStateMessage {
  return { itemId: 0, stateJson: "" };
}

export const ItemStateMessage: MessageFns<ItemStateMessage> = {
  encode(message: ItemStateMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.itemId !== 0) {
      writer.uint32(8).int32(message.itemId);
    }
    if (message.stateJson !== "") {
      writer.uint32(18).string(message.stateJson);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ItemStateMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseItemStateMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.itemId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stateJson = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ItemStateMessage {
    return {
      itemId: isSet(object.itemId) ? globalThis.Number(object.itemId) : 0,
      stateJson: isSet(object.stateJson) ? globalThis.String(object.stateJson) : "",
    };
  },

  toJSON(message: ItemStateMessage): unknown {
    const obj: any = {};
    if (message.itemId !== 0) {
      obj.itemId = Math.round(message.itemId);
    }
    if (message.stateJson !== "") {
      obj.stateJson = message.stateJson;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ItemStateMessage>, I>>(base?: I): ItemStateMessage {
    return ItemStateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ItemStateMessage>, I>>(object: I): ItemStateMessage {
    const message = createBaseItemStateMessage();
    message.itemId = object.itemId ?? 0;
    message.stateJson = object.stateJson ?? "";
    return message;
  },
};

function createBaseGroupUsersUpdateMessage(): GroupUsersUpdateMessage {
  return { groupId: 0, userIds: [] };
}

export const GroupUsersUpdateMessage: MessageFns<GroupUsersUpdateMessage> = {
  encode(message: GroupUsersUpdateMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.groupId !== 0) {
      writer.uint32(8).int32(message.groupId);
    }
    writer.uint32(18).fork();
    for (const v of message.userIds) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupUsersUpdateMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupUsersUpdateMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.groupId = reader.int32();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.userIds.push(reader.int32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.userIds.push(reader.int32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupUsersUpdateMessage {
    return {
      groupId: isSet(object.groupId) ? globalThis.Number(object.groupId) : 0,
      userIds: globalThis.Array.isArray(object?.userIds) ? object.userIds.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: GroupUsersUpdateMessage): unknown {
    const obj: any = {};
    if (message.groupId !== 0) {
      obj.groupId = Math.round(message.groupId);
    }
    if (message.userIds?.length) {
      obj.userIds = message.userIds.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroupUsersUpdateMessage>, I>>(base?: I): GroupUsersUpdateMessage {
    return GroupUsersUpdateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroupUsersUpdateMessage>, I>>(object: I): GroupUsersUpdateMessage {
    const message = createBaseGroupUsersUpdateMessage();
    message.groupId = object.groupId ?? 0;
    message.userIds = object.userIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseRoomConnectedMessage(): RoomConnectedMessage {
  return { editMapCommandsArrayMessage: undefined, tag: [] };
}

export const RoomConnectedMessage: MessageFns<RoomConnectedMessage> = {
  encode(message: RoomConnectedMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.editMapCommandsArrayMessage !== undefined) {
      EditMapCommandsArrayMessage.encode(message.editMapCommandsArrayMessage, writer.uint32(106).fork()).join();
    }
    for (const v of message.tag) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoomConnectedMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomConnectedMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.editMapCommandsArrayMessage = EditMapCommandsArrayMessage.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tag.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoomConnectedMessage {
    return {
      editMapCommandsArrayMessage: isSet(object.editMapCommandsArrayMessage)
        ? EditMapCommandsArrayMessage.fromJSON(object.editMapCommandsArrayMessage)
        : undefined,
      tag: globalThis.Array.isArray(object?.tag) ? object.tag.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: RoomConnectedMessage): unknown {
    const obj: any = {};
    if (message.editMapCommandsArrayMessage !== undefined) {
      obj.editMapCommandsArrayMessage = EditMapCommandsArrayMessage.toJSON(message.editMapCommandsArrayMessage);
    }
    if (message.tag?.length) {
      obj.tag = message.tag;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoomConnectedMessage>, I>>(base?: I): RoomConnectedMessage {
    return RoomConnectedMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoomConnectedMessage>, I>>(object: I): RoomConnectedMessage {
    const message = createBaseRoomConnectedMessage();
    message.editMapCommandsArrayMessage =
      (object.editMapCommandsArrayMessage !== undefined && object.editMapCommandsArrayMessage !== null)
        ? EditMapCommandsArrayMessage.fromPartial(object.editMapCommandsArrayMessage)
        : undefined;
    message.tag = object.tag?.map((e) => e) || [];
    return message;
  },
};

function createBaseRoomJoinedMessage(): RoomJoinedMessage {
  return {
    item: [],
    currentUserId: 0,
    variable: [],
    userRoomToken: "",
    characterTextures: [],
    activatedInviteUser: false,
    playerVariable: [],
    applications: [],
    canEdit: false,
    companionTexture: undefined,
    areaPropertyVariable: [],
  };
}

export const RoomJoinedMessage: MessageFns<RoomJoinedMessage> = {
  encode(message: RoomJoinedMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.item) {
      ItemStateMessage.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.currentUserId !== 0) {
      writer.uint32(32).int32(message.currentUserId);
    }
    for (const v of message.variable) {
      VariableMessage.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.userRoomToken !== "") {
      writer.uint32(58).string(message.userRoomToken);
    }
    for (const v of message.characterTextures) {
      CharacterTextureMessage.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.activatedInviteUser !== false) {
      writer.uint32(72).bool(message.activatedInviteUser);
    }
    for (const v of message.playerVariable) {
      VariableMessage.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.applications) {
      ApplicationMessage.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.canEdit !== false) {
      writer.uint32(128).bool(message.canEdit);
    }
    if (message.companionTexture !== undefined) {
      CompanionTextureMessage.encode(message.companionTexture, writer.uint32(146).fork()).join();
    }
    for (const v of message.areaPropertyVariable) {
      AreaPropertyVariableMessage.encode(v!, writer.uint32(154).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoomJoinedMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomJoinedMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.item.push(ItemStateMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.currentUserId = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.variable.push(VariableMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.userRoomToken = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.characterTextures.push(CharacterTextureMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.activatedInviteUser = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.playerVariable.push(VariableMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.applications.push(ApplicationMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.canEdit = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.companionTexture = CompanionTextureMessage.decode(reader, reader.uint32());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.areaPropertyVariable.push(AreaPropertyVariableMessage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoomJoinedMessage {
    return {
      item: globalThis.Array.isArray(object?.item) ? object.item.map((e: any) => ItemStateMessage.fromJSON(e)) : [],
      currentUserId: isSet(object.currentUserId) ? globalThis.Number(object.currentUserId) : 0,
      variable: globalThis.Array.isArray(object?.variable)
        ? object.variable.map((e: any) => VariableMessage.fromJSON(e))
        : [],
      userRoomToken: isSet(object.userRoomToken) ? globalThis.String(object.userRoomToken) : "",
      characterTextures: globalThis.Array.isArray(object?.characterTextures)
        ? object.characterTextures.map((e: any) => CharacterTextureMessage.fromJSON(e))
        : [],
      activatedInviteUser: isSet(object.activatedInviteUser) ? globalThis.Boolean(object.activatedInviteUser) : false,
      playerVariable: globalThis.Array.isArray(object?.playerVariable)
        ? object.playerVariable.map((e: any) => VariableMessage.fromJSON(e))
        : [],
      applications: globalThis.Array.isArray(object?.applications)
        ? object.applications.map((e: any) => ApplicationMessage.fromJSON(e))
        : [],
      canEdit: isSet(object.canEdit) ? globalThis.Boolean(object.canEdit) : false,
      companionTexture: isSet(object.companionTexture)
        ? CompanionTextureMessage.fromJSON(object.companionTexture)
        : undefined,
      areaPropertyVariable: globalThis.Array.isArray(object?.areaPropertyVariable)
        ? object.areaPropertyVariable.map((e: any) => AreaPropertyVariableMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RoomJoinedMessage): unknown {
    const obj: any = {};
    if (message.item?.length) {
      obj.item = message.item.map((e) => ItemStateMessage.toJSON(e));
    }
    if (message.currentUserId !== 0) {
      obj.currentUserId = Math.round(message.currentUserId);
    }
    if (message.variable?.length) {
      obj.variable = message.variable.map((e) => VariableMessage.toJSON(e));
    }
    if (message.userRoomToken !== "") {
      obj.userRoomToken = message.userRoomToken;
    }
    if (message.characterTextures?.length) {
      obj.characterTextures = message.characterTextures.map((e) => CharacterTextureMessage.toJSON(e));
    }
    if (message.activatedInviteUser !== false) {
      obj.activatedInviteUser = message.activatedInviteUser;
    }
    if (message.playerVariable?.length) {
      obj.playerVariable = message.playerVariable.map((e) => VariableMessage.toJSON(e));
    }
    if (message.applications?.length) {
      obj.applications = message.applications.map((e) => ApplicationMessage.toJSON(e));
    }
    if (message.canEdit !== false) {
      obj.canEdit = message.canEdit;
    }
    if (message.companionTexture !== undefined) {
      obj.companionTexture = CompanionTextureMessage.toJSON(message.companionTexture);
    }
    if (message.areaPropertyVariable?.length) {
      obj.areaPropertyVariable = message.areaPropertyVariable.map((e) => AreaPropertyVariableMessage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoomJoinedMessage>, I>>(base?: I): RoomJoinedMessage {
    return RoomJoinedMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoomJoinedMessage>, I>>(object: I): RoomJoinedMessage {
    const message = createBaseRoomJoinedMessage();
    message.item = object.item?.map((e) => ItemStateMessage.fromPartial(e)) || [];
    message.currentUserId = object.currentUserId ?? 0;
    message.variable = object.variable?.map((e) => VariableMessage.fromPartial(e)) || [];
    message.userRoomToken = object.userRoomToken ?? "";
    message.characterTextures = object.characterTextures?.map((e) => CharacterTextureMessage.fromPartial(e)) || [];
    message.activatedInviteUser = object.activatedInviteUser ?? false;
    message.playerVariable = object.playerVariable?.map((e) => VariableMessage.fromPartial(e)) || [];
    message.applications = object.applications?.map((e) => ApplicationMessage.fromPartial(e)) || [];
    message.canEdit = object.canEdit ?? false;
    message.companionTexture = (object.companionTexture !== undefined && object.companionTexture !== null)
      ? CompanionTextureMessage.fromPartial(object.companionTexture)
      : undefined;
    message.areaPropertyVariable =
      object.areaPropertyVariable?.map((e) => AreaPropertyVariableMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWebRtcStartMessage(): WebRtcStartMessage {
  return { userId: "", initiator: false, connectionId: "" };
}

export const WebRtcStartMessage: MessageFns<WebRtcStartMessage> = {
  encode(message: WebRtcStartMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.initiator !== false) {
      writer.uint32(24).bool(message.initiator);
    }
    if (message.connectionId !== "") {
      writer.uint32(34).string(message.connectionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WebRtcStartMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebRtcStartMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.initiator = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.connectionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebRtcStartMessage {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      initiator: isSet(object.initiator) ? globalThis.Boolean(object.initiator) : false,
      connectionId: isSet(object.connectionId) ? globalThis.String(object.connectionId) : "",
    };
  },

  toJSON(message: WebRtcStartMessage): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.initiator !== false) {
      obj.initiator = message.initiator;
    }
    if (message.connectionId !== "") {
      obj.connectionId = message.connectionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebRtcStartMessage>, I>>(base?: I): WebRtcStartMessage {
    return WebRtcStartMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebRtcStartMessage>, I>>(object: I): WebRtcStartMessage {
    const message = createBaseWebRtcStartMessage();
    message.userId = object.userId ?? "";
    message.initiator = object.initiator ?? false;
    message.connectionId = object.connectionId ?? "";
    return message;
  },
};

function createBaseMeetingConnectionRestartMessage(): MeetingConnectionRestartMessage {
  return { userId: undefined, connectionId: undefined };
}

export const MeetingConnectionRestartMessage: MessageFns<MeetingConnectionRestartMessage> = {
  encode(message: MeetingConnectionRestartMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== undefined) {
      writer.uint32(10).string(message.userId);
    }
    if (message.connectionId !== undefined) {
      writer.uint32(18).string(message.connectionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeetingConnectionRestartMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeetingConnectionRestartMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.connectionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MeetingConnectionRestartMessage {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : undefined,
      connectionId: isSet(object.connectionId) ? globalThis.String(object.connectionId) : undefined,
    };
  },

  toJSON(message: MeetingConnectionRestartMessage): unknown {
    const obj: any = {};
    if (message.userId !== undefined) {
      obj.userId = message.userId;
    }
    if (message.connectionId !== undefined) {
      obj.connectionId = message.connectionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MeetingConnectionRestartMessage>, I>>(base?: I): MeetingConnectionRestartMessage {
    return MeetingConnectionRestartMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MeetingConnectionRestartMessage>, I>>(
    object: I,
  ): MeetingConnectionRestartMessage {
    const message = createBaseMeetingConnectionRestartMessage();
    message.userId = object.userId ?? undefined;
    message.connectionId = object.connectionId ?? undefined;
    return message;
  },
};

function createBaseWebRtcDisconnectMessage(): WebRtcDisconnectMessage {
  return { userId: "" };
}

export const WebRtcDisconnectMessage: MessageFns<WebRtcDisconnectMessage> = {
  encode(message: WebRtcDisconnectMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WebRtcDisconnectMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWebRtcDisconnectMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WebRtcDisconnectMessage {
    return { userId: isSet(object.userId) ? globalThis.String(object.userId) : "" };
  },

  toJSON(message: WebRtcDisconnectMessage): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WebRtcDisconnectMessage>, I>>(base?: I): WebRtcDisconnectMessage {
    return WebRtcDisconnectMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WebRtcDisconnectMessage>, I>>(object: I): WebRtcDisconnectMessage {
    const message = createBaseWebRtcDisconnectMessage();
    message.userId = object.userId ?? "";
    return message;
  },
};

function createBaseTeleportMessageMessage(): TeleportMessageMessage {
  return { map: "" };
}

export const TeleportMessageMessage: MessageFns<TeleportMessageMessage> = {
  encode(message: TeleportMessageMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.map !== "") {
      writer.uint32(10).string(message.map);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeleportMessageMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeleportMessageMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.map = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeleportMessageMessage {
    return { map: isSet(object.map) ? globalThis.String(object.map) : "" };
  },

  toJSON(message: TeleportMessageMessage): unknown {
    const obj: any = {};
    if (message.map !== "") {
      obj.map = message.map;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeleportMessageMessage>, I>>(base?: I): TeleportMessageMessage {
    return TeleportMessageMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeleportMessageMessage>, I>>(object: I): TeleportMessageMessage {
    const message = createBaseTeleportMessageMessage();
    message.map = object.map ?? "";
    return message;
  },
};

function createBaseSendUserMessage(): SendUserMessage {
  return { type: "", message: "" };
}

export const SendUserMessage: MessageFns<SendUserMessage> = {
  encode(message: SendUserMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendUserMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendUserMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendUserMessage {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: SendUserMessage): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendUserMessage>, I>>(base?: I): SendUserMessage {
    return SendUserMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendUserMessage>, I>>(object: I): SendUserMessage {
    const message = createBaseSendUserMessage();
    message.type = object.type ?? "";
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseWorldFullWarningMessage(): WorldFullWarningMessage {
  return {};
}

export const WorldFullWarningMessage: MessageFns<WorldFullWarningMessage> = {
  encode(_: WorldFullWarningMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorldFullWarningMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorldFullWarningMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WorldFullWarningMessage {
    return {};
  },

  toJSON(_: WorldFullWarningMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WorldFullWarningMessage>, I>>(base?: I): WorldFullWarningMessage {
    return WorldFullWarningMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorldFullWarningMessage>, I>>(_: I): WorldFullWarningMessage {
    const message = createBaseWorldFullWarningMessage();
    return message;
  },
};

function createBaseWorldFullWarningToRoomMessage(): WorldFullWarningToRoomMessage {
  return { roomId: "" };
}

export const WorldFullWarningToRoomMessage: MessageFns<WorldFullWarningToRoomMessage> = {
  encode(message: WorldFullWarningToRoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.roomId !== "") {
      writer.uint32(10).string(message.roomId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorldFullWarningToRoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorldFullWarningToRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roomId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorldFullWarningToRoomMessage {
    return { roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "" };
  },

  toJSON(message: WorldFullWarningToRoomMessage): unknown {
    const obj: any = {};
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorldFullWarningToRoomMessage>, I>>(base?: I): WorldFullWarningToRoomMessage {
    return WorldFullWarningToRoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorldFullWarningToRoomMessage>, I>>(
    object: I,
  ): WorldFullWarningToRoomMessage {
    const message = createBaseWorldFullWarningToRoomMessage();
    message.roomId = object.roomId ?? "";
    return message;
  },
};

function createBaseRefreshRoomPromptMessage(): RefreshRoomPromptMessage {
  return { roomId: "" };
}

export const RefreshRoomPromptMessage: MessageFns<RefreshRoomPromptMessage> = {
  encode(message: RefreshRoomPromptMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.roomId !== "") {
      writer.uint32(10).string(message.roomId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RefreshRoomPromptMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRefreshRoomPromptMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roomId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RefreshRoomPromptMessage {
    return { roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "" };
  },

  toJSON(message: RefreshRoomPromptMessage): unknown {
    const obj: any = {};
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RefreshRoomPromptMessage>, I>>(base?: I): RefreshRoomPromptMessage {
    return RefreshRoomPromptMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RefreshRoomPromptMessage>, I>>(object: I): RefreshRoomPromptMessage {
    const message = createBaseRefreshRoomPromptMessage();
    message.roomId = object.roomId ?? "";
    return message;
  },
};

function createBaseRefreshRoomMessage(): RefreshRoomMessage {
  return { roomId: "", versionNumber: 0, timeToRefresh: undefined };
}

export const RefreshRoomMessage: MessageFns<RefreshRoomMessage> = {
  encode(message: RefreshRoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.roomId !== "") {
      writer.uint32(10).string(message.roomId);
    }
    if (message.versionNumber !== 0) {
      writer.uint32(16).int32(message.versionNumber);
    }
    if (message.timeToRefresh !== undefined) {
      writer.uint32(32).int32(message.timeToRefresh);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RefreshRoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRefreshRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roomId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.versionNumber = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.timeToRefresh = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RefreshRoomMessage {
    return {
      roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "",
      versionNumber: isSet(object.versionNumber) ? globalThis.Number(object.versionNumber) : 0,
      timeToRefresh: isSet(object.timeToRefresh) ? globalThis.Number(object.timeToRefresh) : undefined,
    };
  },

  toJSON(message: RefreshRoomMessage): unknown {
    const obj: any = {};
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    if (message.versionNumber !== 0) {
      obj.versionNumber = Math.round(message.versionNumber);
    }
    if (message.timeToRefresh !== undefined) {
      obj.timeToRefresh = Math.round(message.timeToRefresh);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RefreshRoomMessage>, I>>(base?: I): RefreshRoomMessage {
    return RefreshRoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RefreshRoomMessage>, I>>(object: I): RefreshRoomMessage {
    const message = createBaseRefreshRoomMessage();
    message.roomId = object.roomId ?? "";
    message.versionNumber = object.versionNumber ?? 0;
    message.timeToRefresh = object.timeToRefresh ?? undefined;
    return message;
  },
};

function createBaseDeleteMapMessage(): DeleteMapMessage {
  return {};
}

export const DeleteMapMessage: MessageFns<DeleteMapMessage> = {
  encode(_: DeleteMapMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteMapMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteMapMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteMapMessage {
    return {};
  },

  toJSON(_: DeleteMapMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteMapMessage>, I>>(base?: I): DeleteMapMessage {
    return DeleteMapMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteMapMessage>, I>>(_: I): DeleteMapMessage {
    const message = createBaseDeleteMapMessage();
    return message;
  },
};

function createBaseTokenExpiredMessage(): TokenExpiredMessage {
  return {};
}

export const TokenExpiredMessage: MessageFns<TokenExpiredMessage> = {
  encode(_: TokenExpiredMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokenExpiredMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTokenExpiredMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TokenExpiredMessage {
    return {};
  },

  toJSON(_: TokenExpiredMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TokenExpiredMessage>, I>>(base?: I): TokenExpiredMessage {
    return TokenExpiredMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TokenExpiredMessage>, I>>(_: I): TokenExpiredMessage {
    const message = createBaseTokenExpiredMessage();
    return message;
  },
};

function createBaseInvalidCharacterTextureMessage(): InvalidCharacterTextureMessage {
  return { message: "" };
}

export const InvalidCharacterTextureMessage: MessageFns<InvalidCharacterTextureMessage> = {
  encode(message: InvalidCharacterTextureMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InvalidCharacterTextureMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInvalidCharacterTextureMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InvalidCharacterTextureMessage {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: InvalidCharacterTextureMessage): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InvalidCharacterTextureMessage>, I>>(base?: I): InvalidCharacterTextureMessage {
    return InvalidCharacterTextureMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InvalidCharacterTextureMessage>, I>>(
    object: I,
  ): InvalidCharacterTextureMessage {
    const message = createBaseInvalidCharacterTextureMessage();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseInvalidCompanionTextureMessage(): InvalidCompanionTextureMessage {
  return { message: "" };
}

export const InvalidCompanionTextureMessage: MessageFns<InvalidCompanionTextureMessage> = {
  encode(message: InvalidCompanionTextureMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InvalidCompanionTextureMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInvalidCompanionTextureMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InvalidCompanionTextureMessage {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: InvalidCompanionTextureMessage): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InvalidCompanionTextureMessage>, I>>(base?: I): InvalidCompanionTextureMessage {
    return InvalidCompanionTextureMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InvalidCompanionTextureMessage>, I>>(
    object: I,
  ): InvalidCompanionTextureMessage {
    const message = createBaseInvalidCompanionTextureMessage();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseWorldConnectionMessage(): WorldConnectionMessage {
  return { message: "" };
}

export const WorldConnectionMessage: MessageFns<WorldConnectionMessage> = {
  encode(message: WorldConnectionMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorldConnectionMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorldConnectionMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorldConnectionMessage {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: WorldConnectionMessage): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorldConnectionMessage>, I>>(base?: I): WorldConnectionMessage {
    return WorldConnectionMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorldConnectionMessage>, I>>(object: I): WorldConnectionMessage {
    const message = createBaseWorldConnectionMessage();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseBanUserMessage(): BanUserMessage {
  return { type: "", message: "" };
}

export const BanUserMessage: MessageFns<BanUserMessage> = {
  encode(message: BanUserMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BanUserMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBanUserMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BanUserMessage {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: BanUserMessage): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BanUserMessage>, I>>(base?: I): BanUserMessage {
    return BanUserMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BanUserMessage>, I>>(object: I): BanUserMessage {
    const message = createBaseBanUserMessage();
    message.type = object.type ?? "";
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseAskPositionMessage(): AskPositionMessage {
  return { userIdentifier: "", playUri: "", askType: 0, userId: undefined };
}

export const AskPositionMessage: MessageFns<AskPositionMessage> = {
  encode(message: AskPositionMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userIdentifier !== "") {
      writer.uint32(10).string(message.userIdentifier);
    }
    if (message.playUri !== "") {
      writer.uint32(18).string(message.playUri);
    }
    if (message.askType !== 0) {
      writer.uint32(24).int32(message.askType);
    }
    if (message.userId !== undefined) {
      writer.uint32(32).int32(message.userId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AskPositionMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAskPositionMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userIdentifier = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.playUri = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.askType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.userId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AskPositionMessage {
    return {
      userIdentifier: isSet(object.userIdentifier) ? globalThis.String(object.userIdentifier) : "",
      playUri: isSet(object.playUri) ? globalThis.String(object.playUri) : "",
      askType: isSet(object.askType) ? askPositionMessage_AskTypeFromJSON(object.askType) : 0,
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : undefined,
    };
  },

  toJSON(message: AskPositionMessage): unknown {
    const obj: any = {};
    if (message.userIdentifier !== "") {
      obj.userIdentifier = message.userIdentifier;
    }
    if (message.playUri !== "") {
      obj.playUri = message.playUri;
    }
    if (message.askType !== 0) {
      obj.askType = askPositionMessage_AskTypeToJSON(message.askType);
    }
    if (message.userId !== undefined) {
      obj.userId = Math.round(message.userId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AskPositionMessage>, I>>(base?: I): AskPositionMessage {
    return AskPositionMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AskPositionMessage>, I>>(object: I): AskPositionMessage {
    const message = createBaseAskPositionMessage();
    message.userIdentifier = object.userIdentifier ?? "";
    message.playUri = object.playUri ?? "";
    message.askType = object.askType ?? 0;
    message.userId = object.userId ?? undefined;
    return message;
  },
};

function createBaseMeetingInvitationRequestMessage(): MeetingInvitationRequestMessage {
  return { receiverUserUuid: "", receiverUserId: undefined };
}

export const MeetingInvitationRequestMessage: MessageFns<MeetingInvitationRequestMessage> = {
  encode(message: MeetingInvitationRequestMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.receiverUserUuid !== "") {
      writer.uint32(10).string(message.receiverUserUuid);
    }
    if (message.receiverUserId !== undefined) {
      writer.uint32(16).int32(message.receiverUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeetingInvitationRequestMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeetingInvitationRequestMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.receiverUserUuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.receiverUserId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MeetingInvitationRequestMessage {
    return {
      receiverUserUuid: isSet(object.receiverUserUuid) ? globalThis.String(object.receiverUserUuid) : "",
      receiverUserId: isSet(object.receiverUserId) ? globalThis.Number(object.receiverUserId) : undefined,
    };
  },

  toJSON(message: MeetingInvitationRequestMessage): unknown {
    const obj: any = {};
    if (message.receiverUserUuid !== "") {
      obj.receiverUserUuid = message.receiverUserUuid;
    }
    if (message.receiverUserId !== undefined) {
      obj.receiverUserId = Math.round(message.receiverUserId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MeetingInvitationRequestMessage>, I>>(base?: I): MeetingInvitationRequestMessage {
    return MeetingInvitationRequestMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MeetingInvitationRequestMessage>, I>>(
    object: I,
  ): MeetingInvitationRequestMessage {
    const message = createBaseMeetingInvitationRequestMessage();
    message.receiverUserUuid = object.receiverUserUuid ?? "";
    message.receiverUserId = object.receiverUserId ?? undefined;
    return message;
  },
};

function createBaseMeetingInvitationRequestReceivedMessage(): MeetingInvitationRequestReceivedMessage {
  return { senderUserUuid: "", senderPlayUri: "", senderName: "", senderUserId: undefined };
}

export const MeetingInvitationRequestReceivedMessage: MessageFns<MeetingInvitationRequestReceivedMessage> = {
  encode(message: MeetingInvitationRequestReceivedMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.senderUserUuid !== "") {
      writer.uint32(10).string(message.senderUserUuid);
    }
    if (message.senderPlayUri !== "") {
      writer.uint32(18).string(message.senderPlayUri);
    }
    if (message.senderName !== "") {
      writer.uint32(26).string(message.senderName);
    }
    if (message.senderUserId !== undefined) {
      writer.uint32(32).int32(message.senderUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeetingInvitationRequestReceivedMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeetingInvitationRequestReceivedMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.senderUserUuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.senderPlayUri = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.senderName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.senderUserId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MeetingInvitationRequestReceivedMessage {
    return {
      senderUserUuid: isSet(object.senderUserUuid) ? globalThis.String(object.senderUserUuid) : "",
      senderPlayUri: isSet(object.senderPlayUri) ? globalThis.String(object.senderPlayUri) : "",
      senderName: isSet(object.senderName) ? globalThis.String(object.senderName) : "",
      senderUserId: isSet(object.senderUserId) ? globalThis.Number(object.senderUserId) : undefined,
    };
  },

  toJSON(message: MeetingInvitationRequestReceivedMessage): unknown {
    const obj: any = {};
    if (message.senderUserUuid !== "") {
      obj.senderUserUuid = message.senderUserUuid;
    }
    if (message.senderPlayUri !== "") {
      obj.senderPlayUri = message.senderPlayUri;
    }
    if (message.senderName !== "") {
      obj.senderName = message.senderName;
    }
    if (message.senderUserId !== undefined) {
      obj.senderUserId = Math.round(message.senderUserId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MeetingInvitationRequestReceivedMessage>, I>>(
    base?: I,
  ): MeetingInvitationRequestReceivedMessage {
    return MeetingInvitationRequestReceivedMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MeetingInvitationRequestReceivedMessage>, I>>(
    object: I,
  ): MeetingInvitationRequestReceivedMessage {
    const message = createBaseMeetingInvitationRequestReceivedMessage();
    message.senderUserUuid = object.senderUserUuid ?? "";
    message.senderPlayUri = object.senderPlayUri ?? "";
    message.senderName = object.senderName ?? "";
    message.senderUserId = object.senderUserId ?? undefined;
    return message;
  },
};

function createBaseMeetingInvitationResponseMessage(): MeetingInvitationResponseMessage {
  return { accept: false, requestSenderUserUuid: "" };
}

export const MeetingInvitationResponseMessage: MessageFns<MeetingInvitationResponseMessage> = {
  encode(message: MeetingInvitationResponseMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accept !== false) {
      writer.uint32(8).bool(message.accept);
    }
    if (message.requestSenderUserUuid !== "") {
      writer.uint32(18).string(message.requestSenderUserUuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeetingInvitationResponseMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeetingInvitationResponseMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.accept = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.requestSenderUserUuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MeetingInvitationResponseMessage {
    return {
      accept: isSet(object.accept) ? globalThis.Boolean(object.accept) : false,
      requestSenderUserUuid: isSet(object.requestSenderUserUuid) ? globalThis.String(object.requestSenderUserUuid) : "",
    };
  },

  toJSON(message: MeetingInvitationResponseMessage): unknown {
    const obj: any = {};
    if (message.accept !== false) {
      obj.accept = message.accept;
    }
    if (message.requestSenderUserUuid !== "") {
      obj.requestSenderUserUuid = message.requestSenderUserUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MeetingInvitationResponseMessage>, I>>(
    base?: I,
  ): MeetingInvitationResponseMessage {
    return MeetingInvitationResponseMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MeetingInvitationResponseMessage>, I>>(
    object: I,
  ): MeetingInvitationResponseMessage {
    const message = createBaseMeetingInvitationResponseMessage();
    message.accept = object.accept ?? false;
    message.requestSenderUserUuid = object.requestSenderUserUuid ?? "";
    return message;
  },
};

function createBaseMeetingInvitationResponseReceivedMessage(): MeetingInvitationResponseReceivedMessage {
  return { accepted: false, responderName: "" };
}

export const MeetingInvitationResponseReceivedMessage: MessageFns<MeetingInvitationResponseReceivedMessage> = {
  encode(message: MeetingInvitationResponseReceivedMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accepted !== false) {
      writer.uint32(8).bool(message.accepted);
    }
    if (message.responderName !== "") {
      writer.uint32(18).string(message.responderName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeetingInvitationResponseReceivedMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeetingInvitationResponseReceivedMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.accepted = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.responderName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MeetingInvitationResponseReceivedMessage {
    return {
      accepted: isSet(object.accepted) ? globalThis.Boolean(object.accepted) : false,
      responderName: isSet(object.responderName) ? globalThis.String(object.responderName) : "",
    };
  },

  toJSON(message: MeetingInvitationResponseReceivedMessage): unknown {
    const obj: any = {};
    if (message.accepted !== false) {
      obj.accepted = message.accepted;
    }
    if (message.responderName !== "") {
      obj.responderName = message.responderName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MeetingInvitationResponseReceivedMessage>, I>>(
    base?: I,
  ): MeetingInvitationResponseReceivedMessage {
    return MeetingInvitationResponseReceivedMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MeetingInvitationResponseReceivedMessage>, I>>(
    object: I,
  ): MeetingInvitationResponseReceivedMessage {
    const message = createBaseMeetingInvitationResponseReceivedMessage();
    message.accepted = object.accepted ?? false;
    message.responderName = object.responderName ?? "";
    return message;
  },
};

function createBaseMeetingInvitationRequestTooHighMessage(): MeetingInvitationRequestTooHighMessage {
  return {};
}

export const MeetingInvitationRequestTooHighMessage: MessageFns<MeetingInvitationRequestTooHighMessage> = {
  encode(_: MeetingInvitationRequestTooHighMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeetingInvitationRequestTooHighMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeetingInvitationRequestTooHighMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MeetingInvitationRequestTooHighMessage {
    return {};
  },

  toJSON(_: MeetingInvitationRequestTooHighMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MeetingInvitationRequestTooHighMessage>, I>>(
    base?: I,
  ): MeetingInvitationRequestTooHighMessage {
    return MeetingInvitationRequestTooHighMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MeetingInvitationRequestTooHighMessage>, I>>(
    _: I,
  ): MeetingInvitationRequestTooHighMessage {
    const message = createBaseMeetingInvitationRequestTooHighMessage();
    return message;
  },
};

function createBaseMeetingInvitationRequestClosedMessage(): MeetingInvitationRequestClosedMessage {
  return {};
}

export const MeetingInvitationRequestClosedMessage: MessageFns<MeetingInvitationRequestClosedMessage> = {
  encode(_: MeetingInvitationRequestClosedMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeetingInvitationRequestClosedMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeetingInvitationRequestClosedMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MeetingInvitationRequestClosedMessage {
    return {};
  },

  toJSON(_: MeetingInvitationRequestClosedMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MeetingInvitationRequestClosedMessage>, I>>(
    base?: I,
  ): MeetingInvitationRequestClosedMessage {
    return MeetingInvitationRequestClosedMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MeetingInvitationRequestClosedMessage>, I>>(
    _: I,
  ): MeetingInvitationRequestClosedMessage {
    const message = createBaseMeetingInvitationRequestClosedMessage();
    return message;
  },
};

function createBaseMuteAudioPrivateMessage(): MuteAudioPrivateMessage {
  return { force: false };
}

export const MuteAudioPrivateMessage: MessageFns<MuteAudioPrivateMessage> = {
  encode(message: MuteAudioPrivateMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.force !== false) {
      writer.uint32(8).bool(message.force);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MuteAudioPrivateMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMuteAudioPrivateMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.force = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MuteAudioPrivateMessage {
    return { force: isSet(object.force) ? globalThis.Boolean(object.force) : false };
  },

  toJSON(message: MuteAudioPrivateMessage): unknown {
    const obj: any = {};
    if (message.force !== false) {
      obj.force = message.force;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MuteAudioPrivateMessage>, I>>(base?: I): MuteAudioPrivateMessage {
    return MuteAudioPrivateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MuteAudioPrivateMessage>, I>>(object: I): MuteAudioPrivateMessage {
    const message = createBaseMuteAudioPrivateMessage();
    message.force = object.force ?? false;
    return message;
  },
};

function createBaseMuteVideoPrivateMessage(): MuteVideoPrivateMessage {
  return { force: false };
}

export const MuteVideoPrivateMessage: MessageFns<MuteVideoPrivateMessage> = {
  encode(message: MuteVideoPrivateMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.force !== false) {
      writer.uint32(8).bool(message.force);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MuteVideoPrivateMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMuteVideoPrivateMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.force = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MuteVideoPrivateMessage {
    return { force: isSet(object.force) ? globalThis.Boolean(object.force) : false };
  },

  toJSON(message: MuteVideoPrivateMessage): unknown {
    const obj: any = {};
    if (message.force !== false) {
      obj.force = message.force;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MuteVideoPrivateMessage>, I>>(base?: I): MuteVideoPrivateMessage {
    return MuteVideoPrivateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MuteVideoPrivateMessage>, I>>(object: I): MuteVideoPrivateMessage {
    const message = createBaseMuteVideoPrivateMessage();
    message.force = object.force ?? false;
    return message;
  },
};

function createBaseMuteAudioForEverybodyPublicMessage(): MuteAudioForEverybodyPublicMessage {
  return {};
}

export const MuteAudioForEverybodyPublicMessage: MessageFns<MuteAudioForEverybodyPublicMessage> = {
  encode(_: MuteAudioForEverybodyPublicMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MuteAudioForEverybodyPublicMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMuteAudioForEverybodyPublicMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MuteAudioForEverybodyPublicMessage {
    return {};
  },

  toJSON(_: MuteAudioForEverybodyPublicMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MuteAudioForEverybodyPublicMessage>, I>>(
    base?: I,
  ): MuteAudioForEverybodyPublicMessage {
    return MuteAudioForEverybodyPublicMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MuteAudioForEverybodyPublicMessage>, I>>(
    _: I,
  ): MuteAudioForEverybodyPublicMessage {
    const message = createBaseMuteAudioForEverybodyPublicMessage();
    return message;
  },
};

function createBaseMuteVideoForEverybodyPublicMessage(): MuteVideoForEverybodyPublicMessage {
  return {};
}

export const MuteVideoForEverybodyPublicMessage: MessageFns<MuteVideoForEverybodyPublicMessage> = {
  encode(_: MuteVideoForEverybodyPublicMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MuteVideoForEverybodyPublicMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMuteVideoForEverybodyPublicMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MuteVideoForEverybodyPublicMessage {
    return {};
  },

  toJSON(_: MuteVideoForEverybodyPublicMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MuteVideoForEverybodyPublicMessage>, I>>(
    base?: I,
  ): MuteVideoForEverybodyPublicMessage {
    return MuteVideoForEverybodyPublicMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MuteVideoForEverybodyPublicMessage>, I>>(
    _: I,
  ): MuteVideoForEverybodyPublicMessage {
    const message = createBaseMuteVideoForEverybodyPublicMessage();
    return message;
  },
};

function createBaseKickOffUserPrivateMessage(): KickOffUserPrivateMessage {
  return {};
}

export const KickOffUserPrivateMessage: MessageFns<KickOffUserPrivateMessage> = {
  encode(_: KickOffUserPrivateMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KickOffUserPrivateMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKickOffUserPrivateMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): KickOffUserPrivateMessage {
    return {};
  },

  toJSON(_: KickOffUserPrivateMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<KickOffUserPrivateMessage>, I>>(base?: I): KickOffUserPrivateMessage {
    return KickOffUserPrivateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KickOffUserPrivateMessage>, I>>(_: I): KickOffUserPrivateMessage {
    const message = createBaseKickOffUserPrivateMessage();
    return message;
  },
};

function createBaseRecordingUnexpectedlyStoppedPrivateMessage(): RecordingUnexpectedlyStoppedPrivateMessage {
  return {};
}

export const RecordingUnexpectedlyStoppedPrivateMessage: MessageFns<RecordingUnexpectedlyStoppedPrivateMessage> = {
  encode(_: RecordingUnexpectedlyStoppedPrivateMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RecordingUnexpectedlyStoppedPrivateMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecordingUnexpectedlyStoppedPrivateMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RecordingUnexpectedlyStoppedPrivateMessage {
    return {};
  },

  toJSON(_: RecordingUnexpectedlyStoppedPrivateMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RecordingUnexpectedlyStoppedPrivateMessage>, I>>(
    base?: I,
  ): RecordingUnexpectedlyStoppedPrivateMessage {
    return RecordingUnexpectedlyStoppedPrivateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RecordingUnexpectedlyStoppedPrivateMessage>, I>>(
    _: I,
  ): RecordingUnexpectedlyStoppedPrivateMessage {
    const message = createBaseRecordingUnexpectedlyStoppedPrivateMessage();
    return message;
  },
};

function createBasePublicEventFrontToPusher(): PublicEventFrontToPusher {
  return { spaceName: "", spaceEvent: undefined };
}

export const PublicEventFrontToPusher: MessageFns<PublicEventFrontToPusher> = {
  encode(message: PublicEventFrontToPusher, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.spaceEvent !== undefined) {
      SpaceEvent.encode(message.spaceEvent, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PublicEventFrontToPusher {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePublicEventFrontToPusher();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spaceEvent = SpaceEvent.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PublicEventFrontToPusher {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      spaceEvent: isSet(object.spaceEvent) ? SpaceEvent.fromJSON(object.spaceEvent) : undefined,
    };
  },

  toJSON(message: PublicEventFrontToPusher): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.spaceEvent !== undefined) {
      obj.spaceEvent = SpaceEvent.toJSON(message.spaceEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PublicEventFrontToPusher>, I>>(base?: I): PublicEventFrontToPusher {
    return PublicEventFrontToPusher.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PublicEventFrontToPusher>, I>>(object: I): PublicEventFrontToPusher {
    const message = createBasePublicEventFrontToPusher();
    message.spaceName = object.spaceName ?? "";
    message.spaceEvent = (object.spaceEvent !== undefined && object.spaceEvent !== null)
      ? SpaceEvent.fromPartial(object.spaceEvent)
      : undefined;
    return message;
  },
};

function createBaseBackEventFrontToPusherMessage(): BackEventFrontToPusherMessage {
  return { spaceName: "", backEvent: undefined };
}

export const BackEventFrontToPusherMessage: MessageFns<BackEventFrontToPusherMessage> = {
  encode(message: BackEventFrontToPusherMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.backEvent !== undefined) {
      BackEvent.encode(message.backEvent, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BackEventFrontToPusherMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBackEventFrontToPusherMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.backEvent = BackEvent.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BackEventFrontToPusherMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      backEvent: isSet(object.backEvent) ? BackEvent.fromJSON(object.backEvent) : undefined,
    };
  },

  toJSON(message: BackEventFrontToPusherMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.backEvent !== undefined) {
      obj.backEvent = BackEvent.toJSON(message.backEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BackEventFrontToPusherMessage>, I>>(base?: I): BackEventFrontToPusherMessage {
    return BackEventFrontToPusherMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BackEventFrontToPusherMessage>, I>>(
    object: I,
  ): BackEventFrontToPusherMessage {
    const message = createBaseBackEventFrontToPusherMessage();
    message.spaceName = object.spaceName ?? "";
    message.backEvent = (object.backEvent !== undefined && object.backEvent !== null)
      ? BackEvent.fromPartial(object.backEvent)
      : undefined;
    return message;
  },
};

function createBasePublicEvent(): PublicEvent {
  return { spaceName: "", spaceEvent: undefined, senderUserId: "" };
}

export const PublicEvent: MessageFns<PublicEvent> = {
  encode(message: PublicEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.spaceEvent !== undefined) {
      SpaceEvent.encode(message.spaceEvent, writer.uint32(18).fork()).join();
    }
    if (message.senderUserId !== "") {
      writer.uint32(26).string(message.senderUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PublicEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePublicEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spaceEvent = SpaceEvent.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.senderUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PublicEvent {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      spaceEvent: isSet(object.spaceEvent) ? SpaceEvent.fromJSON(object.spaceEvent) : undefined,
      senderUserId: isSet(object.senderUserId) ? globalThis.String(object.senderUserId) : "",
    };
  },

  toJSON(message: PublicEvent): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.spaceEvent !== undefined) {
      obj.spaceEvent = SpaceEvent.toJSON(message.spaceEvent);
    }
    if (message.senderUserId !== "") {
      obj.senderUserId = message.senderUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PublicEvent>, I>>(base?: I): PublicEvent {
    return PublicEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PublicEvent>, I>>(object: I): PublicEvent {
    const message = createBasePublicEvent();
    message.spaceName = object.spaceName ?? "";
    message.spaceEvent = (object.spaceEvent !== undefined && object.spaceEvent !== null)
      ? SpaceEvent.fromPartial(object.spaceEvent)
      : undefined;
    message.senderUserId = object.senderUserId ?? "";
    return message;
  },
};

function createBaseSpaceEvent(): SpaceEvent {
  return { event: undefined };
}

export const SpaceEvent: MessageFns<SpaceEvent> = {
  encode(message: SpaceEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.event?.$case) {
      case "spaceMessage":
        SpaceMessage.encode(message.event.spaceMessage, writer.uint32(10).fork()).join();
        break;
      case "spaceIsTyping":
        SpaceIsTyping.encode(message.event.spaceIsTyping, writer.uint32(18).fork()).join();
        break;
      case "muteAudioForEverybody":
        MuteAudioForEverybodyPublicMessage.encode(message.event.muteAudioForEverybody, writer.uint32(26).fork()).join();
        break;
      case "muteVideoForEverybody":
        MuteVideoForEverybodyPublicMessage.encode(message.event.muteVideoForEverybody, writer.uint32(34).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.event = { $case: "spaceMessage", spaceMessage: SpaceMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.event = { $case: "spaceIsTyping", spaceIsTyping: SpaceIsTyping.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.event = {
            $case: "muteAudioForEverybody",
            muteAudioForEverybody: MuteAudioForEverybodyPublicMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.event = {
            $case: "muteVideoForEverybody",
            muteVideoForEverybody: MuteVideoForEverybodyPublicMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceEvent {
    return {
      event: isSet(object.spaceMessage)
        ? { $case: "spaceMessage", spaceMessage: SpaceMessage.fromJSON(object.spaceMessage) }
        : isSet(object.spaceIsTyping)
        ? { $case: "spaceIsTyping", spaceIsTyping: SpaceIsTyping.fromJSON(object.spaceIsTyping) }
        : isSet(object.muteAudioForEverybody)
        ? {
          $case: "muteAudioForEverybody",
          muteAudioForEverybody: MuteAudioForEverybodyPublicMessage.fromJSON(object.muteAudioForEverybody),
        }
        : isSet(object.muteVideoForEverybody)
        ? {
          $case: "muteVideoForEverybody",
          muteVideoForEverybody: MuteVideoForEverybodyPublicMessage.fromJSON(object.muteVideoForEverybody),
        }
        : undefined,
    };
  },

  toJSON(message: SpaceEvent): unknown {
    const obj: any = {};
    if (message.event?.$case === "spaceMessage") {
      obj.spaceMessage = SpaceMessage.toJSON(message.event.spaceMessage);
    } else if (message.event?.$case === "spaceIsTyping") {
      obj.spaceIsTyping = SpaceIsTyping.toJSON(message.event.spaceIsTyping);
    } else if (message.event?.$case === "muteAudioForEverybody") {
      obj.muteAudioForEverybody = MuteAudioForEverybodyPublicMessage.toJSON(message.event.muteAudioForEverybody);
    } else if (message.event?.$case === "muteVideoForEverybody") {
      obj.muteVideoForEverybody = MuteVideoForEverybodyPublicMessage.toJSON(message.event.muteVideoForEverybody);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceEvent>, I>>(base?: I): SpaceEvent {
    return SpaceEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceEvent>, I>>(object: I): SpaceEvent {
    const message = createBaseSpaceEvent();
    switch (object.event?.$case) {
      case "spaceMessage": {
        if (object.event?.spaceMessage !== undefined && object.event?.spaceMessage !== null) {
          message.event = { $case: "spaceMessage", spaceMessage: SpaceMessage.fromPartial(object.event.spaceMessage) };
        }
        break;
      }
      case "spaceIsTyping": {
        if (object.event?.spaceIsTyping !== undefined && object.event?.spaceIsTyping !== null) {
          message.event = {
            $case: "spaceIsTyping",
            spaceIsTyping: SpaceIsTyping.fromPartial(object.event.spaceIsTyping),
          };
        }
        break;
      }
      case "muteAudioForEverybody": {
        if (object.event?.muteAudioForEverybody !== undefined && object.event?.muteAudioForEverybody !== null) {
          message.event = {
            $case: "muteAudioForEverybody",
            muteAudioForEverybody: MuteAudioForEverybodyPublicMessage.fromPartial(object.event.muteAudioForEverybody),
          };
        }
        break;
      }
      case "muteVideoForEverybody": {
        if (object.event?.muteVideoForEverybody !== undefined && object.event?.muteVideoForEverybody !== null) {
          message.event = {
            $case: "muteVideoForEverybody",
            muteVideoForEverybody: MuteVideoForEverybodyPublicMessage.fromPartial(object.event.muteVideoForEverybody),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBasePrivateSpaceEvent(): PrivateSpaceEvent {
  return { event: undefined };
}

export const PrivateSpaceEvent: MessageFns<PrivateSpaceEvent> = {
  encode(message: PrivateSpaceEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.event?.$case) {
      case "muteVideo":
        MuteVideoPrivateMessage.encode(message.event.muteVideo, writer.uint32(10).fork()).join();
        break;
      case "muteAudio":
        MuteAudioPrivateMessage.encode(message.event.muteAudio, writer.uint32(18).fork()).join();
        break;
      case "kickOffUser":
        KickOffUserPrivateMessage.encode(message.event.kickOffUser, writer.uint32(26).fork()).join();
        break;
      case "webRtcStartMessage":
        WebRtcStartMessage.encode(message.event.webRtcStartMessage, writer.uint32(34).fork()).join();
        break;
      case "webRtcSignal":
        WebRtcSignal.encode(message.event.webRtcSignal, writer.uint32(50).fork()).join();
        break;
      case "webRtcScreenSharingSignal":
        WebRtcSignal.encode(message.event.webRtcScreenSharingSignal, writer.uint32(66).fork()).join();
        break;
      case "webRtcDisconnectMessage":
        WebRtcDisconnectMessage.encode(message.event.webRtcDisconnectMessage, writer.uint32(74).fork()).join();
        break;
      case "communicationStrategyMessage":
        CommunicationStrategyMessage.encode(message.event.communicationStrategyMessage, writer.uint32(82).fork())
          .join();
        break;
      case "switchMessage":
        SwitchMessage.encode(message.event.switchMessage, writer.uint32(90).fork()).join();
        break;
      case "finalizeSwitchMessage":
        FinalizeSwitchMessage.encode(message.event.finalizeSwitchMessage, writer.uint32(98).fork()).join();
        break;
      case "livekitInvitationMessage":
        LivekitInvitationMessage.encode(message.event.livekitInvitationMessage, writer.uint32(106).fork()).join();
        break;
      case "livekitDisconnectMessage":
        LivekitDisconnectMessage.encode(message.event.livekitDisconnectMessage, writer.uint32(114).fork()).join();
        break;
      case "addSpaceUserMessage":
        AddSpaceUserMessage.encode(message.event.addSpaceUserMessage, writer.uint32(130).fork()).join();
        break;
      case "updateSpaceUserMessage":
        UpdateSpaceUserMessage.encode(message.event.updateSpaceUserMessage, writer.uint32(138).fork()).join();
        break;
      case "removeSpaceUserMessage":
        RemoveSpaceUserMessage.encode(message.event.removeSpaceUserMessage, writer.uint32(146).fork()).join();
        break;
      case "blockUserMessage":
        BlockUserMessage.encode(message.event.blockUserMessage, writer.uint32(162).fork()).join();
        break;
      case "unblockUserMessage":
        UnblockUserMessage.encode(message.event.unblockUserMessage, writer.uint32(170).fork()).join();
        break;
      case "meetingConnectionRestartMessage":
        MeetingConnectionRestartMessage.encode(message.event.meetingConnectionRestartMessage, writer.uint32(178).fork())
          .join();
        break;
      case "recordingUnexpectedlyStoppedMessage":
        RecordingUnexpectedlyStoppedPrivateMessage.encode(
          message.event.recordingUnexpectedlyStoppedMessage,
          writer.uint32(186).fork(),
        ).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrivateSpaceEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrivateSpaceEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.event = { $case: "muteVideo", muteVideo: MuteVideoPrivateMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.event = { $case: "muteAudio", muteAudio: MuteAudioPrivateMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.event = {
            $case: "kickOffUser",
            kickOffUser: KickOffUserPrivateMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.event = {
            $case: "webRtcStartMessage",
            webRtcStartMessage: WebRtcStartMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.event = { $case: "webRtcSignal", webRtcSignal: WebRtcSignal.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.event = {
            $case: "webRtcScreenSharingSignal",
            webRtcScreenSharingSignal: WebRtcSignal.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.event = {
            $case: "webRtcDisconnectMessage",
            webRtcDisconnectMessage: WebRtcDisconnectMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.event = {
            $case: "communicationStrategyMessage",
            communicationStrategyMessage: CommunicationStrategyMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.event = { $case: "switchMessage", switchMessage: SwitchMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.event = {
            $case: "finalizeSwitchMessage",
            finalizeSwitchMessage: FinalizeSwitchMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.event = {
            $case: "livekitInvitationMessage",
            livekitInvitationMessage: LivekitInvitationMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.event = {
            $case: "livekitDisconnectMessage",
            livekitDisconnectMessage: LivekitDisconnectMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.event = {
            $case: "addSpaceUserMessage",
            addSpaceUserMessage: AddSpaceUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.event = {
            $case: "updateSpaceUserMessage",
            updateSpaceUserMessage: UpdateSpaceUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.event = {
            $case: "removeSpaceUserMessage",
            removeSpaceUserMessage: RemoveSpaceUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.event = {
            $case: "blockUserMessage",
            blockUserMessage: BlockUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.event = {
            $case: "unblockUserMessage",
            unblockUserMessage: UnblockUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.event = {
            $case: "meetingConnectionRestartMessage",
            meetingConnectionRestartMessage: MeetingConnectionRestartMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.event = {
            $case: "recordingUnexpectedlyStoppedMessage",
            recordingUnexpectedlyStoppedMessage: RecordingUnexpectedlyStoppedPrivateMessage.decode(
              reader,
              reader.uint32(),
            ),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrivateSpaceEvent {
    return {
      event: isSet(object.muteVideo)
        ? { $case: "muteVideo", muteVideo: MuteVideoPrivateMessage.fromJSON(object.muteVideo) }
        : isSet(object.muteAudio)
        ? { $case: "muteAudio", muteAudio: MuteAudioPrivateMessage.fromJSON(object.muteAudio) }
        : isSet(object.kickOffUser)
        ? { $case: "kickOffUser", kickOffUser: KickOffUserPrivateMessage.fromJSON(object.kickOffUser) }
        : isSet(object.webRtcStartMessage)
        ? { $case: "webRtcStartMessage", webRtcStartMessage: WebRtcStartMessage.fromJSON(object.webRtcStartMessage) }
        : isSet(object.webRtcSignal)
        ? { $case: "webRtcSignal", webRtcSignal: WebRtcSignal.fromJSON(object.webRtcSignal) }
        : isSet(object.webRtcScreenSharingSignal)
        ? {
          $case: "webRtcScreenSharingSignal",
          webRtcScreenSharingSignal: WebRtcSignal.fromJSON(object.webRtcScreenSharingSignal),
        }
        : isSet(object.webRtcDisconnectMessage)
        ? {
          $case: "webRtcDisconnectMessage",
          webRtcDisconnectMessage: WebRtcDisconnectMessage.fromJSON(object.webRtcDisconnectMessage),
        }
        : isSet(object.communicationStrategyMessage)
        ? {
          $case: "communicationStrategyMessage",
          communicationStrategyMessage: CommunicationStrategyMessage.fromJSON(object.communicationStrategyMessage),
        }
        : isSet(object.switchMessage)
        ? { $case: "switchMessage", switchMessage: SwitchMessage.fromJSON(object.switchMessage) }
        : isSet(object.finalizeSwitchMessage)
        ? {
          $case: "finalizeSwitchMessage",
          finalizeSwitchMessage: FinalizeSwitchMessage.fromJSON(object.finalizeSwitchMessage),
        }
        : isSet(object.livekitInvitationMessage)
        ? {
          $case: "livekitInvitationMessage",
          livekitInvitationMessage: LivekitInvitationMessage.fromJSON(object.livekitInvitationMessage),
        }
        : isSet(object.livekitDisconnectMessage)
        ? {
          $case: "livekitDisconnectMessage",
          livekitDisconnectMessage: LivekitDisconnectMessage.fromJSON(object.livekitDisconnectMessage),
        }
        : isSet(object.addSpaceUserMessage)
        ? {
          $case: "addSpaceUserMessage",
          addSpaceUserMessage: AddSpaceUserMessage.fromJSON(object.addSpaceUserMessage),
        }
        : isSet(object.updateSpaceUserMessage)
        ? {
          $case: "updateSpaceUserMessage",
          updateSpaceUserMessage: UpdateSpaceUserMessage.fromJSON(object.updateSpaceUserMessage),
        }
        : isSet(object.removeSpaceUserMessage)
        ? {
          $case: "removeSpaceUserMessage",
          removeSpaceUserMessage: RemoveSpaceUserMessage.fromJSON(object.removeSpaceUserMessage),
        }
        : isSet(object.blockUserMessage)
        ? { $case: "blockUserMessage", blockUserMessage: BlockUserMessage.fromJSON(object.blockUserMessage) }
        : isSet(object.unblockUserMessage)
        ? { $case: "unblockUserMessage", unblockUserMessage: UnblockUserMessage.fromJSON(object.unblockUserMessage) }
        : isSet(object.meetingConnectionRestartMessage)
        ? {
          $case: "meetingConnectionRestartMessage",
          meetingConnectionRestartMessage: MeetingConnectionRestartMessage.fromJSON(
            object.meetingConnectionRestartMessage,
          ),
        }
        : isSet(object.recordingUnexpectedlyStoppedMessage)
        ? {
          $case: "recordingUnexpectedlyStoppedMessage",
          recordingUnexpectedlyStoppedMessage: RecordingUnexpectedlyStoppedPrivateMessage.fromJSON(
            object.recordingUnexpectedlyStoppedMessage,
          ),
        }
        : undefined,
    };
  },

  toJSON(message: PrivateSpaceEvent): unknown {
    const obj: any = {};
    if (message.event?.$case === "muteVideo") {
      obj.muteVideo = MuteVideoPrivateMessage.toJSON(message.event.muteVideo);
    } else if (message.event?.$case === "muteAudio") {
      obj.muteAudio = MuteAudioPrivateMessage.toJSON(message.event.muteAudio);
    } else if (message.event?.$case === "kickOffUser") {
      obj.kickOffUser = KickOffUserPrivateMessage.toJSON(message.event.kickOffUser);
    } else if (message.event?.$case === "webRtcStartMessage") {
      obj.webRtcStartMessage = WebRtcStartMessage.toJSON(message.event.webRtcStartMessage);
    } else if (message.event?.$case === "webRtcSignal") {
      obj.webRtcSignal = WebRtcSignal.toJSON(message.event.webRtcSignal);
    } else if (message.event?.$case === "webRtcScreenSharingSignal") {
      obj.webRtcScreenSharingSignal = WebRtcSignal.toJSON(message.event.webRtcScreenSharingSignal);
    } else if (message.event?.$case === "webRtcDisconnectMessage") {
      obj.webRtcDisconnectMessage = WebRtcDisconnectMessage.toJSON(message.event.webRtcDisconnectMessage);
    } else if (message.event?.$case === "communicationStrategyMessage") {
      obj.communicationStrategyMessage = CommunicationStrategyMessage.toJSON(
        message.event.communicationStrategyMessage,
      );
    } else if (message.event?.$case === "switchMessage") {
      obj.switchMessage = SwitchMessage.toJSON(message.event.switchMessage);
    } else if (message.event?.$case === "finalizeSwitchMessage") {
      obj.finalizeSwitchMessage = FinalizeSwitchMessage.toJSON(message.event.finalizeSwitchMessage);
    } else if (message.event?.$case === "livekitInvitationMessage") {
      obj.livekitInvitationMessage = LivekitInvitationMessage.toJSON(message.event.livekitInvitationMessage);
    } else if (message.event?.$case === "livekitDisconnectMessage") {
      obj.livekitDisconnectMessage = LivekitDisconnectMessage.toJSON(message.event.livekitDisconnectMessage);
    } else if (message.event?.$case === "addSpaceUserMessage") {
      obj.addSpaceUserMessage = AddSpaceUserMessage.toJSON(message.event.addSpaceUserMessage);
    } else if (message.event?.$case === "updateSpaceUserMessage") {
      obj.updateSpaceUserMessage = UpdateSpaceUserMessage.toJSON(message.event.updateSpaceUserMessage);
    } else if (message.event?.$case === "removeSpaceUserMessage") {
      obj.removeSpaceUserMessage = RemoveSpaceUserMessage.toJSON(message.event.removeSpaceUserMessage);
    } else if (message.event?.$case === "blockUserMessage") {
      obj.blockUserMessage = BlockUserMessage.toJSON(message.event.blockUserMessage);
    } else if (message.event?.$case === "unblockUserMessage") {
      obj.unblockUserMessage = UnblockUserMessage.toJSON(message.event.unblockUserMessage);
    } else if (message.event?.$case === "meetingConnectionRestartMessage") {
      obj.meetingConnectionRestartMessage = MeetingConnectionRestartMessage.toJSON(
        message.event.meetingConnectionRestartMessage,
      );
    } else if (message.event?.$case === "recordingUnexpectedlyStoppedMessage") {
      obj.recordingUnexpectedlyStoppedMessage = RecordingUnexpectedlyStoppedPrivateMessage.toJSON(
        message.event.recordingUnexpectedlyStoppedMessage,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PrivateSpaceEvent>, I>>(base?: I): PrivateSpaceEvent {
    return PrivateSpaceEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrivateSpaceEvent>, I>>(object: I): PrivateSpaceEvent {
    const message = createBasePrivateSpaceEvent();
    switch (object.event?.$case) {
      case "muteVideo": {
        if (object.event?.muteVideo !== undefined && object.event?.muteVideo !== null) {
          message.event = {
            $case: "muteVideo",
            muteVideo: MuteVideoPrivateMessage.fromPartial(object.event.muteVideo),
          };
        }
        break;
      }
      case "muteAudio": {
        if (object.event?.muteAudio !== undefined && object.event?.muteAudio !== null) {
          message.event = {
            $case: "muteAudio",
            muteAudio: MuteAudioPrivateMessage.fromPartial(object.event.muteAudio),
          };
        }
        break;
      }
      case "kickOffUser": {
        if (object.event?.kickOffUser !== undefined && object.event?.kickOffUser !== null) {
          message.event = {
            $case: "kickOffUser",
            kickOffUser: KickOffUserPrivateMessage.fromPartial(object.event.kickOffUser),
          };
        }
        break;
      }
      case "webRtcStartMessage": {
        if (object.event?.webRtcStartMessage !== undefined && object.event?.webRtcStartMessage !== null) {
          message.event = {
            $case: "webRtcStartMessage",
            webRtcStartMessage: WebRtcStartMessage.fromPartial(object.event.webRtcStartMessage),
          };
        }
        break;
      }
      case "webRtcSignal": {
        if (object.event?.webRtcSignal !== undefined && object.event?.webRtcSignal !== null) {
          message.event = { $case: "webRtcSignal", webRtcSignal: WebRtcSignal.fromPartial(object.event.webRtcSignal) };
        }
        break;
      }
      case "webRtcScreenSharingSignal": {
        if (object.event?.webRtcScreenSharingSignal !== undefined && object.event?.webRtcScreenSharingSignal !== null) {
          message.event = {
            $case: "webRtcScreenSharingSignal",
            webRtcScreenSharingSignal: WebRtcSignal.fromPartial(object.event.webRtcScreenSharingSignal),
          };
        }
        break;
      }
      case "webRtcDisconnectMessage": {
        if (object.event?.webRtcDisconnectMessage !== undefined && object.event?.webRtcDisconnectMessage !== null) {
          message.event = {
            $case: "webRtcDisconnectMessage",
            webRtcDisconnectMessage: WebRtcDisconnectMessage.fromPartial(object.event.webRtcDisconnectMessage),
          };
        }
        break;
      }
      case "communicationStrategyMessage": {
        if (
          object.event?.communicationStrategyMessage !== undefined &&
          object.event?.communicationStrategyMessage !== null
        ) {
          message.event = {
            $case: "communicationStrategyMessage",
            communicationStrategyMessage: CommunicationStrategyMessage.fromPartial(
              object.event.communicationStrategyMessage,
            ),
          };
        }
        break;
      }
      case "switchMessage": {
        if (object.event?.switchMessage !== undefined && object.event?.switchMessage !== null) {
          message.event = {
            $case: "switchMessage",
            switchMessage: SwitchMessage.fromPartial(object.event.switchMessage),
          };
        }
        break;
      }
      case "finalizeSwitchMessage": {
        if (object.event?.finalizeSwitchMessage !== undefined && object.event?.finalizeSwitchMessage !== null) {
          message.event = {
            $case: "finalizeSwitchMessage",
            finalizeSwitchMessage: FinalizeSwitchMessage.fromPartial(object.event.finalizeSwitchMessage),
          };
        }
        break;
      }
      case "livekitInvitationMessage": {
        if (object.event?.livekitInvitationMessage !== undefined && object.event?.livekitInvitationMessage !== null) {
          message.event = {
            $case: "livekitInvitationMessage",
            livekitInvitationMessage: LivekitInvitationMessage.fromPartial(object.event.livekitInvitationMessage),
          };
        }
        break;
      }
      case "livekitDisconnectMessage": {
        if (object.event?.livekitDisconnectMessage !== undefined && object.event?.livekitDisconnectMessage !== null) {
          message.event = {
            $case: "livekitDisconnectMessage",
            livekitDisconnectMessage: LivekitDisconnectMessage.fromPartial(object.event.livekitDisconnectMessage),
          };
        }
        break;
      }
      case "addSpaceUserMessage": {
        if (object.event?.addSpaceUserMessage !== undefined && object.event?.addSpaceUserMessage !== null) {
          message.event = {
            $case: "addSpaceUserMessage",
            addSpaceUserMessage: AddSpaceUserMessage.fromPartial(object.event.addSpaceUserMessage),
          };
        }
        break;
      }
      case "updateSpaceUserMessage": {
        if (object.event?.updateSpaceUserMessage !== undefined && object.event?.updateSpaceUserMessage !== null) {
          message.event = {
            $case: "updateSpaceUserMessage",
            updateSpaceUserMessage: UpdateSpaceUserMessage.fromPartial(object.event.updateSpaceUserMessage),
          };
        }
        break;
      }
      case "removeSpaceUserMessage": {
        if (object.event?.removeSpaceUserMessage !== undefined && object.event?.removeSpaceUserMessage !== null) {
          message.event = {
            $case: "removeSpaceUserMessage",
            removeSpaceUserMessage: RemoveSpaceUserMessage.fromPartial(object.event.removeSpaceUserMessage),
          };
        }
        break;
      }
      case "blockUserMessage": {
        if (object.event?.blockUserMessage !== undefined && object.event?.blockUserMessage !== null) {
          message.event = {
            $case: "blockUserMessage",
            blockUserMessage: BlockUserMessage.fromPartial(object.event.blockUserMessage),
          };
        }
        break;
      }
      case "unblockUserMessage": {
        if (object.event?.unblockUserMessage !== undefined && object.event?.unblockUserMessage !== null) {
          message.event = {
            $case: "unblockUserMessage",
            unblockUserMessage: UnblockUserMessage.fromPartial(object.event.unblockUserMessage),
          };
        }
        break;
      }
      case "meetingConnectionRestartMessage": {
        if (
          object.event?.meetingConnectionRestartMessage !== undefined &&
          object.event?.meetingConnectionRestartMessage !== null
        ) {
          message.event = {
            $case: "meetingConnectionRestartMessage",
            meetingConnectionRestartMessage: MeetingConnectionRestartMessage.fromPartial(
              object.event.meetingConnectionRestartMessage,
            ),
          };
        }
        break;
      }
      case "recordingUnexpectedlyStoppedMessage": {
        if (
          object.event?.recordingUnexpectedlyStoppedMessage !== undefined &&
          object.event?.recordingUnexpectedlyStoppedMessage !== null
        ) {
          message.event = {
            $case: "recordingUnexpectedlyStoppedMessage",
            recordingUnexpectedlyStoppedMessage: RecordingUnexpectedlyStoppedPrivateMessage.fromPartial(
              object.event.recordingUnexpectedlyStoppedMessage,
            ),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseCommunicationStrategyMessage(): CommunicationStrategyMessage {
  return { strategy: "" };
}

export const CommunicationStrategyMessage: MessageFns<CommunicationStrategyMessage> = {
  encode(message: CommunicationStrategyMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.strategy !== "") {
      writer.uint32(10).string(message.strategy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommunicationStrategyMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommunicationStrategyMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.strategy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommunicationStrategyMessage {
    return { strategy: isSet(object.strategy) ? globalThis.String(object.strategy) : "" };
  },

  toJSON(message: CommunicationStrategyMessage): unknown {
    const obj: any = {};
    if (message.strategy !== "") {
      obj.strategy = message.strategy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommunicationStrategyMessage>, I>>(base?: I): CommunicationStrategyMessage {
    return CommunicationStrategyMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommunicationStrategyMessage>, I>>(object: I): CommunicationStrategyMessage {
    const message = createBaseCommunicationStrategyMessage();
    message.strategy = object.strategy ?? "";
    return message;
  },
};

function createBaseSwitchMessage(): SwitchMessage {
  return { strategy: "" };
}

export const SwitchMessage: MessageFns<SwitchMessage> = {
  encode(message: SwitchMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.strategy !== "") {
      writer.uint32(10).string(message.strategy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SwitchMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.strategy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchMessage {
    return { strategy: isSet(object.strategy) ? globalThis.String(object.strategy) : "" };
  },

  toJSON(message: SwitchMessage): unknown {
    const obj: any = {};
    if (message.strategy !== "") {
      obj.strategy = message.strategy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchMessage>, I>>(base?: I): SwitchMessage {
    return SwitchMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchMessage>, I>>(object: I): SwitchMessage {
    const message = createBaseSwitchMessage();
    message.strategy = object.strategy ?? "";
    return message;
  },
};

function createBaseFinalizeSwitchMessage(): FinalizeSwitchMessage {
  return { strategy: "" };
}

export const FinalizeSwitchMessage: MessageFns<FinalizeSwitchMessage> = {
  encode(message: FinalizeSwitchMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.strategy !== "") {
      writer.uint32(10).string(message.strategy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FinalizeSwitchMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFinalizeSwitchMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.strategy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FinalizeSwitchMessage {
    return { strategy: isSet(object.strategy) ? globalThis.String(object.strategy) : "" };
  },

  toJSON(message: FinalizeSwitchMessage): unknown {
    const obj: any = {};
    if (message.strategy !== "") {
      obj.strategy = message.strategy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FinalizeSwitchMessage>, I>>(base?: I): FinalizeSwitchMessage {
    return FinalizeSwitchMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FinalizeSwitchMessage>, I>>(object: I): FinalizeSwitchMessage {
    const message = createBaseFinalizeSwitchMessage();
    message.strategy = object.strategy ?? "";
    return message;
  },
};

function createBaseBlockUserMessage(): BlockUserMessage {
  return {};
}

export const BlockUserMessage: MessageFns<BlockUserMessage> = {
  encode(_: BlockUserMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BlockUserMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlockUserMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): BlockUserMessage {
    return {};
  },

  toJSON(_: BlockUserMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<BlockUserMessage>, I>>(base?: I): BlockUserMessage {
    return BlockUserMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BlockUserMessage>, I>>(_: I): BlockUserMessage {
    const message = createBaseBlockUserMessage();
    return message;
  },
};

function createBaseUnblockUserMessage(): UnblockUserMessage {
  return {};
}

export const UnblockUserMessage: MessageFns<UnblockUserMessage> = {
  encode(_: UnblockUserMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnblockUserMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnblockUserMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UnblockUserMessage {
    return {};
  },

  toJSON(_: UnblockUserMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UnblockUserMessage>, I>>(base?: I): UnblockUserMessage {
    return UnblockUserMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnblockUserMessage>, I>>(_: I): UnblockUserMessage {
    const message = createBaseUnblockUserMessage();
    return message;
  },
};

function createBaseLivekitInvitationMessage(): LivekitInvitationMessage {
  return { token: "", serverUrl: "" };
}

export const LivekitInvitationMessage: MessageFns<LivekitInvitationMessage> = {
  encode(message: LivekitInvitationMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.serverUrl !== "") {
      writer.uint32(18).string(message.serverUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LivekitInvitationMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLivekitInvitationMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.token = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serverUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LivekitInvitationMessage {
    return {
      token: isSet(object.token) ? globalThis.String(object.token) : "",
      serverUrl: isSet(object.serverUrl) ? globalThis.String(object.serverUrl) : "",
    };
  },

  toJSON(message: LivekitInvitationMessage): unknown {
    const obj: any = {};
    if (message.token !== "") {
      obj.token = message.token;
    }
    if (message.serverUrl !== "") {
      obj.serverUrl = message.serverUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LivekitInvitationMessage>, I>>(base?: I): LivekitInvitationMessage {
    return LivekitInvitationMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LivekitInvitationMessage>, I>>(object: I): LivekitInvitationMessage {
    const message = createBaseLivekitInvitationMessage();
    message.token = object.token ?? "";
    message.serverUrl = object.serverUrl ?? "";
    return message;
  },
};

function createBaseLivekitDisconnectMessage(): LivekitDisconnectMessage {
  return {};
}

export const LivekitDisconnectMessage: MessageFns<LivekitDisconnectMessage> = {
  encode(_: LivekitDisconnectMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LivekitDisconnectMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLivekitDisconnectMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): LivekitDisconnectMessage {
    return {};
  },

  toJSON(_: LivekitDisconnectMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<LivekitDisconnectMessage>, I>>(base?: I): LivekitDisconnectMessage {
    return LivekitDisconnectMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LivekitDisconnectMessage>, I>>(_: I): LivekitDisconnectMessage {
    const message = createBaseLivekitDisconnectMessage();
    return message;
  },
};

function createBaseSpaceMessage(): SpaceMessage {
  return { message: "", characterTextures: [], name: undefined };
}

export const SpaceMessage: MessageFns<SpaceMessage> = {
  encode(message: SpaceMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    for (const v of message.characterTextures) {
      CharacterTextureMessage.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.name !== undefined) {
      writer.uint32(26).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.characterTextures.push(CharacterTextureMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceMessage {
    return {
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      characterTextures: globalThis.Array.isArray(object?.characterTextures)
        ? object.characterTextures.map((e: any) => CharacterTextureMessage.fromJSON(e))
        : [],
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
    };
  },

  toJSON(message: SpaceMessage): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.characterTextures?.length) {
      obj.characterTextures = message.characterTextures.map((e) => CharacterTextureMessage.toJSON(e));
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceMessage>, I>>(base?: I): SpaceMessage {
    return SpaceMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceMessage>, I>>(object: I): SpaceMessage {
    const message = createBaseSpaceMessage();
    message.message = object.message ?? "";
    message.characterTextures = object.characterTextures?.map((e) => CharacterTextureMessage.fromPartial(e)) || [];
    message.name = object.name ?? undefined;
    return message;
  },
};

function createBaseSpaceIsTyping(): SpaceIsTyping {
  return { isTyping: false, characterTextures: [], name: undefined };
}

export const SpaceIsTyping: MessageFns<SpaceIsTyping> = {
  encode(message: SpaceIsTyping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isTyping !== false) {
      writer.uint32(8).bool(message.isTyping);
    }
    for (const v of message.characterTextures) {
      CharacterTextureMessage.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.name !== undefined) {
      writer.uint32(26).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceIsTyping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceIsTyping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isTyping = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.characterTextures.push(CharacterTextureMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceIsTyping {
    return {
      isTyping: isSet(object.isTyping) ? globalThis.Boolean(object.isTyping) : false,
      characterTextures: globalThis.Array.isArray(object?.characterTextures)
        ? object.characterTextures.map((e: any) => CharacterTextureMessage.fromJSON(e))
        : [],
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
    };
  },

  toJSON(message: SpaceIsTyping): unknown {
    const obj: any = {};
    if (message.isTyping !== false) {
      obj.isTyping = message.isTyping;
    }
    if (message.characterTextures?.length) {
      obj.characterTextures = message.characterTextures.map((e) => CharacterTextureMessage.toJSON(e));
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceIsTyping>, I>>(base?: I): SpaceIsTyping {
    return SpaceIsTyping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceIsTyping>, I>>(object: I): SpaceIsTyping {
    const message = createBaseSpaceIsTyping();
    message.isTyping = object.isTyping ?? false;
    message.characterTextures = object.characterTextures?.map((e) => CharacterTextureMessage.fromPartial(e)) || [];
    message.name = object.name ?? undefined;
    return message;
  },
};

function createBaseBackEventMessage(): BackEventMessage {
  return { spaceName: "", senderUserId: "", backEvent: undefined };
}

export const BackEventMessage: MessageFns<BackEventMessage> = {
  encode(message: BackEventMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.senderUserId !== "") {
      writer.uint32(26).string(message.senderUserId);
    }
    if (message.backEvent !== undefined) {
      BackEvent.encode(message.backEvent, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BackEventMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBackEventMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.senderUserId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.backEvent = BackEvent.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BackEventMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      senderUserId: isSet(object.senderUserId) ? globalThis.String(object.senderUserId) : "",
      backEvent: isSet(object.backEvent) ? BackEvent.fromJSON(object.backEvent) : undefined,
    };
  },

  toJSON(message: BackEventMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.senderUserId !== "") {
      obj.senderUserId = message.senderUserId;
    }
    if (message.backEvent !== undefined) {
      obj.backEvent = BackEvent.toJSON(message.backEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BackEventMessage>, I>>(base?: I): BackEventMessage {
    return BackEventMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BackEventMessage>, I>>(object: I): BackEventMessage {
    const message = createBaseBackEventMessage();
    message.spaceName = object.spaceName ?? "";
    message.senderUserId = object.senderUserId ?? "";
    message.backEvent = (object.backEvent !== undefined && object.backEvent !== null)
      ? BackEvent.fromPartial(object.backEvent)
      : undefined;
    return message;
  },
};

function createBaseBackEvent(): BackEvent {
  return { event: undefined };
}

export const BackEvent: MessageFns<BackEvent> = {
  encode(message: BackEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.event?.$case) {
      case "meetingConnectionRestartMessage":
        MeetingConnectionRestartMessage.encode(message.event.meetingConnectionRestartMessage, writer.uint32(18).fork())
          .join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BackEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBackEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.event = {
            $case: "meetingConnectionRestartMessage",
            meetingConnectionRestartMessage: MeetingConnectionRestartMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BackEvent {
    return {
      event: isSet(object.meetingConnectionRestartMessage)
        ? {
          $case: "meetingConnectionRestartMessage",
          meetingConnectionRestartMessage: MeetingConnectionRestartMessage.fromJSON(
            object.meetingConnectionRestartMessage,
          ),
        }
        : undefined,
    };
  },

  toJSON(message: BackEvent): unknown {
    const obj: any = {};
    if (message.event?.$case === "meetingConnectionRestartMessage") {
      obj.meetingConnectionRestartMessage = MeetingConnectionRestartMessage.toJSON(
        message.event.meetingConnectionRestartMessage,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BackEvent>, I>>(base?: I): BackEvent {
    return BackEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BackEvent>, I>>(object: I): BackEvent {
    const message = createBaseBackEvent();
    switch (object.event?.$case) {
      case "meetingConnectionRestartMessage": {
        if (
          object.event?.meetingConnectionRestartMessage !== undefined &&
          object.event?.meetingConnectionRestartMessage !== null
        ) {
          message.event = {
            $case: "meetingConnectionRestartMessage",
            meetingConnectionRestartMessage: MeetingConnectionRestartMessage.fromPartial(
              object.event.meetingConnectionRestartMessage,
            ),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBasePrivateEvent(): PrivateEvent {
  return { spaceName: "", receiverUserId: "", senderUserId: "", spaceEvent: undefined };
}

export const PrivateEvent: MessageFns<PrivateEvent> = {
  encode(message: PrivateEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.receiverUserId !== "") {
      writer.uint32(18).string(message.receiverUserId);
    }
    if (message.senderUserId !== "") {
      writer.uint32(26).string(message.senderUserId);
    }
    if (message.spaceEvent !== undefined) {
      PrivateSpaceEvent.encode(message.spaceEvent, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrivateEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrivateEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.receiverUserId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.senderUserId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.spaceEvent = PrivateSpaceEvent.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrivateEvent {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      receiverUserId: isSet(object.receiverUserId) ? globalThis.String(object.receiverUserId) : "",
      senderUserId: isSet(object.senderUserId) ? globalThis.String(object.senderUserId) : "",
      spaceEvent: isSet(object.spaceEvent) ? PrivateSpaceEvent.fromJSON(object.spaceEvent) : undefined,
    };
  },

  toJSON(message: PrivateEvent): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.receiverUserId !== "") {
      obj.receiverUserId = message.receiverUserId;
    }
    if (message.senderUserId !== "") {
      obj.senderUserId = message.senderUserId;
    }
    if (message.spaceEvent !== undefined) {
      obj.spaceEvent = PrivateSpaceEvent.toJSON(message.spaceEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PrivateEvent>, I>>(base?: I): PrivateEvent {
    return PrivateEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrivateEvent>, I>>(object: I): PrivateEvent {
    const message = createBasePrivateEvent();
    message.spaceName = object.spaceName ?? "";
    message.receiverUserId = object.receiverUserId ?? "";
    message.senderUserId = object.senderUserId ?? "";
    message.spaceEvent = (object.spaceEvent !== undefined && object.spaceEvent !== null)
      ? PrivateSpaceEvent.fromPartial(object.spaceEvent)
      : undefined;
    return message;
  },
};

function createBasePrivateEventBackToPusher(): PrivateEventBackToPusher {
  return { spaceName: "", receiverUserId: "", sender: undefined, spaceEvent: undefined };
}

export const PrivateEventBackToPusher: MessageFns<PrivateEventBackToPusher> = {
  encode(message: PrivateEventBackToPusher, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.receiverUserId !== "") {
      writer.uint32(18).string(message.receiverUserId);
    }
    if (message.sender !== undefined) {
      SpaceUser.encode(message.sender, writer.uint32(26).fork()).join();
    }
    if (message.spaceEvent !== undefined) {
      PrivateSpaceEvent.encode(message.spaceEvent, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrivateEventBackToPusher {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrivateEventBackToPusher();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.receiverUserId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sender = SpaceUser.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.spaceEvent = PrivateSpaceEvent.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrivateEventBackToPusher {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      receiverUserId: isSet(object.receiverUserId) ? globalThis.String(object.receiverUserId) : "",
      sender: isSet(object.sender) ? SpaceUser.fromJSON(object.sender) : undefined,
      spaceEvent: isSet(object.spaceEvent) ? PrivateSpaceEvent.fromJSON(object.spaceEvent) : undefined,
    };
  },

  toJSON(message: PrivateEventBackToPusher): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.receiverUserId !== "") {
      obj.receiverUserId = message.receiverUserId;
    }
    if (message.sender !== undefined) {
      obj.sender = SpaceUser.toJSON(message.sender);
    }
    if (message.spaceEvent !== undefined) {
      obj.spaceEvent = PrivateSpaceEvent.toJSON(message.spaceEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PrivateEventBackToPusher>, I>>(base?: I): PrivateEventBackToPusher {
    return PrivateEventBackToPusher.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrivateEventBackToPusher>, I>>(object: I): PrivateEventBackToPusher {
    const message = createBasePrivateEventBackToPusher();
    message.spaceName = object.spaceName ?? "";
    message.receiverUserId = object.receiverUserId ?? "";
    message.sender = (object.sender !== undefined && object.sender !== null)
      ? SpaceUser.fromPartial(object.sender)
      : undefined;
    message.spaceEvent = (object.spaceEvent !== undefined && object.spaceEvent !== null)
      ? PrivateSpaceEvent.fromPartial(object.spaceEvent)
      : undefined;
    return message;
  },
};

function createBasePrivateEventPusherToFront(): PrivateEventPusherToFront {
  return { spaceName: "", receiverUserId: "", sender: undefined, spaceEvent: undefined };
}

export const PrivateEventPusherToFront: MessageFns<PrivateEventPusherToFront> = {
  encode(message: PrivateEventPusherToFront, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.receiverUserId !== "") {
      writer.uint32(18).string(message.receiverUserId);
    }
    if (message.sender !== undefined) {
      SpaceUser.encode(message.sender, writer.uint32(26).fork()).join();
    }
    if (message.spaceEvent !== undefined) {
      PrivateSpaceEvent.encode(message.spaceEvent, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrivateEventPusherToFront {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrivateEventPusherToFront();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.receiverUserId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sender = SpaceUser.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.spaceEvent = PrivateSpaceEvent.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrivateEventPusherToFront {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      receiverUserId: isSet(object.receiverUserId) ? globalThis.String(object.receiverUserId) : "",
      sender: isSet(object.sender) ? SpaceUser.fromJSON(object.sender) : undefined,
      spaceEvent: isSet(object.spaceEvent) ? PrivateSpaceEvent.fromJSON(object.spaceEvent) : undefined,
    };
  },

  toJSON(message: PrivateEventPusherToFront): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.receiverUserId !== "") {
      obj.receiverUserId = message.receiverUserId;
    }
    if (message.sender !== undefined) {
      obj.sender = SpaceUser.toJSON(message.sender);
    }
    if (message.spaceEvent !== undefined) {
      obj.spaceEvent = PrivateSpaceEvent.toJSON(message.spaceEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PrivateEventPusherToFront>, I>>(base?: I): PrivateEventPusherToFront {
    return PrivateEventPusherToFront.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrivateEventPusherToFront>, I>>(object: I): PrivateEventPusherToFront {
    const message = createBasePrivateEventPusherToFront();
    message.spaceName = object.spaceName ?? "";
    message.receiverUserId = object.receiverUserId ?? "";
    message.sender = (object.sender !== undefined && object.sender !== null)
      ? SpaceUser.fromPartial(object.sender)
      : undefined;
    message.spaceEvent = (object.spaceEvent !== undefined && object.spaceEvent !== null)
      ? PrivateSpaceEvent.fromPartial(object.spaceEvent)
      : undefined;
    return message;
  },
};

function createBasePrivateEventFrontToPusher(): PrivateEventFrontToPusher {
  return { spaceName: "", receiverUserId: "", spaceEvent: undefined };
}

export const PrivateEventFrontToPusher: MessageFns<PrivateEventFrontToPusher> = {
  encode(message: PrivateEventFrontToPusher, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.receiverUserId !== "") {
      writer.uint32(18).string(message.receiverUserId);
    }
    if (message.spaceEvent !== undefined) {
      PrivateSpaceEvent.encode(message.spaceEvent, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrivateEventFrontToPusher {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrivateEventFrontToPusher();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.receiverUserId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.spaceEvent = PrivateSpaceEvent.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrivateEventFrontToPusher {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      receiverUserId: isSet(object.receiverUserId) ? globalThis.String(object.receiverUserId) : "",
      spaceEvent: isSet(object.spaceEvent) ? PrivateSpaceEvent.fromJSON(object.spaceEvent) : undefined,
    };
  },

  toJSON(message: PrivateEventFrontToPusher): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.receiverUserId !== "") {
      obj.receiverUserId = message.receiverUserId;
    }
    if (message.spaceEvent !== undefined) {
      obj.spaceEvent = PrivateSpaceEvent.toJSON(message.spaceEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PrivateEventFrontToPusher>, I>>(base?: I): PrivateEventFrontToPusher {
    return PrivateEventFrontToPusher.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrivateEventFrontToPusher>, I>>(object: I): PrivateEventFrontToPusher {
    const message = createBasePrivateEventFrontToPusher();
    message.spaceName = object.spaceName ?? "";
    message.receiverUserId = object.receiverUserId ?? "";
    message.spaceEvent = (object.spaceEvent !== undefined && object.spaceEvent !== null)
      ? PrivateSpaceEvent.fromPartial(object.spaceEvent)
      : undefined;
    return message;
  },
};

function createBaseJoinSpaceRequestMessage(): JoinSpaceRequestMessage {
  return { spaceName: "", propertiesToSync: [] };
}

export const JoinSpaceRequestMessage: MessageFns<JoinSpaceRequestMessage> = {
  encode(message: JoinSpaceRequestMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    for (const v of message.propertiesToSync) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JoinSpaceRequestMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinSpaceRequestMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.propertiesToSync.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JoinSpaceRequestMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      propertiesToSync: globalThis.Array.isArray(object?.propertiesToSync)
        ? object.propertiesToSync.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: JoinSpaceRequestMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.propertiesToSync?.length) {
      obj.propertiesToSync = message.propertiesToSync;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JoinSpaceRequestMessage>, I>>(base?: I): JoinSpaceRequestMessage {
    return JoinSpaceRequestMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoinSpaceRequestMessage>, I>>(object: I): JoinSpaceRequestMessage {
    const message = createBaseJoinSpaceRequestMessage();
    message.spaceName = object.spaceName ?? "";
    message.propertiesToSync = object.propertiesToSync?.map((e) => e) || [];
    return message;
  },
};

function createBaseLeaveSpaceRequestMessage(): LeaveSpaceRequestMessage {
  return { spaceName: "" };
}

export const LeaveSpaceRequestMessage: MessageFns<LeaveSpaceRequestMessage> = {
  encode(message: LeaveSpaceRequestMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LeaveSpaceRequestMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeaveSpaceRequestMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LeaveSpaceRequestMessage {
    return { spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "" };
  },

  toJSON(message: LeaveSpaceRequestMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LeaveSpaceRequestMessage>, I>>(base?: I): LeaveSpaceRequestMessage {
    return LeaveSpaceRequestMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LeaveSpaceRequestMessage>, I>>(object: I): LeaveSpaceRequestMessage {
    const message = createBaseLeaveSpaceRequestMessage();
    message.spaceName = object.spaceName ?? "";
    return message;
  },
};

function createBaseDuplicateUserConnectedMessage(): DuplicateUserConnectedMessage {
  return {};
}

export const DuplicateUserConnectedMessage: MessageFns<DuplicateUserConnectedMessage> = {
  encode(_: DuplicateUserConnectedMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DuplicateUserConnectedMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDuplicateUserConnectedMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DuplicateUserConnectedMessage {
    return {};
  },

  toJSON(_: DuplicateUserConnectedMessage): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DuplicateUserConnectedMessage>, I>>(base?: I): DuplicateUserConnectedMessage {
    return DuplicateUserConnectedMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DuplicateUserConnectedMessage>, I>>(_: I): DuplicateUserConnectedMessage {
    const message = createBaseDuplicateUserConnectedMessage();
    return message;
  },
};

function createBaseBackConnectionCloseReasonMessage(): BackConnectionCloseReasonMessage {
  return { reason: "" };
}

export const BackConnectionCloseReasonMessage: MessageFns<BackConnectionCloseReasonMessage> = {
  encode(message: BackConnectionCloseReasonMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reason !== "") {
      writer.uint32(10).string(message.reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BackConnectionCloseReasonMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBackConnectionCloseReasonMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BackConnectionCloseReasonMessage {
    return { reason: isSet(object.reason) ? globalThis.String(object.reason) : "" };
  },

  toJSON(message: BackConnectionCloseReasonMessage): unknown {
    const obj: any = {};
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BackConnectionCloseReasonMessage>, I>>(
    base?: I,
  ): BackConnectionCloseReasonMessage {
    return BackConnectionCloseReasonMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BackConnectionCloseReasonMessage>, I>>(
    object: I,
  ): BackConnectionCloseReasonMessage {
    const message = createBaseBackConnectionCloseReasonMessage();
    message.reason = object.reason ?? "";
    return message;
  },
};

function createBaseServerToClientMessage(): ServerToClientMessage {
  return { message: undefined };
}

export const ServerToClientMessage: MessageFns<ServerToClientMessage> = {
  encode(message: ServerToClientMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "batchMessage":
        BatchMessage.encode(message.message.batchMessage, writer.uint32(10).fork()).join();
        break;
      case "errorMessage":
        ErrorMessage.encode(message.message.errorMessage, writer.uint32(18).fork()).join();
        break;
      case "roomConnectedMessage":
        RoomConnectedMessage.encode(message.message.roomConnectedMessage, writer.uint32(26).fork()).join();
        break;
      case "roomJoinedMessage":
        RoomJoinedMessage.encode(message.message.roomJoinedMessage, writer.uint32(34).fork()).join();
        break;
      case "teleportMessageMessage":
        TeleportMessageMessage.encode(message.message.teleportMessageMessage, writer.uint32(82).fork()).join();
        break;
      case "sendUserMessage":
        SendUserMessage.encode(message.message.sendUserMessage, writer.uint32(98).fork()).join();
        break;
      case "banUserMessage":
        BanUserMessage.encode(message.message.banUserMessage, writer.uint32(106).fork()).join();
        break;
      case "worldFullWarningMessage":
        WorldFullWarningMessage.encode(message.message.worldFullWarningMessage, writer.uint32(122).fork()).join();
        break;
      case "refreshRoomMessage":
        RefreshRoomMessage.encode(message.message.refreshRoomMessage, writer.uint32(138).fork()).join();
        break;
      case "worldConnectionMessage":
        WorldConnectionMessage.encode(message.message.worldConnectionMessage, writer.uint32(146).fork()).join();
        break;
      case "tokenExpiredMessage":
        TokenExpiredMessage.encode(message.message.tokenExpiredMessage, writer.uint32(162).fork()).join();
        break;
      case "followRequestMessage":
        FollowRequestMessage.encode(message.message.followRequestMessage, writer.uint32(170).fork()).join();
        break;
      case "followConfirmationMessage":
        FollowConfirmationMessage.encode(message.message.followConfirmationMessage, writer.uint32(178).fork()).join();
        break;
      case "followAbortMessage":
        FollowAbortMessage.encode(message.message.followAbortMessage, writer.uint32(186).fork()).join();
        break;
      case "invalidCharacterTextureMessage":
        InvalidCharacterTextureMessage.encode(message.message.invalidCharacterTextureMessage, writer.uint32(194).fork())
          .join();
        break;
      case "deleteMapMessage":
        DeleteMapMessage.encode(message.message.deleteMapMessage, writer.uint32(202).fork()).join();
        break;
      case "errorScreenMessage":
        ErrorScreenMessage.encode(message.message.errorScreenMessage, writer.uint32(210).fork()).join();
        break;
      case "answerMessage":
        AnswerMessage.encode(message.message.answerMessage, writer.uint32(226).fork()).join();
        break;
      case "moveToPositionMessage":
        MoveToPositionMessage.encode(message.message.moveToPositionMessage, writer.uint32(250).fork()).join();
        break;
      case "invalidCompanionTextureMessage":
        InvalidCompanionTextureMessage.encode(message.message.invalidCompanionTextureMessage, writer.uint32(258).fork())
          .join();
        break;
      case "joinSpaceRequestMessage":
        JoinSpaceRequestMessage.encode(message.message.joinSpaceRequestMessage, writer.uint32(266).fork()).join();
        break;
      case "leaveSpaceRequestMessage":
        LeaveSpaceRequestMessage.encode(message.message.leaveSpaceRequestMessage, writer.uint32(274).fork()).join();
        break;
      case "externalModuleMessage":
        ExternalModuleMessage.encode(message.message.externalModuleMessage, writer.uint32(282).fork()).join();
        break;
      case "locatePositionMessage":
        LocatePositionMessage.encode(message.message.locatePositionMessage, writer.uint32(290).fork()).join();
        break;
      case "meetingInvitationRequestReceivedMessage":
        MeetingInvitationRequestReceivedMessage.encode(
          message.message.meetingInvitationRequestReceivedMessage,
          writer.uint32(298).fork(),
        ).join();
        break;
      case "meetingInvitationResponseReceivedMessage":
        MeetingInvitationResponseReceivedMessage.encode(
          message.message.meetingInvitationResponseReceivedMessage,
          writer.uint32(306).fork(),
        ).join();
        break;
      case "meetingInvitationRequestTooHighMessage":
        MeetingInvitationRequestTooHighMessage.encode(
          message.message.meetingInvitationRequestTooHighMessage,
          writer.uint32(314).fork(),
        ).join();
        break;
      case "meetingInvitationRequestClosedMessage":
        MeetingInvitationRequestClosedMessage.encode(
          message.message.meetingInvitationRequestClosedMessage,
          writer.uint32(322).fork(),
        ).join();
        break;
      case "duplicateUserConnectedMessage":
        DuplicateUserConnectedMessage.encode(message.message.duplicateUserConnectedMessage, writer.uint32(330).fork())
          .join();
        break;
      case "backConnectionCloseReasonMessage":
        BackConnectionCloseReasonMessage.encode(
          message.message.backConnectionCloseReasonMessage,
          writer.uint32(338).fork(),
        ).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerToClientMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerToClientMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = { $case: "batchMessage", batchMessage: BatchMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = { $case: "errorMessage", errorMessage: ErrorMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = {
            $case: "roomConnectedMessage",
            roomConnectedMessage: RoomConnectedMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = {
            $case: "roomJoinedMessage",
            roomJoinedMessage: RoomJoinedMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.message = {
            $case: "teleportMessageMessage",
            teleportMessageMessage: TeleportMessageMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.message = {
            $case: "sendUserMessage",
            sendUserMessage: SendUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.message = { $case: "banUserMessage", banUserMessage: BanUserMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.message = {
            $case: "worldFullWarningMessage",
            worldFullWarningMessage: WorldFullWarningMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.message = {
            $case: "refreshRoomMessage",
            refreshRoomMessage: RefreshRoomMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.message = {
            $case: "worldConnectionMessage",
            worldConnectionMessage: WorldConnectionMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.message = {
            $case: "tokenExpiredMessage",
            tokenExpiredMessage: TokenExpiredMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.message = {
            $case: "followRequestMessage",
            followRequestMessage: FollowRequestMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.message = {
            $case: "followConfirmationMessage",
            followConfirmationMessage: FollowConfirmationMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.message = {
            $case: "followAbortMessage",
            followAbortMessage: FollowAbortMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.message = {
            $case: "invalidCharacterTextureMessage",
            invalidCharacterTextureMessage: InvalidCharacterTextureMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.message = {
            $case: "deleteMapMessage",
            deleteMapMessage: DeleteMapMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.message = {
            $case: "errorScreenMessage",
            errorScreenMessage: ErrorScreenMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.message = { $case: "answerMessage", answerMessage: AnswerMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.message = {
            $case: "moveToPositionMessage",
            moveToPositionMessage: MoveToPositionMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.message = {
            $case: "invalidCompanionTextureMessage",
            invalidCompanionTextureMessage: InvalidCompanionTextureMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.message = {
            $case: "joinSpaceRequestMessage",
            joinSpaceRequestMessage: JoinSpaceRequestMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.message = {
            $case: "leaveSpaceRequestMessage",
            leaveSpaceRequestMessage: LeaveSpaceRequestMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.message = {
            $case: "externalModuleMessage",
            externalModuleMessage: ExternalModuleMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.message = {
            $case: "locatePositionMessage",
            locatePositionMessage: LocatePositionMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.message = {
            $case: "meetingInvitationRequestReceivedMessage",
            meetingInvitationRequestReceivedMessage: MeetingInvitationRequestReceivedMessage.decode(
              reader,
              reader.uint32(),
            ),
          };
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.message = {
            $case: "meetingInvitationResponseReceivedMessage",
            meetingInvitationResponseReceivedMessage: MeetingInvitationResponseReceivedMessage.decode(
              reader,
              reader.uint32(),
            ),
          };
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.message = {
            $case: "meetingInvitationRequestTooHighMessage",
            meetingInvitationRequestTooHighMessage: MeetingInvitationRequestTooHighMessage.decode(
              reader,
              reader.uint32(),
            ),
          };
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.message = {
            $case: "meetingInvitationRequestClosedMessage",
            meetingInvitationRequestClosedMessage: MeetingInvitationRequestClosedMessage.decode(
              reader,
              reader.uint32(),
            ),
          };
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.message = {
            $case: "duplicateUserConnectedMessage",
            duplicateUserConnectedMessage: DuplicateUserConnectedMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.message = {
            $case: "backConnectionCloseReasonMessage",
            backConnectionCloseReasonMessage: BackConnectionCloseReasonMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerToClientMessage {
    return {
      message: isSet(object.batchMessage)
        ? { $case: "batchMessage", batchMessage: BatchMessage.fromJSON(object.batchMessage) }
        : isSet(object.errorMessage)
        ? { $case: "errorMessage", errorMessage: ErrorMessage.fromJSON(object.errorMessage) }
        : isSet(object.roomConnectedMessage)
        ? {
          $case: "roomConnectedMessage",
          roomConnectedMessage: RoomConnectedMessage.fromJSON(object.roomConnectedMessage),
        }
        : isSet(object.roomJoinedMessage)
        ? { $case: "roomJoinedMessage", roomJoinedMessage: RoomJoinedMessage.fromJSON(object.roomJoinedMessage) }
        : isSet(object.teleportMessageMessage)
        ? {
          $case: "teleportMessageMessage",
          teleportMessageMessage: TeleportMessageMessage.fromJSON(object.teleportMessageMessage),
        }
        : isSet(object.sendUserMessage)
        ? { $case: "sendUserMessage", sendUserMessage: SendUserMessage.fromJSON(object.sendUserMessage) }
        : isSet(object.banUserMessage)
        ? { $case: "banUserMessage", banUserMessage: BanUserMessage.fromJSON(object.banUserMessage) }
        : isSet(object.worldFullWarningMessage)
        ? {
          $case: "worldFullWarningMessage",
          worldFullWarningMessage: WorldFullWarningMessage.fromJSON(object.worldFullWarningMessage),
        }
        : isSet(object.refreshRoomMessage)
        ? { $case: "refreshRoomMessage", refreshRoomMessage: RefreshRoomMessage.fromJSON(object.refreshRoomMessage) }
        : isSet(object.worldConnectionMessage)
        ? {
          $case: "worldConnectionMessage",
          worldConnectionMessage: WorldConnectionMessage.fromJSON(object.worldConnectionMessage),
        }
        : isSet(object.tokenExpiredMessage)
        ? {
          $case: "tokenExpiredMessage",
          tokenExpiredMessage: TokenExpiredMessage.fromJSON(object.tokenExpiredMessage),
        }
        : isSet(object.followRequestMessage)
        ? {
          $case: "followRequestMessage",
          followRequestMessage: FollowRequestMessage.fromJSON(object.followRequestMessage),
        }
        : isSet(object.followConfirmationMessage)
        ? {
          $case: "followConfirmationMessage",
          followConfirmationMessage: FollowConfirmationMessage.fromJSON(object.followConfirmationMessage),
        }
        : isSet(object.followAbortMessage)
        ? { $case: "followAbortMessage", followAbortMessage: FollowAbortMessage.fromJSON(object.followAbortMessage) }
        : isSet(object.invalidCharacterTextureMessage)
        ? {
          $case: "invalidCharacterTextureMessage",
          invalidCharacterTextureMessage: InvalidCharacterTextureMessage.fromJSON(
            object.invalidCharacterTextureMessage,
          ),
        }
        : isSet(object.deleteMapMessage)
        ? { $case: "deleteMapMessage", deleteMapMessage: DeleteMapMessage.fromJSON(object.deleteMapMessage) }
        : isSet(object.errorScreenMessage)
        ? { $case: "errorScreenMessage", errorScreenMessage: ErrorScreenMessage.fromJSON(object.errorScreenMessage) }
        : isSet(object.answerMessage)
        ? { $case: "answerMessage", answerMessage: AnswerMessage.fromJSON(object.answerMessage) }
        : isSet(object.moveToPositionMessage)
        ? {
          $case: "moveToPositionMessage",
          moveToPositionMessage: MoveToPositionMessage.fromJSON(object.moveToPositionMessage),
        }
        : isSet(object.invalidCompanionTextureMessage)
        ? {
          $case: "invalidCompanionTextureMessage",
          invalidCompanionTextureMessage: InvalidCompanionTextureMessage.fromJSON(
            object.invalidCompanionTextureMessage,
          ),
        }
        : isSet(object.joinSpaceRequestMessage)
        ? {
          $case: "joinSpaceRequestMessage",
          joinSpaceRequestMessage: JoinSpaceRequestMessage.fromJSON(object.joinSpaceRequestMessage),
        }
        : isSet(object.leaveSpaceRequestMessage)
        ? {
          $case: "leaveSpaceRequestMessage",
          leaveSpaceRequestMessage: LeaveSpaceRequestMessage.fromJSON(object.leaveSpaceRequestMessage),
        }
        : isSet(object.externalModuleMessage)
        ? {
          $case: "externalModuleMessage",
          externalModuleMessage: ExternalModuleMessage.fromJSON(object.externalModuleMessage),
        }
        : isSet(object.locatePositionMessage)
        ? {
          $case: "locatePositionMessage",
          locatePositionMessage: LocatePositionMessage.fromJSON(object.locatePositionMessage),
        }
        : isSet(object.meetingInvitationRequestReceivedMessage)
        ? {
          $case: "meetingInvitationRequestReceivedMessage",
          meetingInvitationRequestReceivedMessage: MeetingInvitationRequestReceivedMessage.fromJSON(
            object.meetingInvitationRequestReceivedMessage,
          ),
        }
        : isSet(object.meetingInvitationResponseReceivedMessage)
        ? {
          $case: "meetingInvitationResponseReceivedMessage",
          meetingInvitationResponseReceivedMessage: MeetingInvitationResponseReceivedMessage.fromJSON(
            object.meetingInvitationResponseReceivedMessage,
          ),
        }
        : isSet(object.meetingInvitationRequestTooHighMessage)
        ? {
          $case: "meetingInvitationRequestTooHighMessage",
          meetingInvitationRequestTooHighMessage: MeetingInvitationRequestTooHighMessage.fromJSON(
            object.meetingInvitationRequestTooHighMessage,
          ),
        }
        : isSet(object.meetingInvitationRequestClosedMessage)
        ? {
          $case: "meetingInvitationRequestClosedMessage",
          meetingInvitationRequestClosedMessage: MeetingInvitationRequestClosedMessage.fromJSON(
            object.meetingInvitationRequestClosedMessage,
          ),
        }
        : isSet(object.duplicateUserConnectedMessage)
        ? {
          $case: "duplicateUserConnectedMessage",
          duplicateUserConnectedMessage: DuplicateUserConnectedMessage.fromJSON(object.duplicateUserConnectedMessage),
        }
        : isSet(object.backConnectionCloseReasonMessage)
        ? {
          $case: "backConnectionCloseReasonMessage",
          backConnectionCloseReasonMessage: BackConnectionCloseReasonMessage.fromJSON(
            object.backConnectionCloseReasonMessage,
          ),
        }
        : undefined,
    };
  },

  toJSON(message: ServerToClientMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "batchMessage") {
      obj.batchMessage = BatchMessage.toJSON(message.message.batchMessage);
    } else if (message.message?.$case === "errorMessage") {
      obj.errorMessage = ErrorMessage.toJSON(message.message.errorMessage);
    } else if (message.message?.$case === "roomConnectedMessage") {
      obj.roomConnectedMessage = RoomConnectedMessage.toJSON(message.message.roomConnectedMessage);
    } else if (message.message?.$case === "roomJoinedMessage") {
      obj.roomJoinedMessage = RoomJoinedMessage.toJSON(message.message.roomJoinedMessage);
    } else if (message.message?.$case === "teleportMessageMessage") {
      obj.teleportMessageMessage = TeleportMessageMessage.toJSON(message.message.teleportMessageMessage);
    } else if (message.message?.$case === "sendUserMessage") {
      obj.sendUserMessage = SendUserMessage.toJSON(message.message.sendUserMessage);
    } else if (message.message?.$case === "banUserMessage") {
      obj.banUserMessage = BanUserMessage.toJSON(message.message.banUserMessage);
    } else if (message.message?.$case === "worldFullWarningMessage") {
      obj.worldFullWarningMessage = WorldFullWarningMessage.toJSON(message.message.worldFullWarningMessage);
    } else if (message.message?.$case === "refreshRoomMessage") {
      obj.refreshRoomMessage = RefreshRoomMessage.toJSON(message.message.refreshRoomMessage);
    } else if (message.message?.$case === "worldConnectionMessage") {
      obj.worldConnectionMessage = WorldConnectionMessage.toJSON(message.message.worldConnectionMessage);
    } else if (message.message?.$case === "tokenExpiredMessage") {
      obj.tokenExpiredMessage = TokenExpiredMessage.toJSON(message.message.tokenExpiredMessage);
    } else if (message.message?.$case === "followRequestMessage") {
      obj.followRequestMessage = FollowRequestMessage.toJSON(message.message.followRequestMessage);
    } else if (message.message?.$case === "followConfirmationMessage") {
      obj.followConfirmationMessage = FollowConfirmationMessage.toJSON(message.message.followConfirmationMessage);
    } else if (message.message?.$case === "followAbortMessage") {
      obj.followAbortMessage = FollowAbortMessage.toJSON(message.message.followAbortMessage);
    } else if (message.message?.$case === "invalidCharacterTextureMessage") {
      obj.invalidCharacterTextureMessage = InvalidCharacterTextureMessage.toJSON(
        message.message.invalidCharacterTextureMessage,
      );
    } else if (message.message?.$case === "deleteMapMessage") {
      obj.deleteMapMessage = DeleteMapMessage.toJSON(message.message.deleteMapMessage);
    } else if (message.message?.$case === "errorScreenMessage") {
      obj.errorScreenMessage = ErrorScreenMessage.toJSON(message.message.errorScreenMessage);
    } else if (message.message?.$case === "answerMessage") {
      obj.answerMessage = AnswerMessage.toJSON(message.message.answerMessage);
    } else if (message.message?.$case === "moveToPositionMessage") {
      obj.moveToPositionMessage = MoveToPositionMessage.toJSON(message.message.moveToPositionMessage);
    } else if (message.message?.$case === "invalidCompanionTextureMessage") {
      obj.invalidCompanionTextureMessage = InvalidCompanionTextureMessage.toJSON(
        message.message.invalidCompanionTextureMessage,
      );
    } else if (message.message?.$case === "joinSpaceRequestMessage") {
      obj.joinSpaceRequestMessage = JoinSpaceRequestMessage.toJSON(message.message.joinSpaceRequestMessage);
    } else if (message.message?.$case === "leaveSpaceRequestMessage") {
      obj.leaveSpaceRequestMessage = LeaveSpaceRequestMessage.toJSON(message.message.leaveSpaceRequestMessage);
    } else if (message.message?.$case === "externalModuleMessage") {
      obj.externalModuleMessage = ExternalModuleMessage.toJSON(message.message.externalModuleMessage);
    } else if (message.message?.$case === "locatePositionMessage") {
      obj.locatePositionMessage = LocatePositionMessage.toJSON(message.message.locatePositionMessage);
    } else if (message.message?.$case === "meetingInvitationRequestReceivedMessage") {
      obj.meetingInvitationRequestReceivedMessage = MeetingInvitationRequestReceivedMessage.toJSON(
        message.message.meetingInvitationRequestReceivedMessage,
      );
    } else if (message.message?.$case === "meetingInvitationResponseReceivedMessage") {
      obj.meetingInvitationResponseReceivedMessage = MeetingInvitationResponseReceivedMessage.toJSON(
        message.message.meetingInvitationResponseReceivedMessage,
      );
    } else if (message.message?.$case === "meetingInvitationRequestTooHighMessage") {
      obj.meetingInvitationRequestTooHighMessage = MeetingInvitationRequestTooHighMessage.toJSON(
        message.message.meetingInvitationRequestTooHighMessage,
      );
    } else if (message.message?.$case === "meetingInvitationRequestClosedMessage") {
      obj.meetingInvitationRequestClosedMessage = MeetingInvitationRequestClosedMessage.toJSON(
        message.message.meetingInvitationRequestClosedMessage,
      );
    } else if (message.message?.$case === "duplicateUserConnectedMessage") {
      obj.duplicateUserConnectedMessage = DuplicateUserConnectedMessage.toJSON(
        message.message.duplicateUserConnectedMessage,
      );
    } else if (message.message?.$case === "backConnectionCloseReasonMessage") {
      obj.backConnectionCloseReasonMessage = BackConnectionCloseReasonMessage.toJSON(
        message.message.backConnectionCloseReasonMessage,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerToClientMessage>, I>>(base?: I): ServerToClientMessage {
    return ServerToClientMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerToClientMessage>, I>>(object: I): ServerToClientMessage {
    const message = createBaseServerToClientMessage();
    switch (object.message?.$case) {
      case "batchMessage": {
        if (object.message?.batchMessage !== undefined && object.message?.batchMessage !== null) {
          message.message = {
            $case: "batchMessage",
            batchMessage: BatchMessage.fromPartial(object.message.batchMessage),
          };
        }
        break;
      }
      case "errorMessage": {
        if (object.message?.errorMessage !== undefined && object.message?.errorMessage !== null) {
          message.message = {
            $case: "errorMessage",
            errorMessage: ErrorMessage.fromPartial(object.message.errorMessage),
          };
        }
        break;
      }
      case "roomConnectedMessage": {
        if (object.message?.roomConnectedMessage !== undefined && object.message?.roomConnectedMessage !== null) {
          message.message = {
            $case: "roomConnectedMessage",
            roomConnectedMessage: RoomConnectedMessage.fromPartial(object.message.roomConnectedMessage),
          };
        }
        break;
      }
      case "roomJoinedMessage": {
        if (object.message?.roomJoinedMessage !== undefined && object.message?.roomJoinedMessage !== null) {
          message.message = {
            $case: "roomJoinedMessage",
            roomJoinedMessage: RoomJoinedMessage.fromPartial(object.message.roomJoinedMessage),
          };
        }
        break;
      }
      case "teleportMessageMessage": {
        if (object.message?.teleportMessageMessage !== undefined && object.message?.teleportMessageMessage !== null) {
          message.message = {
            $case: "teleportMessageMessage",
            teleportMessageMessage: TeleportMessageMessage.fromPartial(object.message.teleportMessageMessage),
          };
        }
        break;
      }
      case "sendUserMessage": {
        if (object.message?.sendUserMessage !== undefined && object.message?.sendUserMessage !== null) {
          message.message = {
            $case: "sendUserMessage",
            sendUserMessage: SendUserMessage.fromPartial(object.message.sendUserMessage),
          };
        }
        break;
      }
      case "banUserMessage": {
        if (object.message?.banUserMessage !== undefined && object.message?.banUserMessage !== null) {
          message.message = {
            $case: "banUserMessage",
            banUserMessage: BanUserMessage.fromPartial(object.message.banUserMessage),
          };
        }
        break;
      }
      case "worldFullWarningMessage": {
        if (object.message?.worldFullWarningMessage !== undefined && object.message?.worldFullWarningMessage !== null) {
          message.message = {
            $case: "worldFullWarningMessage",
            worldFullWarningMessage: WorldFullWarningMessage.fromPartial(object.message.worldFullWarningMessage),
          };
        }
        break;
      }
      case "refreshRoomMessage": {
        if (object.message?.refreshRoomMessage !== undefined && object.message?.refreshRoomMessage !== null) {
          message.message = {
            $case: "refreshRoomMessage",
            refreshRoomMessage: RefreshRoomMessage.fromPartial(object.message.refreshRoomMessage),
          };
        }
        break;
      }
      case "worldConnectionMessage": {
        if (object.message?.worldConnectionMessage !== undefined && object.message?.worldConnectionMessage !== null) {
          message.message = {
            $case: "worldConnectionMessage",
            worldConnectionMessage: WorldConnectionMessage.fromPartial(object.message.worldConnectionMessage),
          };
        }
        break;
      }
      case "tokenExpiredMessage": {
        if (object.message?.tokenExpiredMessage !== undefined && object.message?.tokenExpiredMessage !== null) {
          message.message = {
            $case: "tokenExpiredMessage",
            tokenExpiredMessage: TokenExpiredMessage.fromPartial(object.message.tokenExpiredMessage),
          };
        }
        break;
      }
      case "followRequestMessage": {
        if (object.message?.followRequestMessage !== undefined && object.message?.followRequestMessage !== null) {
          message.message = {
            $case: "followRequestMessage",
            followRequestMessage: FollowRequestMessage.fromPartial(object.message.followRequestMessage),
          };
        }
        break;
      }
      case "followConfirmationMessage": {
        if (
          object.message?.followConfirmationMessage !== undefined && object.message?.followConfirmationMessage !== null
        ) {
          message.message = {
            $case: "followConfirmationMessage",
            followConfirmationMessage: FollowConfirmationMessage.fromPartial(object.message.followConfirmationMessage),
          };
        }
        break;
      }
      case "followAbortMessage": {
        if (object.message?.followAbortMessage !== undefined && object.message?.followAbortMessage !== null) {
          message.message = {
            $case: "followAbortMessage",
            followAbortMessage: FollowAbortMessage.fromPartial(object.message.followAbortMessage),
          };
        }
        break;
      }
      case "invalidCharacterTextureMessage": {
        if (
          object.message?.invalidCharacterTextureMessage !== undefined &&
          object.message?.invalidCharacterTextureMessage !== null
        ) {
          message.message = {
            $case: "invalidCharacterTextureMessage",
            invalidCharacterTextureMessage: InvalidCharacterTextureMessage.fromPartial(
              object.message.invalidCharacterTextureMessage,
            ),
          };
        }
        break;
      }
      case "deleteMapMessage": {
        if (object.message?.deleteMapMessage !== undefined && object.message?.deleteMapMessage !== null) {
          message.message = {
            $case: "deleteMapMessage",
            deleteMapMessage: DeleteMapMessage.fromPartial(object.message.deleteMapMessage),
          };
        }
        break;
      }
      case "errorScreenMessage": {
        if (object.message?.errorScreenMessage !== undefined && object.message?.errorScreenMessage !== null) {
          message.message = {
            $case: "errorScreenMessage",
            errorScreenMessage: ErrorScreenMessage.fromPartial(object.message.errorScreenMessage),
          };
        }
        break;
      }
      case "answerMessage": {
        if (object.message?.answerMessage !== undefined && object.message?.answerMessage !== null) {
          message.message = {
            $case: "answerMessage",
            answerMessage: AnswerMessage.fromPartial(object.message.answerMessage),
          };
        }
        break;
      }
      case "moveToPositionMessage": {
        if (object.message?.moveToPositionMessage !== undefined && object.message?.moveToPositionMessage !== null) {
          message.message = {
            $case: "moveToPositionMessage",
            moveToPositionMessage: MoveToPositionMessage.fromPartial(object.message.moveToPositionMessage),
          };
        }
        break;
      }
      case "invalidCompanionTextureMessage": {
        if (
          object.message?.invalidCompanionTextureMessage !== undefined &&
          object.message?.invalidCompanionTextureMessage !== null
        ) {
          message.message = {
            $case: "invalidCompanionTextureMessage",
            invalidCompanionTextureMessage: InvalidCompanionTextureMessage.fromPartial(
              object.message.invalidCompanionTextureMessage,
            ),
          };
        }
        break;
      }
      case "joinSpaceRequestMessage": {
        if (object.message?.joinSpaceRequestMessage !== undefined && object.message?.joinSpaceRequestMessage !== null) {
          message.message = {
            $case: "joinSpaceRequestMessage",
            joinSpaceRequestMessage: JoinSpaceRequestMessage.fromPartial(object.message.joinSpaceRequestMessage),
          };
        }
        break;
      }
      case "leaveSpaceRequestMessage": {
        if (
          object.message?.leaveSpaceRequestMessage !== undefined && object.message?.leaveSpaceRequestMessage !== null
        ) {
          message.message = {
            $case: "leaveSpaceRequestMessage",
            leaveSpaceRequestMessage: LeaveSpaceRequestMessage.fromPartial(object.message.leaveSpaceRequestMessage),
          };
        }
        break;
      }
      case "externalModuleMessage": {
        if (object.message?.externalModuleMessage !== undefined && object.message?.externalModuleMessage !== null) {
          message.message = {
            $case: "externalModuleMessage",
            externalModuleMessage: ExternalModuleMessage.fromPartial(object.message.externalModuleMessage),
          };
        }
        break;
      }
      case "locatePositionMessage": {
        if (object.message?.locatePositionMessage !== undefined && object.message?.locatePositionMessage !== null) {
          message.message = {
            $case: "locatePositionMessage",
            locatePositionMessage: LocatePositionMessage.fromPartial(object.message.locatePositionMessage),
          };
        }
        break;
      }
      case "meetingInvitationRequestReceivedMessage": {
        if (
          object.message?.meetingInvitationRequestReceivedMessage !== undefined &&
          object.message?.meetingInvitationRequestReceivedMessage !== null
        ) {
          message.message = {
            $case: "meetingInvitationRequestReceivedMessage",
            meetingInvitationRequestReceivedMessage: MeetingInvitationRequestReceivedMessage.fromPartial(
              object.message.meetingInvitationRequestReceivedMessage,
            ),
          };
        }
        break;
      }
      case "meetingInvitationResponseReceivedMessage": {
        if (
          object.message?.meetingInvitationResponseReceivedMessage !== undefined &&
          object.message?.meetingInvitationResponseReceivedMessage !== null
        ) {
          message.message = {
            $case: "meetingInvitationResponseReceivedMessage",
            meetingInvitationResponseReceivedMessage: MeetingInvitationResponseReceivedMessage.fromPartial(
              object.message.meetingInvitationResponseReceivedMessage,
            ),
          };
        }
        break;
      }
      case "meetingInvitationRequestTooHighMessage": {
        if (
          object.message?.meetingInvitationRequestTooHighMessage !== undefined &&
          object.message?.meetingInvitationRequestTooHighMessage !== null
        ) {
          message.message = {
            $case: "meetingInvitationRequestTooHighMessage",
            meetingInvitationRequestTooHighMessage: MeetingInvitationRequestTooHighMessage.fromPartial(
              object.message.meetingInvitationRequestTooHighMessage,
            ),
          };
        }
        break;
      }
      case "meetingInvitationRequestClosedMessage": {
        if (
          object.message?.meetingInvitationRequestClosedMessage !== undefined &&
          object.message?.meetingInvitationRequestClosedMessage !== null
        ) {
          message.message = {
            $case: "meetingInvitationRequestClosedMessage",
            meetingInvitationRequestClosedMessage: MeetingInvitationRequestClosedMessage.fromPartial(
              object.message.meetingInvitationRequestClosedMessage,
            ),
          };
        }
        break;
      }
      case "duplicateUserConnectedMessage": {
        if (
          object.message?.duplicateUserConnectedMessage !== undefined &&
          object.message?.duplicateUserConnectedMessage !== null
        ) {
          message.message = {
            $case: "duplicateUserConnectedMessage",
            duplicateUserConnectedMessage: DuplicateUserConnectedMessage.fromPartial(
              object.message.duplicateUserConnectedMessage,
            ),
          };
        }
        break;
      }
      case "backConnectionCloseReasonMessage": {
        if (
          object.message?.backConnectionCloseReasonMessage !== undefined &&
          object.message?.backConnectionCloseReasonMessage !== null
        ) {
          message.message = {
            $case: "backConnectionCloseReasonMessage",
            backConnectionCloseReasonMessage: BackConnectionCloseReasonMessage.fromPartial(
              object.message.backConnectionCloseReasonMessage,
            ),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseConnectToRoomMessage(): ConnectToRoomMessage {
  return { roomId: "", lastCommandId: undefined, tag: [] };
}

export const ConnectToRoomMessage: MessageFns<ConnectToRoomMessage> = {
  encode(message: ConnectToRoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.roomId !== "") {
      writer.uint32(10).string(message.roomId);
    }
    if (message.lastCommandId !== undefined) {
      StringValue.encode({ value: message.lastCommandId! }, writer.uint32(18).fork()).join();
    }
    for (const v of message.tag) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConnectToRoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConnectToRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roomId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lastCommandId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tag.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConnectToRoomMessage {
    return {
      roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "",
      lastCommandId: isSet(object.lastCommandId) ? String(object.lastCommandId) : undefined,
      tag: globalThis.Array.isArray(object?.tag) ? object.tag.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ConnectToRoomMessage): unknown {
    const obj: any = {};
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    if (message.lastCommandId !== undefined) {
      obj.lastCommandId = message.lastCommandId;
    }
    if (message.tag?.length) {
      obj.tag = message.tag;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConnectToRoomMessage>, I>>(base?: I): ConnectToRoomMessage {
    return ConnectToRoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConnectToRoomMessage>, I>>(object: I): ConnectToRoomMessage {
    const message = createBaseConnectToRoomMessage();
    message.roomId = object.roomId ?? "";
    message.lastCommandId = object.lastCommandId ?? undefined;
    message.tag = object.tag?.map((e) => e) || [];
    return message;
  },
};

function createBaseJoinRoomFrontMessage(): JoinRoomFrontMessage {
  return { positionMessage: undefined, viewportMessage: undefined, name: "", availabilityStatus: 0 };
}

export const JoinRoomFrontMessage: MessageFns<JoinRoomFrontMessage> = {
  encode(message: JoinRoomFrontMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.positionMessage !== undefined) {
      PositionMessage.encode(message.positionMessage, writer.uint32(10).fork()).join();
    }
    if (message.viewportMessage !== undefined) {
      ViewportMessage.encode(message.viewportMessage, writer.uint32(18).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.availabilityStatus !== 0) {
      writer.uint32(48).int32(message.availabilityStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JoinRoomFrontMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinRoomFrontMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.positionMessage = PositionMessage.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.viewportMessage = ViewportMessage.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.availabilityStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JoinRoomFrontMessage {
    return {
      positionMessage: isSet(object.positionMessage) ? PositionMessage.fromJSON(object.positionMessage) : undefined,
      viewportMessage: isSet(object.viewportMessage) ? ViewportMessage.fromJSON(object.viewportMessage) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      availabilityStatus: isSet(object.availabilityStatus) ? availabilityStatusFromJSON(object.availabilityStatus) : 0,
    };
  },

  toJSON(message: JoinRoomFrontMessage): unknown {
    const obj: any = {};
    if (message.positionMessage !== undefined) {
      obj.positionMessage = PositionMessage.toJSON(message.positionMessage);
    }
    if (message.viewportMessage !== undefined) {
      obj.viewportMessage = ViewportMessage.toJSON(message.viewportMessage);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.availabilityStatus !== 0) {
      obj.availabilityStatus = availabilityStatusToJSON(message.availabilityStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JoinRoomFrontMessage>, I>>(base?: I): JoinRoomFrontMessage {
    return JoinRoomFrontMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoinRoomFrontMessage>, I>>(object: I): JoinRoomFrontMessage {
    const message = createBaseJoinRoomFrontMessage();
    message.positionMessage = (object.positionMessage !== undefined && object.positionMessage !== null)
      ? PositionMessage.fromPartial(object.positionMessage)
      : undefined;
    message.viewportMessage = (object.viewportMessage !== undefined && object.viewportMessage !== null)
      ? ViewportMessage.fromPartial(object.viewportMessage)
      : undefined;
    message.name = object.name ?? "";
    message.availabilityStatus = object.availabilityStatus ?? 0;
    return message;
  },
};

function createBaseJoinRoomMessage(): JoinRoomMessage {
  return {
    positionMessage: undefined,
    name: "",
    characterTextures: [],
    userUuid: "",
    tag: [],
    IPAddress: "",
    companionTexture: undefined,
    visitCardUrl: undefined,
    userRoomToken: "",
    availabilityStatus: 0,
    activatedInviteUser: false,
    isLogged: false,
    applications: [],
    canEdit: false,
    chatID: undefined,
    tabId: undefined,
  };
}

export const JoinRoomMessage: MessageFns<JoinRoomMessage> = {
  encode(message: JoinRoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.positionMessage !== undefined) {
      PositionMessage.encode(message.positionMessage, writer.uint32(10).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    for (const v of message.characterTextures) {
      CharacterTextureMessage.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.userUuid !== "") {
      writer.uint32(34).string(message.userUuid);
    }
    for (const v of message.tag) {
      writer.uint32(50).string(v!);
    }
    if (message.IPAddress !== "") {
      writer.uint32(58).string(message.IPAddress);
    }
    if (message.companionTexture !== undefined) {
      CompanionTextureMessage.encode(message.companionTexture, writer.uint32(66).fork()).join();
    }
    if (message.visitCardUrl !== undefined) {
      StringValue.encode({ value: message.visitCardUrl! }, writer.uint32(74).fork()).join();
    }
    if (message.userRoomToken !== "") {
      writer.uint32(82).string(message.userRoomToken);
    }
    if (message.availabilityStatus !== 0) {
      writer.uint32(88).int32(message.availabilityStatus);
    }
    if (message.activatedInviteUser !== false) {
      writer.uint32(96).bool(message.activatedInviteUser);
    }
    if (message.isLogged !== false) {
      writer.uint32(104).bool(message.isLogged);
    }
    for (const v of message.applications) {
      ApplicationMessage.encode(v!, writer.uint32(114).fork()).join();
    }
    if (message.canEdit !== false) {
      writer.uint32(136).bool(message.canEdit);
    }
    if (message.chatID !== undefined) {
      StringValue.encode({ value: message.chatID! }, writer.uint32(146).fork()).join();
    }
    if (message.tabId !== undefined) {
      writer.uint32(154).string(message.tabId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JoinRoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.positionMessage = PositionMessage.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.characterTextures.push(CharacterTextureMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.userUuid = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.tag.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.IPAddress = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.companionTexture = CompanionTextureMessage.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.visitCardUrl = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.userRoomToken = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.availabilityStatus = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.activatedInviteUser = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.isLogged = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.applications.push(ApplicationMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.canEdit = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.chatID = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.tabId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JoinRoomMessage {
    return {
      positionMessage: isSet(object.positionMessage) ? PositionMessage.fromJSON(object.positionMessage) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      characterTextures: globalThis.Array.isArray(object?.characterTextures)
        ? object.characterTextures.map((e: any) => CharacterTextureMessage.fromJSON(e))
        : [],
      userUuid: isSet(object.userUuid) ? globalThis.String(object.userUuid) : "",
      tag: globalThis.Array.isArray(object?.tag) ? object.tag.map((e: any) => globalThis.String(e)) : [],
      IPAddress: isSet(object.IPAddress) ? globalThis.String(object.IPAddress) : "",
      companionTexture: isSet(object.companionTexture)
        ? CompanionTextureMessage.fromJSON(object.companionTexture)
        : undefined,
      visitCardUrl: isSet(object.visitCardUrl) ? String(object.visitCardUrl) : undefined,
      userRoomToken: isSet(object.userRoomToken) ? globalThis.String(object.userRoomToken) : "",
      availabilityStatus: isSet(object.availabilityStatus) ? availabilityStatusFromJSON(object.availabilityStatus) : 0,
      activatedInviteUser: isSet(object.activatedInviteUser) ? globalThis.Boolean(object.activatedInviteUser) : false,
      isLogged: isSet(object.isLogged) ? globalThis.Boolean(object.isLogged) : false,
      applications: globalThis.Array.isArray(object?.applications)
        ? object.applications.map((e: any) => ApplicationMessage.fromJSON(e))
        : [],
      canEdit: isSet(object.canEdit) ? globalThis.Boolean(object.canEdit) : false,
      chatID: isSet(object.chatID) ? String(object.chatID) : undefined,
      tabId: isSet(object.tabId) ? globalThis.String(object.tabId) : undefined,
    };
  },

  toJSON(message: JoinRoomMessage): unknown {
    const obj: any = {};
    if (message.positionMessage !== undefined) {
      obj.positionMessage = PositionMessage.toJSON(message.positionMessage);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.characterTextures?.length) {
      obj.characterTextures = message.characterTextures.map((e) => CharacterTextureMessage.toJSON(e));
    }
    if (message.userUuid !== "") {
      obj.userUuid = message.userUuid;
    }
    if (message.tag?.length) {
      obj.tag = message.tag;
    }
    if (message.IPAddress !== "") {
      obj.IPAddress = message.IPAddress;
    }
    if (message.companionTexture !== undefined) {
      obj.companionTexture = CompanionTextureMessage.toJSON(message.companionTexture);
    }
    if (message.visitCardUrl !== undefined) {
      obj.visitCardUrl = message.visitCardUrl;
    }
    if (message.userRoomToken !== "") {
      obj.userRoomToken = message.userRoomToken;
    }
    if (message.availabilityStatus !== 0) {
      obj.availabilityStatus = availabilityStatusToJSON(message.availabilityStatus);
    }
    if (message.activatedInviteUser !== false) {
      obj.activatedInviteUser = message.activatedInviteUser;
    }
    if (message.isLogged !== false) {
      obj.isLogged = message.isLogged;
    }
    if (message.applications?.length) {
      obj.applications = message.applications.map((e) => ApplicationMessage.toJSON(e));
    }
    if (message.canEdit !== false) {
      obj.canEdit = message.canEdit;
    }
    if (message.chatID !== undefined) {
      obj.chatID = message.chatID;
    }
    if (message.tabId !== undefined) {
      obj.tabId = message.tabId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JoinRoomMessage>, I>>(base?: I): JoinRoomMessage {
    return JoinRoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoinRoomMessage>, I>>(object: I): JoinRoomMessage {
    const message = createBaseJoinRoomMessage();
    message.positionMessage = (object.positionMessage !== undefined && object.positionMessage !== null)
      ? PositionMessage.fromPartial(object.positionMessage)
      : undefined;
    message.name = object.name ?? "";
    message.characterTextures = object.characterTextures?.map((e) => CharacterTextureMessage.fromPartial(e)) || [];
    message.userUuid = object.userUuid ?? "";
    message.tag = object.tag?.map((e) => e) || [];
    message.IPAddress = object.IPAddress ?? "";
    message.companionTexture = (object.companionTexture !== undefined && object.companionTexture !== null)
      ? CompanionTextureMessage.fromPartial(object.companionTexture)
      : undefined;
    message.visitCardUrl = object.visitCardUrl ?? undefined;
    message.userRoomToken = object.userRoomToken ?? "";
    message.availabilityStatus = object.availabilityStatus ?? 0;
    message.activatedInviteUser = object.activatedInviteUser ?? false;
    message.isLogged = object.isLogged ?? false;
    message.applications = object.applications?.map((e) => ApplicationMessage.fromPartial(e)) || [];
    message.canEdit = object.canEdit ?? false;
    message.chatID = object.chatID ?? undefined;
    message.tabId = object.tabId ?? undefined;
    return message;
  },
};

function createBaseUserJoinedZoneMessage(): UserJoinedZoneMessage {
  return {
    userId: 0,
    name: "",
    characterTextures: [],
    position: undefined,
    fromZone: undefined,
    companionTexture: undefined,
    visitCardUrl: "",
    userUuid: "",
    outlineColor: 0,
    hasOutline: false,
    availabilityStatus: 0,
    variables: {},
    chatID: undefined,
    sayMessage: undefined,
  };
}

export const UserJoinedZoneMessage: MessageFns<UserJoinedZoneMessage> = {
  encode(message: UserJoinedZoneMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== 0) {
      writer.uint32(8).int32(message.userId);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    for (const v of message.characterTextures) {
      CharacterTextureMessage.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.position !== undefined) {
      PositionMessage.encode(message.position, writer.uint32(42).fork()).join();
    }
    if (message.fromZone !== undefined) {
      Zone.encode(message.fromZone, writer.uint32(50).fork()).join();
    }
    if (message.companionTexture !== undefined) {
      CompanionTextureMessage.encode(message.companionTexture, writer.uint32(58).fork()).join();
    }
    if (message.visitCardUrl !== "") {
      writer.uint32(66).string(message.visitCardUrl);
    }
    if (message.userUuid !== "") {
      writer.uint32(74).string(message.userUuid);
    }
    if (message.outlineColor !== 0) {
      writer.uint32(80).uint32(message.outlineColor);
    }
    if (message.hasOutline !== false) {
      writer.uint32(88).bool(message.hasOutline);
    }
    if (message.availabilityStatus !== 0) {
      writer.uint32(96).int32(message.availabilityStatus);
    }
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, string]) => {
      UserJoinedZoneMessage_VariablesEntry.encode({ key: key as any, value }, writer.uint32(106).fork()).join();
    });
    if (message.chatID !== undefined) {
      writer.uint32(114).string(message.chatID);
    }
    if (message.sayMessage !== undefined) {
      SayMessage.encode(message.sayMessage, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserJoinedZoneMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserJoinedZoneMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.userId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.characterTextures.push(CharacterTextureMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.position = PositionMessage.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fromZone = Zone.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.companionTexture = CompanionTextureMessage.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.visitCardUrl = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.userUuid = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.outlineColor = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.hasOutline = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.availabilityStatus = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          const entry13 = UserJoinedZoneMessage_VariablesEntry.decode(reader, reader.uint32());
          if (entry13.value !== undefined) {
            message.variables[entry13.key] = entry13.value;
          }
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.chatID = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.sayMessage = SayMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserJoinedZoneMessage {
    return {
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      characterTextures: globalThis.Array.isArray(object?.characterTextures)
        ? object.characterTextures.map((e: any) => CharacterTextureMessage.fromJSON(e))
        : [],
      position: isSet(object.position) ? PositionMessage.fromJSON(object.position) : undefined,
      fromZone: isSet(object.fromZone) ? Zone.fromJSON(object.fromZone) : undefined,
      companionTexture: isSet(object.companionTexture)
        ? CompanionTextureMessage.fromJSON(object.companionTexture)
        : undefined,
      visitCardUrl: isSet(object.visitCardUrl) ? globalThis.String(object.visitCardUrl) : "",
      userUuid: isSet(object.userUuid) ? globalThis.String(object.userUuid) : "",
      outlineColor: isSet(object.outlineColor) ? globalThis.Number(object.outlineColor) : 0,
      hasOutline: isSet(object.hasOutline) ? globalThis.Boolean(object.hasOutline) : false,
      availabilityStatus: isSet(object.availabilityStatus) ? availabilityStatusFromJSON(object.availabilityStatus) : 0,
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
      chatID: isSet(object.chatID) ? globalThis.String(object.chatID) : undefined,
      sayMessage: isSet(object.sayMessage) ? SayMessage.fromJSON(object.sayMessage) : undefined,
    };
  },

  toJSON(message: UserJoinedZoneMessage): unknown {
    const obj: any = {};
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.characterTextures?.length) {
      obj.characterTextures = message.characterTextures.map((e) => CharacterTextureMessage.toJSON(e));
    }
    if (message.position !== undefined) {
      obj.position = PositionMessage.toJSON(message.position);
    }
    if (message.fromZone !== undefined) {
      obj.fromZone = Zone.toJSON(message.fromZone);
    }
    if (message.companionTexture !== undefined) {
      obj.companionTexture = CompanionTextureMessage.toJSON(message.companionTexture);
    }
    if (message.visitCardUrl !== "") {
      obj.visitCardUrl = message.visitCardUrl;
    }
    if (message.userUuid !== "") {
      obj.userUuid = message.userUuid;
    }
    if (message.outlineColor !== 0) {
      obj.outlineColor = Math.round(message.outlineColor);
    }
    if (message.hasOutline !== false) {
      obj.hasOutline = message.hasOutline;
    }
    if (message.availabilityStatus !== 0) {
      obj.availabilityStatus = availabilityStatusToJSON(message.availabilityStatus);
    }
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, string][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    if (message.chatID !== undefined) {
      obj.chatID = message.chatID;
    }
    if (message.sayMessage !== undefined) {
      obj.sayMessage = SayMessage.toJSON(message.sayMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserJoinedZoneMessage>, I>>(base?: I): UserJoinedZoneMessage {
    return UserJoinedZoneMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserJoinedZoneMessage>, I>>(object: I): UserJoinedZoneMessage {
    const message = createBaseUserJoinedZoneMessage();
    message.userId = object.userId ?? 0;
    message.name = object.name ?? "";
    message.characterTextures = object.characterTextures?.map((e) => CharacterTextureMessage.fromPartial(e)) || [];
    message.position = (object.position !== undefined && object.position !== null)
      ? PositionMessage.fromPartial(object.position)
      : undefined;
    message.fromZone = (object.fromZone !== undefined && object.fromZone !== null)
      ? Zone.fromPartial(object.fromZone)
      : undefined;
    message.companionTexture = (object.companionTexture !== undefined && object.companionTexture !== null)
      ? CompanionTextureMessage.fromPartial(object.companionTexture)
      : undefined;
    message.visitCardUrl = object.visitCardUrl ?? "";
    message.userUuid = object.userUuid ?? "";
    message.outlineColor = object.outlineColor ?? 0;
    message.hasOutline = object.hasOutline ?? false;
    message.availabilityStatus = object.availabilityStatus ?? 0;
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.chatID = object.chatID ?? undefined;
    message.sayMessage = (object.sayMessage !== undefined && object.sayMessage !== null)
      ? SayMessage.fromPartial(object.sayMessage)
      : undefined;
    return message;
  },
};

function createBaseUserJoinedZoneMessage_VariablesEntry(): UserJoinedZoneMessage_VariablesEntry {
  return { key: "", value: "" };
}

export const UserJoinedZoneMessage_VariablesEntry: MessageFns<UserJoinedZoneMessage_VariablesEntry> = {
  encode(message: UserJoinedZoneMessage_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserJoinedZoneMessage_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserJoinedZoneMessage_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserJoinedZoneMessage_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: UserJoinedZoneMessage_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserJoinedZoneMessage_VariablesEntry>, I>>(
    base?: I,
  ): UserJoinedZoneMessage_VariablesEntry {
    return UserJoinedZoneMessage_VariablesEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserJoinedZoneMessage_VariablesEntry>, I>>(
    object: I,
  ): UserJoinedZoneMessage_VariablesEntry {
    const message = createBaseUserJoinedZoneMessage_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseUserLeftZoneMessage(): UserLeftZoneMessage {
  return { userId: 0, toZone: undefined };
}

export const UserLeftZoneMessage: MessageFns<UserLeftZoneMessage> = {
  encode(message: UserLeftZoneMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== 0) {
      writer.uint32(8).int32(message.userId);
    }
    if (message.toZone !== undefined) {
      Zone.encode(message.toZone, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserLeftZoneMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserLeftZoneMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.userId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.toZone = Zone.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserLeftZoneMessage {
    return {
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0,
      toZone: isSet(object.toZone) ? Zone.fromJSON(object.toZone) : undefined,
    };
  },

  toJSON(message: UserLeftZoneMessage): unknown {
    const obj: any = {};
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId);
    }
    if (message.toZone !== undefined) {
      obj.toZone = Zone.toJSON(message.toZone);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserLeftZoneMessage>, I>>(base?: I): UserLeftZoneMessage {
    return UserLeftZoneMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserLeftZoneMessage>, I>>(object: I): UserLeftZoneMessage {
    const message = createBaseUserLeftZoneMessage();
    message.userId = object.userId ?? 0;
    message.toZone = (object.toZone !== undefined && object.toZone !== null)
      ? Zone.fromPartial(object.toZone)
      : undefined;
    return message;
  },
};

function createBaseGroupUpdateZoneMessage(): GroupUpdateZoneMessage {
  return { groupId: 0, position: undefined, groupSize: 0, fromZone: undefined, locked: false, userIds: [] };
}

export const GroupUpdateZoneMessage: MessageFns<GroupUpdateZoneMessage> = {
  encode(message: GroupUpdateZoneMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.groupId !== 0) {
      writer.uint32(8).int32(message.groupId);
    }
    if (message.position !== undefined) {
      PointMessage.encode(message.position, writer.uint32(18).fork()).join();
    }
    if (message.groupSize !== 0) {
      writer.uint32(24).int32(message.groupSize);
    }
    if (message.fromZone !== undefined) {
      Zone.encode(message.fromZone, writer.uint32(34).fork()).join();
    }
    if (message.locked !== false) {
      writer.uint32(40).bool(message.locked);
    }
    writer.uint32(50).fork();
    for (const v of message.userIds) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupUpdateZoneMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupUpdateZoneMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.groupId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.position = PointMessage.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.groupSize = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fromZone = Zone.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 6: {
          if (tag === 48) {
            message.userIds.push(reader.int32());

            continue;
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.userIds.push(reader.int32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupUpdateZoneMessage {
    return {
      groupId: isSet(object.groupId) ? globalThis.Number(object.groupId) : 0,
      position: isSet(object.position) ? PointMessage.fromJSON(object.position) : undefined,
      groupSize: isSet(object.groupSize) ? globalThis.Number(object.groupSize) : 0,
      fromZone: isSet(object.fromZone) ? Zone.fromJSON(object.fromZone) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : false,
      userIds: globalThis.Array.isArray(object?.userIds) ? object.userIds.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: GroupUpdateZoneMessage): unknown {
    const obj: any = {};
    if (message.groupId !== 0) {
      obj.groupId = Math.round(message.groupId);
    }
    if (message.position !== undefined) {
      obj.position = PointMessage.toJSON(message.position);
    }
    if (message.groupSize !== 0) {
      obj.groupSize = Math.round(message.groupSize);
    }
    if (message.fromZone !== undefined) {
      obj.fromZone = Zone.toJSON(message.fromZone);
    }
    if (message.locked !== false) {
      obj.locked = message.locked;
    }
    if (message.userIds?.length) {
      obj.userIds = message.userIds.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroupUpdateZoneMessage>, I>>(base?: I): GroupUpdateZoneMessage {
    return GroupUpdateZoneMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroupUpdateZoneMessage>, I>>(object: I): GroupUpdateZoneMessage {
    const message = createBaseGroupUpdateZoneMessage();
    message.groupId = object.groupId ?? 0;
    message.position = (object.position !== undefined && object.position !== null)
      ? PointMessage.fromPartial(object.position)
      : undefined;
    message.groupSize = object.groupSize ?? 0;
    message.fromZone = (object.fromZone !== undefined && object.fromZone !== null)
      ? Zone.fromPartial(object.fromZone)
      : undefined;
    message.locked = object.locked ?? false;
    message.userIds = object.userIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGroupLeftZoneMessage(): GroupLeftZoneMessage {
  return { groupId: 0, toZone: undefined };
}

export const GroupLeftZoneMessage: MessageFns<GroupLeftZoneMessage> = {
  encode(message: GroupLeftZoneMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.groupId !== 0) {
      writer.uint32(8).int32(message.groupId);
    }
    if (message.toZone !== undefined) {
      Zone.encode(message.toZone, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupLeftZoneMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupLeftZoneMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.groupId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.toZone = Zone.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupLeftZoneMessage {
    return {
      groupId: isSet(object.groupId) ? globalThis.Number(object.groupId) : 0,
      toZone: isSet(object.toZone) ? Zone.fromJSON(object.toZone) : undefined,
    };
  },

  toJSON(message: GroupLeftZoneMessage): unknown {
    const obj: any = {};
    if (message.groupId !== 0) {
      obj.groupId = Math.round(message.groupId);
    }
    if (message.toZone !== undefined) {
      obj.toZone = Zone.toJSON(message.toZone);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroupLeftZoneMessage>, I>>(base?: I): GroupLeftZoneMessage {
    return GroupLeftZoneMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroupLeftZoneMessage>, I>>(object: I): GroupLeftZoneMessage {
    const message = createBaseGroupLeftZoneMessage();
    message.groupId = object.groupId ?? 0;
    message.toZone = (object.toZone !== undefined && object.toZone !== null)
      ? Zone.fromPartial(object.toZone)
      : undefined;
    return message;
  },
};

function createBasePlayerDetailsUpdatedMessage(): PlayerDetailsUpdatedMessage {
  return { userId: 0, details: undefined };
}

export const PlayerDetailsUpdatedMessage: MessageFns<PlayerDetailsUpdatedMessage> = {
  encode(message: PlayerDetailsUpdatedMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== 0) {
      writer.uint32(8).int32(message.userId);
    }
    if (message.details !== undefined) {
      SetPlayerDetailsMessage.encode(message.details, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlayerDetailsUpdatedMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlayerDetailsUpdatedMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.userId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.details = SetPlayerDetailsMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlayerDetailsUpdatedMessage {
    return {
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0,
      details: isSet(object.details) ? SetPlayerDetailsMessage.fromJSON(object.details) : undefined,
    };
  },

  toJSON(message: PlayerDetailsUpdatedMessage): unknown {
    const obj: any = {};
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId);
    }
    if (message.details !== undefined) {
      obj.details = SetPlayerDetailsMessage.toJSON(message.details);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlayerDetailsUpdatedMessage>, I>>(base?: I): PlayerDetailsUpdatedMessage {
    return PlayerDetailsUpdatedMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlayerDetailsUpdatedMessage>, I>>(object: I): PlayerDetailsUpdatedMessage {
    const message = createBasePlayerDetailsUpdatedMessage();
    message.userId = object.userId ?? 0;
    message.details = (object.details !== undefined && object.details !== null)
      ? SetPlayerDetailsMessage.fromPartial(object.details)
      : undefined;
    return message;
  },
};

function createBaseZone(): Zone {
  return { x: 0, y: 0 };
}

export const Zone: MessageFns<Zone> = {
  encode(message: Zone, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(8).int32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(16).int32(message.y);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Zone {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseZone();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.x = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.y = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Zone {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
    };
  },

  toJSON(message: Zone): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Zone>, I>>(base?: I): Zone {
    return Zone.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Zone>, I>>(object: I): Zone {
    const message = createBaseZone();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    return message;
  },
};

function createBaseSubscribeZoneMessage(): SubscribeZoneMessage {
  return { x: 0, y: 0 };
}

export const SubscribeZoneMessage: MessageFns<SubscribeZoneMessage> = {
  encode(message: SubscribeZoneMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(8).int32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(16).int32(message.y);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscribeZoneMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribeZoneMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.x = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.y = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscribeZoneMessage {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
    };
  },

  toJSON(message: SubscribeZoneMessage): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscribeZoneMessage>, I>>(base?: I): SubscribeZoneMessage {
    return SubscribeZoneMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscribeZoneMessage>, I>>(object: I): SubscribeZoneMessage {
    const message = createBaseSubscribeZoneMessage();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    return message;
  },
};

function createBaseUnsubscribeZoneMessage(): UnsubscribeZoneMessage {
  return { x: 0, y: 0 };
}

export const UnsubscribeZoneMessage: MessageFns<UnsubscribeZoneMessage> = {
  encode(message: UnsubscribeZoneMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(8).int32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(16).int32(message.y);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnsubscribeZoneMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnsubscribeZoneMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.x = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.y = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnsubscribeZoneMessage {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
    };
  },

  toJSON(message: UnsubscribeZoneMessage): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnsubscribeZoneMessage>, I>>(base?: I): UnsubscribeZoneMessage {
    return UnsubscribeZoneMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnsubscribeZoneMessage>, I>>(object: I): UnsubscribeZoneMessage {
    const message = createBaseUnsubscribeZoneMessage();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    return message;
  },
};

function createBaseRoomMessage(): RoomMessage {
  return { roomId: "" };
}

export const RoomMessage: MessageFns<RoomMessage> = {
  encode(message: RoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.roomId !== "") {
      writer.uint32(10).string(message.roomId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roomId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoomMessage {
    return { roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "" };
  },

  toJSON(message: RoomMessage): unknown {
    const obj: any = {};
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoomMessage>, I>>(base?: I): RoomMessage {
    return RoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoomMessage>, I>>(object: I): RoomMessage {
    const message = createBaseRoomMessage();
    message.roomId = object.roomId ?? "";
    return message;
  },
};

function createBasePusherToBackRoomMessage(): PusherToBackRoomMessage {
  return { message: undefined };
}

export const PusherToBackRoomMessage: MessageFns<PusherToBackRoomMessage> = {
  encode(message: PusherToBackRoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "initRoomMessage":
        InitRoomMessage.encode(message.message.initRoomMessage, writer.uint32(26).fork()).join();
        break;
      case "subscribeZoneMessage":
        SubscribeZoneMessage.encode(message.message.subscribeZoneMessage, writer.uint32(10).fork()).join();
        break;
      case "unsubscribeZoneMessage":
        UnsubscribeZoneMessage.encode(message.message.unsubscribeZoneMessage, writer.uint32(18).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PusherToBackRoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePusherToBackRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = {
            $case: "initRoomMessage",
            initRoomMessage: InitRoomMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = {
            $case: "subscribeZoneMessage",
            subscribeZoneMessage: SubscribeZoneMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = {
            $case: "unsubscribeZoneMessage",
            unsubscribeZoneMessage: UnsubscribeZoneMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PusherToBackRoomMessage {
    return {
      message: isSet(object.initRoomMessage)
        ? { $case: "initRoomMessage", initRoomMessage: InitRoomMessage.fromJSON(object.initRoomMessage) }
        : isSet(object.subscribeZoneMessage)
        ? {
          $case: "subscribeZoneMessage",
          subscribeZoneMessage: SubscribeZoneMessage.fromJSON(object.subscribeZoneMessage),
        }
        : isSet(object.unsubscribeZoneMessage)
        ? {
          $case: "unsubscribeZoneMessage",
          unsubscribeZoneMessage: UnsubscribeZoneMessage.fromJSON(object.unsubscribeZoneMessage),
        }
        : undefined,
    };
  },

  toJSON(message: PusherToBackRoomMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "initRoomMessage") {
      obj.initRoomMessage = InitRoomMessage.toJSON(message.message.initRoomMessage);
    } else if (message.message?.$case === "subscribeZoneMessage") {
      obj.subscribeZoneMessage = SubscribeZoneMessage.toJSON(message.message.subscribeZoneMessage);
    } else if (message.message?.$case === "unsubscribeZoneMessage") {
      obj.unsubscribeZoneMessage = UnsubscribeZoneMessage.toJSON(message.message.unsubscribeZoneMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PusherToBackRoomMessage>, I>>(base?: I): PusherToBackRoomMessage {
    return PusherToBackRoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PusherToBackRoomMessage>, I>>(object: I): PusherToBackRoomMessage {
    const message = createBasePusherToBackRoomMessage();
    switch (object.message?.$case) {
      case "initRoomMessage": {
        if (object.message?.initRoomMessage !== undefined && object.message?.initRoomMessage !== null) {
          message.message = {
            $case: "initRoomMessage",
            initRoomMessage: InitRoomMessage.fromPartial(object.message.initRoomMessage),
          };
        }
        break;
      }
      case "subscribeZoneMessage": {
        if (object.message?.subscribeZoneMessage !== undefined && object.message?.subscribeZoneMessage !== null) {
          message.message = {
            $case: "subscribeZoneMessage",
            subscribeZoneMessage: SubscribeZoneMessage.fromPartial(object.message.subscribeZoneMessage),
          };
        }
        break;
      }
      case "unsubscribeZoneMessage": {
        if (object.message?.unsubscribeZoneMessage !== undefined && object.message?.unsubscribeZoneMessage !== null) {
          message.message = {
            $case: "unsubscribeZoneMessage",
            unsubscribeZoneMessage: UnsubscribeZoneMessage.fromPartial(object.message.unsubscribeZoneMessage),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseInitRoomMessage(): InitRoomMessage {
  return { roomId: "" };
}

export const InitRoomMessage: MessageFns<InitRoomMessage> = {
  encode(message: InitRoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.roomId !== "") {
      writer.uint32(10).string(message.roomId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InitRoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roomId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InitRoomMessage {
    return { roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "" };
  },

  toJSON(message: InitRoomMessage): unknown {
    const obj: any = {};
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InitRoomMessage>, I>>(base?: I): InitRoomMessage {
    return InitRoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitRoomMessage>, I>>(object: I): InitRoomMessage {
    const message = createBaseInitRoomMessage();
    message.roomId = object.roomId ?? "";
    return message;
  },
};

function createBasePusherToBackMessage(): PusherToBackMessage {
  return { message: undefined };
}

export const PusherToBackMessage: MessageFns<PusherToBackMessage> = {
  encode(message: PusherToBackMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "connectToRoomMessage":
        ConnectToRoomMessage.encode(message.message.connectToRoomMessage, writer.uint32(10).fork()).join();
        break;
      case "joinRoomMessage":
        JoinRoomMessage.encode(message.message.joinRoomMessage, writer.uint32(18).fork()).join();
        break;
      case "userMovesMessage":
        UserMovesMessage.encode(message.message.userMovesMessage, writer.uint32(26).fork()).join();
        break;
      case "itemEventMessage":
        ItemEventMessage.encode(message.message.itemEventMessage, writer.uint32(34).fork()).join();
        break;
      case "setPlayerDetailsMessage":
        SetPlayerDetailsMessage.encode(message.message.setPlayerDetailsMessage, writer.uint32(42).fork()).join();
        break;
      case "emotePromptMessage":
        EmotePromptMessage.encode(message.message.emotePromptMessage, writer.uint32(114).fork()).join();
        break;
      case "variableMessage":
        VariableMessage.encode(message.message.variableMessage, writer.uint32(122).fork()).join();
        break;
      case "followRequestMessage":
        FollowRequestMessage.encode(message.message.followRequestMessage, writer.uint32(130).fork()).join();
        break;
      case "followConfirmationMessage":
        FollowConfirmationMessage.encode(message.message.followConfirmationMessage, writer.uint32(138).fork()).join();
        break;
      case "followAbortMessage":
        FollowAbortMessage.encode(message.message.followAbortMessage, writer.uint32(146).fork()).join();
        break;
      case "lockGroupPromptMessage":
        LockGroupPromptMessage.encode(message.message.lockGroupPromptMessage, writer.uint32(154).fork()).join();
        break;
      case "queryMessage":
        QueryMessage.encode(message.message.queryMessage, writer.uint32(170).fork()).join();
        break;
      case "abortQueryMessage":
        AbortQueryMessage.encode(message.message.abortQueryMessage, writer.uint32(202).fork()).join();
        break;
      case "askPositionMessage":
        AskPositionMessage.encode(message.message.askPositionMessage, writer.uint32(178).fork()).join();
        break;
      case "editMapCommandMessage":
        EditMapCommandMessage.encode(message.message.editMapCommandMessage, writer.uint32(186).fork()).join();
        break;
      case "pingMessage":
        PingMessage.encode(message.message.pingMessage, writer.uint32(194).fork()).join();
        break;
      case "publicEvent":
        PublicEvent.encode(message.message.publicEvent, writer.uint32(242).fork()).join();
        break;
      case "privateEvent":
        PrivateEvent.encode(message.message.privateEvent, writer.uint32(250).fork()).join();
        break;
      case "meetingInvitationRequestMessage":
        MeetingInvitationRequestMessage.encode(
          message.message.meetingInvitationRequestMessage,
          writer.uint32(258).fork(),
        ).join();
        break;
      case "meetingInvitationResponseMessage":
        MeetingInvitationResponseMessage.encode(
          message.message.meetingInvitationResponseMessage,
          writer.uint32(266).fork(),
        ).join();
        break;
      case "setAreaPropertyVariableMessage":
        SetAreaPropertyVariableMessage.encode(message.message.setAreaPropertyVariableMessage, writer.uint32(274).fork())
          .join();
        break;
      case "entityMessage":
        EntityMessage.encode(message.message.entityMessage, writer.uint32(282).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PusherToBackMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePusherToBackMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = {
            $case: "connectToRoomMessage",
            connectToRoomMessage: ConnectToRoomMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = {
            $case: "joinRoomMessage",
            joinRoomMessage: JoinRoomMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = {
            $case: "userMovesMessage",
            userMovesMessage: UserMovesMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = {
            $case: "itemEventMessage",
            itemEventMessage: ItemEventMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.message = {
            $case: "setPlayerDetailsMessage",
            setPlayerDetailsMessage: SetPlayerDetailsMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.message = {
            $case: "emotePromptMessage",
            emotePromptMessage: EmotePromptMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.message = {
            $case: "variableMessage",
            variableMessage: VariableMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.message = {
            $case: "followRequestMessage",
            followRequestMessage: FollowRequestMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.message = {
            $case: "followConfirmationMessage",
            followConfirmationMessage: FollowConfirmationMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.message = {
            $case: "followAbortMessage",
            followAbortMessage: FollowAbortMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.message = {
            $case: "lockGroupPromptMessage",
            lockGroupPromptMessage: LockGroupPromptMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.message = { $case: "queryMessage", queryMessage: QueryMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.message = {
            $case: "abortQueryMessage",
            abortQueryMessage: AbortQueryMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.message = {
            $case: "askPositionMessage",
            askPositionMessage: AskPositionMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.message = {
            $case: "editMapCommandMessage",
            editMapCommandMessage: EditMapCommandMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.message = { $case: "pingMessage", pingMessage: PingMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.message = { $case: "publicEvent", publicEvent: PublicEvent.decode(reader, reader.uint32()) };
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.message = { $case: "privateEvent", privateEvent: PrivateEvent.decode(reader, reader.uint32()) };
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.message = {
            $case: "meetingInvitationRequestMessage",
            meetingInvitationRequestMessage: MeetingInvitationRequestMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.message = {
            $case: "meetingInvitationResponseMessage",
            meetingInvitationResponseMessage: MeetingInvitationResponseMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.message = {
            $case: "setAreaPropertyVariableMessage",
            setAreaPropertyVariableMessage: SetAreaPropertyVariableMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.message = { $case: "entityMessage", entityMessage: EntityMessage.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PusherToBackMessage {
    return {
      message: isSet(object.connectToRoomMessage)
        ? {
          $case: "connectToRoomMessage",
          connectToRoomMessage: ConnectToRoomMessage.fromJSON(object.connectToRoomMessage),
        }
        : isSet(object.joinRoomMessage)
        ? { $case: "joinRoomMessage", joinRoomMessage: JoinRoomMessage.fromJSON(object.joinRoomMessage) }
        : isSet(object.userMovesMessage)
        ? { $case: "userMovesMessage", userMovesMessage: UserMovesMessage.fromJSON(object.userMovesMessage) }
        : isSet(object.itemEventMessage)
        ? { $case: "itemEventMessage", itemEventMessage: ItemEventMessage.fromJSON(object.itemEventMessage) }
        : isSet(object.setPlayerDetailsMessage)
        ? {
          $case: "setPlayerDetailsMessage",
          setPlayerDetailsMessage: SetPlayerDetailsMessage.fromJSON(object.setPlayerDetailsMessage),
        }
        : isSet(object.emotePromptMessage)
        ? { $case: "emotePromptMessage", emotePromptMessage: EmotePromptMessage.fromJSON(object.emotePromptMessage) }
        : isSet(object.variableMessage)
        ? { $case: "variableMessage", variableMessage: VariableMessage.fromJSON(object.variableMessage) }
        : isSet(object.followRequestMessage)
        ? {
          $case: "followRequestMessage",
          followRequestMessage: FollowRequestMessage.fromJSON(object.followRequestMessage),
        }
        : isSet(object.followConfirmationMessage)
        ? {
          $case: "followConfirmationMessage",
          followConfirmationMessage: FollowConfirmationMessage.fromJSON(object.followConfirmationMessage),
        }
        : isSet(object.followAbortMessage)
        ? { $case: "followAbortMessage", followAbortMessage: FollowAbortMessage.fromJSON(object.followAbortMessage) }
        : isSet(object.lockGroupPromptMessage)
        ? {
          $case: "lockGroupPromptMessage",
          lockGroupPromptMessage: LockGroupPromptMessage.fromJSON(object.lockGroupPromptMessage),
        }
        : isSet(object.queryMessage)
        ? { $case: "queryMessage", queryMessage: QueryMessage.fromJSON(object.queryMessage) }
        : isSet(object.abortQueryMessage)
        ? { $case: "abortQueryMessage", abortQueryMessage: AbortQueryMessage.fromJSON(object.abortQueryMessage) }
        : isSet(object.askPositionMessage)
        ? { $case: "askPositionMessage", askPositionMessage: AskPositionMessage.fromJSON(object.askPositionMessage) }
        : isSet(object.editMapCommandMessage)
        ? {
          $case: "editMapCommandMessage",
          editMapCommandMessage: EditMapCommandMessage.fromJSON(object.editMapCommandMessage),
        }
        : isSet(object.pingMessage)
        ? { $case: "pingMessage", pingMessage: PingMessage.fromJSON(object.pingMessage) }
        : isSet(object.publicEvent)
        ? { $case: "publicEvent", publicEvent: PublicEvent.fromJSON(object.publicEvent) }
        : isSet(object.privateEvent)
        ? { $case: "privateEvent", privateEvent: PrivateEvent.fromJSON(object.privateEvent) }
        : isSet(object.meetingInvitationRequestMessage)
        ? {
          $case: "meetingInvitationRequestMessage",
          meetingInvitationRequestMessage: MeetingInvitationRequestMessage.fromJSON(
            object.meetingInvitationRequestMessage,
          ),
        }
        : isSet(object.meetingInvitationResponseMessage)
        ? {
          $case: "meetingInvitationResponseMessage",
          meetingInvitationResponseMessage: MeetingInvitationResponseMessage.fromJSON(
            object.meetingInvitationResponseMessage,
          ),
        }
        : isSet(object.setAreaPropertyVariableMessage)
        ? {
          $case: "setAreaPropertyVariableMessage",
          setAreaPropertyVariableMessage: SetAreaPropertyVariableMessage.fromJSON(
            object.setAreaPropertyVariableMessage,
          ),
        }
        : isSet(object.entityMessage)
        ? { $case: "entityMessage", entityMessage: EntityMessage.fromJSON(object.entityMessage) }
        : undefined,
    };
  },

  toJSON(message: PusherToBackMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "connectToRoomMessage") {
      obj.connectToRoomMessage = ConnectToRoomMessage.toJSON(message.message.connectToRoomMessage);
    } else if (message.message?.$case === "joinRoomMessage") {
      obj.joinRoomMessage = JoinRoomMessage.toJSON(message.message.joinRoomMessage);
    } else if (message.message?.$case === "userMovesMessage") {
      obj.userMovesMessage = UserMovesMessage.toJSON(message.message.userMovesMessage);
    } else if (message.message?.$case === "itemEventMessage") {
      obj.itemEventMessage = ItemEventMessage.toJSON(message.message.itemEventMessage);
    } else if (message.message?.$case === "setPlayerDetailsMessage") {
      obj.setPlayerDetailsMessage = SetPlayerDetailsMessage.toJSON(message.message.setPlayerDetailsMessage);
    } else if (message.message?.$case === "emotePromptMessage") {
      obj.emotePromptMessage = EmotePromptMessage.toJSON(message.message.emotePromptMessage);
    } else if (message.message?.$case === "variableMessage") {
      obj.variableMessage = VariableMessage.toJSON(message.message.variableMessage);
    } else if (message.message?.$case === "followRequestMessage") {
      obj.followRequestMessage = FollowRequestMessage.toJSON(message.message.followRequestMessage);
    } else if (message.message?.$case === "followConfirmationMessage") {
      obj.followConfirmationMessage = FollowConfirmationMessage.toJSON(message.message.followConfirmationMessage);
    } else if (message.message?.$case === "followAbortMessage") {
      obj.followAbortMessage = FollowAbortMessage.toJSON(message.message.followAbortMessage);
    } else if (message.message?.$case === "lockGroupPromptMessage") {
      obj.lockGroupPromptMessage = LockGroupPromptMessage.toJSON(message.message.lockGroupPromptMessage);
    } else if (message.message?.$case === "queryMessage") {
      obj.queryMessage = QueryMessage.toJSON(message.message.queryMessage);
    } else if (message.message?.$case === "abortQueryMessage") {
      obj.abortQueryMessage = AbortQueryMessage.toJSON(message.message.abortQueryMessage);
    } else if (message.message?.$case === "askPositionMessage") {
      obj.askPositionMessage = AskPositionMessage.toJSON(message.message.askPositionMessage);
    } else if (message.message?.$case === "editMapCommandMessage") {
      obj.editMapCommandMessage = EditMapCommandMessage.toJSON(message.message.editMapCommandMessage);
    } else if (message.message?.$case === "pingMessage") {
      obj.pingMessage = PingMessage.toJSON(message.message.pingMessage);
    } else if (message.message?.$case === "publicEvent") {
      obj.publicEvent = PublicEvent.toJSON(message.message.publicEvent);
    } else if (message.message?.$case === "privateEvent") {
      obj.privateEvent = PrivateEvent.toJSON(message.message.privateEvent);
    } else if (message.message?.$case === "meetingInvitationRequestMessage") {
      obj.meetingInvitationRequestMessage = MeetingInvitationRequestMessage.toJSON(
        message.message.meetingInvitationRequestMessage,
      );
    } else if (message.message?.$case === "meetingInvitationResponseMessage") {
      obj.meetingInvitationResponseMessage = MeetingInvitationResponseMessage.toJSON(
        message.message.meetingInvitationResponseMessage,
      );
    } else if (message.message?.$case === "setAreaPropertyVariableMessage") {
      obj.setAreaPropertyVariableMessage = SetAreaPropertyVariableMessage.toJSON(
        message.message.setAreaPropertyVariableMessage,
      );
    } else if (message.message?.$case === "entityMessage") {
      obj.entityMessage = EntityMessage.toJSON(message.message.entityMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PusherToBackMessage>, I>>(base?: I): PusherToBackMessage {
    return PusherToBackMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PusherToBackMessage>, I>>(object: I): PusherToBackMessage {
    const message = createBasePusherToBackMessage();
    switch (object.message?.$case) {
      case "connectToRoomMessage": {
        if (object.message?.connectToRoomMessage !== undefined && object.message?.connectToRoomMessage !== null) {
          message.message = {
            $case: "connectToRoomMessage",
            connectToRoomMessage: ConnectToRoomMessage.fromPartial(object.message.connectToRoomMessage),
          };
        }
        break;
      }
      case "joinRoomMessage": {
        if (object.message?.joinRoomMessage !== undefined && object.message?.joinRoomMessage !== null) {
          message.message = {
            $case: "joinRoomMessage",
            joinRoomMessage: JoinRoomMessage.fromPartial(object.message.joinRoomMessage),
          };
        }
        break;
      }
      case "userMovesMessage": {
        if (object.message?.userMovesMessage !== undefined && object.message?.userMovesMessage !== null) {
          message.message = {
            $case: "userMovesMessage",
            userMovesMessage: UserMovesMessage.fromPartial(object.message.userMovesMessage),
          };
        }
        break;
      }
      case "itemEventMessage": {
        if (object.message?.itemEventMessage !== undefined && object.message?.itemEventMessage !== null) {
          message.message = {
            $case: "itemEventMessage",
            itemEventMessage: ItemEventMessage.fromPartial(object.message.itemEventMessage),
          };
        }
        break;
      }
      case "setPlayerDetailsMessage": {
        if (object.message?.setPlayerDetailsMessage !== undefined && object.message?.setPlayerDetailsMessage !== null) {
          message.message = {
            $case: "setPlayerDetailsMessage",
            setPlayerDetailsMessage: SetPlayerDetailsMessage.fromPartial(object.message.setPlayerDetailsMessage),
          };
        }
        break;
      }
      case "emotePromptMessage": {
        if (object.message?.emotePromptMessage !== undefined && object.message?.emotePromptMessage !== null) {
          message.message = {
            $case: "emotePromptMessage",
            emotePromptMessage: EmotePromptMessage.fromPartial(object.message.emotePromptMessage),
          };
        }
        break;
      }
      case "variableMessage": {
        if (object.message?.variableMessage !== undefined && object.message?.variableMessage !== null) {
          message.message = {
            $case: "variableMessage",
            variableMessage: VariableMessage.fromPartial(object.message.variableMessage),
          };
        }
        break;
      }
      case "followRequestMessage": {
        if (object.message?.followRequestMessage !== undefined && object.message?.followRequestMessage !== null) {
          message.message = {
            $case: "followRequestMessage",
            followRequestMessage: FollowRequestMessage.fromPartial(object.message.followRequestMessage),
          };
        }
        break;
      }
      case "followConfirmationMessage": {
        if (
          object.message?.followConfirmationMessage !== undefined && object.message?.followConfirmationMessage !== null
        ) {
          message.message = {
            $case: "followConfirmationMessage",
            followConfirmationMessage: FollowConfirmationMessage.fromPartial(object.message.followConfirmationMessage),
          };
        }
        break;
      }
      case "followAbortMessage": {
        if (object.message?.followAbortMessage !== undefined && object.message?.followAbortMessage !== null) {
          message.message = {
            $case: "followAbortMessage",
            followAbortMessage: FollowAbortMessage.fromPartial(object.message.followAbortMessage),
          };
        }
        break;
      }
      case "lockGroupPromptMessage": {
        if (object.message?.lockGroupPromptMessage !== undefined && object.message?.lockGroupPromptMessage !== null) {
          message.message = {
            $case: "lockGroupPromptMessage",
            lockGroupPromptMessage: LockGroupPromptMessage.fromPartial(object.message.lockGroupPromptMessage),
          };
        }
        break;
      }
      case "queryMessage": {
        if (object.message?.queryMessage !== undefined && object.message?.queryMessage !== null) {
          message.message = {
            $case: "queryMessage",
            queryMessage: QueryMessage.fromPartial(object.message.queryMessage),
          };
        }
        break;
      }
      case "abortQueryMessage": {
        if (object.message?.abortQueryMessage !== undefined && object.message?.abortQueryMessage !== null) {
          message.message = {
            $case: "abortQueryMessage",
            abortQueryMessage: AbortQueryMessage.fromPartial(object.message.abortQueryMessage),
          };
        }
        break;
      }
      case "askPositionMessage": {
        if (object.message?.askPositionMessage !== undefined && object.message?.askPositionMessage !== null) {
          message.message = {
            $case: "askPositionMessage",
            askPositionMessage: AskPositionMessage.fromPartial(object.message.askPositionMessage),
          };
        }
        break;
      }
      case "editMapCommandMessage": {
        if (object.message?.editMapCommandMessage !== undefined && object.message?.editMapCommandMessage !== null) {
          message.message = {
            $case: "editMapCommandMessage",
            editMapCommandMessage: EditMapCommandMessage.fromPartial(object.message.editMapCommandMessage),
          };
        }
        break;
      }
      case "pingMessage": {
        if (object.message?.pingMessage !== undefined && object.message?.pingMessage !== null) {
          message.message = { $case: "pingMessage", pingMessage: PingMessage.fromPartial(object.message.pingMessage) };
        }
        break;
      }
      case "publicEvent": {
        if (object.message?.publicEvent !== undefined && object.message?.publicEvent !== null) {
          message.message = { $case: "publicEvent", publicEvent: PublicEvent.fromPartial(object.message.publicEvent) };
        }
        break;
      }
      case "privateEvent": {
        if (object.message?.privateEvent !== undefined && object.message?.privateEvent !== null) {
          message.message = {
            $case: "privateEvent",
            privateEvent: PrivateEvent.fromPartial(object.message.privateEvent),
          };
        }
        break;
      }
      case "meetingInvitationRequestMessage": {
        if (
          object.message?.meetingInvitationRequestMessage !== undefined &&
          object.message?.meetingInvitationRequestMessage !== null
        ) {
          message.message = {
            $case: "meetingInvitationRequestMessage",
            meetingInvitationRequestMessage: MeetingInvitationRequestMessage.fromPartial(
              object.message.meetingInvitationRequestMessage,
            ),
          };
        }
        break;
      }
      case "meetingInvitationResponseMessage": {
        if (
          object.message?.meetingInvitationResponseMessage !== undefined &&
          object.message?.meetingInvitationResponseMessage !== null
        ) {
          message.message = {
            $case: "meetingInvitationResponseMessage",
            meetingInvitationResponseMessage: MeetingInvitationResponseMessage.fromPartial(
              object.message.meetingInvitationResponseMessage,
            ),
          };
        }
        break;
      }
      case "setAreaPropertyVariableMessage": {
        if (
          object.message?.setAreaPropertyVariableMessage !== undefined &&
          object.message?.setAreaPropertyVariableMessage !== null
        ) {
          message.message = {
            $case: "setAreaPropertyVariableMessage",
            setAreaPropertyVariableMessage: SetAreaPropertyVariableMessage.fromPartial(
              object.message.setAreaPropertyVariableMessage,
            ),
          };
        }
        break;
      }
      case "entityMessage": {
        if (object.message?.entityMessage !== undefined && object.message?.entityMessage !== null) {
          message.message = {
            $case: "entityMessage",
            entityMessage: EntityMessage.fromPartial(object.message.entityMessage),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseBatchToPusherRoomMessage(): BatchToPusherRoomMessage {
  return { payload: [] };
}

export const BatchToPusherRoomMessage: MessageFns<BatchToPusherRoomMessage> = {
  encode(message: BatchToPusherRoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.payload) {
      SubToPusherRoomMessage.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BatchToPusherRoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchToPusherRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.payload.push(SubToPusherRoomMessage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatchToPusherRoomMessage {
    return {
      payload: globalThis.Array.isArray(object?.payload)
        ? object.payload.map((e: any) => SubToPusherRoomMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BatchToPusherRoomMessage): unknown {
    const obj: any = {};
    if (message.payload?.length) {
      obj.payload = message.payload.map((e) => SubToPusherRoomMessage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BatchToPusherRoomMessage>, I>>(base?: I): BatchToPusherRoomMessage {
    return BatchToPusherRoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BatchToPusherRoomMessage>, I>>(object: I): BatchToPusherRoomMessage {
    const message = createBaseBatchToPusherRoomMessage();
    message.payload = object.payload?.map((e) => SubToPusherRoomMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSubToPusherRoomMessage(): SubToPusherRoomMessage {
  return { message: undefined };
}

export const SubToPusherRoomMessage: MessageFns<SubToPusherRoomMessage> = {
  encode(message: SubToPusherRoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "variableMessage":
        VariableWithTagMessage.encode(message.message.variableMessage, writer.uint32(10).fork()).join();
        break;
      case "errorMessage":
        ErrorMessage.encode(message.message.errorMessage, writer.uint32(18).fork()).join();
        break;
      case "editMapCommandMessage":
        EditMapCommandMessage.encode(message.message.editMapCommandMessage, writer.uint32(26).fork()).join();
        break;
      case "receivedEventMessage":
        ReceivedEventMessage.encode(message.message.receivedEventMessage, writer.uint32(50).fork()).join();
        break;
      case "entityMessage":
        EntityMessage.encode(message.message.entityMessage, writer.uint32(74).fork()).join();
        break;
      case "zoneMessage":
        ZoneMessage.encode(message.message.zoneMessage, writer.uint32(58).fork()).join();
        break;
      case "areaPropertyVariableMessage":
        AreaPropertyVariableMessage.encode(message.message.areaPropertyVariableMessage, writer.uint32(66).fork())
          .join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubToPusherRoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubToPusherRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = {
            $case: "variableMessage",
            variableMessage: VariableWithTagMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = { $case: "errorMessage", errorMessage: ErrorMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = {
            $case: "editMapCommandMessage",
            editMapCommandMessage: EditMapCommandMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.message = {
            $case: "receivedEventMessage",
            receivedEventMessage: ReceivedEventMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.message = { $case: "entityMessage", entityMessage: EntityMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.message = { $case: "zoneMessage", zoneMessage: ZoneMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.message = {
            $case: "areaPropertyVariableMessage",
            areaPropertyVariableMessage: AreaPropertyVariableMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubToPusherRoomMessage {
    return {
      message: isSet(object.variableMessage)
        ? { $case: "variableMessage", variableMessage: VariableWithTagMessage.fromJSON(object.variableMessage) }
        : isSet(object.errorMessage)
        ? { $case: "errorMessage", errorMessage: ErrorMessage.fromJSON(object.errorMessage) }
        : isSet(object.editMapCommandMessage)
        ? {
          $case: "editMapCommandMessage",
          editMapCommandMessage: EditMapCommandMessage.fromJSON(object.editMapCommandMessage),
        }
        : isSet(object.receivedEventMessage)
        ? {
          $case: "receivedEventMessage",
          receivedEventMessage: ReceivedEventMessage.fromJSON(object.receivedEventMessage),
        }
        : isSet(object.entityMessage)
        ? { $case: "entityMessage", entityMessage: EntityMessage.fromJSON(object.entityMessage) }
        : isSet(object.zoneMessage)
        ? { $case: "zoneMessage", zoneMessage: ZoneMessage.fromJSON(object.zoneMessage) }
        : isSet(object.areaPropertyVariableMessage)
        ? {
          $case: "areaPropertyVariableMessage",
          areaPropertyVariableMessage: AreaPropertyVariableMessage.fromJSON(object.areaPropertyVariableMessage),
        }
        : undefined,
    };
  },

  toJSON(message: SubToPusherRoomMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "variableMessage") {
      obj.variableMessage = VariableWithTagMessage.toJSON(message.message.variableMessage);
    } else if (message.message?.$case === "errorMessage") {
      obj.errorMessage = ErrorMessage.toJSON(message.message.errorMessage);
    } else if (message.message?.$case === "editMapCommandMessage") {
      obj.editMapCommandMessage = EditMapCommandMessage.toJSON(message.message.editMapCommandMessage);
    } else if (message.message?.$case === "receivedEventMessage") {
      obj.receivedEventMessage = ReceivedEventMessage.toJSON(message.message.receivedEventMessage);
    } else if (message.message?.$case === "entityMessage") {
      obj.entityMessage = EntityMessage.toJSON(message.message.entityMessage);
    } else if (message.message?.$case === "zoneMessage") {
      obj.zoneMessage = ZoneMessage.toJSON(message.message.zoneMessage);
    } else if (message.message?.$case === "areaPropertyVariableMessage") {
      obj.areaPropertyVariableMessage = AreaPropertyVariableMessage.toJSON(message.message.areaPropertyVariableMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubToPusherRoomMessage>, I>>(base?: I): SubToPusherRoomMessage {
    return SubToPusherRoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubToPusherRoomMessage>, I>>(object: I): SubToPusherRoomMessage {
    const message = createBaseSubToPusherRoomMessage();
    switch (object.message?.$case) {
      case "variableMessage": {
        if (object.message?.variableMessage !== undefined && object.message?.variableMessage !== null) {
          message.message = {
            $case: "variableMessage",
            variableMessage: VariableWithTagMessage.fromPartial(object.message.variableMessage),
          };
        }
        break;
      }
      case "errorMessage": {
        if (object.message?.errorMessage !== undefined && object.message?.errorMessage !== null) {
          message.message = {
            $case: "errorMessage",
            errorMessage: ErrorMessage.fromPartial(object.message.errorMessage),
          };
        }
        break;
      }
      case "editMapCommandMessage": {
        if (object.message?.editMapCommandMessage !== undefined && object.message?.editMapCommandMessage !== null) {
          message.message = {
            $case: "editMapCommandMessage",
            editMapCommandMessage: EditMapCommandMessage.fromPartial(object.message.editMapCommandMessage),
          };
        }
        break;
      }
      case "receivedEventMessage": {
        if (object.message?.receivedEventMessage !== undefined && object.message?.receivedEventMessage !== null) {
          message.message = {
            $case: "receivedEventMessage",
            receivedEventMessage: ReceivedEventMessage.fromPartial(object.message.receivedEventMessage),
          };
        }
        break;
      }
      case "entityMessage": {
        if (object.message?.entityMessage !== undefined && object.message?.entityMessage !== null) {
          message.message = {
            $case: "entityMessage",
            entityMessage: EntityMessage.fromPartial(object.message.entityMessage),
          };
        }
        break;
      }
      case "zoneMessage": {
        if (object.message?.zoneMessage !== undefined && object.message?.zoneMessage !== null) {
          message.message = { $case: "zoneMessage", zoneMessage: ZoneMessage.fromPartial(object.message.zoneMessage) };
        }
        break;
      }
      case "areaPropertyVariableMessage": {
        if (
          object.message?.areaPropertyVariableMessage !== undefined &&
          object.message?.areaPropertyVariableMessage !== null
        ) {
          message.message = {
            $case: "areaPropertyVariableMessage",
            areaPropertyVariableMessage: AreaPropertyVariableMessage.fromPartial(
              object.message.areaPropertyVariableMessage,
            ),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseUserJoinedRoomMessage(): UserJoinedRoomMessage {
  return { uuid: "", ipAddress: "", name: "" };
}

export const UserJoinedRoomMessage: MessageFns<UserJoinedRoomMessage> = {
  encode(message: UserJoinedRoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uuid !== "") {
      writer.uint32(10).string(message.uuid);
    }
    if (message.ipAddress !== "") {
      writer.uint32(18).string(message.ipAddress);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserJoinedRoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserJoinedRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserJoinedRoomMessage {
    return {
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: UserJoinedRoomMessage): unknown {
    const obj: any = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserJoinedRoomMessage>, I>>(base?: I): UserJoinedRoomMessage {
    return UserJoinedRoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserJoinedRoomMessage>, I>>(object: I): UserJoinedRoomMessage {
    const message = createBaseUserJoinedRoomMessage();
    message.uuid = object.uuid ?? "";
    message.ipAddress = object.ipAddress ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseUserLeftRoomMessage(): UserLeftRoomMessage {
  return { uuid: "" };
}

export const UserLeftRoomMessage: MessageFns<UserLeftRoomMessage> = {
  encode(message: UserLeftRoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uuid !== "") {
      writer.uint32(10).string(message.uuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserLeftRoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserLeftRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserLeftRoomMessage {
    return { uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "" };
  },

  toJSON(message: UserLeftRoomMessage): unknown {
    const obj: any = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserLeftRoomMessage>, I>>(base?: I): UserLeftRoomMessage {
    return UserLeftRoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserLeftRoomMessage>, I>>(object: I): UserLeftRoomMessage {
    const message = createBaseUserLeftRoomMessage();
    message.uuid = object.uuid ?? "";
    return message;
  },
};

function createBaseServerToAdminClientMessage(): ServerToAdminClientMessage {
  return { message: undefined };
}

export const ServerToAdminClientMessage: MessageFns<ServerToAdminClientMessage> = {
  encode(message: ServerToAdminClientMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "userJoinedRoom":
        UserJoinedRoomMessage.encode(message.message.userJoinedRoom, writer.uint32(10).fork()).join();
        break;
      case "userLeftRoom":
        UserLeftRoomMessage.encode(message.message.userLeftRoom, writer.uint32(18).fork()).join();
        break;
      case "errorMessage":
        ErrorMessage.encode(message.message.errorMessage, writer.uint32(26).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerToAdminClientMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerToAdminClientMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = {
            $case: "userJoinedRoom",
            userJoinedRoom: UserJoinedRoomMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = {
            $case: "userLeftRoom",
            userLeftRoom: UserLeftRoomMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = { $case: "errorMessage", errorMessage: ErrorMessage.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerToAdminClientMessage {
    return {
      message: isSet(object.userJoinedRoom)
        ? { $case: "userJoinedRoom", userJoinedRoom: UserJoinedRoomMessage.fromJSON(object.userJoinedRoom) }
        : isSet(object.userLeftRoom)
        ? { $case: "userLeftRoom", userLeftRoom: UserLeftRoomMessage.fromJSON(object.userLeftRoom) }
        : isSet(object.errorMessage)
        ? { $case: "errorMessage", errorMessage: ErrorMessage.fromJSON(object.errorMessage) }
        : undefined,
    };
  },

  toJSON(message: ServerToAdminClientMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "userJoinedRoom") {
      obj.userJoinedRoom = UserJoinedRoomMessage.toJSON(message.message.userJoinedRoom);
    } else if (message.message?.$case === "userLeftRoom") {
      obj.userLeftRoom = UserLeftRoomMessage.toJSON(message.message.userLeftRoom);
    } else if (message.message?.$case === "errorMessage") {
      obj.errorMessage = ErrorMessage.toJSON(message.message.errorMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerToAdminClientMessage>, I>>(base?: I): ServerToAdminClientMessage {
    return ServerToAdminClientMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerToAdminClientMessage>, I>>(object: I): ServerToAdminClientMessage {
    const message = createBaseServerToAdminClientMessage();
    switch (object.message?.$case) {
      case "userJoinedRoom": {
        if (object.message?.userJoinedRoom !== undefined && object.message?.userJoinedRoom !== null) {
          message.message = {
            $case: "userJoinedRoom",
            userJoinedRoom: UserJoinedRoomMessage.fromPartial(object.message.userJoinedRoom),
          };
        }
        break;
      }
      case "userLeftRoom": {
        if (object.message?.userLeftRoom !== undefined && object.message?.userLeftRoom !== null) {
          message.message = {
            $case: "userLeftRoom",
            userLeftRoom: UserLeftRoomMessage.fromPartial(object.message.userLeftRoom),
          };
        }
        break;
      }
      case "errorMessage": {
        if (object.message?.errorMessage !== undefined && object.message?.errorMessage !== null) {
          message.message = {
            $case: "errorMessage",
            errorMessage: ErrorMessage.fromPartial(object.message.errorMessage),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseAdminPusherToBackMessage(): AdminPusherToBackMessage {
  return { message: undefined };
}

export const AdminPusherToBackMessage: MessageFns<AdminPusherToBackMessage> = {
  encode(message: AdminPusherToBackMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "subscribeToRoom":
        writer.uint32(10).string(message.message.subscribeToRoom);
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminPusherToBackMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminPusherToBackMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = { $case: "subscribeToRoom", subscribeToRoom: reader.string() };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminPusherToBackMessage {
    return {
      message: isSet(object.subscribeToRoom)
        ? { $case: "subscribeToRoom", subscribeToRoom: globalThis.String(object.subscribeToRoom) }
        : undefined,
    };
  },

  toJSON(message: AdminPusherToBackMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "subscribeToRoom") {
      obj.subscribeToRoom = message.message.subscribeToRoom;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminPusherToBackMessage>, I>>(base?: I): AdminPusherToBackMessage {
    return AdminPusherToBackMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminPusherToBackMessage>, I>>(object: I): AdminPusherToBackMessage {
    const message = createBaseAdminPusherToBackMessage();
    switch (object.message?.$case) {
      case "subscribeToRoom": {
        if (object.message?.subscribeToRoom !== undefined && object.message?.subscribeToRoom !== null) {
          message.message = { $case: "subscribeToRoom", subscribeToRoom: object.message.subscribeToRoom };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseMapStorageRefreshMessage(): MapStorageRefreshMessage {
  return { comment: "" };
}

export const MapStorageRefreshMessage: MessageFns<MapStorageRefreshMessage> = {
  encode(message: MapStorageRefreshMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.comment !== "") {
      writer.uint32(10).string(message.comment);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MapStorageRefreshMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMapStorageRefreshMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MapStorageRefreshMessage {
    return { comment: isSet(object.comment) ? globalThis.String(object.comment) : "" };
  },

  toJSON(message: MapStorageRefreshMessage): unknown {
    const obj: any = {};
    if (message.comment !== "") {
      obj.comment = message.comment;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MapStorageRefreshMessage>, I>>(base?: I): MapStorageRefreshMessage {
    return MapStorageRefreshMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MapStorageRefreshMessage>, I>>(object: I): MapStorageRefreshMessage {
    const message = createBaseMapStorageRefreshMessage();
    message.comment = object.comment ?? "";
    return message;
  },
};

function createBaseMapStorageToBackMessage(): MapStorageToBackMessage {
  return { message: undefined };
}

export const MapStorageToBackMessage: MessageFns<MapStorageToBackMessage> = {
  encode(message: MapStorageToBackMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "mapStorageRefreshMessage":
        MapStorageRefreshMessage.encode(message.message.mapStorageRefreshMessage, writer.uint32(10).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MapStorageToBackMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMapStorageToBackMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = {
            $case: "mapStorageRefreshMessage",
            mapStorageRefreshMessage: MapStorageRefreshMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MapStorageToBackMessage {
    return {
      message: isSet(object.mapStorageRefreshMessage)
        ? {
          $case: "mapStorageRefreshMessage",
          mapStorageRefreshMessage: MapStorageRefreshMessage.fromJSON(object.mapStorageRefreshMessage),
        }
        : undefined,
    };
  },

  toJSON(message: MapStorageToBackMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "mapStorageRefreshMessage") {
      obj.mapStorageRefreshMessage = MapStorageRefreshMessage.toJSON(message.message.mapStorageRefreshMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MapStorageToBackMessage>, I>>(base?: I): MapStorageToBackMessage {
    return MapStorageToBackMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MapStorageToBackMessage>, I>>(object: I): MapStorageToBackMessage {
    const message = createBaseMapStorageToBackMessage();
    switch (object.message?.$case) {
      case "mapStorageRefreshMessage": {
        if (
          object.message?.mapStorageRefreshMessage !== undefined && object.message?.mapStorageRefreshMessage !== null
        ) {
          message.message = {
            $case: "mapStorageRefreshMessage",
            mapStorageRefreshMessage: MapStorageRefreshMessage.fromPartial(object.message.mapStorageRefreshMessage),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseMapStorageUrlMessage(): MapStorageUrlMessage {
  return { mapUrl: "", roomId: "" };
}

export const MapStorageUrlMessage: MessageFns<MapStorageUrlMessage> = {
  encode(message: MapStorageUrlMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mapUrl !== "") {
      writer.uint32(10).string(message.mapUrl);
    }
    if (message.roomId !== "") {
      writer.uint32(18).string(message.roomId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MapStorageUrlMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMapStorageUrlMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.mapUrl = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.roomId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MapStorageUrlMessage {
    return {
      mapUrl: isSet(object.mapUrl) ? globalThis.String(object.mapUrl) : "",
      roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "",
    };
  },

  toJSON(message: MapStorageUrlMessage): unknown {
    const obj: any = {};
    if (message.mapUrl !== "") {
      obj.mapUrl = message.mapUrl;
    }
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MapStorageUrlMessage>, I>>(base?: I): MapStorageUrlMessage {
    return MapStorageUrlMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MapStorageUrlMessage>, I>>(object: I): MapStorageUrlMessage {
    const message = createBaseMapStorageUrlMessage();
    message.mapUrl = object.mapUrl ?? "";
    message.roomId = object.roomId ?? "";
    return message;
  },
};

function createBaseMapStorageClearAfterUploadMessage(): MapStorageClearAfterUploadMessage {
  return { wamUrl: "" };
}

export const MapStorageClearAfterUploadMessage: MessageFns<MapStorageClearAfterUploadMessage> = {
  encode(message: MapStorageClearAfterUploadMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.wamUrl !== "") {
      writer.uint32(10).string(message.wamUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MapStorageClearAfterUploadMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMapStorageClearAfterUploadMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.wamUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MapStorageClearAfterUploadMessage {
    return { wamUrl: isSet(object.wamUrl) ? globalThis.String(object.wamUrl) : "" };
  },

  toJSON(message: MapStorageClearAfterUploadMessage): unknown {
    const obj: any = {};
    if (message.wamUrl !== "") {
      obj.wamUrl = message.wamUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MapStorageClearAfterUploadMessage>, I>>(
    base?: I,
  ): MapStorageClearAfterUploadMessage {
    return MapStorageClearAfterUploadMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MapStorageClearAfterUploadMessage>, I>>(
    object: I,
  ): MapStorageClearAfterUploadMessage {
    const message = createBaseMapStorageClearAfterUploadMessage();
    message.wamUrl = object.wamUrl ?? "";
    return message;
  },
};

function createBaseMapStorageDeleteMessage(): MapStorageDeleteMessage {
  return { wamUrl: "" };
}

export const MapStorageDeleteMessage: MessageFns<MapStorageDeleteMessage> = {
  encode(message: MapStorageDeleteMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.wamUrl !== "") {
      writer.uint32(10).string(message.wamUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MapStorageDeleteMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMapStorageDeleteMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.wamUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MapStorageDeleteMessage {
    return { wamUrl: isSet(object.wamUrl) ? globalThis.String(object.wamUrl) : "" };
  },

  toJSON(message: MapStorageDeleteMessage): unknown {
    const obj: any = {};
    if (message.wamUrl !== "") {
      obj.wamUrl = message.wamUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MapStorageDeleteMessage>, I>>(base?: I): MapStorageDeleteMessage {
    return MapStorageDeleteMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MapStorageDeleteMessage>, I>>(object: I): MapStorageDeleteMessage {
    const message = createBaseMapStorageDeleteMessage();
    message.wamUrl = object.wamUrl ?? "";
    return message;
  },
};

function createBaseAdminRoomMessage(): AdminRoomMessage {
  return { message: "", roomId: "", type: "" };
}

export const AdminRoomMessage: MessageFns<AdminRoomMessage> = {
  encode(message: AdminRoomMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    if (message.roomId !== "") {
      writer.uint32(18).string(message.roomId);
    }
    if (message.type !== "") {
      writer.uint32(26).string(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminRoomMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminRoomMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.roomId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.type = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminRoomMessage {
    return {
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
    };
  },

  toJSON(message: AdminRoomMessage): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminRoomMessage>, I>>(base?: I): AdminRoomMessage {
    return AdminRoomMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminRoomMessage>, I>>(object: I): AdminRoomMessage {
    const message = createBaseAdminRoomMessage();
    message.message = object.message ?? "";
    message.roomId = object.roomId ?? "";
    message.type = object.type ?? "";
    return message;
  },
};

function createBaseAdminGlobalMessage(): AdminGlobalMessage {
  return { message: "" };
}

export const AdminGlobalMessage: MessageFns<AdminGlobalMessage> = {
  encode(message: AdminGlobalMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGlobalMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGlobalMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGlobalMessage {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: AdminGlobalMessage): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGlobalMessage>, I>>(base?: I): AdminGlobalMessage {
    return AdminGlobalMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGlobalMessage>, I>>(object: I): AdminGlobalMessage {
    const message = createBaseAdminGlobalMessage();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseBanMessage(): BanMessage {
  return { recipientUuid: "", roomId: "", type: "", message: "" };
}

export const BanMessage: MessageFns<BanMessage> = {
  encode(message: BanMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.recipientUuid !== "") {
      writer.uint32(10).string(message.recipientUuid);
    }
    if (message.roomId !== "") {
      writer.uint32(18).string(message.roomId);
    }
    if (message.type !== "") {
      writer.uint32(26).string(message.type);
    }
    if (message.message !== "") {
      writer.uint32(34).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BanMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBanMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.recipientUuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.roomId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BanMessage {
    return {
      recipientUuid: isSet(object.recipientUuid) ? globalThis.String(object.recipientUuid) : "",
      roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: BanMessage): unknown {
    const obj: any = {};
    if (message.recipientUuid !== "") {
      obj.recipientUuid = message.recipientUuid;
    }
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BanMessage>, I>>(base?: I): BanMessage {
    return BanMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BanMessage>, I>>(object: I): BanMessage {
    const message = createBaseBanMessage();
    message.recipientUuid = object.recipientUuid ?? "";
    message.roomId = object.roomId ?? "";
    message.type = object.type ?? "";
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseRoomDescription(): RoomDescription {
  return { roomId: "", nbUsers: 0 };
}

export const RoomDescription: MessageFns<RoomDescription> = {
  encode(message: RoomDescription, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.roomId !== "") {
      writer.uint32(10).string(message.roomId);
    }
    if (message.nbUsers !== 0) {
      writer.uint32(16).int32(message.nbUsers);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoomDescription {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomDescription();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roomId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.nbUsers = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoomDescription {
    return {
      roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "",
      nbUsers: isSet(object.nbUsers) ? globalThis.Number(object.nbUsers) : 0,
    };
  },

  toJSON(message: RoomDescription): unknown {
    const obj: any = {};
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    if (message.nbUsers !== 0) {
      obj.nbUsers = Math.round(message.nbUsers);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoomDescription>, I>>(base?: I): RoomDescription {
    return RoomDescription.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoomDescription>, I>>(object: I): RoomDescription {
    const message = createBaseRoomDescription();
    message.roomId = object.roomId ?? "";
    message.nbUsers = object.nbUsers ?? 0;
    return message;
  },
};

function createBaseRoomsList(): RoomsList {
  return { roomDescription: [] };
}

export const RoomsList: MessageFns<RoomsList> = {
  encode(message: RoomsList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.roomDescription) {
      RoomDescription.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoomsList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomsList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roomDescription.push(RoomDescription.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoomsList {
    return {
      roomDescription: globalThis.Array.isArray(object?.roomDescription)
        ? object.roomDescription.map((e: any) => RoomDescription.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RoomsList): unknown {
    const obj: any = {};
    if (message.roomDescription?.length) {
      obj.roomDescription = message.roomDescription.map((e) => RoomDescription.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RoomsList>, I>>(base?: I): RoomsList {
    return RoomsList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RoomsList>, I>>(object: I): RoomsList {
    const message = createBaseRoomsList();
    message.roomDescription = object.roomDescription?.map((e) => RoomDescription.fromPartial(e)) || [];
    return message;
  },
};

function createBaseWorldUsersQuery(): WorldUsersQuery {
  return { world: "" };
}

export const WorldUsersQuery: MessageFns<WorldUsersQuery> = {
  encode(message: WorldUsersQuery, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.world !== "") {
      writer.uint32(10).string(message.world);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorldUsersQuery {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorldUsersQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.world = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorldUsersQuery {
    return { world: isSet(object.world) ? globalThis.String(object.world) : "" };
  },

  toJSON(message: WorldUsersQuery): unknown {
    const obj: any = {};
    if (message.world !== "") {
      obj.world = message.world;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorldUsersQuery>, I>>(base?: I): WorldUsersQuery {
    return WorldUsersQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorldUsersQuery>, I>>(object: I): WorldUsersQuery {
    const message = createBaseWorldUsersQuery();
    message.world = object.world ?? "";
    return message;
  },
};

function createBaseWorldUser(): WorldUser {
  return { uuid: "", name: "", ipAddress: "", roomUrl: "" };
}

export const WorldUser: MessageFns<WorldUser> = {
  encode(message: WorldUser, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uuid !== "") {
      writer.uint32(10).string(message.uuid);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.ipAddress !== "") {
      writer.uint32(26).string(message.ipAddress);
    }
    if (message.roomUrl !== "") {
      writer.uint32(34).string(message.roomUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorldUser {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorldUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ipAddress = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.roomUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorldUser {
    return {
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      ipAddress: isSet(object.ipAddress) ? globalThis.String(object.ipAddress) : "",
      roomUrl: isSet(object.roomUrl) ? globalThis.String(object.roomUrl) : "",
    };
  },

  toJSON(message: WorldUser): unknown {
    const obj: any = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.ipAddress !== "") {
      obj.ipAddress = message.ipAddress;
    }
    if (message.roomUrl !== "") {
      obj.roomUrl = message.roomUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorldUser>, I>>(base?: I): WorldUser {
    return WorldUser.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorldUser>, I>>(object: I): WorldUser {
    const message = createBaseWorldUser();
    message.uuid = object.uuid ?? "";
    message.name = object.name ?? "";
    message.ipAddress = object.ipAddress ?? "";
    message.roomUrl = object.roomUrl ?? "";
    return message;
  },
};

function createBaseWorldUsersAnswer(): WorldUsersAnswer {
  return { users: [] };
}

export const WorldUsersAnswer: MessageFns<WorldUsersAnswer> = {
  encode(message: WorldUsersAnswer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.users) {
      WorldUser.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorldUsersAnswer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorldUsersAnswer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.users.push(WorldUser.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorldUsersAnswer {
    return {
      users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => WorldUser.fromJSON(e)) : [],
    };
  },

  toJSON(message: WorldUsersAnswer): unknown {
    const obj: any = {};
    if (message.users?.length) {
      obj.users = message.users.map((e) => WorldUser.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WorldUsersAnswer>, I>>(base?: I): WorldUsersAnswer {
    return WorldUsersAnswer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WorldUsersAnswer>, I>>(object: I): WorldUsersAnswer {
    const message = createBaseWorldUsersAnswer();
    message.users = object.users?.map((e) => WorldUser.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDispatchGlobalEventRequest(): DispatchGlobalEventRequest {
  return { name: "", value: undefined };
}

export const DispatchGlobalEventRequest: MessageFns<DispatchGlobalEventRequest> = {
  encode(message: DispatchGlobalEventRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.value !== undefined) {
      Value.encode(Value.wrap(message.value), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DispatchGlobalEventRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDispatchGlobalEventRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DispatchGlobalEventRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object?.value) ? object.value : undefined,
    };
  },

  toJSON(message: DispatchGlobalEventRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value !== undefined) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DispatchGlobalEventRequest>, I>>(base?: I): DispatchGlobalEventRequest {
    return DispatchGlobalEventRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DispatchGlobalEventRequest>, I>>(object: I): DispatchGlobalEventRequest {
    const message = createBaseDispatchGlobalEventRequest();
    message.name = object.name ?? "";
    message.value = object.value ?? undefined;
    return message;
  },
};

function createBaseExternalModuleMessage(): ExternalModuleMessage {
  return { moduleId: "", recipientUuid: undefined, roomId: undefined, message: undefined };
}

export const ExternalModuleMessage: MessageFns<ExternalModuleMessage> = {
  encode(message: ExternalModuleMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.moduleId !== "") {
      writer.uint32(10).string(message.moduleId);
    }
    if (message.recipientUuid !== undefined) {
      writer.uint32(18).string(message.recipientUuid);
    }
    if (message.roomId !== undefined) {
      writer.uint32(26).string(message.roomId);
    }
    if (message.message !== undefined) {
      Value.encode(Value.wrap(message.message), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExternalModuleMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExternalModuleMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.moduleId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.recipientUuid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.roomId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExternalModuleMessage {
    return {
      moduleId: isSet(object.moduleId) ? globalThis.String(object.moduleId) : "",
      recipientUuid: isSet(object.recipientUuid) ? globalThis.String(object.recipientUuid) : undefined,
      roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : undefined,
      message: isSet(object?.message) ? object.message : undefined,
    };
  },

  toJSON(message: ExternalModuleMessage): unknown {
    const obj: any = {};
    if (message.moduleId !== "") {
      obj.moduleId = message.moduleId;
    }
    if (message.recipientUuid !== undefined) {
      obj.recipientUuid = message.recipientUuid;
    }
    if (message.roomId !== undefined) {
      obj.roomId = message.roomId;
    }
    if (message.message !== undefined) {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExternalModuleMessage>, I>>(base?: I): ExternalModuleMessage {
    return ExternalModuleMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExternalModuleMessage>, I>>(object: I): ExternalModuleMessage {
    const message = createBaseExternalModuleMessage();
    message.moduleId = object.moduleId ?? "";
    message.recipientUuid = object.recipientUuid ?? undefined;
    message.roomId = object.roomId ?? undefined;
    message.message = object.message ?? undefined;
    return message;
  },
};

function createBasePusherToBackSpaceMessage(): PusherToBackSpaceMessage {
  return { message: undefined };
}

export const PusherToBackSpaceMessage: MessageFns<PusherToBackSpaceMessage> = {
  encode(message: PusherToBackSpaceMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "joinSpaceMessage":
        JoinSpaceMessage.encode(message.message.joinSpaceMessage, writer.uint32(10).fork()).join();
        break;
      case "leaveSpaceMessage":
        LeaveSpaceMessage.encode(message.message.leaveSpaceMessage, writer.uint32(18).fork()).join();
        break;
      case "updateSpaceUserMessage":
        UpdateSpaceUserMessage.encode(message.message.updateSpaceUserMessage, writer.uint32(34).fork()).join();
        break;
      case "pongMessage":
        PingMessage.encode(message.message.pongMessage, writer.uint32(50).fork()).join();
        break;
      case "updateSpaceMetadataPusherToBackMessage":
        UpdateSpaceMetadataPusherToBackMessage.encode(
          message.message.updateSpaceMetadataPusherToBackMessage,
          writer.uint32(58).fork(),
        ).join();
        break;
      case "kickOffMessage":
        KickOffMessage.encode(message.message.kickOffMessage, writer.uint32(66).fork()).join();
        break;
      case "publicEvent":
        PublicEvent.encode(message.message.publicEvent, writer.uint32(122).fork()).join();
        break;
      case "privateEvent":
        PrivateEvent.encode(message.message.privateEvent, writer.uint32(130).fork()).join();
        break;
      case "syncSpaceUsersMessage":
        SyncSpaceUsersMessage.encode(message.message.syncSpaceUsersMessage, writer.uint32(138).fork()).join();
        break;
      case "spaceQueryMessage":
        SpaceQueryMessage.encode(message.message.spaceQueryMessage, writer.uint32(146).fork()).join();
        break;
      case "addSpaceUserToNotifyMessage":
        AddSpaceUserToNotifyMessage.encode(message.message.addSpaceUserToNotifyMessage, writer.uint32(154).fork())
          .join();
        break;
      case "deleteSpaceUserToNotifyMessage":
        DeleteSpaceUserToNotifyMessage.encode(message.message.deleteSpaceUserToNotifyMessage, writer.uint32(162).fork())
          .join();
        break;
      case "backEvent":
        BackEventMessage.encode(message.message.backEvent, writer.uint32(178).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PusherToBackSpaceMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePusherToBackSpaceMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = {
            $case: "joinSpaceMessage",
            joinSpaceMessage: JoinSpaceMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = {
            $case: "leaveSpaceMessage",
            leaveSpaceMessage: LeaveSpaceMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = {
            $case: "updateSpaceUserMessage",
            updateSpaceUserMessage: UpdateSpaceUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.message = { $case: "pongMessage", pongMessage: PingMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.message = {
            $case: "updateSpaceMetadataPusherToBackMessage",
            updateSpaceMetadataPusherToBackMessage: UpdateSpaceMetadataPusherToBackMessage.decode(
              reader,
              reader.uint32(),
            ),
          };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.message = { $case: "kickOffMessage", kickOffMessage: KickOffMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.message = { $case: "publicEvent", publicEvent: PublicEvent.decode(reader, reader.uint32()) };
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.message = { $case: "privateEvent", privateEvent: PrivateEvent.decode(reader, reader.uint32()) };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.message = {
            $case: "syncSpaceUsersMessage",
            syncSpaceUsersMessage: SyncSpaceUsersMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.message = {
            $case: "spaceQueryMessage",
            spaceQueryMessage: SpaceQueryMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.message = {
            $case: "addSpaceUserToNotifyMessage",
            addSpaceUserToNotifyMessage: AddSpaceUserToNotifyMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.message = {
            $case: "deleteSpaceUserToNotifyMessage",
            deleteSpaceUserToNotifyMessage: DeleteSpaceUserToNotifyMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.message = { $case: "backEvent", backEvent: BackEventMessage.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PusherToBackSpaceMessage {
    return {
      message: isSet(object.joinSpaceMessage)
        ? { $case: "joinSpaceMessage", joinSpaceMessage: JoinSpaceMessage.fromJSON(object.joinSpaceMessage) }
        : isSet(object.leaveSpaceMessage)
        ? { $case: "leaveSpaceMessage", leaveSpaceMessage: LeaveSpaceMessage.fromJSON(object.leaveSpaceMessage) }
        : isSet(object.updateSpaceUserMessage)
        ? {
          $case: "updateSpaceUserMessage",
          updateSpaceUserMessage: UpdateSpaceUserMessage.fromJSON(object.updateSpaceUserMessage),
        }
        : isSet(object.pongMessage)
        ? { $case: "pongMessage", pongMessage: PingMessage.fromJSON(object.pongMessage) }
        : isSet(object.updateSpaceMetadataPusherToBackMessage)
        ? {
          $case: "updateSpaceMetadataPusherToBackMessage",
          updateSpaceMetadataPusherToBackMessage: UpdateSpaceMetadataPusherToBackMessage.fromJSON(
            object.updateSpaceMetadataPusherToBackMessage,
          ),
        }
        : isSet(object.kickOffMessage)
        ? { $case: "kickOffMessage", kickOffMessage: KickOffMessage.fromJSON(object.kickOffMessage) }
        : isSet(object.publicEvent)
        ? { $case: "publicEvent", publicEvent: PublicEvent.fromJSON(object.publicEvent) }
        : isSet(object.privateEvent)
        ? { $case: "privateEvent", privateEvent: PrivateEvent.fromJSON(object.privateEvent) }
        : isSet(object.syncSpaceUsersMessage)
        ? {
          $case: "syncSpaceUsersMessage",
          syncSpaceUsersMessage: SyncSpaceUsersMessage.fromJSON(object.syncSpaceUsersMessage),
        }
        : isSet(object.spaceQueryMessage)
        ? { $case: "spaceQueryMessage", spaceQueryMessage: SpaceQueryMessage.fromJSON(object.spaceQueryMessage) }
        : isSet(object.addSpaceUserToNotifyMessage)
        ? {
          $case: "addSpaceUserToNotifyMessage",
          addSpaceUserToNotifyMessage: AddSpaceUserToNotifyMessage.fromJSON(object.addSpaceUserToNotifyMessage),
        }
        : isSet(object.deleteSpaceUserToNotifyMessage)
        ? {
          $case: "deleteSpaceUserToNotifyMessage",
          deleteSpaceUserToNotifyMessage: DeleteSpaceUserToNotifyMessage.fromJSON(
            object.deleteSpaceUserToNotifyMessage,
          ),
        }
        : isSet(object.backEvent)
        ? { $case: "backEvent", backEvent: BackEventMessage.fromJSON(object.backEvent) }
        : undefined,
    };
  },

  toJSON(message: PusherToBackSpaceMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "joinSpaceMessage") {
      obj.joinSpaceMessage = JoinSpaceMessage.toJSON(message.message.joinSpaceMessage);
    } else if (message.message?.$case === "leaveSpaceMessage") {
      obj.leaveSpaceMessage = LeaveSpaceMessage.toJSON(message.message.leaveSpaceMessage);
    } else if (message.message?.$case === "updateSpaceUserMessage") {
      obj.updateSpaceUserMessage = UpdateSpaceUserMessage.toJSON(message.message.updateSpaceUserMessage);
    } else if (message.message?.$case === "pongMessage") {
      obj.pongMessage = PingMessage.toJSON(message.message.pongMessage);
    } else if (message.message?.$case === "updateSpaceMetadataPusherToBackMessage") {
      obj.updateSpaceMetadataPusherToBackMessage = UpdateSpaceMetadataPusherToBackMessage.toJSON(
        message.message.updateSpaceMetadataPusherToBackMessage,
      );
    } else if (message.message?.$case === "kickOffMessage") {
      obj.kickOffMessage = KickOffMessage.toJSON(message.message.kickOffMessage);
    } else if (message.message?.$case === "publicEvent") {
      obj.publicEvent = PublicEvent.toJSON(message.message.publicEvent);
    } else if (message.message?.$case === "privateEvent") {
      obj.privateEvent = PrivateEvent.toJSON(message.message.privateEvent);
    } else if (message.message?.$case === "syncSpaceUsersMessage") {
      obj.syncSpaceUsersMessage = SyncSpaceUsersMessage.toJSON(message.message.syncSpaceUsersMessage);
    } else if (message.message?.$case === "spaceQueryMessage") {
      obj.spaceQueryMessage = SpaceQueryMessage.toJSON(message.message.spaceQueryMessage);
    } else if (message.message?.$case === "addSpaceUserToNotifyMessage") {
      obj.addSpaceUserToNotifyMessage = AddSpaceUserToNotifyMessage.toJSON(message.message.addSpaceUserToNotifyMessage);
    } else if (message.message?.$case === "deleteSpaceUserToNotifyMessage") {
      obj.deleteSpaceUserToNotifyMessage = DeleteSpaceUserToNotifyMessage.toJSON(
        message.message.deleteSpaceUserToNotifyMessage,
      );
    } else if (message.message?.$case === "backEvent") {
      obj.backEvent = BackEventMessage.toJSON(message.message.backEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PusherToBackSpaceMessage>, I>>(base?: I): PusherToBackSpaceMessage {
    return PusherToBackSpaceMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PusherToBackSpaceMessage>, I>>(object: I): PusherToBackSpaceMessage {
    const message = createBasePusherToBackSpaceMessage();
    switch (object.message?.$case) {
      case "joinSpaceMessage": {
        if (object.message?.joinSpaceMessage !== undefined && object.message?.joinSpaceMessage !== null) {
          message.message = {
            $case: "joinSpaceMessage",
            joinSpaceMessage: JoinSpaceMessage.fromPartial(object.message.joinSpaceMessage),
          };
        }
        break;
      }
      case "leaveSpaceMessage": {
        if (object.message?.leaveSpaceMessage !== undefined && object.message?.leaveSpaceMessage !== null) {
          message.message = {
            $case: "leaveSpaceMessage",
            leaveSpaceMessage: LeaveSpaceMessage.fromPartial(object.message.leaveSpaceMessage),
          };
        }
        break;
      }
      case "updateSpaceUserMessage": {
        if (object.message?.updateSpaceUserMessage !== undefined && object.message?.updateSpaceUserMessage !== null) {
          message.message = {
            $case: "updateSpaceUserMessage",
            updateSpaceUserMessage: UpdateSpaceUserMessage.fromPartial(object.message.updateSpaceUserMessage),
          };
        }
        break;
      }
      case "pongMessage": {
        if (object.message?.pongMessage !== undefined && object.message?.pongMessage !== null) {
          message.message = { $case: "pongMessage", pongMessage: PingMessage.fromPartial(object.message.pongMessage) };
        }
        break;
      }
      case "updateSpaceMetadataPusherToBackMessage": {
        if (
          object.message?.updateSpaceMetadataPusherToBackMessage !== undefined &&
          object.message?.updateSpaceMetadataPusherToBackMessage !== null
        ) {
          message.message = {
            $case: "updateSpaceMetadataPusherToBackMessage",
            updateSpaceMetadataPusherToBackMessage: UpdateSpaceMetadataPusherToBackMessage.fromPartial(
              object.message.updateSpaceMetadataPusherToBackMessage,
            ),
          };
        }
        break;
      }
      case "kickOffMessage": {
        if (object.message?.kickOffMessage !== undefined && object.message?.kickOffMessage !== null) {
          message.message = {
            $case: "kickOffMessage",
            kickOffMessage: KickOffMessage.fromPartial(object.message.kickOffMessage),
          };
        }
        break;
      }
      case "publicEvent": {
        if (object.message?.publicEvent !== undefined && object.message?.publicEvent !== null) {
          message.message = { $case: "publicEvent", publicEvent: PublicEvent.fromPartial(object.message.publicEvent) };
        }
        break;
      }
      case "privateEvent": {
        if (object.message?.privateEvent !== undefined && object.message?.privateEvent !== null) {
          message.message = {
            $case: "privateEvent",
            privateEvent: PrivateEvent.fromPartial(object.message.privateEvent),
          };
        }
        break;
      }
      case "syncSpaceUsersMessage": {
        if (object.message?.syncSpaceUsersMessage !== undefined && object.message?.syncSpaceUsersMessage !== null) {
          message.message = {
            $case: "syncSpaceUsersMessage",
            syncSpaceUsersMessage: SyncSpaceUsersMessage.fromPartial(object.message.syncSpaceUsersMessage),
          };
        }
        break;
      }
      case "spaceQueryMessage": {
        if (object.message?.spaceQueryMessage !== undefined && object.message?.spaceQueryMessage !== null) {
          message.message = {
            $case: "spaceQueryMessage",
            spaceQueryMessage: SpaceQueryMessage.fromPartial(object.message.spaceQueryMessage),
          };
        }
        break;
      }
      case "addSpaceUserToNotifyMessage": {
        if (
          object.message?.addSpaceUserToNotifyMessage !== undefined &&
          object.message?.addSpaceUserToNotifyMessage !== null
        ) {
          message.message = {
            $case: "addSpaceUserToNotifyMessage",
            addSpaceUserToNotifyMessage: AddSpaceUserToNotifyMessage.fromPartial(
              object.message.addSpaceUserToNotifyMessage,
            ),
          };
        }
        break;
      }
      case "deleteSpaceUserToNotifyMessage": {
        if (
          object.message?.deleteSpaceUserToNotifyMessage !== undefined &&
          object.message?.deleteSpaceUserToNotifyMessage !== null
        ) {
          message.message = {
            $case: "deleteSpaceUserToNotifyMessage",
            deleteSpaceUserToNotifyMessage: DeleteSpaceUserToNotifyMessage.fromPartial(
              object.message.deleteSpaceUserToNotifyMessage,
            ),
          };
        }
        break;
      }
      case "backEvent": {
        if (object.message?.backEvent !== undefined && object.message?.backEvent !== null) {
          message.message = { $case: "backEvent", backEvent: BackEventMessage.fromPartial(object.message.backEvent) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseBackToPusherSpaceMessage(): BackToPusherSpaceMessage {
  return { message: undefined };
}

export const BackToPusherSpaceMessage: MessageFns<BackToPusherSpaceMessage> = {
  encode(message: BackToPusherSpaceMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.message?.$case) {
      case "addSpaceUserMessage":
        AddSpaceUserMessage.encode(message.message.addSpaceUserMessage, writer.uint32(10).fork()).join();
        break;
      case "updateSpaceUserMessage":
        UpdateSpaceUserMessage.encode(message.message.updateSpaceUserMessage, writer.uint32(18).fork()).join();
        break;
      case "removeSpaceUserMessage":
        RemoveSpaceUserMessage.encode(message.message.removeSpaceUserMessage, writer.uint32(26).fork()).join();
        break;
      case "pingMessage":
        PingMessage.encode(message.message.pingMessage, writer.uint32(34).fork()).join();
        break;
      case "updateSpaceMetadataMessage":
        UpdateSpaceMetadataMessage.encode(message.message.updateSpaceMetadataMessage, writer.uint32(42).fork()).join();
        break;
      case "kickOffMessage":
        KickOffMessage.encode(message.message.kickOffMessage, writer.uint32(50).fork()).join();
        break;
      case "publicEvent":
        PublicEvent.encode(message.message.publicEvent, writer.uint32(106).fork()).join();
        break;
      case "privateEvent":
        PrivateEventBackToPusher.encode(message.message.privateEvent, writer.uint32(114).fork()).join();
        break;
      case "spaceAnswerMessage":
        SpaceAnswerMessage.encode(message.message.spaceAnswerMessage, writer.uint32(122).fork()).join();
        break;
      case "initSpaceUsersMessage":
        InitSpaceUsersMessage.encode(message.message.initSpaceUsersMessage, writer.uint32(130).fork()).join();
        break;
      case "spaceStatePatchMessage":
        SpaceStatePatchMessage.encode(message.message.spaceStatePatchMessage, writer.uint32(138).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BackToPusherSpaceMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBackToPusherSpaceMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = {
            $case: "addSpaceUserMessage",
            addSpaceUserMessage: AddSpaceUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = {
            $case: "updateSpaceUserMessage",
            updateSpaceUserMessage: UpdateSpaceUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = {
            $case: "removeSpaceUserMessage",
            removeSpaceUserMessage: RemoveSpaceUserMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.message = { $case: "pingMessage", pingMessage: PingMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.message = {
            $case: "updateSpaceMetadataMessage",
            updateSpaceMetadataMessage: UpdateSpaceMetadataMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.message = { $case: "kickOffMessage", kickOffMessage: KickOffMessage.decode(reader, reader.uint32()) };
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.message = { $case: "publicEvent", publicEvent: PublicEvent.decode(reader, reader.uint32()) };
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.message = {
            $case: "privateEvent",
            privateEvent: PrivateEventBackToPusher.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.message = {
            $case: "spaceAnswerMessage",
            spaceAnswerMessage: SpaceAnswerMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.message = {
            $case: "initSpaceUsersMessage",
            initSpaceUsersMessage: InitSpaceUsersMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.message = {
            $case: "spaceStatePatchMessage",
            spaceStatePatchMessage: SpaceStatePatchMessage.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BackToPusherSpaceMessage {
    return {
      message: isSet(object.addSpaceUserMessage)
        ? {
          $case: "addSpaceUserMessage",
          addSpaceUserMessage: AddSpaceUserMessage.fromJSON(object.addSpaceUserMessage),
        }
        : isSet(object.updateSpaceUserMessage)
        ? {
          $case: "updateSpaceUserMessage",
          updateSpaceUserMessage: UpdateSpaceUserMessage.fromJSON(object.updateSpaceUserMessage),
        }
        : isSet(object.removeSpaceUserMessage)
        ? {
          $case: "removeSpaceUserMessage",
          removeSpaceUserMessage: RemoveSpaceUserMessage.fromJSON(object.removeSpaceUserMessage),
        }
        : isSet(object.pingMessage)
        ? { $case: "pingMessage", pingMessage: PingMessage.fromJSON(object.pingMessage) }
        : isSet(object.updateSpaceMetadataMessage)
        ? {
          $case: "updateSpaceMetadataMessage",
          updateSpaceMetadataMessage: UpdateSpaceMetadataMessage.fromJSON(object.updateSpaceMetadataMessage),
        }
        : isSet(object.kickOffMessage)
        ? { $case: "kickOffMessage", kickOffMessage: KickOffMessage.fromJSON(object.kickOffMessage) }
        : isSet(object.publicEvent)
        ? { $case: "publicEvent", publicEvent: PublicEvent.fromJSON(object.publicEvent) }
        : isSet(object.privateEvent)
        ? { $case: "privateEvent", privateEvent: PrivateEventBackToPusher.fromJSON(object.privateEvent) }
        : isSet(object.spaceAnswerMessage)
        ? { $case: "spaceAnswerMessage", spaceAnswerMessage: SpaceAnswerMessage.fromJSON(object.spaceAnswerMessage) }
        : isSet(object.initSpaceUsersMessage)
        ? {
          $case: "initSpaceUsersMessage",
          initSpaceUsersMessage: InitSpaceUsersMessage.fromJSON(object.initSpaceUsersMessage),
        }
        : isSet(object.spaceStatePatchMessage)
        ? {
          $case: "spaceStatePatchMessage",
          spaceStatePatchMessage: SpaceStatePatchMessage.fromJSON(object.spaceStatePatchMessage),
        }
        : undefined,
    };
  },

  toJSON(message: BackToPusherSpaceMessage): unknown {
    const obj: any = {};
    if (message.message?.$case === "addSpaceUserMessage") {
      obj.addSpaceUserMessage = AddSpaceUserMessage.toJSON(message.message.addSpaceUserMessage);
    } else if (message.message?.$case === "updateSpaceUserMessage") {
      obj.updateSpaceUserMessage = UpdateSpaceUserMessage.toJSON(message.message.updateSpaceUserMessage);
    } else if (message.message?.$case === "removeSpaceUserMessage") {
      obj.removeSpaceUserMessage = RemoveSpaceUserMessage.toJSON(message.message.removeSpaceUserMessage);
    } else if (message.message?.$case === "pingMessage") {
      obj.pingMessage = PingMessage.toJSON(message.message.pingMessage);
    } else if (message.message?.$case === "updateSpaceMetadataMessage") {
      obj.updateSpaceMetadataMessage = UpdateSpaceMetadataMessage.toJSON(message.message.updateSpaceMetadataMessage);
    } else if (message.message?.$case === "kickOffMessage") {
      obj.kickOffMessage = KickOffMessage.toJSON(message.message.kickOffMessage);
    } else if (message.message?.$case === "publicEvent") {
      obj.publicEvent = PublicEvent.toJSON(message.message.publicEvent);
    } else if (message.message?.$case === "privateEvent") {
      obj.privateEvent = PrivateEventBackToPusher.toJSON(message.message.privateEvent);
    } else if (message.message?.$case === "spaceAnswerMessage") {
      obj.spaceAnswerMessage = SpaceAnswerMessage.toJSON(message.message.spaceAnswerMessage);
    } else if (message.message?.$case === "initSpaceUsersMessage") {
      obj.initSpaceUsersMessage = InitSpaceUsersMessage.toJSON(message.message.initSpaceUsersMessage);
    } else if (message.message?.$case === "spaceStatePatchMessage") {
      obj.spaceStatePatchMessage = SpaceStatePatchMessage.toJSON(message.message.spaceStatePatchMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BackToPusherSpaceMessage>, I>>(base?: I): BackToPusherSpaceMessage {
    return BackToPusherSpaceMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BackToPusherSpaceMessage>, I>>(object: I): BackToPusherSpaceMessage {
    const message = createBaseBackToPusherSpaceMessage();
    switch (object.message?.$case) {
      case "addSpaceUserMessage": {
        if (object.message?.addSpaceUserMessage !== undefined && object.message?.addSpaceUserMessage !== null) {
          message.message = {
            $case: "addSpaceUserMessage",
            addSpaceUserMessage: AddSpaceUserMessage.fromPartial(object.message.addSpaceUserMessage),
          };
        }
        break;
      }
      case "updateSpaceUserMessage": {
        if (object.message?.updateSpaceUserMessage !== undefined && object.message?.updateSpaceUserMessage !== null) {
          message.message = {
            $case: "updateSpaceUserMessage",
            updateSpaceUserMessage: UpdateSpaceUserMessage.fromPartial(object.message.updateSpaceUserMessage),
          };
        }
        break;
      }
      case "removeSpaceUserMessage": {
        if (object.message?.removeSpaceUserMessage !== undefined && object.message?.removeSpaceUserMessage !== null) {
          message.message = {
            $case: "removeSpaceUserMessage",
            removeSpaceUserMessage: RemoveSpaceUserMessage.fromPartial(object.message.removeSpaceUserMessage),
          };
        }
        break;
      }
      case "pingMessage": {
        if (object.message?.pingMessage !== undefined && object.message?.pingMessage !== null) {
          message.message = { $case: "pingMessage", pingMessage: PingMessage.fromPartial(object.message.pingMessage) };
        }
        break;
      }
      case "updateSpaceMetadataMessage": {
        if (
          object.message?.updateSpaceMetadataMessage !== undefined &&
          object.message?.updateSpaceMetadataMessage !== null
        ) {
          message.message = {
            $case: "updateSpaceMetadataMessage",
            updateSpaceMetadataMessage: UpdateSpaceMetadataMessage.fromPartial(
              object.message.updateSpaceMetadataMessage,
            ),
          };
        }
        break;
      }
      case "kickOffMessage": {
        if (object.message?.kickOffMessage !== undefined && object.message?.kickOffMessage !== null) {
          message.message = {
            $case: "kickOffMessage",
            kickOffMessage: KickOffMessage.fromPartial(object.message.kickOffMessage),
          };
        }
        break;
      }
      case "publicEvent": {
        if (object.message?.publicEvent !== undefined && object.message?.publicEvent !== null) {
          message.message = { $case: "publicEvent", publicEvent: PublicEvent.fromPartial(object.message.publicEvent) };
        }
        break;
      }
      case "privateEvent": {
        if (object.message?.privateEvent !== undefined && object.message?.privateEvent !== null) {
          message.message = {
            $case: "privateEvent",
            privateEvent: PrivateEventBackToPusher.fromPartial(object.message.privateEvent),
          };
        }
        break;
      }
      case "spaceAnswerMessage": {
        if (object.message?.spaceAnswerMessage !== undefined && object.message?.spaceAnswerMessage !== null) {
          message.message = {
            $case: "spaceAnswerMessage",
            spaceAnswerMessage: SpaceAnswerMessage.fromPartial(object.message.spaceAnswerMessage),
          };
        }
        break;
      }
      case "initSpaceUsersMessage": {
        if (object.message?.initSpaceUsersMessage !== undefined && object.message?.initSpaceUsersMessage !== null) {
          message.message = {
            $case: "initSpaceUsersMessage",
            initSpaceUsersMessage: InitSpaceUsersMessage.fromPartial(object.message.initSpaceUsersMessage),
          };
        }
        break;
      }
      case "spaceStatePatchMessage": {
        if (object.message?.spaceStatePatchMessage !== undefined && object.message?.spaceStatePatchMessage !== null) {
          message.message = {
            $case: "spaceStatePatchMessage",
            spaceStatePatchMessage: SpaceStatePatchMessage.fromPartial(object.message.spaceStatePatchMessage),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseJoinSpaceMessage(): JoinSpaceMessage {
  return { spaceName: "", propertiesToSync: [], filterType: 0, world: "" };
}

export const JoinSpaceMessage: MessageFns<JoinSpaceMessage> = {
  encode(message: JoinSpaceMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    for (const v of message.propertiesToSync) {
      writer.uint32(18).string(v!);
    }
    if (message.filterType !== 0) {
      writer.uint32(24).int32(message.filterType);
    }
    if (message.world !== "") {
      writer.uint32(42).string(message.world);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JoinSpaceMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinSpaceMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.propertiesToSync.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.filterType = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.world = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JoinSpaceMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      propertiesToSync: globalThis.Array.isArray(object?.propertiesToSync)
        ? object.propertiesToSync.map((e: any) => globalThis.String(e))
        : [],
      filterType: isSet(object.filterType) ? filterTypeFromJSON(object.filterType) : 0,
      world: isSet(object.world) ? globalThis.String(object.world) : "",
    };
  },

  toJSON(message: JoinSpaceMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.propertiesToSync?.length) {
      obj.propertiesToSync = message.propertiesToSync;
    }
    if (message.filterType !== 0) {
      obj.filterType = filterTypeToJSON(message.filterType);
    }
    if (message.world !== "") {
      obj.world = message.world;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JoinSpaceMessage>, I>>(base?: I): JoinSpaceMessage {
    return JoinSpaceMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoinSpaceMessage>, I>>(object: I): JoinSpaceMessage {
    const message = createBaseJoinSpaceMessage();
    message.spaceName = object.spaceName ?? "";
    message.propertiesToSync = object.propertiesToSync?.map((e) => e) || [];
    message.filterType = object.filterType ?? 0;
    message.world = object.world ?? "";
    return message;
  },
};

function createBaseLeaveSpaceMessage(): LeaveSpaceMessage {
  return { spaceName: "" };
}

export const LeaveSpaceMessage: MessageFns<LeaveSpaceMessage> = {
  encode(message: LeaveSpaceMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LeaveSpaceMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeaveSpaceMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LeaveSpaceMessage {
    return { spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "" };
  },

  toJSON(message: LeaveSpaceMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LeaveSpaceMessage>, I>>(base?: I): LeaveSpaceMessage {
    return LeaveSpaceMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LeaveSpaceMessage>, I>>(object: I): LeaveSpaceMessage {
    const message = createBaseLeaveSpaceMessage();
    message.spaceName = object.spaceName ?? "";
    return message;
  },
};

function createBaseSpaceUser(): SpaceUser {
  return {
    spaceUserId: "",
    name: "",
    playUri: "",
    color: "",
    characterTextures: [],
    isLogged: false,
    availabilityStatus: 0,
    roomName: undefined,
    visitCardUrl: undefined,
    tags: [],
    cameraState: false,
    microphoneState: false,
    screenSharingState: false,
    megaphoneState: false,
    jitsiParticipantId: undefined,
    uuid: "",
    chatID: undefined,
    showVoiceIndicator: false,
    attendeesState: false,
    cpuLimited: false,
  };
}

export const SpaceUser: MessageFns<SpaceUser> = {
  encode(message: SpaceUser, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceUserId !== "") {
      writer.uint32(10).string(message.spaceUserId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.playUri !== "") {
      writer.uint32(26).string(message.playUri);
    }
    if (message.color !== "") {
      writer.uint32(34).string(message.color);
    }
    for (const v of message.characterTextures) {
      CharacterTextureMessage.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.isLogged !== false) {
      writer.uint32(48).bool(message.isLogged);
    }
    if (message.availabilityStatus !== 0) {
      writer.uint32(56).int32(message.availabilityStatus);
    }
    if (message.roomName !== undefined) {
      StringValue.encode({ value: message.roomName! }, writer.uint32(66).fork()).join();
    }
    if (message.visitCardUrl !== undefined) {
      StringValue.encode({ value: message.visitCardUrl! }, writer.uint32(74).fork()).join();
    }
    for (const v of message.tags) {
      writer.uint32(82).string(v!);
    }
    if (message.cameraState !== false) {
      writer.uint32(88).bool(message.cameraState);
    }
    if (message.microphoneState !== false) {
      writer.uint32(96).bool(message.microphoneState);
    }
    if (message.screenSharingState !== false) {
      writer.uint32(104).bool(message.screenSharingState);
    }
    if (message.megaphoneState !== false) {
      writer.uint32(112).bool(message.megaphoneState);
    }
    if (message.jitsiParticipantId !== undefined) {
      StringValue.encode({ value: message.jitsiParticipantId! }, writer.uint32(122).fork()).join();
    }
    if (message.uuid !== "") {
      writer.uint32(130).string(message.uuid);
    }
    if (message.chatID !== undefined) {
      StringValue.encode({ value: message.chatID! }, writer.uint32(138).fork()).join();
    }
    if (message.showVoiceIndicator !== false) {
      writer.uint32(144).bool(message.showVoiceIndicator);
    }
    if (message.attendeesState !== false) {
      writer.uint32(152).bool(message.attendeesState);
    }
    if (message.cpuLimited !== false) {
      writer.uint32(160).bool(message.cpuLimited);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceUser {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceUserId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.playUri = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.color = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.characterTextures.push(CharacterTextureMessage.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isLogged = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.availabilityStatus = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.roomName = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.visitCardUrl = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.cameraState = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.microphoneState = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.screenSharingState = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.megaphoneState = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.jitsiParticipantId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.chatID = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.showVoiceIndicator = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.attendeesState = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.cpuLimited = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceUser {
    return {
      spaceUserId: isSet(object.spaceUserId) ? globalThis.String(object.spaceUserId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      playUri: isSet(object.playUri) ? globalThis.String(object.playUri) : "",
      color: isSet(object.color) ? globalThis.String(object.color) : "",
      characterTextures: globalThis.Array.isArray(object?.characterTextures)
        ? object.characterTextures.map((e: any) => CharacterTextureMessage.fromJSON(e))
        : [],
      isLogged: isSet(object.isLogged) ? globalThis.Boolean(object.isLogged) : false,
      availabilityStatus: isSet(object.availabilityStatus) ? globalThis.Number(object.availabilityStatus) : 0,
      roomName: isSet(object.roomName) ? String(object.roomName) : undefined,
      visitCardUrl: isSet(object.visitCardUrl) ? String(object.visitCardUrl) : undefined,
      tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => globalThis.String(e)) : [],
      cameraState: isSet(object.cameraState) ? globalThis.Boolean(object.cameraState) : false,
      microphoneState: isSet(object.microphoneState) ? globalThis.Boolean(object.microphoneState) : false,
      screenSharingState: isSet(object.screenSharingState) ? globalThis.Boolean(object.screenSharingState) : false,
      megaphoneState: isSet(object.megaphoneState) ? globalThis.Boolean(object.megaphoneState) : false,
      jitsiParticipantId: isSet(object.jitsiParticipantId) ? String(object.jitsiParticipantId) : undefined,
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      chatID: isSet(object.chatID) ? String(object.chatID) : undefined,
      showVoiceIndicator: isSet(object.showVoiceIndicator) ? globalThis.Boolean(object.showVoiceIndicator) : false,
      attendeesState: isSet(object.attendeesState) ? globalThis.Boolean(object.attendeesState) : false,
      cpuLimited: isSet(object.cpuLimited) ? globalThis.Boolean(object.cpuLimited) : false,
    };
  },

  toJSON(message: SpaceUser): unknown {
    const obj: any = {};
    if (message.spaceUserId !== "") {
      obj.spaceUserId = message.spaceUserId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.playUri !== "") {
      obj.playUri = message.playUri;
    }
    if (message.color !== "") {
      obj.color = message.color;
    }
    if (message.characterTextures?.length) {
      obj.characterTextures = message.characterTextures.map((e) => CharacterTextureMessage.toJSON(e));
    }
    if (message.isLogged !== false) {
      obj.isLogged = message.isLogged;
    }
    if (message.availabilityStatus !== 0) {
      obj.availabilityStatus = Math.round(message.availabilityStatus);
    }
    if (message.roomName !== undefined) {
      obj.roomName = message.roomName;
    }
    if (message.visitCardUrl !== undefined) {
      obj.visitCardUrl = message.visitCardUrl;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.cameraState !== false) {
      obj.cameraState = message.cameraState;
    }
    if (message.microphoneState !== false) {
      obj.microphoneState = message.microphoneState;
    }
    if (message.screenSharingState !== false) {
      obj.screenSharingState = message.screenSharingState;
    }
    if (message.megaphoneState !== false) {
      obj.megaphoneState = message.megaphoneState;
    }
    if (message.jitsiParticipantId !== undefined) {
      obj.jitsiParticipantId = message.jitsiParticipantId;
    }
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.chatID !== undefined) {
      obj.chatID = message.chatID;
    }
    if (message.showVoiceIndicator !== false) {
      obj.showVoiceIndicator = message.showVoiceIndicator;
    }
    if (message.attendeesState !== false) {
      obj.attendeesState = message.attendeesState;
    }
    if (message.cpuLimited !== false) {
      obj.cpuLimited = message.cpuLimited;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceUser>, I>>(base?: I): SpaceUser {
    return SpaceUser.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceUser>, I>>(object: I): SpaceUser {
    const message = createBaseSpaceUser();
    message.spaceUserId = object.spaceUserId ?? "";
    message.name = object.name ?? "";
    message.playUri = object.playUri ?? "";
    message.color = object.color ?? "";
    message.characterTextures = object.characterTextures?.map((e) => CharacterTextureMessage.fromPartial(e)) || [];
    message.isLogged = object.isLogged ?? false;
    message.availabilityStatus = object.availabilityStatus ?? 0;
    message.roomName = object.roomName ?? undefined;
    message.visitCardUrl = object.visitCardUrl ?? undefined;
    message.tags = object.tags?.map((e) => e) || [];
    message.cameraState = object.cameraState ?? false;
    message.microphoneState = object.microphoneState ?? false;
    message.screenSharingState = object.screenSharingState ?? false;
    message.megaphoneState = object.megaphoneState ?? false;
    message.jitsiParticipantId = object.jitsiParticipantId ?? undefined;
    message.uuid = object.uuid ?? "";
    message.chatID = object.chatID ?? undefined;
    message.showVoiceIndicator = object.showVoiceIndicator ?? false;
    message.attendeesState = object.attendeesState ?? false;
    message.cpuLimited = object.cpuLimited ?? false;
    return message;
  },
};

function createBaseAddSpaceUserMessage(): AddSpaceUserMessage {
  return { spaceName: "", user: undefined };
}

export const AddSpaceUserMessage: MessageFns<AddSpaceUserMessage> = {
  encode(message: AddSpaceUserMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.user !== undefined) {
      SpaceUser.encode(message.user, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddSpaceUserMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSpaceUserMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = SpaceUser.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSpaceUserMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      user: isSet(object.user) ? SpaceUser.fromJSON(object.user) : undefined,
    };
  },

  toJSON(message: AddSpaceUserMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.user !== undefined) {
      obj.user = SpaceUser.toJSON(message.user);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSpaceUserMessage>, I>>(base?: I): AddSpaceUserMessage {
    return AddSpaceUserMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSpaceUserMessage>, I>>(object: I): AddSpaceUserMessage {
    const message = createBaseAddSpaceUserMessage();
    message.spaceName = object.spaceName ?? "";
    message.user = (object.user !== undefined && object.user !== null) ? SpaceUser.fromPartial(object.user) : undefined;
    return message;
  },
};

function createBaseInitSpaceUsersMessage(): InitSpaceUsersMessage {
  return { spaceName: "", users: [], metadata: "", state: "" };
}

export const InitSpaceUsersMessage: MessageFns<InitSpaceUsersMessage> = {
  encode(message: InitSpaceUsersMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    for (const v of message.users) {
      SpaceUser.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.metadata !== "") {
      writer.uint32(26).string(message.metadata);
    }
    if (message.state !== "") {
      writer.uint32(34).string(message.state);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InitSpaceUsersMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitSpaceUsersMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.users.push(SpaceUser.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.metadata = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.state = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InitSpaceUsersMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => SpaceUser.fromJSON(e)) : [],
      metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : "",
      state: isSet(object.state) ? globalThis.String(object.state) : "",
    };
  },

  toJSON(message: InitSpaceUsersMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.users?.length) {
      obj.users = message.users.map((e) => SpaceUser.toJSON(e));
    }
    if (message.metadata !== "") {
      obj.metadata = message.metadata;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InitSpaceUsersMessage>, I>>(base?: I): InitSpaceUsersMessage {
    return InitSpaceUsersMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitSpaceUsersMessage>, I>>(object: I): InitSpaceUsersMessage {
    const message = createBaseInitSpaceUsersMessage();
    message.spaceName = object.spaceName ?? "";
    message.users = object.users?.map((e) => SpaceUser.fromPartial(e)) || [];
    message.metadata = object.metadata ?? "";
    message.state = object.state ?? "";
    return message;
  },
};

function createBaseUpdateSpaceUserMessage(): UpdateSpaceUserMessage {
  return { spaceName: "", user: undefined, updateMask: undefined };
}

export const UpdateSpaceUserMessage: MessageFns<UpdateSpaceUserMessage> = {
  encode(message: UpdateSpaceUserMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.user !== undefined) {
      SpaceUser.encode(message.user, writer.uint32(18).fork()).join();
    }
    if (message.updateMask !== undefined) {
      FieldMask.encode(FieldMask.wrap(message.updateMask), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSpaceUserMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSpaceUserMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = SpaceUser.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updateMask = FieldMask.unwrap(FieldMask.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSpaceUserMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      user: isSet(object.user) ? SpaceUser.fromJSON(object.user) : undefined,
      updateMask: isSet(object.updateMask) ? FieldMask.unwrap(FieldMask.fromJSON(object.updateMask)) : undefined,
    };
  },

  toJSON(message: UpdateSpaceUserMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.user !== undefined) {
      obj.user = SpaceUser.toJSON(message.user);
    }
    if (message.updateMask !== undefined) {
      obj.updateMask = FieldMask.toJSON(FieldMask.wrap(message.updateMask));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSpaceUserMessage>, I>>(base?: I): UpdateSpaceUserMessage {
    return UpdateSpaceUserMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSpaceUserMessage>, I>>(object: I): UpdateSpaceUserMessage {
    const message = createBaseUpdateSpaceUserMessage();
    message.spaceName = object.spaceName ?? "";
    message.user = (object.user !== undefined && object.user !== null) ? SpaceUser.fromPartial(object.user) : undefined;
    message.updateMask = object.updateMask ?? undefined;
    return message;
  },
};

function createBaseUpdateSpaceUserPusherToFrontMessage(): UpdateSpaceUserPusherToFrontMessage {
  return { spaceName: "", user: undefined, updateMask: undefined };
}

export const UpdateSpaceUserPusherToFrontMessage: MessageFns<UpdateSpaceUserPusherToFrontMessage> = {
  encode(message: UpdateSpaceUserPusherToFrontMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.user !== undefined) {
      SpaceUser.encode(message.user, writer.uint32(18).fork()).join();
    }
    if (message.updateMask !== undefined) {
      FieldMask.encode(FieldMask.wrap(message.updateMask), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSpaceUserPusherToFrontMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSpaceUserPusherToFrontMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = SpaceUser.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updateMask = FieldMask.unwrap(FieldMask.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSpaceUserPusherToFrontMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      user: isSet(object.user) ? SpaceUser.fromJSON(object.user) : undefined,
      updateMask: isSet(object.updateMask) ? FieldMask.unwrap(FieldMask.fromJSON(object.updateMask)) : undefined,
    };
  },

  toJSON(message: UpdateSpaceUserPusherToFrontMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.user !== undefined) {
      obj.user = SpaceUser.toJSON(message.user);
    }
    if (message.updateMask !== undefined) {
      obj.updateMask = FieldMask.toJSON(FieldMask.wrap(message.updateMask));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSpaceUserPusherToFrontMessage>, I>>(
    base?: I,
  ): UpdateSpaceUserPusherToFrontMessage {
    return UpdateSpaceUserPusherToFrontMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSpaceUserPusherToFrontMessage>, I>>(
    object: I,
  ): UpdateSpaceUserPusherToFrontMessage {
    const message = createBaseUpdateSpaceUserPusherToFrontMessage();
    message.spaceName = object.spaceName ?? "";
    message.user = (object.user !== undefined && object.user !== null) ? SpaceUser.fromPartial(object.user) : undefined;
    message.updateMask = object.updateMask ?? undefined;
    return message;
  },
};

function createBaseRemoveSpaceUserMessage(): RemoveSpaceUserMessage {
  return { spaceName: "", spaceUserId: "" };
}

export const RemoveSpaceUserMessage: MessageFns<RemoveSpaceUserMessage> = {
  encode(message: RemoveSpaceUserMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.spaceUserId !== "") {
      writer.uint32(18).string(message.spaceUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveSpaceUserMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveSpaceUserMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spaceUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveSpaceUserMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      spaceUserId: isSet(object.spaceUserId) ? globalThis.String(object.spaceUserId) : "",
    };
  },

  toJSON(message: RemoveSpaceUserMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.spaceUserId !== "") {
      obj.spaceUserId = message.spaceUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveSpaceUserMessage>, I>>(base?: I): RemoveSpaceUserMessage {
    return RemoveSpaceUserMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveSpaceUserMessage>, I>>(object: I): RemoveSpaceUserMessage {
    const message = createBaseRemoveSpaceUserMessage();
    message.spaceName = object.spaceName ?? "";
    message.spaceUserId = object.spaceUserId ?? "";
    return message;
  },
};

function createBaseRemoveSpaceUserPusherToFrontMessage(): RemoveSpaceUserPusherToFrontMessage {
  return { spaceName: "", spaceUserId: "" };
}

export const RemoveSpaceUserPusherToFrontMessage: MessageFns<RemoveSpaceUserPusherToFrontMessage> = {
  encode(message: RemoveSpaceUserPusherToFrontMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.spaceUserId !== "") {
      writer.uint32(18).string(message.spaceUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveSpaceUserPusherToFrontMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveSpaceUserPusherToFrontMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.spaceUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveSpaceUserPusherToFrontMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      spaceUserId: isSet(object.spaceUserId) ? globalThis.String(object.spaceUserId) : "",
    };
  },

  toJSON(message: RemoveSpaceUserPusherToFrontMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.spaceUserId !== "") {
      obj.spaceUserId = message.spaceUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveSpaceUserPusherToFrontMessage>, I>>(
    base?: I,
  ): RemoveSpaceUserPusherToFrontMessage {
    return RemoveSpaceUserPusherToFrontMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveSpaceUserPusherToFrontMessage>, I>>(
    object: I,
  ): RemoveSpaceUserPusherToFrontMessage {
    const message = createBaseRemoveSpaceUserPusherToFrontMessage();
    message.spaceName = object.spaceName ?? "";
    message.spaceUserId = object.spaceUserId ?? "";
    return message;
  },
};

function createBaseUpdateSpaceMetadataMessage(): UpdateSpaceMetadataMessage {
  return { spaceName: "", metadata: "" };
}

export const UpdateSpaceMetadataMessage: MessageFns<UpdateSpaceMetadataMessage> = {
  encode(message: UpdateSpaceMetadataMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.metadata !== "") {
      writer.uint32(18).string(message.metadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSpaceMetadataMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSpaceMetadataMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSpaceMetadataMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : "",
    };
  },

  toJSON(message: UpdateSpaceMetadataMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.metadata !== "") {
      obj.metadata = message.metadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSpaceMetadataMessage>, I>>(base?: I): UpdateSpaceMetadataMessage {
    return UpdateSpaceMetadataMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSpaceMetadataMessage>, I>>(object: I): UpdateSpaceMetadataMessage {
    const message = createBaseUpdateSpaceMetadataMessage();
    message.spaceName = object.spaceName ?? "";
    message.metadata = object.metadata ?? "";
    return message;
  },
};

function createBaseUpdateSpaceMetadataPusherToBackMessage(): UpdateSpaceMetadataPusherToBackMessage {
  return { spaceName: "", metadata: "", senderId: "" };
}

export const UpdateSpaceMetadataPusherToBackMessage: MessageFns<UpdateSpaceMetadataPusherToBackMessage> = {
  encode(message: UpdateSpaceMetadataPusherToBackMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.metadata !== "") {
      writer.uint32(18).string(message.metadata);
    }
    if (message.senderId !== "") {
      writer.uint32(26).string(message.senderId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSpaceMetadataPusherToBackMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSpaceMetadataPusherToBackMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.senderId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSpaceMetadataPusherToBackMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : "",
      senderId: isSet(object.senderId) ? globalThis.String(object.senderId) : "",
    };
  },

  toJSON(message: UpdateSpaceMetadataPusherToBackMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.metadata !== "") {
      obj.metadata = message.metadata;
    }
    if (message.senderId !== "") {
      obj.senderId = message.senderId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSpaceMetadataPusherToBackMessage>, I>>(
    base?: I,
  ): UpdateSpaceMetadataPusherToBackMessage {
    return UpdateSpaceMetadataPusherToBackMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSpaceMetadataPusherToBackMessage>, I>>(
    object: I,
  ): UpdateSpaceMetadataPusherToBackMessage {
    const message = createBaseUpdateSpaceMetadataPusherToBackMessage();
    message.spaceName = object.spaceName ?? "";
    message.metadata = object.metadata ?? "";
    message.senderId = object.senderId ?? "";
    return message;
  },
};

function createBaseSyncSpaceUsersMessage(): SyncSpaceUsersMessage {
  return { spaceName: "", users: [] };
}

export const SyncSpaceUsersMessage: MessageFns<SyncSpaceUsersMessage> = {
  encode(message: SyncSpaceUsersMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    for (const v of message.users) {
      SpaceUser.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SyncSpaceUsersMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSyncSpaceUsersMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.users.push(SpaceUser.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SyncSpaceUsersMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => SpaceUser.fromJSON(e)) : [],
    };
  },

  toJSON(message: SyncSpaceUsersMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.users?.length) {
      obj.users = message.users.map((e) => SpaceUser.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SyncSpaceUsersMessage>, I>>(base?: I): SyncSpaceUsersMessage {
    return SyncSpaceUsersMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SyncSpaceUsersMessage>, I>>(object: I): SyncSpaceUsersMessage {
    const message = createBaseSyncSpaceUsersMessage();
    message.spaceName = object.spaceName ?? "";
    message.users = object.users?.map((e) => SpaceUser.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddSpaceUserToNotifyMessage(): AddSpaceUserToNotifyMessage {
  return { spaceName: "", user: undefined };
}

export const AddSpaceUserToNotifyMessage: MessageFns<AddSpaceUserToNotifyMessage> = {
  encode(message: AddSpaceUserToNotifyMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.user !== undefined) {
      SpaceUser.encode(message.user, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddSpaceUserToNotifyMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSpaceUserToNotifyMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = SpaceUser.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSpaceUserToNotifyMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      user: isSet(object.user) ? SpaceUser.fromJSON(object.user) : undefined,
    };
  },

  toJSON(message: AddSpaceUserToNotifyMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.user !== undefined) {
      obj.user = SpaceUser.toJSON(message.user);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSpaceUserToNotifyMessage>, I>>(base?: I): AddSpaceUserToNotifyMessage {
    return AddSpaceUserToNotifyMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSpaceUserToNotifyMessage>, I>>(object: I): AddSpaceUserToNotifyMessage {
    const message = createBaseAddSpaceUserToNotifyMessage();
    message.spaceName = object.spaceName ?? "";
    message.user = (object.user !== undefined && object.user !== null) ? SpaceUser.fromPartial(object.user) : undefined;
    return message;
  },
};

function createBaseDeleteSpaceUserToNotifyMessage(): DeleteSpaceUserToNotifyMessage {
  return { spaceName: "", user: undefined };
}

export const DeleteSpaceUserToNotifyMessage: MessageFns<DeleteSpaceUserToNotifyMessage> = {
  encode(message: DeleteSpaceUserToNotifyMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.user !== undefined) {
      SpaceUser.encode(message.user, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteSpaceUserToNotifyMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteSpaceUserToNotifyMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = SpaceUser.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteSpaceUserToNotifyMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      user: isSet(object.user) ? SpaceUser.fromJSON(object.user) : undefined,
    };
  },

  toJSON(message: DeleteSpaceUserToNotifyMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.user !== undefined) {
      obj.user = SpaceUser.toJSON(message.user);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteSpaceUserToNotifyMessage>, I>>(base?: I): DeleteSpaceUserToNotifyMessage {
    return DeleteSpaceUserToNotifyMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteSpaceUserToNotifyMessage>, I>>(
    object: I,
  ): DeleteSpaceUserToNotifyMessage {
    const message = createBaseDeleteSpaceUserToNotifyMessage();
    message.spaceName = object.spaceName ?? "";
    message.user = (object.user !== undefined && object.user !== null) ? SpaceUser.fromPartial(object.user) : undefined;
    return message;
  },
};

function createBaseSpaceDestroyedMessage(): SpaceDestroyedMessage {
  return { spaceName: "" };
}

export const SpaceDestroyedMessage: MessageFns<SpaceDestroyedMessage> = {
  encode(message: SpaceDestroyedMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceDestroyedMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceDestroyedMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceDestroyedMessage {
    return { spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "" };
  },

  toJSON(message: SpaceDestroyedMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceDestroyedMessage>, I>>(base?: I): SpaceDestroyedMessage {
    return SpaceDestroyedMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceDestroyedMessage>, I>>(object: I): SpaceDestroyedMessage {
    const message = createBaseSpaceDestroyedMessage();
    message.spaceName = object.spaceName ?? "";
    return message;
  },
};

function createBaseKickOffMessage(): KickOffMessage {
  return { spaceName: "", userId: "" };
}

export const KickOffMessage: MessageFns<KickOffMessage> = {
  encode(message: KickOffMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KickOffMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKickOffMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KickOffMessage {
    return {
      spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
    };
  },

  toJSON(message: KickOffMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KickOffMessage>, I>>(base?: I): KickOffMessage {
    return KickOffMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KickOffMessage>, I>>(object: I): KickOffMessage {
    const message = createBaseKickOffMessage();
    message.spaceName = object.spaceName ?? "";
    message.userId = object.userId ?? "";
    return message;
  },
};

function createBaseAddSpaceFilterMessage(): AddSpaceFilterMessage {
  return { spaceFilterMessage: undefined };
}

export const AddSpaceFilterMessage: MessageFns<AddSpaceFilterMessage> = {
  encode(message: AddSpaceFilterMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceFilterMessage !== undefined) {
      SpaceFilterMessage.encode(message.spaceFilterMessage, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddSpaceFilterMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSpaceFilterMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceFilterMessage = SpaceFilterMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSpaceFilterMessage {
    return {
      spaceFilterMessage: isSet(object.spaceFilterMessage)
        ? SpaceFilterMessage.fromJSON(object.spaceFilterMessage)
        : undefined,
    };
  },

  toJSON(message: AddSpaceFilterMessage): unknown {
    const obj: any = {};
    if (message.spaceFilterMessage !== undefined) {
      obj.spaceFilterMessage = SpaceFilterMessage.toJSON(message.spaceFilterMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSpaceFilterMessage>, I>>(base?: I): AddSpaceFilterMessage {
    return AddSpaceFilterMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSpaceFilterMessage>, I>>(object: I): AddSpaceFilterMessage {
    const message = createBaseAddSpaceFilterMessage();
    message.spaceFilterMessage = (object.spaceFilterMessage !== undefined && object.spaceFilterMessage !== null)
      ? SpaceFilterMessage.fromPartial(object.spaceFilterMessage)
      : undefined;
    return message;
  },
};

function createBaseRemoveSpaceFilterMessage(): RemoveSpaceFilterMessage {
  return { spaceFilterMessage: undefined };
}

export const RemoveSpaceFilterMessage: MessageFns<RemoveSpaceFilterMessage> = {
  encode(message: RemoveSpaceFilterMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceFilterMessage !== undefined) {
      SpaceFilterMessage.encode(message.spaceFilterMessage, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveSpaceFilterMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveSpaceFilterMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceFilterMessage = SpaceFilterMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveSpaceFilterMessage {
    return {
      spaceFilterMessage: isSet(object.spaceFilterMessage)
        ? SpaceFilterMessage.fromJSON(object.spaceFilterMessage)
        : undefined,
    };
  },

  toJSON(message: RemoveSpaceFilterMessage): unknown {
    const obj: any = {};
    if (message.spaceFilterMessage !== undefined) {
      obj.spaceFilterMessage = SpaceFilterMessage.toJSON(message.spaceFilterMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveSpaceFilterMessage>, I>>(base?: I): RemoveSpaceFilterMessage {
    return RemoveSpaceFilterMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveSpaceFilterMessage>, I>>(object: I): RemoveSpaceFilterMessage {
    const message = createBaseRemoveSpaceFilterMessage();
    message.spaceFilterMessage = (object.spaceFilterMessage !== undefined && object.spaceFilterMessage !== null)
      ? SpaceFilterMessage.fromPartial(object.spaceFilterMessage)
      : undefined;
    return message;
  },
};

function createBaseSpaceFilterMessage(): SpaceFilterMessage {
  return { spaceName: "" };
}

export const SpaceFilterMessage: MessageFns<SpaceFilterMessage> = {
  encode(message: SpaceFilterMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.spaceName !== "") {
      writer.uint32(10).string(message.spaceName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceFilterMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceFilterMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.spaceName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceFilterMessage {
    return { spaceName: isSet(object.spaceName) ? globalThis.String(object.spaceName) : "" };
  },

  toJSON(message: SpaceFilterMessage): unknown {
    const obj: any = {};
    if (message.spaceName !== "") {
      obj.spaceName = message.spaceName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceFilterMessage>, I>>(base?: I): SpaceFilterMessage {
    return SpaceFilterMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceFilterMessage>, I>>(object: I): SpaceFilterMessage {
    const message = createBaseSpaceFilterMessage();
    message.spaceName = object.spaceName ?? "";
    return message;
  },
};

function createBaseSpaceFilterContainName(): SpaceFilterContainName {
  return { value: "" };
}

export const SpaceFilterContainName: MessageFns<SpaceFilterContainName> = {
  encode(message: SpaceFilterContainName, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== "") {
      writer.uint32(10).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceFilterContainName {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceFilterContainName();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpaceFilterContainName {
    return { value: isSet(object.value) ? globalThis.String(object.value) : "" };
  },

  toJSON(message: SpaceFilterContainName): unknown {
    const obj: any = {};
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceFilterContainName>, I>>(base?: I): SpaceFilterContainName {
    return SpaceFilterContainName.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceFilterContainName>, I>>(object: I): SpaceFilterContainName {
    const message = createBaseSpaceFilterContainName();
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseSpaceFilterLiveStreaming(): SpaceFilterLiveStreaming {
  return {};
}

export const SpaceFilterLiveStreaming: MessageFns<SpaceFilterLiveStreaming> = {
  encode(_: SpaceFilterLiveStreaming, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceFilterLiveStreaming {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceFilterLiveStreaming();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpaceFilterLiveStreaming {
    return {};
  },

  toJSON(_: SpaceFilterLiveStreaming): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceFilterLiveStreaming>, I>>(base?: I): SpaceFilterLiveStreaming {
    return SpaceFilterLiveStreaming.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceFilterLiveStreaming>, I>>(_: I): SpaceFilterLiveStreaming {
    const message = createBaseSpaceFilterLiveStreaming();
    return message;
  },
};

function createBaseSpaceFilterEverybody(): SpaceFilterEverybody {
  return {};
}

export const SpaceFilterEverybody: MessageFns<SpaceFilterEverybody> = {
  encode(_: SpaceFilterEverybody, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpaceFilterEverybody {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpaceFilterEverybody();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpaceFilterEverybody {
    return {};
  },

  toJSON(_: SpaceFilterEverybody): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpaceFilterEverybody>, I>>(base?: I): SpaceFilterEverybody {
    return SpaceFilterEverybody.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpaceFilterEverybody>, I>>(_: I): SpaceFilterEverybody {
    const message = createBaseSpaceFilterEverybody();
    return message;
  },
};

function createBaseVariableRequest(): VariableRequest {
  return { room: "", name: "" };
}

export const VariableRequest: MessageFns<VariableRequest> = {
  encode(message: VariableRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.room !== "") {
      writer.uint32(10).string(message.room);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVariableRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.room = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VariableRequest {
    return {
      room: isSet(object.room) ? globalThis.String(object.room) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: VariableRequest): unknown {
    const obj: any = {};
    if (message.room !== "") {
      obj.room = message.room;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VariableRequest>, I>>(base?: I): VariableRequest {
    return VariableRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VariableRequest>, I>>(object: I): VariableRequest {
    const message = createBaseVariableRequest();
    message.room = object.room ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseSaveVariableRequest(): SaveVariableRequest {
  return { room: "", name: "", value: undefined };
}

export const SaveVariableRequest: MessageFns<SaveVariableRequest> = {
  encode(message: SaveVariableRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.room !== "") {
      writer.uint32(10).string(message.room);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.value !== undefined) {
      Value.encode(Value.wrap(message.value), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SaveVariableRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSaveVariableRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.room = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.value = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SaveVariableRequest {
    return {
      room: isSet(object.room) ? globalThis.String(object.room) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object?.value) ? object.value : undefined,
    };
  },

  toJSON(message: SaveVariableRequest): unknown {
    const obj: any = {};
    if (message.room !== "") {
      obj.room = message.room;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value !== undefined) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SaveVariableRequest>, I>>(base?: I): SaveVariableRequest {
    return SaveVariableRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SaveVariableRequest>, I>>(object: I): SaveVariableRequest {
    const message = createBaseSaveVariableRequest();
    message.room = object.room ?? "";
    message.name = object.name ?? "";
    message.value = object.value ?? undefined;
    return message;
  },
};

function createBaseEventRequest(): EventRequest {
  return { room: "", name: "" };
}

export const EventRequest: MessageFns<EventRequest> = {
  encode(message: EventRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.room !== "") {
      writer.uint32(10).string(message.room);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EventRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.room = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EventRequest {
    return {
      room: isSet(object.room) ? globalThis.String(object.room) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: EventRequest): unknown {
    const obj: any = {};
    if (message.room !== "") {
      obj.room = message.room;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EventRequest>, I>>(base?: I): EventRequest {
    return EventRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EventRequest>, I>>(object: I): EventRequest {
    const message = createBaseEventRequest();
    message.room = object.room ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseEventResponse(): EventResponse {
  return { data: undefined, senderId: undefined };
}

export const EventResponse: MessageFns<EventResponse> = {
  encode(message: EventResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      Value.encode(Value.wrap(message.data), writer.uint32(10).fork()).join();
    }
    if (message.senderId !== undefined) {
      writer.uint32(16).int32(message.senderId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EventResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.senderId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EventResponse {
    return {
      data: isSet(object?.data) ? object.data : undefined,
      senderId: isSet(object.senderId) ? globalThis.Number(object.senderId) : undefined,
    };
  },

  toJSON(message: EventResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = message.data;
    }
    if (message.senderId !== undefined) {
      obj.senderId = Math.round(message.senderId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EventResponse>, I>>(base?: I): EventResponse {
    return EventResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EventResponse>, I>>(object: I): EventResponse {
    const message = createBaseEventResponse();
    message.data = object.data ?? undefined;
    message.senderId = object.senderId ?? undefined;
    return message;
  },
};

function createBaseDispatchEventRequest(): DispatchEventRequest {
  return { room: "", name: "", data: undefined, targetUserIds: [] };
}

export const DispatchEventRequest: MessageFns<DispatchEventRequest> = {
  encode(message: DispatchEventRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.room !== "") {
      writer.uint32(10).string(message.room);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.data !== undefined) {
      Value.encode(Value.wrap(message.data), writer.uint32(26).fork()).join();
    }
    writer.uint32(34).fork();
    for (const v of message.targetUserIds) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DispatchEventRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDispatchEventRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.room = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.data = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.targetUserIds.push(reader.int32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.targetUserIds.push(reader.int32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DispatchEventRequest {
    return {
      room: isSet(object.room) ? globalThis.String(object.room) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      data: isSet(object?.data) ? object.data : undefined,
      targetUserIds: globalThis.Array.isArray(object?.targetUserIds)
        ? object.targetUserIds.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: DispatchEventRequest): unknown {
    const obj: any = {};
    if (message.room !== "") {
      obj.room = message.room;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.data !== undefined) {
      obj.data = message.data;
    }
    if (message.targetUserIds?.length) {
      obj.targetUserIds = message.targetUserIds.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DispatchEventRequest>, I>>(base?: I): DispatchEventRequest {
    return DispatchEventRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DispatchEventRequest>, I>>(object: I): DispatchEventRequest {
    const message = createBaseDispatchEventRequest();
    message.room = object.room ?? "";
    message.name = object.name ?? "";
    message.data = object.data ?? undefined;
    message.targetUserIds = object.targetUserIds?.map((e) => e) || [];
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from((globalThis as any).Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return (globalThis as any).Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
